import { storage } from '../shared/util'
import { createStore } from './create'

export type Language = 'en' | 'zh' | 'ja' | 'tw'

export interface Translations {
  chub_title: string
  chub_search_placeholder: string
  chub_tags_placeholder: string
  chub_import: string
  chub_preview: string
  chub_disclaimer: string
  chub_import_book_hint_1: string
  chub_import_book_hint_2: string
  chub_import_char_hint_1: string
  chub_import_char_hint_2: string
  chub_import_char_name_label: string
  chub_import_char_name_helper: string
  chub_import_char_optional: string
  chub_import_char_greeting: string
  chub_import_char_scenario: string
  chub_import_char_sample_chat: string
  chub_import_char_persona: string
  chub_filter_nsfw_label: string
  chub_filter_nsfw_helper: string
  chub_filter_query_tags_label: string
  chub_filter_query_tags_helper: string
  chub_filter_exclude_tags_label: string
  chub_filter_exclude_tags_helper: string
  chub_filter_sort_label: string
  chub_invalid_tavern_image: string
  chub_sort_default: string
  chub_sort_trending: string
  chub_sort_favorites: string
  chub_sort_random: string
  chub_sort_rating: string
  chub_sort_updated: string
  chub_sort_popularity: string
  chub_sort_created: string
  chub_sort_name: string
  chub_sort_tokens: string
  chub_sort_ratings: string
  chub_error_importing: string
  chub_filter_tags_placeholder: string
  product_name: string
  product_slogan: string

  // Common
  welcome: string
  login: string
  register: string
  language: string
  close: string
  cancel: string
  confirm: string
  ok: string
  yes: string
  no: string
  edit: string
  editing: string
  update: string
  save: string
  copy: string
  search: string
  voice: string
  
  // Time
  time_seconds: string
  time_second: string
  time_minutes: string
  time_minute: string
  time_hours: string
  time_hour: string
  time_days: string
  time_day: string
  time_aMoment: string
  time_unknown: string
  time_ago: string
  
  // Welcome Modal
  welcomeTitle: string
  welcomeMessage: string
  welcomeDisclaimer: string
  welcomeContentWarning: string
  termsAgreement: string
  termsLink: string
  ageConfirmation: string
  
  // Navigation
  createCharacter: string
  importCharacter: string
  characters: string
  lorebooks: string
  creativeWorkshop: string
  personalCenter: string
  chatHistory: string
  trending: string
  memoryFragments: string
  menu: string
  library: string
  lib_memories: string
  lib_scenarios: string
  lib_templates: string
  lib_embeddings: string
  login_remote_error_not_logged_in: string
  login_remote_missing_callback: string
  login_remote_failed: string
  login_remote_request_access: string
  login_remote_application_access: string
  login_remote_authorize: string
  login_remote_authorizing: string
  presets: string
  settings: string
  profile: string
  chats: string
  sounds: string
  manage: string
  gen_presets_copy_preset: string
  gen_presets_edit_preset: string
  configuration: string
  users: string
  subscriptions: string
  announcements: string
  persona: string
  faq: string
  termsOfService: string
  privacyPolicy: string
  nav_home: string
  nav_trends: string
  nav_workshop: string
  nav_me: string
  home_tab_recommended: string
  home_tab_trending: string
  home_tab_latest: string

  // Profile / Subscription
  profile_checkout_success: string
  profile_checkout_thank_you: string
  profile_checkout_start_using: string
  profile_checkout_close_window: string
  profile_checkout_cancelled: string
  profile_checkout_cancelled_msg: string
  profile_sub_valid_until: string
  profile_sub_patreon_subscriber: string
  profile_sub_cancels_at: string
  profile_sub_renews_at: string
  profile_sub_why_title: string
  profile_sub_why_msg_1: string
  profile_sub_why_msg_2: string
  profile_sub_why_msg_3: string
  profile_sub_support_contact: string
  profile_sub_view_models: string
  profile_sub_current_title: string
  profile_sub_update_payment: string
  profile_sub_via: string
  profile_sub_via_gift: string
  profile_sub_via_patreon: string
  profile_sub_via_stripe: string
  profile_sub_via_none: string
  profile_sub_set_to_downgrade: string
  profile_sub_cancel_downgrade: string
  profile_sub_scheduled_to_cancel: string
  profile_sub_resume: string
  profile_sub_enjoy: string
  profile_sub_subscribed: string
  profile_sub_options: string
  profile_sub_patreon_msg: string
  profile_sub_gifted_to_you: string
  profile_sub_login_to_subscribe: string
  profile_sub_upgrade: string
  profile_sub_downgrading: string
  profile_sub_downgrade: string
  profile_sub_resubscribe: string
  profile_sub_subscribe: string
  profile_sub_prices_usd: string
  profile_sub_unsubscribe: string
  profile_sub_confirm_unsubscribe: string
  profile_sub_upgrade_charge_msg: string
  profile_sub_confirm_upgrade: string
  profile_sub_downgrade_affect_msg: string
  profile_sub_confirm_downgrade: string
  profile_sub_per_mo: string
  profile_sub_or: string

  // Prompt Templates
  prompt_templates_title: string
  prompt_templates_new_template: string
  prompt_templates_no_templates: string
  prompt_templates_builtin: string
  prompt_templates_updated: string
  prompt_templates_created: string
  prompt_templates_name: string

  // Saga
  saga_help_link: string
  saga_preview_title: string
  saga_preview_msg: string
  saga_new_template: string
  saga_untitled_template: string
  saga_menu_prompts: string
  saga_menu_preset: string
  saga_menu_help: string
  saga_session_saved: string
  saga_btn_restart: string
  saga_btn_start: string
  saga_btn_new: string
  saga_btn_load: string
  saga_btn_save: string
  saga_btn_reimage: string
  saga_tab_template: string
  saga_tab_session: string
  saga_current_template: string
  saga_load_template: string
  saga_field_name: string
  saga_field_format: string
  saga_field_init_template: string
  saga_field_init_template_helper: string
  saga_field_intro_format: string
  saga_field_intro_format_helper: string
  saga_field_display_format: string
  saga_field_display_format_helper: string
  saga_field_image_prompt: string
  saga_field_image_prompt_helper: string
  saga_field_history_template: string
  saga_field_history_template_helper: string
  saga_field_loop_template: string
  saga_field_loop_template_helper: string
  saga_manual_fields: string
  saga_manual_fields_helper: string
  saga_fields: string
  saga_fields_helper: string
  saga_lists: string
  saga_add_items: string
  saga_required_value: string
  saga_optional_value: string
  saga_guidance_title: string
  saga_import_success: string
  saga_import_title: string
  saga_import_json_label: string

  // Scenario
  scenario_title: string
  scenario_import: string
  scenario_create: string
  scenario_no_scenarios: string
  scenario_unnamed: string
  scenario_edit_title: string
  scenario_btn_duplicate: string
  scenario_btn_download: string
  scenario_btn_delete: string
  scenario_no_events: string
  scenario_events_count: string
  scenario_details_title: string
  scenario_field_name_helper: string
  scenario_field_desc: string
  scenario_field_desc_helper: string
  scenario_field_prompt: string
  scenario_field_prompt_helper: string
  scenario_field_overwrite: string
  scenario_field_overwrite_helper: string
  scenario_field_instructions: string
  scenario_field_instructions_helper: string
  scenario_confirm_delete: string
  scenario_download_title: string
  scenario_event_type_hidden: string
  scenario_event_type_world: string
  scenario_event_type_character: string
  scenario_event_type_ooc: string
  scenario_trigger_greeting: string
  scenario_trigger_manual: string
  scenario_trigger_opened: string
  scenario_trigger_received: string
  scenario_states_used: string
  scenario_states_used_helper: string
  scenario_events_title: string
  scenario_btn_create_event: string
  scenario_no_events_msg: string
  scenario_event_name_placeholder: string
  scenario_field_trigger: string
  scenario_field_req_states: string
  scenario_field_req_states_helper: string
  scenario_field_req_states_placeholder: string
  scenario_field_assign_states: string
  scenario_field_assign_states_helper: string
  scenario_field_assign_states_placeholder: string
  scenario_field_event_type: string
  scenario_field_event_type_helper: string
  scenario_field_event_prompt_helper: string
  scenario_event_greeting_msg: string
  scenario_field_probability: string
  scenario_field_probability_helper: string
  scenario_field_after_hours: string
  scenario_field_after_hours_helper: string
  scenario_field_after_messages: string
  scenario_field_after_messages_helper: string
  scenario_btn_update: string
  scenario_help_title: string
  scenario_help_triggers_msg: string
  scenario_help_greeting_msg: string
  scenario_help_manual_msg: string
  scenario_help_opened_msg: string
  scenario_help_received_msg: string
  scenario_help_prompt_msg: string
  scenario_help_world_msg: string
  scenario_help_character_msg: string
  scenario_help_hidden_msg: string
  scenario_help_ooc_msg: string
  scenario_help_processing_msg: string
  scenario_help_placeholders_msg: string
  scenario_help_ooc_processing_msg: string
  scenario_help_asterisks_msg: string
  scenario_help_states_msg: string
  scenario_help_req_states_msg: string
  scenario_help_assign_states_msg: string
  scenario_help_random_msg: string
  scenario_import_error_json: string
  scenario_import_error_schema: string
  scenario_import_error_invalid: string
  scenario_import_json_label: string
  scenario_import_supported_formats: string

  // Generation Presets
  gen_presets_title: string
  gen_presets_new_preset: string
  gen_presets_load_preset: string
  gen_presets_save_preset: string
  gen_presets_import_preset: string
  gen_presets_delete_preset_confirm: string
  gen_presets_name_label: string
  gen_presets_name_helper: string
  gen_presets_name_placeholder: string
  gen_presets_id_label: string
  gen_presets_new_preset_id: string
  gen_presets_builtin_warning: string
  gen_presets_copy_click_here: string
  gen_presets_copy_helper_text: string
  gen_presets_select_preset_helper: string
  gen_presets_filter_placeholder: string
  gen_presets_providers_tab: string
  gen_presets_presets_tab: string
  gen_presets_new_button: string
  gen_presets_import_button: string
  gen_presets_preset_json_label: string
  gen_presets_imported: string
  gen_presets_imported_preset: string
  gen_presets_invalid_preset: string
  gen_presets_could_not_parse: string

  // Additional UI
  nav_charHub: string
  nav_sagasPreview: string
  nav_imageGeneration: string
  nav_toggleTheme: string
  nav_newNotifications: string
  nav_noNotifications: string
  nav_subscribeCTA: string
  
  home_modelsTitle: string
  home_modelsMessage: string
  home_browserNoStorage: string
  home_officialGuides: string
  
  chat_forkConversation: string
  chat_forkConfirm: string
  chat_user_handle_you: string
  chat_user_anon_name: string
  chat_bot_label: string
  chat_profile_label: string
  chat_ago: string
  chat_confirm_discard: string
  chat_thinking: string
  chat_reasoning_thought: string
  chat_option_prompt: string
  chat_option_edit: string
  chat_option_fork: string
  chat_option_regen: string
  chat_option_attach: string
  chat_option_visibility: string
  chat_option_delete: string
  chat_option_gen_image: string
  chat_option_gen_json: string
  chat_option_export: string
  chat_removed_from_convo: string
  chat_unnamed_preset: string
  remove_all: string
  char_editCharacter: string
  chat_temp_char_updated: string
  chat_memory_guide: string
  chat_ui_settings: string
  chat_confirmDeleteChat: string
  chat_graph_rejoin_node: string
  chat_graph_assign_parent: string
  chat_graph_select_parent: string
  chat_graph_collapse: string
  chat_graph_expand: string
  chat_graph_rotate: string
  chat_graph_help: string
  chat_token_probabilities: string
  chat_save_memory_book: string
  chat_memory_book: string
  chat_memory_book_helper: string
  chat_create_new_memory_book: string
  chat_embedding: string
  chat_embedding_helper: string
  chat_use_embedding: string
  chat_msg_info_title: string
  admin_adapter: string
  chat_json_output: string
  chat_img_prompt_updated: string
  chat_caption_hint_helper: string
  chat_caption_hint_placeholder: string
  chat_image_prompt: string
  interrupt: string
  admin_clean: string
  admin_edit: string
  chat_msg_prompt_title: string
  chat_prompt_approx_helper: string
  chat_prompt_budget_helper: string
  chat_est_tokens: string
  chat_speech_recognition_error: string
  chat_visibility_current: string
  chat_visibility_toggles: string
  chat_settings_defaults_per_char: string
  chat_settings_defaults_per_char_helper: string
  chat: string
  download: string
  chat_export_title: string
  chat_system_preset_horde: string
  chat_system_preset: string
  chat_your_default_preset: string
  chat_delete_msg_title: string
  chat_delete_swipe: string
  chat_delete_one: string
  chat_delete_msg_confirm: string
  chat_delete_msg_one_note: string
  chat_delete_msg_image_confirm: string
  chat_system_built_in_preset_horde: string
  chat_please_select_preset: string
  chat_load_more: string
  chat_add_temp_character: string
  chat_user: string
  chat_temp_characters: string
  chat_deleted_temp_characters: string
  chat_remove_user_confirm: string
  chat_no_chars_to_invite: string
  chat_select_char_to_add: string
  chat_no_chars_available_to_add: string
  chat_no_user_id_provided: string
  chat_invite_user: string
  chat_invite_user_helper: string
  chat_send_invite: string
  chat_owner: string
  chat_temp_character: string
  reset: string
  back: string
  character: string

  admin_notYetImplemented: string
  admin_noSubscriptionId: string
  admin_session: string
  
  // Home
  recentConversations: string
  startConversation: string
  guides: string
  links: string
  gettingStarted: string
  createACharacter: string
  configureYourAIServices: string
  officialGuides: string
  memoryBook: string
  agnaisticDiscord: string
  github: string
  notableFeatures: string
  lookingForHelp: string
  checkOutThe: string
  officialGuide: string
  orHeadToThe: string

  // Guides
  guide_memory_title: string
  guide_memory_text: string
  guide_novel_title: string
  guide_novel_text: string
  guide_pipeline_title: string
  guide_pipeline_subtitle: string
  guide_pipeline_text: string

  home_faq_title: string
  home_faq_subtitle: string
  home_faq_content: string
  maxNewTokens: string
  
  // Login
  username: string
  password: string
  confirmPassword: string
  displayName: string
  passwordsDoNotMatch: string
  invalidCallbackUrl: string
  loggingIn: string
  registering: string
  welcomeToAccount: string
  authorizing: string
  youAreAlreadyLoggedIn: string
  toYourAccount: string
  orContinueAsGuest: string
  failedToLogIn: string
  somethingWentWrong: string
  couldNotReachServers: string
  byLoggingIn: string
  youAgree: string
  and: string
  whyRegister: string
  youDontNeedToRegister: string
  ifYouChooseToRegister: string
  yourDataWillBeStored: string

  // Admin
  admin_serverConfiguration: string
  admin_general: string
  admin_images: string
  admin_voice: string
  admin_supportEmail: string
  admin_supportEmailHelper: string
  admin_maintenanceModeEnabled: string
  admin_maintenanceModeHelper: string
  admin_maintenanceMessage: string
  admin_maintenanceMessageHelper: string
  admin_stripeCustomerPortal: string
  admin_lockDuration: string
  admin_lockDurationHelper: string
  admin_googleClientId: string
  admin_googleClientIdHelper: string
  admin_slotsConfiguration: string
  admin_slotsConfigurationHelper: string
  admin_format: string
  admin_enablePolicies: string
  admin_enablePoliciesHelper: string
  admin_privacyStatement: string
  admin_apiAccessLevel: string
  admin_off: string
  admin_allUsers: string
  admin_subscribers: string
  admin_administrators: string
  admin_maxGuidanceTokens: string
  admin_maxGuidanceTokensHelper: string
  admin_maxGuidanceVariables: string
  admin_maxGuidanceVariablesHelper: string
  admin_imagesHost: string
  admin_imagesLoraUrl: string
  admin_defaultImageModel: string
  admin_imageModels: string
  admin_add: string
  admin_addModel: string
  admin_description: string
  admin_modelDescriptionPlaceholder: string
  admin_url: string
  admin_loraSupport: string
  admin_host: string
  admin_modelNamePlaceholder: string
  admin_override: string
  admin_level: string
  admin_prefix: string
  admin_suffix: string
  admin_negative: string
  admin_steps: string
  admin_init: string
  admin_max: string
  admin_cfgScale: string
  admin_width: string
  admin_height: string
  admin_clipSkip: string
  admin_voiceAccessLevel: string
  admin_voiceHost: string
  admin_voiceHostHelper: string
  admin_voiceApiKey: string
  admin_metrics: string
  admin_refresh: string
  admin_onlineUsers: string
  admin_versions: string
  admin_maxOnlineUsers: string
  admin_registeredUsers: string
  admin_services: string
  admin_messageAllUsers: string
  admin_send: string
  admin_confirmMessageAll: string
  admin_userManagement: string
  admin_backToManage: string
  admin_customerId: string
  admin_subscribed: string
  admin_search: string
  admin_reset: string
  admin_info: string
  admin_impersonate: string
  admin_changePassword: string
  admin_banUser: string
  admin_unbanUser: string
  admin_userId: string
  admin_banned: string
  admin_handle: string
  admin_subscriptionDetails: string
  admin_gift: string
  admin_expiry: string
  admin_apply: string
  admin_assignSub: string
  admin_stripeSubscriptionId: string
  admin_assign: string
  admin_sessionIds: string
  admin_subscriptionLevel: string
  admin_native: string
  admin_manual: string
  admin_periodStart: string
  admin_renewsAt: string
  admin_downgradingAt: string
  admin_cancelledAt: string
  admin_cancelsAt: string
  admin_state: string
  admin_history: string
  admin_noReasonGiven: string
  admin_banReason: string
  admin_resetLink: string
  admin_generateLink: string
  admin_manageAnnouncements: string
  admin_created: string
  admin_hide: string
  admin_unhide: string
  admin_delete: string
  admin_instructions: string
  admin_deleted: string
  admin_hidden: string
  admin_pending: string
  admin_active: string
  admin_announcement: string
  admin_title: string
  admin_displayAtRequired: string
  admin_errorProductNotFound: string
  admin_errorProductNoPrice: string
  admin_errorPriceNotFound: string
  admin_location: string
  admin_home: string
  admin_notification: string
  admin_locationHelper: string
  admin_userLevelThreshold: string
  admin_userLevelThresholdHelper: string
  admin_content: string
  admin_hideAnnouncement: string
  admin_displayAt: string
  admin_now: string
  admin_apiKey: string
  admin_apiKeyHelper: string
  admin_apiKeyIsSet: string
  admin_apiKeyIsNotSet: string
  admin_subscriptionLevelHelper: string
  admin_replacementIdNotSet: string
  admin_id: string
  admin_name: string
  admin_apiAccessCapable: string
  admin_guidanceAccessCapable: string
  admin_imagesAccessCapable: string
  admin_patreonTier: string
  admin_preview: string
  admin_stripeProduct: string
  admin_enabled: string
  admin_disableSlots: string
  admin_subscriptionTier: string
  admin_backToSubscriptions: string
  admin_noPaymentRequired: string
  admin_descriptionHelper: string
  admin_apiAccessHelper: string
  admin_guidanceAccessHelper: string
  admin_imagesAccessHelper: string
  admin_patreonTierHelper: string
  admin_enabledHelper: string
  admin_disableSlotsHelper: string
  admin_subscriptions: string
  admin_model: string
  admin_tier: string
  admin_noTiers: string
  admin_tiers: string
  admin_models: string
  admin_disabled: string
  admin_default: string
  admin_stripe: string
  admin_patreon: string
  admin_unset: string
  admin_confirmDeleteSubscription: string
  admin_subscriptionModel: string
  admin_loadPreset: string
  admin_newSubscription: string
  admin_replaceSupercede: string
  admin_modelHelper: string
  admin_modelServiceUrl: string
  admin_modelServiceUrlHelper: string
  admin_guidanceCapable: string
  admin_guidanceCapableHelper: string
  admin_subscriptionDisabled: string
  admin_subscriptionDisabledHelper: string
  admin_isDefaultSubscription: string
  admin_isDefaultSubscriptionHelper: string
  admin_jsonSchemaCapable: string
  admin_visionModel: string
  admin_visionModelHelper: string
  admin_allowGuestUsage: string
  admin_allowGuestUsageHelper: string
  admin_tokenizerOverride: string
  admin_tokenizerOverrideHelper: string
  admin_confirmDeletePreset: string
  admin_replaceSubscription: string
  admin_replacementSubscription: string
  admin_replacementSubscriptionHelper: string
  admin_replace: string
  admin_levels: string
  admin_subLevel: string
  admin_tokens: string
  admin_context: string
  admin_copySubscription: string
  admin_createSubscription: string
  admin_editSubscription: string
  admin_selectAIServiceBeforeSaving: string
  admin_preset: string
  admin_presetHelper: string
  
  // Profile
  profile_myProfile: string
  profile_updateProfile: string
  profile_impersonateNote: string
  profile_linkGoogle: string
  profile_accountLinkedGoogle: string
  profile_unlinkGoogle: string
  profile_userIdHelper: string
  profile_usernameHelper: string
  profile_displayNameHelper: string
  profile_profileImage: string
  profile_removeAvatar: string
  profile_fileSizeLimit2MB: string
  profile_guestData: string
  profile_prepareBackup: string
  profile_backupNotReady: string
  profile_downloadGuestData: string
  profile_unimpersonate: string
  profile_logout: string
  profile_deleteAccount: string
  profile_importGuestDataWarning: string
  profile_importFailed: string
  profile_changePassword: string
  profile_changePasswordDescription: string
  profile_updatePassword: string
  profile_newPassword: string
  profile_confirmPassword: string
  profile_deleteAccountWarning: string
  profile_deleteAccountConfirmNote: string
  profile_confirmDeletion: string
  
  // Settings
  settings_title: string
  settings_updateSettings: string
  settings_thisCannotBeUndone: string
  settings_deleteGuestState: string
  settings_ui_theme: string
  settings_ui_chat: string
  settings_ui_messages: string
  settings_ui_color: string
  settings_ui_mode: string
  settings_ui_dark: string
  settings_ui_light: string
  settings_ui_siteFontSize: string
  settings_ui_backgrounds: string
  settings_ui_resetToDefault: string
  settings_ui_backgroundColor: string
  settings_ui_backgroundImage: string
  settings_ui_remove: string
  settings_ui_font: string
  settings_ui_custom: string
  settings_ui_responseHints: string
  settings_ui_responseHintsHelper: string
  settings_ui_avatarWrapAround: string
  settings_ui_avatarWrapAroundHelper: string
  settings_ui_trimIncompleteSentences: string
  settings_ui_expandReasoning: string
  settings_ui_expandReasoningHelper: string
  settings_ui_midReasoningBehavior: string
  settings_ui_midReasoningBehaviorHelper: string
  settings_ui_anonymizeChat: string
  settings_ui_anonymizeChatHelper: string
  settings_ui_sendOnEnterOnMobile: string
  settings_ui_sendOnEnterOnMobileHelper: string
  settings_ui_textSpeed: string
  settings_ui_textSpeedHelper: string
  settings_ui_viewMode: string
  settings_ui_viewModeHelper: string
  settings_ui_splitHeight: string
  settings_ui_splitHeightHelper: string
  settings_ui_standard: string
  settings_ui_split: string
  settings_ui_backgroundAuto: string
  settings_ui_backgroundCover: string
  settings_ui_backgroundContain: string
  settings_ui_defaultAll: string
  settings_ui_all: string
  settings_ui_afterThought: string
  settings_ui_beforeThought: string
  settings_ui_avatars: string
  settings_ui_size: string
  settings_ui_cornerRadius: string
  settings_ui_width: string
  settings_ui_height: string
  settings_ui_messageBackgroundColor: string
  settings_ui_botMessageBackgroundColor: string
  settings_ui_chatTextColor: string
  settings_ui_chatEmphasisColor: string
  settings_ui_chatQuoteColor: string
  settings_ui_chatQuoteEmphasisColor: string
  settings_ui_chatQuoteEmphasisWeight: string
  settings_ui_contentWidth: string
  settings_ui_messageOpacity: string
  settings_ui_messageOpacityHelper: string
  settings_ui_inlineMessageOptions: string
  settings_ui_inlineMessageOptionsHelper: string
  settings_ui_preview: string
  settings_ui_none: string
  settings_ui_bold: string
  settings_ui_narrow: string
  settings_ui_large: string
  settings_ui_xlarge: string
  settings_ui_2xlarge: string
  settings_ui_3xlarge: string
  settings_ui_100: string
  settings_ui_msg_edit: string
  settings_ui_msg_regenerate: string
  settings_ui_msg_promptView: string
  settings_ui_msg_fork: string
  settings_ui_msg_delete: string
  settings_ui_msg_attach: string
  settings_ui_msg_visibility: string
  settings_ui_msg_genImage: string
  settings_ui_msg_genJson: string
  settings_ai_embeddings: string
  settings_ai_embeddingsHelper: string
  settings_ai_presets: string
  settings_ai_chargen: string
  settings_ai_useServerDefault: string
  settings_ai_chatSummary: string
  settings_ai_useActiveChatPreset: string
  settings_ai_jsonSchemas: string
  settings_ai_defaultPreset: string
  settings_ai_defaultPresetHelper: string
  settings_ai_apiAccessTitle: string
  settings_ai_howToUseApi: string
  settings_ai_apiAccessPreset: string
  settings_ai_apiAccessPresetHelper: string
  settings_ai_apiKey: string
  settings_ai_revealKey: string
  settings_ai_generateKey: string
  settings_ai_regenerateKey: string
  settings_ai_apiKeyHidden: string
  settings_ai_lookingForProviders: string
  settings_ai_headToPresets: string
  settings_ai_editSummaryPreset: string
  settings_ai_apiAccessHelp: string
  settings_voice_sttTitle: string
  settings_voice_sttNotAvailable: string
  settings_voice_sttHelper: string
  settings_voice_sttEnabled: string
  settings_voice_sttEnabledHelper: string
  settings_voice_sttAutoSubmit: string
  settings_voice_sttAutoSubmitHelper: string
  settings_voice_sttAutoRecord: string
  settings_voice_sttAutoRecordHelper: string
  settings_voice_ttsTitle: string
  settings_voice_ttsHelper: string
  settings_voice_ttsEnabled: string
  settings_voice_ttsEnabledHelper: string
  settings_voice_ttsFilterActions: string
  settings_voice_ttsFilterActionsHelper: string
  settings_voice_voiceServices: string
  settings_voice_agnaistic: string
  settings_voice_webspeechsynthesis: string
  settings_voice_elevenlabs: string
  settings_voice_novel: string
  
  // Character
  char_advancedOptions: string
  char_systemPrompt: string
  char_systemPromptHelper: string
  char_systemPromptPlaceholder: string
  char_jailbreak: string
  char_jailbreakHelper: string
  char_jailbreakPlaceholder: string
  char_insertDepthPrompt: string
  char_insertDepthPromptHelper: string
  char_insertDepth: string
  char_insertDepthHelper: string
  char_creator: string
  char_creatorPlaceholder: string
  char_version: string
  char_versionPlaceholder: string
  char_chats: string
  char_noConversations: string
  char_chatActivity: string
  char_botActivity: string
  char_chatCreated: string
  char_botName: string
  char_botCreated: string
  char_chatCounts: string
  char_allCharacters: string
  char_confirmDeleteChat: string
  char_noConversationsYet: string
  char_noConversationsWith: string
  char_lastModified: string
  char_lastConversed: string
  char_created: string
  char_select: string
  char_archiveSelected: string
  char_unarchiveSelected: string
  char_deleteSelected: string
  char_searchByName: string
  char_selectedNone: string
  char_selectedCount: string
  char_favorites: string
  char_editingTitle: string
  char_noCharactersFound: string
  char_toGetStarted: string
  char_jsonStructuredResponsesHelper: string
  char_updateSchema: string
  char_editingSchema: string
  char_testSchema: string
  char_templateReferencesUndefined: string
  char_responseTemplateWarning: string
  char_invalidJsonSchema: string
  char_deleteChatsWarning: string
  char_newChat: string
  char_new: string
  char_unfavorite: string
  char_duplicate: string
  char_downloadRetreiveFailed: string
  char_imageCard: string
  char_textgen: string
  char_downloadJson: string
  char_downloadPng: string
  char_createACharacterTitle: string
  char_editACharacterTitle: string
  char_copyACharacterTitle: string
  char_tokensPermanent: string
  char_aiCharacterGenerationGuide: string
  char_characterOverridesWarning: string
  char_temporaryCharacterWarning: string
  char_clearEditorConfirm: string
  char_descriptionCreatorsNotesHelper: string
  char_tagsHelper: string
  char_scenario: string
  char_scenarioHelper: string
  char_personality: string
  char_personalityWarning: string
  char_greeting: string
  char_greetingHelper: string
  char_greetingPlaceholder: string
  char_sampleConversation: string
  char_sampleConversationHelper: string
  char_voiceHelper: string
  char_languageHelper: string
  char_languageNote: string
  char_imageSettingsMoved: string
  char_inMainMenu: string
  char_avatarOrJsonFile: string
  char_charactersToImport: string
  char_andOneOther: string
  char_andOthers: string
  char_failedCharacterImports: string
  char_persona: string
  char_images: string
  char_advanced: string
  char_attributesFormat: string
  char_plainTextFormat: string
  char_downloadSuccess: string
  char_downloadFailed: string
  char_sampleConversationPlaceholder: string
  char_unnamed: string
  char_importChatLog: string
  char_chatLogAccepted: string
  char_invalidChatLogFormat: string
  char_chatLogImportFor: string
  char_jsonLinesFile: string
  char_messagesToImport: string
  chat_chatWith: string
  chat_notesFromCreator: string
  chat_generateMessage: string
  chat_forkConversationConfirm: string
  chat_sendAMessage: string
  chat_sendAMessageTo: string
  chat_confirmCancelSwipe: string
  chat_respondAsMe: string
  chat_autoReply: string
  chat_none: string
  chat_stopBotReply: string
  chat_generateImage: string
  chat_respondAgain: string
  chat_generateMore: string
  chat_playVoice: string
  chat_triggerEvent: string
  chat_attachImage: string
  chat_responseHint: string
  chat_invalidFileTypeImage: string
  chat_attachmentExceedsLimit: string
  chat_loading: string
  chat_participants: string
  chat_editChat: string
  chat_memory: string
  chat_ui: string
  chat_graph: string
  chat_screenshot: string
  chat_anonymize: string
  chat_hideOocMessages: string
  chat_mainCharacter: string
  chat_beginning_group: string
  chat_beginning_with: string
  chat_restart: string
  chat_loadingWait: string
  chat_screenshotFailedElement: string
  chat_screenshotFailedConsole: string
  chat_ooc_suffix: string
  chat_msg_id: string
  chat_msg_chat: string
  chat_msg_descendants: string
  chat_pending_retrying: string
  chat_pending_waiting: string
  chat_pending_chatId: string
  chat_graph_root: string
  chat_avatar_modal_title: string
  chat_graph_circular_error: string
  char_listView: string
  char_cardsView: string
  char_folderView: string
  char_failedToLoad: string
  char_jsonStructuredResponses: string
  char_jsonStructuredWarning: string
  char_responseTemplate: string
  char_responseTemplateHelper: string
  char_historyTemplate: string
  char_historyTemplateHelper: string
  char_imageCaptionTemplate: string
  char_imageCaptionTemplateHelper: string
  char_jsonSchemaFile: string
  char_confirmDeletion: string
  char_confirmDeletionMessage: string
  char_toggleFavorite: string
  char_openRecentChat: string
  char_openCharacterChats: string
  char_favorite: string
  char_downloadCharacter: string
  char_outputFormat: string
  char_fileType: string
  char_characterName: string
  char_descriptionCreatorsNotes: string
  char_tags: string
  char_scenarioPlaceholder: string
  char_formatAsIsHelper: string
  char_formatToUseHelper: string
  char_firstMessagePlaceholder: string
  char_voice: string
  char_disableVoice: string
  char_updatePreset: string
  char_presetUsedForGeneration: string
  char_foldersGuide: string
  char_foldersInstructions: string
  char_currentFolder: string
  char_newFolder: string
  char_generateAvatar: string
  char_impersonate: string
  char_changeChatPersona: string
  char_changeDefaultPersona: string
  char_impersonationHelper: string
  char_failedImports: string
  char_multiUserNote: string
  char_alternateGreeting: string
  char_appearancePrompt: string
  char_characterBook: string
  char_noCharacterBook: string
  char_hasCharacterBook: string
  char_characterMemory: string
  char_characterDesigner: string
  char_root: string
  char_changeFolderTitle: string
  char_folderNamesNormalized: string
  char_normalizedName: string
  char_openchats_with: string
  char_remove_from_favorites: string
  char_add_to_favorites: string
  char_create_new_chat_with: string
  char_download_character_name: string
  char_edit_character_name: string
  char_duplicate_character_name: string
  char_delete_character_name: string
  char_save: string
  char_drag_to_move: string
  char_drag_to_new_folder: string
  char_drag_onto_folder: string
  char_regenerate_tooltip: string
  char_regenerate_warn: string
  char_reel_send_to_editor: string
  char_insert_depth_placeholder: string
  char_importMemoryBook: string
  char_editBook: string
  char_deleteBook: string
  char_createNewBook: string
  char_hasNoCharacterBook: string
  char_addAlternateGreeting: string
  char_alternateGreetingPlaceholder: string
  char_voiceService: string
  char_voiceLoading: string
  char_openCharacterBuilder: string
  char_selectAvatarImage: string
  char_appearancePromptPlaceholder: string
  char_visualTypeAvatar: string
  char_visualTypeSprite: string
  char_personaTab: string
  char_voiceTab: string
  char_imagesTab: string
  char_advancedTab: string
  char_currentChatPersona: string
  char_defaultPersona: string
  char_impersonateDescription: string
  char_useMyProfile: string
  char_currentLabel: string
  char_defaultLabel: string
  char_defaultForNewConvos: string
  char_jsonSchemaGenerationStatus: string
  char_tempJsonSchemaUpdated: string
  char_characterHubDownloadSuccess: string
  char_characterHubDownloadFailed: string
  char_recommended: string
  char_unrecognizedFormat: string
  char_open_recent_chat: string
  char_open_character_chats: string

  // Voice
  voice_elevenLabsModel: string
  voice_stability: string
  voice_claritySimilarityEnhancement: string
  voice_playbackRate: string
  voice_seed: string
  voice_service: string
  voice_pitch: string
  voice_rate: string
  voice_preview: string
  voice_modelsLoading: string
  voice_agnaisticSeedHelper: string
  voice_novelSeedHelper: string
  voice_stabilityHelper: string
  voice_similarityBoostHelper: string
  voice_pitchHelper: string
  voice_rateHelper: string

  // App
  app_login_issues: string
  app_logging_out: string
  app_log_back_in: string
  app_page_loading_issues: string
  app_clicking_here: string
  app_failed_to_load: string
  app_try_again: string
  app_banned_message: string
  app_banned_contact: string
  app_account_banned: string
  app_information: string

  // Home
  home_free_to_use: string
  home_chat_multi_user: string
  home_create_memory_book: string
  home_use_images: string
  home_give_voice: string
  home_customise_presets: string
  home_horde_guide: string
  home_horde_important: string
  home_horde_volunteers: string
  home_horde_tokens: string
  home_horde_anonymous: string
  home_openai_guide: string
  home_openai_paid: string
  home_openai_register: string
  home_openai_generate_key: string
  home_openai_set_key: string
  home_openai_preset: string

  // Chat Create
  chat_create_title: string
  chat_create_description: string
  chat_create_applied_to_new: string
  chat_create_main_character_helper: string
  chat_mode: string
  chat_mode_companion_description: string
  chat_mode_standard: string
  chat_mode_companion: string
  chat_conversation_name: string
  chat_conversation_name_helper: string
  chat_override_character_definitions: string
  chat_override_helper: string
  chat_scenario_helper: string
  chat_create_button: string

  // Chat Settings
  chat_settings_reset_character: string
  chat_settings_image_source: string
  chat_settings_image_source_helper: string
  chat_settings_main_character: string
  chat_settings_last_character: string
  chat_settings_chat_settings: string
  chat_settings_app_settings: string
  chat_settings_background_image: string
  chat_settings_background_image_helper: string
  chat_settings_chat_mode_irreversible: string
  chat_settings_chat_name: string
  chat_settings_override_helper: string
  chat_settings_scenario_state: string
  chat_settings_scenario_state_helper: string
  chat_settings_field_description_helper: string
  chat_settings_post_history_instructions: string
  chat_settings_default_visibility: string
  chat_settings_visibility_helper: string
  chat_settings_visible: string
  chat_settings_invisible: string
  chat_settings_not_set: string
  chat_settings_defaults_all: string

  // Settings UI
  settings_ui_viewMode_background: string
  settings_ui_typewriter_test: string

  // Navigation
  nav_main_page_aria: string
  nav_add_new_preset: string
  nav_add_new_character: string
  nav_create_new_chat: string
  nav_edit_user_profile: string
  nav_open_impersonation: string
  nav_email_support: string

  // Toasts
  toasts_site_updates: string
  toasts_no_notifications: string
  toasts_clear_notifications: string
  toasts_message_from_admin: string
  toasts_latest_updates: string
  toasts_admin_notification: string
  image_prompt: string
  image_clean: string
  image_generate: string
  image_stop: string
  image_to_unsent: string
  image_to_current: string
  image_add_attachment: string
  image_caption: string
  image_caption_hint_placeholder: string
  image_count: string
  image_fix: string
  image_attach_to_message: string
  invite_title: string
  invite_no_pending: string
  invite_from: string
  invite_character: string
  invite_sent: string
  invite_unknown_user: string
  invite_unknown_character: string
  login_reset_password: string
  login_username_placeholder: string
  login_password_placeholder: string
  login_confirm_password_placeholder: string
  login_error_not_logged_in: string
  login_missing_callback: string
  login_failed: string
  login_oauth_request: string
  login_oauth_access_list: string
  login_oauth_access_items: string
  login_authorize: string
  login_authorizing: string
  memory_create_book: string
  memory_edit_book: string
  memory_update_book: string
  memory_definitions: string
  memory_priority: string
  memory_priority_helper: string
  memory_weight: string
  memory_weight_helper: string
  memory_keywords: string
  memory_keywords_helper: string
  memory_entry: string
  memory_entry_helper: string
  memory_embeddings: string
  memory_loaded: string
  memory_not_loaded: string
  memory_books: string
  memory_no_books: string
  memory_book_accepted: string
  memory_import_book: string
  memory_json_file: string
  memory_import_helper: string
  memory_sort_creation: string
  memory_sort_alpha: string
  memory_book_name: string
  memory_book_name_placeholder: string
  memory_description_placeholder: string
  memory_entries: string
  memory_filter_placeholder: string
  memory_entry_name_placeholder: string
  memory_keywords_placeholder: string
  memory_entry_placeholder: string
  memory_embedding_created: string
  memory_article: string
  memory_pdf: string
  memory_text_file: string
  memory_plain_text: string
  memory_enter_name: string
  memory_no_pdf: string
  memory_content_empty: string
  memory_enable_embeddings_helper: string
  memory_embed_wiki: string
  memory_embed_wiki_helper: string
  memory_wiki_placeholder: string
  memory_embed_article_button: string
  memory_embed_name_helper: string
  memory_embed_pdf: string
  memory_embed_pdf_helper: string
  memory_embed_file: string
  memory_embed_file_helper: string
  memory_embed_text_helper: string
  memory_embed_text_button: string
  memory_embed_name_optional_helper: string
  memory_embed_name_slug_helper: string
  privacy_policy_text: string

  // WorkerModal
  worker_modal_title: string
  worker_modal_select_workers: string
  worker_modal_helper: string
  worker_modal_selected_count: string
  worker_modal_deselect_all: string

  // OpenRouterOauth
  openrouter_oauth_instruction: string
  openrouter_oauth_logging_in: string
  openrouter_oauth_login: string
  openrouter_oauth_logout: string

  // PatreonOauth
  patreon_oauth_verifying: string
  patreon_oauth_error: string
  patreon_oauth_return_to_settings: string
  patreon_oauth_success: string
  patreon_oauth_redirecting: string
  patreon_oauth_link_benefit: string
  patreon_oauth_link: string
  patreon_oauth_unlink: string
  patreon_oauth_revalidate: string

  // ImageSettings
  image_settings_shared: string
  image_settings_global_default: string
  image_settings_character_settings: string
  image_settings_character: string
  image_settings_current_chat: string
  image_settings_chatting_with: string
  image_settings_source_label: string
  image_settings_source_helper: string
  image_settings_use_settings: string
  image_settings_use_settings_active: string
  image_settings_summary_preset: string
  image_settings_summary_preset_helper: string
  image_settings_summary_settings: string
  image_settings_summarise_chat: string
  image_settings_summarise_chat_helper: string
  image_settings_summary_prompt: string
  image_settings_summary_prompt_helper: string
  image_settings_default: string
  image_settings_style_booru: string
  image_settings_style_plain: string
  image_settings_use_recommended: string
  image_settings_use_recommended_helper: string
  image_settings_toggle_all: string
  image_settings_affixes: string
  image_settings_size: string
  image_settings_guidance: string
  image_settings_steps: string
  image_settings_negative_prompt: string
  image_settings_sampler: string
  image_settings_recommended_hint: string
  image_settings_sampling_steps: string
  image_settings_clip_skip: string
  image_settings_width: string
  image_settings_height: string
  image_settings_guidance_scale: string
  image_settings_seed: string
  image_settings_seed_helper: string
  image_settings_prefix: string
  image_settings_prefix_helper: string
  image_settings_prefix_placeholder: string
  image_settings_suffix: string
  image_settings_suffix_helper: string
  image_settings_suffix_placeholder: string
  image_settings_negative_helper: string
  image_settings_negative_placeholder: string
  image_settings_edit_summary_preset: string
  image_settings_unavailable_hint: string
  image_settings_image_settings: string

  // ServiceSettings
  service_settings_model: string
  service_settings_sampler: string
  service_settings_novel_key_error: string
  service_settings_novel_quality_tags: string
  service_settings_novel_undesired_content: string
  service_settings_novel_undesired_content_helper: string
  service_settings_novel_heavy: string
  service_settings_novel_light: string
  service_settings_novel_none: string
  service_settings_swarm_url: string
  service_settings_swarm_url_helper: string
  service_settings_automatic: string
  service_settings_add_lora: string
  service_settings_use_local: string
  service_settings_none_selected: string
  service_settings_sd_url: string
  service_settings_sd_url_helper: string
  service_settings_sd_provider_helper: string
  service_settings_no_options: string
  service_settings_draft_mode: string
  service_settings_draft_mode_helper: string
  service_settings_recommended: string
  service_settings_limits: string
  service_settings_tags_keyword: string
  service_settings_tags: string
  service_settings_on: string
  service_settings_off: string
  service_settings_model_strength: string
  service_settings_clip_strength: string
  service_settings_image_model: string
  service_settings_sampler_label: string
  service_settings_steps: string
  service_settings_cfg: string
  service_settings_width: string
  service_settings_height: string
  service_settings_clip_skip: string
  service_settings_sampler_title: string
  service_settings_prefix: string
  service_settings_suffix: string
  service_settings_negative: string

  // Provider/index
  provider_index_select_provider: string
  provider_index_service: string
  provider_index_providers: string
  provider_index_providers_helper: string
  provider_index_new_provider_helper: string
  provider_index_format_helper: string
  provider_index_important_helper: string
  provider_index_edit_selected: string
  provider_index_new: string
  provider_index_edit: string
  provider_index_edit_connection: string
  provider_index_accept: string
  provider_index_ai_service: string
  provider_index_no_service_warning: string
  provider_index_third_party_format: string
  provider_index_request_format_helper: string
  provider_index_none: string
  provider_index_url: string
  provider_index_url_helper: string
  provider_index_url_placeholder: string
  provider_index_api_key: string
  provider_index_remove_key: string
  provider_index_key_warning: string
  provider_index_key_is_set: string
  provider_index_key_placeholder: string

  // Provider/Manage
  provider_manage_supported: string
  provider_manage_local_selfhost: string
  provider_manage_custom: string
  provider_manage_choose_provider: string
  provider_manage_provider_prefix: string
  provider_manage_invalid_url: string
  provider_manage_update_title: string
  provider_manage_create_title: string
  provider_manage_delete: string
  provider_manage_update: string
  provider_manage_create: string
  provider_manage_instruction: string
  provider_manage_label: string
  provider_manage_label_placeholder: string
  provider_manage_url_placeholder: string
  provider_manage_disable_auto_url: string
  provider_manage_request_format: string
  provider_manage_test_connection: string
}

const PRODUCT_NAME = '幻友AI'
const SLOGAN = '跨越次元，只为见你'

const translations: Record<Language, Translations> = {
  en: {
    chub_title: 'Character Hub',
    chub_search_placeholder: 'Search by name...',
    chub_tags_placeholder: 'Tags...',
    chub_import: 'Import',
    chub_preview: 'Preview',
    chub_disclaimer: 'Disclaimer: Characters are owned and managed by',
    chub_import_book_hint_1: 'Optionally modify all the aspects of the memory book other than the image.',
    chub_import_book_hint_2: 'The information provided here will be saved with the memory book on import.',
    chub_import_char_hint_1: 'Optionally modify all the aspects of the character other than the avatar.',
    chub_import_char_hint_2: 'The information provided here will be saved with the character on import.',
    chub_import_char_name_label: 'Character Name',
    chub_import_char_name_helper: 'Override the name of the character here',
    chub_import_char_optional: '(Optional)',
    chub_import_char_greeting: 'Greeting',
    chub_import_char_scenario: 'Scenario',
    chub_import_char_sample_chat: 'Sample Chat',
    chub_import_char_persona: 'Persona',
    chub_filter_nsfw_label: 'NSFW',
    chub_filter_nsfw_helper: 'Allow NSFW characters/lorebooks to appear in results.',
    chub_filter_query_tags_label: 'Query Tags',
    chub_filter_query_tags_helper: 'A comma-separated list of tags to include.',
    chub_filter_exclude_tags_label: 'Exclude Tags',
    chub_filter_exclude_tags_helper: 'A comma-separated list of tags to exclude.',
    chub_filter_sort_label: 'Sort By',
    chub_invalid_tavern_image: 'Invalid tavern image',
    chub_sort_default: 'Default',
    chub_sort_trending: 'Trending',
    chub_sort_favorites: '# Favorites',
    chub_sort_random: 'Random',
    chub_sort_rating: 'Rating',
    chub_sort_updated: 'Updated',
    chub_sort_popularity: 'Popularity',
    chub_sort_created: 'Created',
    chub_sort_name: 'Name',
    chub_sort_tokens: '# Tokens',
    chub_sort_ratings: '# Ratings',
    chub_error_importing: 'Error importing {name}! {error}',
    chub_filter_tags_placeholder: 'E.g. blue_archive,female,anime',
    product_name: 'HuanYou AI',
    product_slogan: 'Beyond Dimensions, Just to See You',

    welcome: 'Welcome',
    login: 'Login',
    register: 'Register',
    language: 'Language',
    close: 'Close',
    cancel: 'Cancel',
    confirm: 'Confirm',
    ok: 'OK',
    yes: 'Yes',
    no: 'No',
    edit: 'Edit',
    editing: 'Editing',
    update: 'Update',
    save: 'Save',
    copy: 'Copy',
    search: 'Search',
    voice: 'Voice',

    // Time
    time_seconds: '{count} seconds',
    time_second: '{count} second',
    time_minutes: '{count} mins',
    time_minute: '{count} min',
    time_hours: '{count} hours',
    time_hour: '{count} hour',
    time_days: '{count} days',
    time_day: '{count} day',
    time_aMoment: 'a moment',
    time_unknown: 'unknown',
    time_ago: '{duration} ago',

    welcomeTitle: `Welcome to ${PRODUCT_NAME}`,
    welcomeMessage: SLOGAN,
    welcomeDisclaimer: 'This platform does not provide services to users in mainland China. Please confirm that you are 18 years old and not using this platform in mainland China.',
    welcomeContentWarning: 'All interactive content is AI-generated. Please do not easily believe or be misled, and do not guide AI to generate non-compliant content.',
    termsAgreement: 'I am 18 years old and agree to the',
    termsLink: 'user terms',
    ageConfirmation: 'I am 18 years old and agree to the user terms',
    createCharacter: 'Create Character',
    importCharacter: 'Import Character',
    characters: 'Characters',
    lorebooks: 'Lorebooks',
    creativeWorkshop: 'Creative Workshop',
    personalCenter: 'Personal Center',
    chatHistory: 'Chat History',
    trending: 'Trending',
    memoryFragments: 'Memory Fragments',
    menu: 'Menu',
    library: 'Library',
    lib_memories: 'Memories',
    lib_scenarios: 'Scenarios',
    lib_templates: 'Templates',
    lib_embeddings: 'Embeddings',
    login_remote_error_not_logged_in: 'Error - You are not currently logged in.',
    login_remote_missing_callback: 'Missing callback from query parameters.',
    login_remote_failed: 'Failed: {error}',
    login_remote_request_access: `An application is requesting to access your ${PRODUCT_NAME} account on your behalf`,
    login_remote_application_access: 'The application will be able to access your profile name, avatar, characters, and presets.',
    login_remote_authorize: 'Authorize',
    login_remote_authorizing: 'Authorizing...',
    presets: 'Presets',
    settings: 'Settings',
    profile: 'Profile',
    chats: 'Chats',
    sounds: 'Sounds',
    manage: 'Manage',
    gen_presets_copy_preset: 'Copy preset {name}',
    gen_presets_edit_preset: 'Edit preset {name}',
    configuration: 'Configuration',
    users: 'Users',
    subscriptions: 'Subscriptions',
    announcements: 'Announcements',
    persona: 'Persona',
    faq: 'FAQ',
    termsOfService: 'Terms of Service',
    nav_home: 'Characters',
    nav_trends: 'Trending',
    nav_workshop: 'Workshop',
    nav_me: 'Me',
    home_tab_recommended: 'Recommended',
    home_tab_trending: 'Trending',
    home_tab_latest: 'Latest',
    home_tab_race: 'Race',
    home_filter_gender: 'Gender',
    home_filter_tags: 'Select Tags',
    char_card_original: 'Original',
    workshop_title: 'Workshop',
    workshop_my_characters: 'My Characters',
    workshop_create_character: 'Create Character',
    workshop_import_character: 'Import Character',
    trends_title: 'Trends',
    trends_latest: 'Latest',
    trends_follow: 'Follow',
    share_fragment_title: 'Share Conversation',
    share_fragment_select: 'Select messages to share',
    share_fragment_post: 'Post to Trends',
    share_fragment_success: 'Shared successfully!',
    char_visibility: 'Visibility',
    char_visibility_public: 'Public',
    char_visibility_unlisted: 'Unlisted',
    char_visibility_private: 'Private',
    profile_my_creations: 'My Creations',
    profile_my_favorites: 'My Favorites',
    profile_chat_history: 'Chat History',
    search_placeholder: 'Search characters, creators or tags...',
    trending_hot_keywords: 'Hot Keywords',
    trending_hot_tags: 'Hot Tags',
    trending_ranking: 'Ranking',
    trending_top10: 'TOP10',
    trending_top30: 'TOP30',
    trending_top50: 'TOP50',
    trending_daily: 'Daily',
    trending_weekly: 'Weekly',
    trending_monthly: 'Monthly',
    trending_views: 'Views',
    trending_likes: 'Likes',
    trending_favorites: 'Favorites',
    trending_chats: 'Chats',
    trending_author: 'Author',
    trending_author_ranking_title: 'Wealthy Ranking',
    trending_author_total: 'Total',
    trending_author_tips: 'Tips',
    trending_author_income: 'Income',
    privacyPolicy: 'Privacy Policy',

    // Profile / Subscription
    profile_checkout_success: 'Checkout Success',
    profile_checkout_thank_you: 'Thank you for subscribing!',
    profile_checkout_start_using: 'Start using your subscription by creating and using an {name} preset.',
    profile_checkout_close_window: 'Close Window',
    profile_checkout_cancelled: 'Checkout Cancelled',
    profile_checkout_cancelled_msg: 'Your attempt to subscribe was cancelled. You have not been charged.',
    profile_sub_valid_until: 'Valid until',
    profile_sub_patreon_subscriber: 'Patreon Subscriber',
    profile_sub_cancels_at: 'Cancels at',
    profile_sub_renews_at: 'Renews at',
    profile_sub_why_title: 'Why subscribe?',
    profile_sub_why_msg_1: 'Subscribing grants you access to higher quality models, quicker responses, and larger contexts.',
    profile_sub_why_msg_2: "In the future you'll also have access to additional features! Such as: voice generation, image storage, and with integration third-party apps like Discord, Slack, and WhatsApp, and more!",
    profile_sub_why_msg_3: `Subscribing allows me to spend more time developing and enhancing ${PRODUCT_NAME}.`,
    profile_sub_support_contact: 'If you require billing or subscription support contact',
    profile_sub_view_models: 'View Available Models',
    profile_sub_current_title: 'Current Subscription',
    profile_sub_update_payment: 'Update Payment Method',
    profile_sub_via: 'Subscribed via',
    profile_sub_via_gift: 'Gift',
    profile_sub_via_patreon: 'Patreon',
    profile_sub_via_stripe: 'Stripe',
    profile_sub_via_none: 'None',
    profile_sub_set_to_downgrade: 'Your subscription is set to downgrade',
    profile_sub_cancel_downgrade: 'Cancel Downgrade',
    profile_sub_scheduled_to_cancel: 'Your subscription is currently scheduled to cancel',
    profile_sub_resume: 'Resume Subscription',
    profile_sub_enjoy: 'Enjoy!',
    profile_sub_subscribed: 'Subscribed!',
    profile_sub_options: 'Subscription Options',
    profile_sub_patreon_msg: 'Become a Patron and link your account or use the options below',
    profile_sub_gifted_to_you: 'This tier is currently gifted to you',
    profile_sub_login_to_subscribe: 'Login to Subscribe',
    profile_sub_upgrade: 'Upgrade',
    profile_sub_downgrading: 'Downgrading...',
    profile_sub_downgrade: 'Downgrade',
    profile_sub_resubscribe: 'Re-subscribe',
    profile_sub_subscribe: 'Subscribe',
    profile_sub_prices_usd: 'All prices are in USD',
    profile_sub_unsubscribe: 'Unsubscribe',
    profile_sub_confirm_unsubscribe: 'Are you sure you wish to unsubscribe?',
    profile_sub_upgrade_charge_msg: 'You will be immediately charged upon confirm.',
    profile_sub_confirm_upgrade: 'Are you sure you wish to upgrade now?',
    profile_sub_downgrade_affect_msg: 'Your downgrade will take affect at the beginning of your next billing period. You will retain access to your current subscription tier until your downgrade takes affect.',
    profile_sub_confirm_downgrade: 'Are you sure you wish to downgrade?',
    profile_sub_per_mo: '/mo',
    profile_sub_or: 'or',

    // Prompt Templates
    prompt_templates_title: 'Prompt Templates',
    prompt_templates_new_template: 'Template',
    prompt_templates_no_templates: 'You have no prompt templates saved',
    prompt_templates_builtin: 'Built-in Templates',
    prompt_templates_updated: 'Template updated',
    prompt_templates_created: 'Template created',
    prompt_templates_name: 'Name',

    // Saga
    saga_help_link: 'Saga Template Help',
    saga_preview_title: 'Preview: Sagas',
    saga_preview_msg: 'This is a preview of "Sagas". These are open ended text-based adventures made by users.',
    saga_new_template: 'New Template',
    saga_untitled_template: 'Untitled Template',
    saga_menu_prompts: 'Prompts',
    saga_menu_preset: 'Preset',
    saga_menu_help: 'Help',
    saga_session_saved: 'Session saved',
    saga_btn_restart: 'Restart',
    saga_btn_start: 'Start',
    saga_btn_new: 'New',
    saga_btn_load: 'Load',
    saga_btn_save: 'Save',
    saga_btn_reimage: 'Re-image',
    saga_tab_template: 'Template',
    saga_tab_session: 'Session',
    saga_current_template: 'Current Template',
    saga_load_template: 'Load Template',
    saga_field_name: 'Name',
    saga_field_format: 'Format',
    saga_field_init_template: 'Initial Template',
    saga_field_init_template_helper: 'For generating the initial values for your introduction.',
    saga_field_intro_format: 'Introduction Format',
    saga_field_intro_format_helper: 'How to format your introduction. .\n\nYou can use any field derived from your **Initial Template**.',
    saga_field_display_format: 'Response Display Format (Optional)',
    saga_field_display_format_helper: 'How to display responses for **display** (Uses **Response Prompt Format** if empty)\nYou can use any field derived from your templates.',
    saga_field_image_prompt: 'Prompt Template for Image Generation',
    saga_field_image_prompt_helper: 'Leave empty to disable image generation',
    saga_field_history_template: 'History Template',
    saga_field_history_template_helper: 'Use **{{history}}** in the game loop template',
    saga_field_loop_template: 'Game Loop Template',
    saga_field_loop_template_helper: 'Use **{{input}}** to use the user input',
    saga_manual_fields: 'Manual Fields',
    saga_manual_fields_helper: 'These fields are required to be filled out by you',
    saga_fields: 'Fields',
    saga_fields_helper: '**Toggle**: Controls whether the field appears in the chat window.\n**Label**: When enabled, how the field will be named in the chat window.\n**Value**: Override the value instead of generating it.',
    saga_lists: 'Lists',
    saga_add_items: 'Add items...',
    saga_required_value: '(Required) value',
    saga_optional_value: '(Optional) value',
    saga_guidance_title: 'Guidance',
    saga_import_success: 'Successfully imported template',
    saga_import_title: 'Import Template',
    saga_import_json_label: 'Template JSON',

    // Scenario
    scenario_title: 'Scenarios',
    scenario_import: 'Import Scenario',
    scenario_create: 'Create Scenario',
    scenario_no_scenarios: 'You have no scenarios yet.',
    scenario_unnamed: 'Unnamed Scenario',
    scenario_edit_title: 'Edit Scenario',
    scenario_btn_duplicate: 'Duplicate',
    scenario_btn_download: 'Download',
    scenario_btn_delete: 'Delete',
    scenario_no_events: 'No events attached to this scenario',
    scenario_events_count: 'event(s)',
    scenario_details_title: 'Scenario Details',
    scenario_field_name_helper: 'The name of your scenario.',
    scenario_field_desc: 'Description',
    scenario_field_desc_helper: 'More information about your scenario.',
    scenario_field_prompt: 'Prompt Text',
    scenario_field_prompt_helper: 'Optional. Additional text to add to the scenario prompt.',
    scenario_field_overwrite: "Overwrite character's scenario",
    scenario_field_overwrite_helper: 'If the character already has a scenario, overwrite it with this one. Otherwise, append to it.',
    scenario_field_instructions: 'User Instructions',
    scenario_field_instructions_helper: 'Optional. Text to display to the user to help them understand how to use this scenario.',
    scenario_confirm_delete: 'Are you sure you wish to delete this scenario?',
    scenario_download_title: 'Download Scenario',
    scenario_event_type_hidden: 'Hidden (not shown to the user)',
    scenario_event_type_world: 'World (shown, external to the character)',
    scenario_event_type_character: 'Character (shown, thought or action by the character)',
    scenario_event_type_ooc: 'Out Of Character (only visible by the user)',
    scenario_trigger_greeting: 'Greeting',
    scenario_trigger_manual: 'Manual Trigger',
    scenario_trigger_opened: 'Chat Opened',
    scenario_trigger_received: 'Message Received',
    scenario_states_used: 'States Used',
    scenario_states_used_helper: 'The states you have used in your events so far',
    scenario_events_title: 'Events',
    scenario_btn_create_event: 'Create Event',
    scenario_no_events_msg: 'You have no events yet.',
    scenario_event_name_placeholder: 'Event name, e.g. "Greeting"',
    scenario_field_trigger: 'Trigger',
    scenario_field_req_states: 'Required States',
    scenario_field_req_states_helper: 'Which state(s) are required before this event can be triggered.',
    scenario_field_req_states_placeholder: 'States required to trigger',
    scenario_field_assign_states: 'States to Assign',
    scenario_field_assign_states_helper: 'When triggered, which states will be assigned to the chat',
    scenario_field_assign_states_placeholder: 'States to add when triggered',
    scenario_field_event_type: 'Type',
    scenario_field_event_type_helper: 'How will this event be shown to the user.',
    scenario_field_event_prompt_helper: 'The prompt text to send whenever this event occurs. The (OOC: something) text will be hidden from the user.',
    scenario_event_greeting_msg: 'Automatically sent when starting a new chat.',
    scenario_field_probability: 'Probability',
    scenario_field_probability_helper: 'Manual triggers will be randomly selected, with higher probability for higher values.',
    scenario_field_after_hours: 'After (hours)',
    scenario_field_after_hours_helper: 'After how many hours should this trigger be activated? The longest trigger will be selected.',
    scenario_field_after_messages: 'After (messages since last event)',
    scenario_field_after_messages_helper: 'After how many message should this trigger be activated? The shortest trigger will be selected.',
    scenario_btn_update: 'Update',
    scenario_help_title: 'Scenario Events Help',
    scenario_help_triggers_msg: 'Events are triggers when:',
    scenario_help_greeting_msg: 'The very first time the user starts a chat',
    scenario_help_manual_msg: 'When the user uses the Trigger Event menu in the chat',
    scenario_help_opened_msg: 'When the user opens a chat with a character after some time',
    scenario_help_received_msg: 'When the character writes something',
    scenario_help_prompt_msg: 'Whenever an event is triggered, a prompt will be sent to the character.',
    scenario_help_world_msg: 'The event will be shown as if something happened independently of the character.',
    scenario_help_character_msg: 'The event will be shown as if the character wrote it, for example if the character does something.',
    scenario_help_hidden_msg: 'The event will be hidden from the user. This is useful to make the character do something, and make it look like it was on their own initiative.',
    scenario_help_ooc_msg: 'The event will be hidden from the character. This is useful to give information or clues to the user.',
    scenario_help_processing_msg: 'The prompt text will have processing.',
    scenario_help_placeholders_msg: 'The {{char}} and {{user}} placeholders will be replaced',
    scenario_help_ooc_processing_msg:
      'Any text with (OOC: TEXT) will be hidden from the user, so you can add additional instructions for the character.',
    scenario_help_asterisks_msg:
      'It is recommended to wrap your text in *asterisks* unless you want the character to say the prompt text.',
    scenario_help_states_msg:
      'Finally, you can use the states to control which events are triggered under which conditions. The chat will keep track of a list of states, which can be assigned by events.',
    scenario_help_req_states_msg:
      'Required states are states that must exist in the chat to allow the trigger to run. You can also prefix a required state by ! to require the state not to exist in the chat for the event to run. You can specify multiple states by separating them with a comma.',
    scenario_help_assign_states_msg:
      'Assigned states are states that will be added to the chat whenever the event is triggered. You can also prefix an assigned state by ! to remove the state from the chat. You can specify multiple states by separating them with a comma.',
    scenario_help_random_msg: 'When multiple events can run, they will be randomly selected.',
    scenario_import_error_json: 'File was not a valid JSON',
    scenario_import_error_schema: 'File was not a supported scenario (incorrect schema)',
    scenario_import_error_invalid: 'Invalid scenario',
    scenario_import_json_label: 'Scenario JSON File',
    scenario_import_supported_formats: 'Supported formats: HuanYouAI',

    // Generation Presets
    gen_presets_title: 'Generation Presets',
    gen_presets_new_preset: 'New Preset',
    gen_presets_load_preset: 'Load Preset',
    gen_presets_save_preset: 'Save Preset',
    gen_presets_import_preset: 'Import Preset',
    gen_presets_delete_preset_confirm: 'Are you sure you wish to delete this preset?',
    gen_presets_name_label: 'Name',
    gen_presets_name_helper: 'A name or short description of your preset',
    gen_presets_name_placeholder: 'Preset name',
    gen_presets_id_label: 'ID',
    gen_presets_new_preset_id: 'New Preset',
    gen_presets_builtin_warning: 'This is a built-in preset and cannot be saved.',
    gen_presets_copy_click_here: 'Click here',
    gen_presets_copy_helper_text: "if you'd like to create a copy of this preset.",
    gen_presets_select_preset_helper: "Select a preset to start editing. If you are currently editing a preset, it won't be in the list.",
    gen_presets_filter_placeholder: 'Filter...',
    gen_presets_providers_tab: 'Providers',
    gen_presets_presets_tab: 'Presets',
    gen_presets_new_button: 'New',
    gen_presets_import_button: 'Import',
    gen_presets_preset_json_label: 'Preset JSON',
    gen_presets_imported: 'Imported',
    gen_presets_imported_preset: 'Imported Preset',
    gen_presets_invalid_preset: 'Preset is not valid',
    gen_presets_could_not_parse: 'Could not parse preset',

    // Additional UI
    nav_charHub: 'CharHub',
    nav_sagasPreview: 'Sagas Preview',
    nav_imageGeneration: 'Image Generation',
    nav_toggleTheme: 'Toggle between light and dark mode',
    nav_newNotifications: 'Status: You have {count} new notifications',
    nav_noNotifications: 'Status: No new notifications',
    nav_subscribeCTA: 'Subscribe for higher quality chats and no ads',
    home_modelsTitle: 'Models',
    home_modelsMessage: 'HuanYouAI now hosts its own models! Get started for free by using the Agnaistic service in your presets',
    home_browserNoStorage: 'Your browser does not support local storage. You will need to login/register to use Agnaistic.',
    home_officialGuides: 'Official Guides',
    chat_forkConversation: 'Fork Conversation',
    chat_forkConfirm: 'Forking from here will delete all messages after this one. Do you wish to continue?',
    chat_user_handle_you: 'You',
    chat_user_anon_name: 'User {id}',
    chat_bot_label: 'Bot: {name}',
    chat_profile_label: 'Profile: {handle}',
    chat_ago: '{duration} ago',
    chat_confirm_discard: 'Discard',
    chat_thinking: 'Thinking...',
    chat_reasoning_thought: 'Thought',
    chat_option_prompt: 'Prompt',
    chat_option_edit: 'Edit',
    chat_option_fork: 'Fork',
    chat_option_regen: 'Regenerate',
    chat_option_attach: 'Attach',
    chat_option_visibility: 'Visibility',
    chat_option_delete: 'Delete',
    chat_option_gen_image: 'Gen Image',
    chat_option_gen_json: 'Gen JSON',
    chat_option_export: 'Export',
    chat_removed_from_convo: 'You have been removed from the conversation',
    chat_unnamed_preset: 'Unnamed Preset',
    admin_notYetImplemented: 'Not yet implemented',
    admin_noSubscriptionId: 'No subscription ID',
    admin_session: 'Session:',

    recentConversations: 'Recent Conversations',
    startConversation: 'Start Conversation',
    guides: 'Guides',
    links: 'Links',
    gettingStarted: 'Getting Started',
    createACharacter: 'Create a Character',
    configureYourAIServices: 'Configure your AI Services',
    officialGuides: 'Official Guides',
    memoryBook: 'Memory Book',
    agnaisticDiscord: 'HuanYouAI Discord',
    github: 'GitHub',
    notableFeatures: 'Notable Features',
    lookingForHelp: 'Looking for help with getting started?',
    checkOutThe: 'Check out the',
    officialGuide: 'Official Guide',
    orHeadToThe: 'or head to the',

    // Guides
    guide_memory_title: 'Memory Books',
    guide_memory_text: `## What is it?

Memory books are a way to dynamically provide context to your characters as you talk with them. Instead of filling up your entire context budget with your \`Scenario\`, \`Persona\` and \`Sample Chat\`, you can use Memory Books instead.

## How does it work?

When you create a **Memory Entry**, you provide: \`keywords\` and the \`entry\` text.  
You can also provide \`priority\` and \`weight\`, but we'll get to that later.

- Keywords:
  - These are words that "trigger" the memory to be inserted into your prompt.
  - E.g. \`drink, thrist, hydrate, hydrate\`
- Entry:
  - This is the text that is inserted into your prompt when one of your keywords is found.
  - E.g. \`{{user}}'s favourite drink is red cordial on the rocks\`

Your generation settings will have a **Memory Depth**. This is the maximum number of chat messages that Agnai will scan for keywords.  
It is important to remember this all happens in your browser.

### Why is it important to remember this occurs in the browser?

_Note: This does not apply to anonymous/guest users. Guest users always have the entire chat history available for prompt building._

If you configure your memory depth above \`100\`, the keywords may not trigger as you expect them to.
When you initially load your chat, you will be sent a maximum of 100 messages from the server. You can continue to scroll up to retrieve more messages.

## What are priority and weight?

In a nutshell, these two values are used to determine which memories to include in your memory budget (\`memory context limit\`) and in what order they appear in the prompt.

### Priority

The higher this value is, the more "important" it is. To evalulate which memories we will include in the prompt:

- We sort the memories by priority
- We add the memories one by one to the prompt until the budget is full

### Weight

The higher this value is, the further toward the bottom of the memory prompt the memory will be.  
The theory is: the further toward the bottom of the prompt something is, the more important it is when generating a response.

After the memories have been "pruned" to fit inside the budget the memories and then sorted by weight.

## What memory generation settings do you recommend?

At the moment I have no idea. I would be very interested to hear your experiences as you experiment with them.

The generation settings available to play with are: \`depth\` and \`contextLimit\`.

- **Depth**: This is the maximum number of chat messages to scan for keywords.
- **Context Limit**: This is the maximum number of tokens that the memory prompt will consume from your "Max Context Length".`,
    guide_novel_title: 'NovelAI Guide',
    guide_novel_text: `# Novel Instructions

There are two methods to setup NovelAI:

**Get the persistent API token from the NovelAI site.**

1. Login to [NovelAI](https://novelai.net/stories)
2. Open your User Settings and go to the Account tab
3. Press the Get Persistent API Token button
4. Copy (use the clipboard button)/paste the resulting token into the \`Novel API Key\` field in your [NovelAI Settings Page](https://agnai.chat/settings?tab=ai&service=novelai)

The API Key will look something like this:

\`\`\`
pst-ykHYhtDti6ZYYmgCtUnhYraECciZQCEVMGhhh4HUgRf7XLQGzeDinQtCRECZJXWE
\`\`\`

or

**Manually retrieve your token from the NovelAI site using the Developer Tools.**

1. Login to [Novel AI](https://novelai.net/stories)
2. Open the Developer Tools using one of the following methods:

   - \`Ctrl + Shift + I\`
   - Right click the page --> Click _Inspect_

3. Open the \`Console\` tab and type:

- \`console.log(JSON.parse(localStorage.getItem('session')).auth_token)\`

4. Copy/paste the resulting output into the \`Novel API Key\` field in your [NovelAI Settings Page](/settings?tab=ai&service=novelai)

The API Key will look something like this:

\`\`\`
eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6Ii4uLiIsImlhdCI6MTUxNjIzOTAyMn0.pCVUFONBLI_Lw3vKQG6ykCkuWNeG4cDhdEqRO_QJbh4
\`\`\`

Please note that this token will periodically expire and will require replacement once every month. It is preferred to use the persistent API token.`,
    guide_pipeline_title: 'Pipeline Guide',
    guide_pipeline_subtitle: 'How to install and use the Agnai Pipeline API',
    guide_pipeline_text: `### What is the Pipeline API?
The Pipeline API allows you to run additional features to enhance your conversations. 
Agnai.chat and local hosted conversations are both supported.
At the moment, only Embedding support using ChromaDB is currently available.

### What are embeddings?
Embeddings are similar to Memory Books, but more sophisticated. Instead of using simple "keyword" matching, they use a technique called "semantic similarity".
This means the results are based on the "likeness or closeness of their meaning". Your message is used to query entire body of text and the results are the "closest in meaning".
This means we can do things like:
- Use the last message to "jog the memory" of the AI and recall parts of the conversation that no longer fit in the prompt.
- Pass relevant parts of a PDF or article to the AI to provide meaningful responses based on that information.

### How do I install and run the Pipeline?
- You'll need [Node.JS v16+](https://nodejs.org/en/download) and [Python 3.10+](https://www.python.org/downloads/) installed.  
- Install Agnaistic using the NPM Package. From your terminal: \`npm install agnai -g \`
- Run \`agnai --pipeline\` from your terminal

### How do I now use the Pipeline?
- Head to your \`Settings -> AI Settings\` and enable "Use Local Pipeline" and hit Save.
- If your Pipeline is successfully connected, you will see a notification and a green Signal bar next to \`Memory\` in the main menu.
- If the Pipeline disconnects, you can click the Power icon next to \`Memory\` in the menu.

### How do I create and use Embeddings?
- In your \`Chat Options -> Memory\` modal, you can create embeddings from Wikipedia Articles or PDFs. This can also be done from the \`Memory -> Embeddings\` page.
- Once created, choose the Embedding from dropdown in the Memory modal and click \`Use Embedding\`.


The \`{{user_embed}}\` placeholder will automatically be injected into your prompt if you provide embedding information.
You can also manually add this to the \`{{user_embed}}\` placeholder to your template.`,

    home_faq_title: 'FAQ',
    home_faq_subtitle: 'Frequently Asked Questions',
    home_faq_content: `### Are my responses filtered?
No, HuanYouAI does not make any attempt to filter your responses.

### The response from the character keeps getting cut off mid-sentence. What can I do?
There are a few things you can try:
- In your **Preset Settings** increase your \`Max Tokens\`.
- If you're using **Horde**, make sure your \`Max Tokens\` isn't "too high". In your **Settings -> Horde Settings** you can click \`Select Workers\` to view the "Context and Token" limits of each worker. Ensure your \`Max Tokens\` does not exceed their token limit.

### How can I have multiple profiles or change my name in the chat?
This is accomplished by **impersonating a character**. To impersonate, click on your Avatar/Name in the main menu.

### Can I have multiple users and characters in my chat?
Yes. In your **Chat Options**, you can add characters and invite users from **Participants**.

### Can I edit or delete my chat messages?
Yes. In the **Chat Options** enable *Chat Editing* and extra buttons will appear in your chat messages.

### My response was cut off mid-sentence, can I continue it?
Yes. In the **Input Options** you can choose to *Generate More*.

### Can I generate images based on my conversation?
Yes, you can configure image generation in your **Settings -> Image Settings**.
When you specify the Web URL, make sure it is *publicly accessible* using a service like Local Tunnel or NGrok.

### Do you support Text-to-Speech?
Yes, In your **Settings -> Voice Settings** we support a variety of text-to-speech services.

### Can I customise the UI?
Yes, you can change some elements of Agnaistic in your **Settings -> UI Settings**.

### I came from "some other site", how can I get my bot to talk like it was on that site?
All frontends behave a little differently. You can tweak how your character behaves by modifying your **Prompt Template** in your **Preset**.

### I forgot my password!
Recovering your account is not guaranteed. You can try to contact Sceik on [Discord](https://discord.agnai.chat) to try to recover your account.

### My question isn't answered here, where should I ask?
The best place to get a quick answer is on [Discord](https://discord.agnai.chat).

### Glossory / Terminology:
- **Input Options**: Accessed from the Right hand side (three-dot menu) of your chat text input.
- **Chat Options**: Accessed from your Top Right of your chat window.
- **Settings**: Accessed from the Settings link in the main menu.
- **AI Settings**: Available in your Settings page.
- **Prompt**: This is the body of text sent to your AI service to generate a response.
- **Max Context Length**: The maximum size of the prompt to send to your AI service.
- **Max Tokens**: The maximum amount of tokens to receive in response from your AI service.
- **Preset**: Also known as **Generation Settings**. This controls:
    - Which AI service you use
    - The format/shape of your *Prompt*
    - *Maximum Context Length* and *Max Tokens*
    - "Generation settings" such as "temperature", "repetition penalty", etc.`,
    maxNewTokens: 'Max New Tokens',
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    displayName: 'Display Name',
    passwordsDoNotMatch: 'Passwords do not match',
    invalidCallbackUrl: 'Invalid callback URL',
    loggingIn: 'Logging in...',
    registering: 'Registering...',
    welcomeToAccount: 'Welcome',
    authorizing: 'Authorizing',
    youAreAlreadyLoggedIn: 'You are already logged in.',
    toYourAccount: 'to your account',
    orContinueAsGuest: 'or continue as a guest.',
    failedToLogIn: 'Failed to log in.',
    somethingWentWrong: "Something went wrong.",
    couldNotReachServers: "We couldn't reach our servers.",
    byLoggingIn: 'By logging in or registering, you agree that you are 18 years or older and agree to the',
    youAgree: 'you agree',
    and: 'and',
    whyRegister: 'Why register?',
    youDontNeedToRegister: "You don't need to register to use HuanYouAI. You can use it anonymously and no data will be stored on any servers.",
    ifYouChooseToRegister: 'If you choose to register',
    yourDataWillBeStored: 'your data will be stored and accessible on any devices you login with.',

    // Admin
    admin_serverConfiguration: 'Server Configuration',
    admin_general: 'General',
    admin_images: 'Images',
    admin_voice: 'Voice',
    admin_supportEmail: 'Support Email',
    admin_supportEmailHelper: 'If provided, a link to this email will be added to the main navigation',
    admin_maintenanceModeEnabled: 'Maintenance Mode Enabled',
    admin_maintenanceModeHelper: 'Caution: If your database is no available, this flag will not work. Use the environment variable instead.',
    admin_maintenanceMessage: 'Maintenance Message',
    admin_maintenanceMessageHelper: 'Markdown is supported',
    admin_stripeCustomerPortal: 'Stripe Customer Portal',
    admin_lockDuration: 'Lock Duration (seconds)',
    admin_lockDurationHelper: 'Maximum TTL of user-level lock - Set to zero (0) to disable',
    admin_googleClientId: 'Google Client ID',
    admin_googleClientIdHelper: 'Used for Sign In',
    admin_slotsConfiguration: 'Slots Configuration',
    admin_slotsConfigurationHelper: 'Must be JSON. Merged with remote slots config -- This config overrides slots.txt',
    admin_format: 'Format',
    admin_enablePolicies: 'Enable Policies',
    admin_enablePoliciesHelper: 'Display TOS and Privacy Statements',
    admin_privacyStatement: 'Privacy Statement',
    admin_apiAccessLevel: 'API Access Level',
    admin_off: 'Off',
    admin_allUsers: 'All Users',
    admin_subscribers: 'Subscribers',
    admin_administrators: 'Administrators',
    admin_maxGuidanceTokens: 'Max Guidance Tokens',
    admin_maxGuidanceTokensHelper: 'Max number of tokens a saga/guidance template can request. Set to 0 to disable.',
    admin_maxGuidanceVariables: 'Max Guidance Variables',
    admin_maxGuidanceVariablesHelper: 'Max number of variables a saga/guidance template can request. Set to 0 to disable.',
    admin_imagesHost: 'Images Host (A1111 Compatible)',
    admin_imagesLoraUrl: 'Images LoRA URL',
    admin_defaultImageModel: 'Default Image Model',
    admin_imageModels: 'Image Models',
    admin_add: 'Add',
    admin_addModel: 'Add Model',
    admin_description: 'Description',
    admin_modelDescriptionPlaceholder: 'Model Description...',
    admin_url: 'URL',
    admin_loraSupport: 'LoRA Support',
    admin_host: 'Host',
    admin_modelNamePlaceholder: 'Model Name...',
    admin_override: 'Override',
    admin_level: 'Level',
    admin_prefix: 'Prefix',
    admin_suffix: 'Suffix',
    admin_negative: 'Negative',
    admin_steps: 'Steps',
    admin_init: 'Init',
    admin_max: 'Max',
    admin_cfgScale: 'CFG Scale',
    admin_width: 'Width',
    admin_height: 'Height',
    admin_clipSkip: 'Clip Skip',
    admin_voiceAccessLevel: 'Voice Access Level',
    admin_voiceHost: 'Voice Host',
    admin_voiceHostHelper: 'Full URL with Path - Include any query parameters',
    admin_voiceApiKey: 'Voice API Key',
    admin_metrics: 'Metrics',
    admin_refresh: 'Refresh',
    admin_onlineUsers: 'Online Users',
    admin_versions: 'Versions',
    admin_maxOnlineUsers: 'Max Online Users',
    admin_registeredUsers: 'Registered Users',
    admin_services: 'Services',
    admin_messageAllUsers: 'Message All Users',
    admin_send: 'Send',
    admin_confirmMessageAll: 'Are you sure you wish to send a message to all users?',
    admin_userManagement: 'User Management',
    admin_backToManage: 'Back to Manage',
    admin_customerId: 'Customer ID',
    admin_subscribed: 'Subscribed',
    admin_search: 'Search',
    admin_reset: 'Reset',
    admin_info: 'Info',
    admin_impersonate: 'Impersonate',
    admin_changePassword: 'Change Password',
    admin_banUser: 'Ban User',
    admin_unbanUser: 'Unban User',
    admin_userId: 'User ID',
    admin_banned: 'Banned',
    admin_handle: 'Handle',
    admin_subscriptionDetails: 'Subscription Details',
    admin_gift: 'Gift',
    admin_expiry: 'Expiry',
    admin_apply: 'Apply',
    admin_assignSub: 'Assign Sub',
    admin_stripeSubscriptionId: 'Stripe Subscription ID',
    admin_assign: 'Assign',
    admin_sessionIds: 'Session IDs',
    admin_subscriptionLevel: 'Subscription Level',
    admin_native: 'Native',
    admin_manual: 'Manual',
    admin_periodStart: 'Period Start',
    admin_renewsAt: 'Renews at',
    admin_downgradingAt: 'Downgrading at',
    admin_cancelledAt: 'Cancelled at',
    admin_cancelsAt: 'Cancels at',
    admin_state: 'State',
    admin_history: 'History',
    admin_noReasonGiven: 'No reason given',
    admin_banReason: 'Ban Reason',
    admin_resetLink: 'Reset Link',
    admin_generateLink: 'Generate Link',
    admin_manageAnnouncements: 'Manage Announcements',
    admin_created: 'Created',
    admin_hide: 'Hide',
    admin_unhide: 'Unhide',
    admin_delete: 'Delete',
    admin_instructions: 'Instructions',
    admin_deleted: 'Deleted',
    admin_hidden: 'Hidden',
    admin_pending: 'Pending',
    admin_active: 'Active',
    admin_announcement: 'Announcement',
    admin_title: 'Title',
    admin_displayAtRequired: '"Display At" is required',
    admin_errorProductNotFound: 'Product not found: {id}',
    admin_errorProductNoPrice: 'Product has no default price: {id}',
    admin_errorPriceNotFound: 'Price not found: {id}',
    admin_location: 'Location',
    admin_home: 'Home',
    admin_notification: 'Notification',
    admin_locationHelper: 'Appear on the homepage or notifications list',
    admin_userLevelThreshold: 'User Level (Threshold)',
    admin_userLevelThresholdHelper: 'Announce to users with a tier level or greater `All Users = -1` `Subscribed = 0`',
    admin_content: 'Content',
    admin_hideAnnouncement: 'Hide Announcement',
    admin_displayAt: 'Display At',
    admin_now: 'Now',
    admin_id: 'ID',
    admin_name: 'Name',
    admin_apiAccessCapable: 'API Access Capable',
    admin_guidanceAccessCapable: 'Guidance (V2) Access Capable',
    admin_imagesAccessCapable: 'Image Generation Access',
    admin_patreonTier: 'Patreon Tier',
    admin_preview: 'Preview',
    admin_stripeProduct: 'Stripe Product',
    admin_enabled: 'Enabled',
    admin_disableSlots: 'Disable Slots',
    admin_subscriptionTier: 'Subscription Tier',
    admin_backToSubscriptions: 'Back to Subscriptions',
    admin_noPaymentRequired: 'No payment required',
    admin_descriptionHelper: 'This is be rendered using the markdown renderer. HTML is also supported here.',
    admin_apiAccessHelper: 'If enabled, this tier can use API access if the server allows it',
    admin_guidanceAccessHelper: 'If enabled, this tier can use GuidanceV2 if the server/preset allows it',
    admin_imagesAccessHelper: 'If enabled, this tier can use HuanYouAI Image Generation',
    admin_patreonTierHelper: 'If Patreon is linked, the minimum tier is required',
    admin_enabledHelper: 'If disabled, this tier will not be available to users for selection.',
    admin_disableSlotsHelper: 'This tier will prevent slots from rendering',
    admin_subscriptions: 'Subscriptions',
    admin_model: 'Model',
    admin_tier: 'Tier',
    admin_noTiers: 'No Tiers',
    admin_tiers: 'Tiers',
    admin_models: 'Models',
    admin_disabled: 'Disabled',
    admin_default: 'Default',
    admin_stripe: 'Stripe',
    admin_patreon: 'Patreon',
    admin_unset: 'Unset',
    admin_confirmDeleteSubscription: 'Are you sure you wish to delete this subscription?',
    admin_subscriptionModel: 'Subscription Model',
    admin_loadPreset: 'Load Preset',
    admin_newSubscription: 'New Subscription',
    admin_replaceSupercede: 'Replace/Supercede',
    admin_modelHelper: 'HuanYouAI service only',
    admin_modelServiceUrl: 'Model Service URL',
    admin_modelServiceUrlHelper: 'HuanYouAI service only',
    admin_guidanceCapable: 'Guidance Capable',
    admin_guidanceCapableHelper: 'HuanYouAI service only',
    admin_subscriptionDisabled: 'Subscription Disabled',
    admin_subscriptionDisabledHelper: 'Disable the use of this subscription',
    admin_isDefaultSubscription: 'Is Default Subscription',
    admin_isDefaultSubscriptionHelper: 'Is chosen as fallback when no subscription is provided with a request',
    admin_jsonSchemaCapable: 'JSON Schema Capable (Structured Responses)',
    admin_visionModel: 'Vision Model',
    admin_visionModelHelper: 'HuanYouAI service only',
    admin_allowGuestUsage: 'Allow Guest Usage',
    admin_allowGuestUsageHelper: 'Typically for default subscriptions. Require users to sign in to use this subscription.',
    admin_tokenizerOverride: 'Tokenizer Override',
    admin_tokenizerOverrideHelper: 'Optional. For use with custom models.',
    admin_confirmDeletePreset: 'Are you sure you wish to delete this preset?',
    admin_replaceSubscription: 'Replace Subscription',
    admin_replacementSubscription: 'Replacement Subscription',
    admin_replacementSubscriptionHelper: 'The subscription that will supercede the current subscription',
    admin_replace: 'Replace',
    admin_levels: 'Levels',
    admin_subLevel: 'Sub Level',
    admin_tokens: 'Tokens',
    admin_context: 'Context',
    admin_copySubscription: 'Copy subscription',
    admin_createSubscription: 'Create subscription',
    admin_editSubscription: 'Edit subscription',
    admin_selectAIServiceBeforeSaving: 'You must select an AI service before saving',
    admin_preset: 'Preset',
    admin_presetHelper: 'Select a preset to start editing. If you are currently editing a preset, it won\'t be in the list.',
    admin_apiKey: 'API Key',
    admin_apiKeyHelper: '(Optional) API Key for your AI service if applicable.',
    admin_apiKeyIsSet: 'API Key is set',
    admin_apiKeyIsNotSet: 'API Key is not set',
    admin_subscriptionLevelHelper: 'Anything above -1 requires a "subscription". All users by default are -1.',
    admin_replacementIdNotSet: 'Replacement ID not set',
    
    // Profile
    profile_myProfile: 'My Profile',
    profile_updateProfile: 'Update Profile',
    profile_impersonateNote: 'You can Impersonate characters by clicking the Persona button at the top of the main menu.',
    profile_linkGoogle: 'Link with Google to enable Sign-in with Google',
    profile_accountLinkedGoogle: 'Your account is Linked to Google',
    profile_unlinkGoogle: 'Unlink Google Account',
    profile_userIdHelper: 'Your user ID. This is used by others to send you chat invitations.',
    profile_usernameHelper: 'Your username. This cannot be changed. You never need to share your username.',
    profile_displayNameHelper: 'Your name in chats and to others (when not impersonating)',
    profile_profileImage: 'Profile Image',
    profile_removeAvatar: 'Remove Avatar',
    profile_fileSizeLimit2MB: 'File size limit of 2MB',
    profile_guestData: 'Guest Data',
    profile_prepareBackup: 'Prepare Backup',
    profile_backupNotReady: 'Backup Not Ready',
    profile_downloadGuestData: 'Download Guest Data',
    profile_unimpersonate: 'Unimpersonate',
    profile_logout: 'Logout',
    profile_deleteAccount: 'Delete Account',
    profile_importGuestDataWarning: 'This will REPLACE all of your existing guest data. Are you sure?',
    profile_importFailed: 'Import failed: {message}',
    profile_changePassword: 'Change Password',
    profile_changePasswordDescription: 'This window lets you change your account password',
    profile_updatePassword: 'Update your password',
    profile_newPassword: 'New Password',
    profile_confirmPassword: 'Confirm Password',
    profile_deleteAccountWarning: 'This is irreversible! Your account cannot be recovered if it is deleted.',
    profile_deleteAccountConfirmNote: 'Enter your username then click "Confirm" to confirm the deletion of your account',
    profile_confirmDeletion: 'Confirm Deletion',

    // Settings
    settings_title: 'Settings',
    settings_updateSettings: 'Update Settings',
    settings_thisCannotBeUndone: 'This cannot be undone!',
    settings_deleteGuestState: 'Delete Guest State',
    settings_ui_theme: 'Theme',
    settings_ui_chat: 'Chat',
    settings_ui_messages: 'Messages',
    settings_ui_color: 'Color',
    settings_ui_mode: 'Mode',
    settings_ui_dark: 'Dark',
    settings_ui_light: 'Light',
    settings_ui_siteFontSize: 'Site Font Size',
    settings_ui_backgrounds: 'Backgrounds',
    settings_ui_resetToDefault: 'Reset to Default',
    settings_ui_backgroundColor: 'Background Color',
    settings_ui_backgroundImage: 'Background Image',
    settings_ui_remove: 'Remove',
    settings_ui_font: 'Font',
    settings_ui_custom: 'Custom',
    settings_ui_responseHints: 'Response Hints',
    settings_ui_responseHintsHelper: 'Add a hint to your message to guide the response',
    settings_ui_avatarWrapAround: 'Avatar Wrap Around',
    settings_ui_avatarWrapAroundHelper: 'Allow text in messages to "wrap around" avatars',
    settings_ui_trimIncompleteSentences: 'Trim Incomplete Sentences',
    settings_ui_expandReasoning: 'Expand Reasoning by Default',
    settings_ui_expandReasoningHelper: 'Reasoning thoughts are collapsed by default. Enable this to expand them by default.',
    settings_ui_midReasoningBehavior: 'Mid-Reasoning Behavior',
    settings_ui_midReasoningBehaviorHelper: 'When reasoning is in the middle of a response, which utterance (i.e., non-thought) should be kept',
    settings_ui_anonymizeChat: 'Anonymize Chat',
    settings_ui_anonymizeChatHelper: 'Hide profile name in conversations. Typically for screenshots.',
    settings_ui_sendOnEnterOnMobile: 'Send on Enter on Mobile',
    settings_ui_sendOnEnterOnMobileHelper: 'Instead of adding a line break, "Enter" will send the message (Mobile only)',
    settings_ui_textSpeed: 'Text Speed',
    settings_ui_textSpeedHelper: 'Control the speed that text streams in. Set to `0` to disable.',
    settings_ui_viewMode: 'View Mode',
    settings_ui_viewModeHelper: 'Standard: Messages take up the entire chat screen. Split: Character\'s avatar appears at the top of the screen. Background: Character\'s avatar will become the Chat Background.',
    settings_ui_splitHeight: 'Split Height (%)',
    settings_ui_splitHeightHelper: 'Maximum height of the character\'s avatar when in split mode',
    settings_ui_standard: 'Standard',
    settings_ui_split: 'Split',
    settings_ui_backgroundAuto: 'Background: Auto',
    settings_ui_backgroundCover: 'Background: Cover',
    settings_ui_backgroundContain: 'Background: Contain',
    settings_ui_defaultAll: 'Default (All)',
    settings_ui_all: 'All',
    settings_ui_afterThought: 'After Thought',
    settings_ui_beforeThought: 'Before Thought',
    settings_ui_avatars: 'Avatars',
    settings_ui_size: 'Size',
    settings_ui_cornerRadius: 'Corner Radius',
    settings_ui_width: 'Width',
    settings_ui_height: 'Height',
    settings_ui_messageBackgroundColor: 'Message Background Color',
    settings_ui_botMessageBackgroundColor: 'Bot Message Background Color',
    settings_ui_chatTextColor: 'Chat Text Color',
    settings_ui_chatEmphasisColor: 'Chat Emphasis Color',
    settings_ui_chatQuoteColor: 'Chat Quote Color',
    settings_ui_chatQuoteEmphasisColor: 'Chat Quote Emphasis Color',
    settings_ui_chatQuoteEmphasisWeight: 'Chat Quote Emphasis Weight',
    settings_ui_contentWidth: 'Content Width',
    settings_ui_messageOpacity: 'Message Opacity',
    settings_ui_messageOpacityHelper: 'The opacity of the message block in the chat window.',
    settings_ui_inlineMessageOptions: 'Inline Message Options',
    settings_ui_inlineMessageOptionsHelper: 'Enable which message options appear \'inline\' in a message. The rest will reside in the \'more options\' drop menu',
    settings_ui_preview: 'Preview',
    settings_ui_none: 'None',
    settings_ui_bold: 'Bold',
    settings_ui_narrow: 'Narrow',
    settings_ui_large: 'Large',
    settings_ui_xlarge: 'X-Large',
    settings_ui_2xlarge: '2X-Large',
    settings_ui_3xlarge: '3X-Large',
    settings_ui_100: '100%',
    settings_ui_msg_edit: 'Edit',
    settings_ui_msg_regenerate: 'Regenerate',
    settings_ui_msg_promptView: 'Prompt View',
    settings_ui_msg_fork: 'Fork',
    settings_ui_msg_delete: 'Delete',
    settings_ui_msg_attach: 'Attach',
    settings_ui_msg_visibility: 'Visibility',
    settings_ui_msg_genImage: 'Gen Image',
    settings_ui_msg_genJson: 'Gen JSON',
    settings_ai_embeddings: 'Embeddings/Long-Term Memory',
    settings_ai_embeddingsHelper: 'Improves site performance when disabled. Disable long-term memory if your chat is laggy and unresponsive.',
    settings_ai_presets: 'Presets',
    settings_ai_chargen: 'Character Field Generation',
    settings_ai_useServerDefault: 'Use Server Default',
    settings_ai_chatSummary: 'Chat Summary',
    settings_ai_useActiveChatPreset: 'Use Active Chat Preset',
    settings_ai_jsonSchemas: 'JSON Schemas/Output',
    settings_ai_defaultPreset: 'Default Preset',
    settings_ai_defaultPresetHelper: 'The initially selected preset when creating a new chat.',
    settings_ai_apiAccessTitle: 'HuanYouAI API Access',
    settings_ai_howToUseApi: 'How to use API Access',
    settings_ai_apiAccessPreset: 'Default/API Access Preset',
    settings_ai_apiAccessPresetHelper: 'Preset used when using API access. Also the initially selected preset when creating a new chat.',
    settings_ai_apiKey: 'API Key',
    settings_ai_revealKey: 'Reveal Key',
    settings_ai_generateKey: 'Generate Key',
    settings_ai_regenerateKey: 'Regenerate Key',
    settings_ai_apiKeyHidden: 'API Key Hidden',
    settings_ai_lookingForProviders: 'Looking for the Providers section?',
    settings_ai_headToPresets: 'Head to the Presets page',
    settings_ai_editSummaryPreset: 'Edit Summary Preset',
    settings_ai_apiAccessHelp: 'The subscriber API endpoint uses the OpenAI Text Completion or OpenAI Chat Completion format.\n\nThe full URL for these endpoints are:\n- https://api.agnai.chat/v1/completions\n- https://api.agnai.chat/v1/chat/completions\n\nInstructions:\n1. Select your API Access Preset: This preset will be used for your API calls. Change this on your settings page.\n2. Generate your API Key.\n3. Use the API URL https://api.agnai.chat or https://api.agnai.chat/v1 and your generated API key.',
    settings_voice_sttTitle: 'Speech to text (Speak with Microphone)',
    settings_voice_sttNotAvailable: 'Speech to text is not available in your browser',
    settings_voice_sttHelper: 'You can use speech recognition by using the microphone icon in the input text box.',
    settings_voice_sttEnabled: 'Enabled',
    settings_voice_sttEnabledHelper: 'Whether to show the microphone button.',
    settings_voice_sttAutoSubmit: 'Submit Automatically',
    settings_voice_sttAutoSubmitHelper: 'Whether to send the message when a sentence has been completed.',
    settings_voice_sttAutoRecord: 'Resume Listening Automatically',
    settings_voice_sttAutoRecordHelper: 'Whether to re-start recording after a message has been received.',
    settings_voice_ttsTitle: 'Text to Speech (Character Voice)',
    settings_voice_ttsHelper: 'You need to configure a voice on the character\'s edit page.',
    settings_voice_ttsEnabled: 'Enabled',
    settings_voice_ttsEnabledHelper: 'Characters with a configured voice will speak automatically.',
    settings_voice_ttsFilterActions: 'Filter Action Text',
    settings_voice_ttsFilterActionsHelper: 'Skips text in asterisks and parenthesis.',
    settings_voice_voiceServices: 'Voice Services',
    settings_voice_agnaistic: 'HuanYouAI',
    settings_voice_webspeechsynthesis: 'Web Speech Synthesis',
    settings_voice_elevenlabs: 'ElevenLabs',
    settings_voice_novel: 'NovelAI Text To Speech',

    // Character
    char_advancedOptions: 'Advanced Options',
    char_systemPrompt: 'Character System Prompt (optional)',
    char_systemPromptHelper: 'A global set of instructions applied to the character.',
    char_systemPromptPlaceholder: 'Enter roleplay mode. You will write {{char}}\'s next reply in a dialogue between {{char}} and {{user}}. Do not decide what {{user}} says or does. Use Internet roleplay style, e.g. no quotation marks, and write user actions in italic in third person like: *example*. You are allowed to use markdown. Be proactive, creative, drive the plot and conversation forward. Write at least one paragraph, up to four. Always stay in character. Always keep the conversation going. (Repetition is highly discouraged)',
    char_jailbreak: 'Character Jailbreak (optional)',
    char_jailbreakHelper: 'Instructions applied at the end of the conversation history. Useful for ensuring character persona.',
    char_jailbreakPlaceholder: 'Write at least four paragraphs.',
    char_insertDepthPrompt: 'Insert / Depth Prompt',
    char_insertDepthPromptHelper: 'A set of instructions inserted into the conversation history at {depth}.',
    char_insertDepth: 'Insert Depth',
    char_insertDepthHelper: 'The number of messages that should exist below the Insert Prompt. Between 1 and',
    char_creator: 'Creator (optional)',
    char_creatorPlaceholder: 'e.g. John1990',
    char_version: 'Character Version (optional)',
    char_versionPlaceholder: 'any text e.g. 1, 2, v1, v1fempov...',
    char_chats: 'Chats',
    char_noConversations: 'No conversations',
    char_chatActivity: 'Chat Activity',
    char_botActivity: 'Bot Activity',
    char_chatCreated: 'Chat Created',
    char_botName: 'Bot Name',
    char_botCreated: 'Bot Created',
    char_chatCounts: 'Chat Counts',
    char_allCharacters: 'All Characters',
    char_confirmDeleteChat: 'Are you sure you wish to delete the conversation?',
    char_noConversationsYet: 'You have no conversations yet.',
    char_noConversationsWith: 'You have no conversations with',
    char_lastModified: 'Last Modified',
    char_lastConversed: 'Last Conversed',
    char_created: 'Created',
    char_select: 'Select',
    char_archiveSelected: 'Archive {count} characters?',
    char_unarchiveSelected: 'Unarchive {count} characters?',
    char_deleteSelected: 'Are you sure you wish to delete {count} characters?',
    char_searchByName: 'Search by name...',
    char_selectedNone: 'Selected: None',
    char_selectedCount: 'Selected: {count}',
    char_favorites: 'Favorites',
    char_editingTitle: 'Editing: {name}',
    char_noCharactersFound: 'No characters found',
    char_toGetStarted: 'to get started!',
    char_jsonStructuredResponsesHelper: 'Request and structure responses using JSON. Only used if JSON schemas are available',
    char_updateSchema: 'Update Schema',
    char_editingSchema: 'Editing Schema',
    char_testSchema: 'Test Schema',
    char_templateReferencesUndefined: 'Template references undefined placeholders:',
    char_responseTemplateWarning: 'Warning: {{response}} is not included in your history or response template. The {{response}} field is always generated and is highly recommended to be used.',
    char_invalidJsonSchema: 'Invalid JSON Schema:',
    char_deleteChatsWarning: 'This will delete all of the chats associated with this character!',
    char_newChat: 'New Chat',
    char_new: 'New',
    char_unfavorite: 'Unfavorite',
    char_duplicate: 'Duplicate',
    char_downloadRetreiveFailed: 'Failed to retrieve character for download:',
    char_imageCard: 'Image Card',
    char_textgen: 'Textgen',
    char_downloadJson: 'Download (JSON)',
    char_downloadPng: 'Download (PNG)',
    char_createACharacterTitle: 'Create a Character',
    char_editACharacterTitle: 'Edit a Character',
    char_copyACharacterTitle: 'Copy a Character',
    char_tokensPermanent: '{totalTokens} tokens, {totalPermanentTokens} permanent',
    char_aiCharacterGenerationGuide: 'AI Character Generation Guide',
    char_characterOverridesWarning: 'Warning! Your chat currently overrides your character definitions. These changes won\'t affect your current chat until you disable them in the "Edit Chat" menu.',
    char_temporaryCharacterWarning: 'You are {action} a temporary character. A temporary character exist within your current chat only.',
    char_clearEditorConfirm: 'Are you sure you wish to clear the editor?',
    char_descriptionCreatorsNotesHelper: 'A description, label, or notes for your character. This is will not influence your character in any way.',
    char_tagsHelper: 'Used to help you organize and filter your characters.',
    char_scenario: 'Scenario',
    char_scenarioHelper: 'The current circumstances and context of the conversation and the characters.',
    char_personality: 'Personality',
    char_personalityWarning: 'WARNING: "Plain Text" and "Non-Plain Text" schemas are not compatible. Changing between them will cause data loss.',
    char_greeting: 'Greeting',
    char_greetingHelper: 'The first message from your character. It is recommended to provide a lengthy first message to encourage the character to give longer responses.',
    char_greetingPlaceholder: 'E.g. *I smile as you walk into the room* Hello, {{user}}! I can\'t believe it\'s lunch time already! Where are we going?',
    char_sampleConversation: 'Sample Conversation',
    char_sampleConversationHelper: 'Example chat between you and the character. This section is very important for teaching your character should speak.',
    char_voiceHelper: 'Toggle on to disable this character from automatically speaking',
    char_languageHelper: 'The language this character speaks and understands.',
    char_languageNote: ' NOTE: You need to also translate the preset gaslight to use a non-english language.',
    char_imageSettingsMoved: 'Image Settings have moved: Click the',
    char_inMainMenu: 'in the main menu',
    char_avatarOrJsonFile: 'Avatar or JSON file',
    char_charactersToImport: 'Characters to import:',
    char_andOneOther: '... and one other',
    char_andOthers: '... and {count} others',
    char_failedCharacterImports: 'Failed character imports:',
    char_persona: 'Persona',
    char_images: 'Images',
    char_advanced: 'Advanced',
    char_attributesFormat: 'Attributes (Key: value)',
    char_plainTextFormat: 'Plain Text',
    char_downloadSuccess: 'Successfully downloaded from Character Hub',
    char_downloadFailed: 'Character Hub download failed: {message}',
    char_sampleConversationPlaceholder: '{{char}}: *smiles and waves back* Hello! I\'m so happy you\'re here!',
    char_unnamed: 'Unnamed',
    char_importChatLog: 'Import Chat Log',
    char_chatLogAccepted: 'Chat log accepted',
    char_invalidChatLogFormat: 'Invalid chat log file format. Supported formats: HuanYouAI, TavernAI',
    char_chatLogImportFor: 'Your chat log will be imported for {name}.',
    char_jsonLinesFile: 'JSON Lines File (.jsonl)',
    char_messagesToImport: '{count} message(s) will be imported.',
    chat_chatWith: 'Chat with',
    chat_notesFromCreator: 'Notes from the creator of {name}',
    chat_generateMessage: 'Generate Message',
    chat_forkConversationConfirm: 'This will fork your conversation from the greeting message.',
    chat_sendAMessage: 'Send a message...',
    chat_sendAMessageTo: 'Send a message to {name}...',
    chat_confirmCancelSwipe: 'Confirm or cancel swiping before sending',
    chat_respondAsMe: 'Respond as Me',
    chat_autoReply: 'Auto-reply',
    chat_none: 'None',
    chat_stopBotReply: 'Stop Bot Reply',
    chat_generateImage: 'Generate Image',
    chat_respondAgain: 'Respond Again',
    chat_generateMore: 'Generate More',
    chat_playVoice: 'Play Voice',
    chat_triggerEvent: 'Trigger Event',
    chat_attachImage: 'Attach Image',
    chat_responseHint: 'Response hint...',
    chat_invalidFileTypeImage: 'Invalid file type: Must be an image',
    chat_attachmentExceedsLimit: 'Attachment exceeds size limit (1MB)',
    chat_loading: 'HuanYouAI loading...',
    chat_participants: 'Participants',
    chat_editChat: 'Edit Chat',
    chat_memory: 'Memory',
    chat_ui: 'UI',
    chat_graph: 'Chat Graph',
    chat_screenshot: 'Screenshot',
    chat_anonymize: 'Anonymize',
    chat_hideOocMessages: 'Hide OOC messages',
    chat_mainCharacter: 'Main Character',
    chat_beginning_group: 'This is the beginning of the group conversation.',
    chat_beginning_with: 'This is the beginning of your conversation with {name}.',
    chat_restart: 'Restart',
    chat_loadingWait: 'Loading, please wait...',
    chat_screenshotFailedElement: "Screenshot failed: Couldn't find messages element",
    chat_screenshotFailedConsole: 'Screenshot failed: error logged in console',
    chat_ooc_suffix: '(OOC)',
    chat_msg_id: 'id',
    chat_msg_chat: 'chat',
    chat_msg_descendants: 'descendants',
    chat_pending_retrying: 'Retrying',
    chat_pending_waiting: 'Waiting',
    chat_pending_chatId: 'Chat ID',
    chat_graph_root: 'Root',
    chat_avatar_modal_title: 'Avatar Preview',
    chat_graph_circular_error: 'Invalid chat tree: Contains a circular reference',
    char_listView: 'List View',
    char_cardsView: 'Cards View',
    char_folderView: 'Folder View',
    char_failedToLoad: 'Failed to load characters. Refresh to try again.',
    char_jsonStructuredResponses: 'JSON Structured Responses',
    char_jsonStructuredWarning: 'Warning: Not all models support JSON Output/Responses.',
    char_responseTemplate: 'Response Template',
    char_responseTemplateHelper: 'How the message appears in your chat',
    char_historyTemplate: 'History Template',
    char_historyTemplateHelper: 'How the message appears in a prompt',
    char_imageCaptionTemplate: 'Image Caption Template',
    char_imageCaptionTemplateHelper: 'Used to auto-populate the "Image Prompt" for image generation.',
    char_jsonSchemaFile: 'JSON Schema File (.json)',
    char_confirmDeletion: 'Confirm Deletion',
    char_confirmDeletionMessage: 'Are you sure you wish to delete this character?',
    char_toggleFavorite: 'Toggle Favorite',
    char_openRecentChat: 'Open Recent Chat',
    char_openCharacterChats: 'Open Character Chats',
    char_favorite: 'Favorite',
    char_downloadCharacter: 'Download Character',
    char_outputFormat: 'Output Format',
    char_fileType: 'File type',
    char_characterName: 'Character Name',
    char_descriptionCreatorsNotes: 'Description / Creator\'s notes',
    char_tags: 'Tags',
    char_scenarioPlaceholder: 'E.g. {{char}} is in their office working. {{user}} opens the door and walks in.',
    char_formatAsIsHelper: 'If you do not know what this mean, you can leave this as-is.',
    char_formatToUseHelper: 'Format to use for the character\'s format',
    char_firstMessagePlaceholder: '{{char}}: *smiles and waves back* Hello! I\'m so happy you\'re here!',
    char_voice: 'Voice',
    char_disableVoice: 'Disable Character\'s Voice',
    char_updatePreset: 'Update Preset',
    char_presetUsedForGeneration: 'This preset used for character generation',
    char_foldersGuide: 'Folders Guide',
    char_foldersInstructions: '- Drag a character to NEW FOLDER to create a new folder\n- Drag a character onto a folder to move the character',
    char_currentFolder: 'Current Folder',
    char_newFolder: 'New Folder',
    char_generateAvatar: 'Generate Avatar',
    char_impersonate: 'Impersonate',
    char_changeChatPersona: 'Change your current chat persona.',
    char_changeDefaultPersona: 'Change your default persona.',
    char_impersonationHelper: 'Use character impersonation to speak as another persona in a',
    char_failedImports: 'Failed character imports:',
    char_multiUserNote: "Note: This currently doesn't support multi-user chats. All messages will",
    char_alternateGreeting: 'An alternate greeting for your character',
    char_appearancePrompt: 'Appearance Prompt (used for Avatar Generation)',
    char_characterBook: 'Character Book',
    char_noCharacterBook: 'This character doesn\'t have a Character Book.',
    char_hasCharacterBook: 'This character has a Character Book.',
    char_characterMemory: 'Character Memory',
    char_characterDesigner: 'Character Designer',
    char_root: 'root',
    char_changeFolderTitle: 'Change Folder: {name}',
    char_folderNamesNormalized: 'Folder names are \'normalized\'.',
    char_normalizedName: 'Normalized name: {name}',
    char_openchats_with: 'Open chats with {name}',
    char_remove_from_favorites: 'Remove {name} from favorite characters',
    char_add_to_favorites: 'Add {name} to favorite characters',
    char_create_new_chat_with: 'Create new chat with {name}',
    char_download_character_name: 'Download character {name}',
    char_edit_character_name: 'Edit character {name}',
    char_duplicate_character_name: 'Duplicate character {name}',
    char_delete_character_name: 'Delete character {name}',
    char_save: 'Save',
    char_drag_to_move: 'Drag the icon to move a character',
    char_drag_to_new_folder: 'Drag a character to NEW FOLDER to create a new folder',
    char_drag_onto_folder: 'Drag a character onto a folder to move the character',
    char_regenerate_tooltip: 'Name and description must be filled',
    char_regenerate_warn: 'Fill in the Name and Description to generate',
    char_reel_send_to_editor: 'Send to Editor',
    char_insert_depth_placeholder: 'E.g. ### Instruction: Write like James Joyce.',
    char_importMemoryBook: 'Import Memory Book',
    char_editBook: 'Edit book',
    char_deleteBook: 'Delete book',
    char_createNewBook: 'Create new book',
    char_hasNoCharacterBook: 'This character has no memory book.',
    char_addAlternateGreeting: 'Add alternate greeting',
    char_alternateGreetingPlaceholder: 'Write an alternate greeting...',
    char_voiceService: 'Voice Service',
    char_voiceLoading: 'Voices loading...',
    char_openCharacterBuilder: 'Open Character Builder',
    char_selectAvatarImage: 'Select avatar image',
    char_appearancePromptPlaceholder: 'Describe how your character should look...',
    char_visualTypeAvatar: 'Avatar',
    char_visualTypeSprite: 'Sprite',
    char_personaTab: 'Persona',
    char_voiceTab: 'Voice',
    char_imagesTab: 'Images',
    char_advancedTab: 'Advanced',
    char_currentChatPersona: 'Current chat persona',
    char_defaultPersona: 'Default persona',
    char_impersonateDescription: 'Choose which persona you would like to use for this chat.',
    char_useMyProfile: 'Use my profile',
    char_currentLabel: 'current',
    char_defaultLabel: 'default',
    char_defaultForNewConvos: 'Default persona for new conversations',
    char_jsonSchemaGenerationStatus: 'JSON schema generated successfully.',
    char_tempJsonSchemaUpdated: 'Temporary JSON schema updated.',
    char_characterHubDownloadSuccess: 'Character Hub download successful.',
    char_characterHubDownloadFailed: 'Character Hub download failed: {message}',
    char_recommended: 'recommended',
    char_unrecognizedFormat: 'Unrecognized format',
    char_open_recent_chat: 'Open recent chat',
    char_open_character_chats: 'Open character chats',

    // Voice
    voice_elevenLabsModel: 'ElevenLabs Model',
    voice_stability: 'Stability',
    voice_claritySimilarityEnhancement: 'Clarity + Similarity Enhancement',
    voice_playbackRate: 'Playback Rate',
    voice_seed: 'Seed',
    voice_service: 'Voice Service',
    voice_pitch: 'Pitch',
    voice_rate: 'Rate',
    voice_preview: 'Preview',
    voice_modelsLoading: 'Models loading...',
    voice_agnaisticSeedHelper: 'Use a fixed seed to make generations more reproducible.',
    voice_novelSeedHelper: 'Set the NovelAI seed (leave blank for random).',
    voice_stabilityHelper: 'Higher stability makes the voice more consistent but less expressive.',
    voice_similarityBoostHelper: 'Increase to make the voice closer to the reference, decrease for more variation.',
    voice_pitchHelper: 'Controls the pitch of the synthesized voice.',
    voice_rateHelper: 'Controls how fast the voice speaks.',

    // App
    app_login_issues: 'Login issues? Try',
    app_logging_out: 'Logging out',
    app_log_back_in: 'then log back in.',
    app_page_loading_issues: 'Page loading issues? Try',
    app_clicking_here: 'clicking here',
    app_failed_to_load: 'HuanYouAI failed to load',
    app_try_again: 'Try Again',
    app_banned_message: 'This account has been banned for the following reason:',
    app_banned_contact: 'If you believe this is an error, please contact support.',
    app_account_banned: 'Account Banned',
    app_information: 'Information',

    // Home
    home_free_to_use: 'HuanYouAI is completely free to use. It is free to register. Your data will be kept private and you can permanently delete your data at any time. We take your privacy very seriously.',
    home_chat_multi_user: 'Chat with multiple users and multiple characters at the same time',
    home_create_memory_book: 'Create {memoryBook} to give your characters information about their world.',
    home_use_images: '{images} - Use Horde, NovelAI or your own Stable Diffusion server.',
    home_give_voice: '{voice} - Give your characters a voice and speak back to them.',
    home_customise_presets: '{presets} - Completely customise the Generation settings used to generate your responses.',
    home_horde_guide: 'Horde Guide',
    home_horde_important: 'Important! For reliable responses, ensure you have registered at {link}. Once you have your key, add it to your {settings}.',
    home_horde_volunteers: 'AI Horde is run and powered by a small number of volunteers that provide their GPUs. This is a great service, but it can be a little slow. Consider contributing to the Horde!',
    home_horde_tokens: "Keep your {maxNewTokens} below 100 unless you know what you're doing! Using high values for 'Max New Tokens' is the main cause of timeouts and slow replies.",
    home_horde_anonymous: 'By default we use anonymous access. You can provide your API key or change the model in the Settings page.',
    home_openai_guide: 'OpenAI Guide',
    home_openai_paid: 'OpenAI is a {paidService}. To use OpenAI, you to need provide your OpenAI API Key in your settings:',
    home_openai_register: 'Firstly, you will need to {registerLink}.',
    home_openai_generate_key: 'Once registered, you will need to {generateLink}.',
    home_openai_set_key: 'Once you have your API key, head to the {settingsLink} page and set your key in the OpenAI area.',
    home_openai_preset: 'To use OpenAI to generate your responses, ensure your chat is using OpenAI Preset in your {chatPresetSettings}. You can access these via the top-right menu in your chat.',

    // Chat Create
    chat_create_title: 'Create Chat',
    chat_create_description: "Optionally modify some of the conversation context. You can override other aspects of the character's persona from the conversation after it is created.",
    chat_create_applied_to_new: 'The information provided here is only applied to the newly created conversation.',
    chat_create_main_character_helper: "The conversation's main character",
    chat_mode: 'Chat Mode',
    chat_mode_companion_description: 'COMPANION: Everything is permanent. You will not be able to: Edit Chat, Retry Message, Delete Messages, etc.',
    chat_mode_standard: 'Conversation',
    chat_mode_companion: 'Companion',
    chat_conversation_name: 'Conversation Name',
    chat_conversation_name_helper: 'A name for the conversation. This is purely for labelling. (Optional)',
    chat_override_character_definitions: 'Override Character Definitions',
    chat_override_helper: 'Overrides will only apply to the newly created conversation.',
    chat_scenario_helper: 'The scenario to use for this conversation',
    chat_create_button: 'Create',

    // Chat Settings
    chat_settings_reset_character: 'Reset Character',
    chat_settings_image_source: 'Image Source',
    chat_settings_image_source_helper: 'Which settings to use when generating images for this chat',
    chat_settings_main_character: 'Main Character',
    chat_settings_last_character: 'Last Character to Speak',
    chat_settings_chat_settings: 'Chat Settings',
    chat_settings_app_settings: 'App Settings',
    chat_settings_background_image: 'Background Image',
    chat_settings_background_image_helper: 'The image will be stored on your current device and not available on other devices',
    chat_settings_chat_mode_irreversible: 'Warning! Switching to COMPANION mode is irreversible! You will no longer be able to: retry messages, delete chats, edit chat settings.',
    chat_settings_chat_name: 'Chat name',
    chat_settings_override_helper: "Overrides apply to this chat only. If you want to edit the original character, open the 'Character' link in the Chat Menu instead.",
    chat_settings_scenario_state: 'The current state of the scenario',
    chat_settings_scenario_state_helper: 'What flags have been set in the chat by the scenario so far',
    chat_settings_field_description_helper: "A description, label, or notes for your character: Used for AI field generation. Does not change your character's behavior.",
    chat_settings_post_history_instructions: 'Character Post-History Instructions',
    chat_settings_default_visibility: 'Default Message Visibility',
    chat_settings_visibility_helper: 'When the Message has not had visibility edited. The most specific takes precedence: Message > Character Default > All Default',
    chat_settings_visible: 'Visible',
    chat_settings_invisible: 'Invisible',
    chat_settings_not_set: 'Not Set',
    chat_settings_defaults_all: 'Defaults for All Messages',
    chat_settings_defaults_per_char: 'Defaults Per Character',
    chat_settings_defaults_per_char_helper: 'Set default visibility for each character perspective',
    remove_all: 'Remove All',
    char_editCharacter: 'Edit Character',
    chat_temp_char_updated: 'Temporary character updated',
    chat_memory_guide: 'Memory Guide',
    chat_ui_settings: 'Chat UI Settings',
    chat_confirmDeleteChat: 'Are you sure you wish to delete the conversation?',
    chat_graph_rejoin_node: 'Re-join Node',
    chat_graph_assign_parent: 'Assign Parent',
    chat_graph_select_parent: 'Select Parent',
    chat_graph_collapse: 'Collapse',
    chat_graph_expand: 'Expand',
    chat_graph_rotate: 'Rotate',
    chat_graph_help: 'Click a node to load the path. Click&Drag to move the graph. Pinch/Scroll to zoom.',
    chat_token_probabilities: 'Token Probabilities',
    chat_save_memory_book: 'Save Memory Book',
    chat_memory_book: 'Memory Book',
    chat_memory_book_helper: 'Select a memory book to use for this chat',
    chat_create_new_memory_book: 'Create New Memory Book',
    chat_embedding: 'Embedding',
    chat_embedding_helper: 'Select an embedding to use for this chat',
    chat_use_embedding: 'Use Embedding',
    chat_msg_info_title: 'Message Info',
    admin_adapter: 'Adapter',
    chat_json_output: 'JSON Output',
    chat_img_prompt_updated: 'Image prompt updated',
    chat_caption_hint_helper: 'Hint for generating image captions',
    chat_caption_hint_placeholder: 'Enter caption hint...',
    chat_image_prompt: 'Image Prompt',
    interrupt: 'Interrupt',
    admin_clean: 'Clean',
    admin_edit: 'Edit',
    chat_msg_prompt_title: 'Prompt View',
    chat_prompt_approx_helper: 'Approximate token count. Actual usage may vary.',
    chat_prompt_budget_helper: 'Token budget information',
    chat_est_tokens: 'Estimated Tokens: {count}',
    chat_speech_recognition_error: 'Speech recognition error: {error}',
    chat_visibility_current: 'Current Visibility',
    chat_visibility_toggles: 'Toggle Visibility',
    chat: 'Chat',
    download: 'Download',
    chat_export_title: 'Export Chat',
    chat_system_preset_horde: 'Horde',
    chat_system_preset: 'System Preset',
    chat_your_default_preset: 'Your Default Preset',
    chat_delete_msg_title: 'Confirm Delete',
    chat_delete_swipe: 'Delete Swipe',
    chat_delete_one: 'Delete One',
    chat_delete_msg_confirm: 'Are you sure you wish to delete the one or the last {count} messages?',
    chat_delete_msg_one_note: 'Deleting "one" will delete the selected message only.',
    chat_delete_msg_image_confirm: 'Are you sure you wish to delete 1 image message?',
    chat_system_built_in_preset_horde: 'Horde',
    chat_please_select_preset: 'Please select a preset',
    chat_load_more: 'Load More',
    chat_add_temp_character: 'Add Temp Character',
    chat_user: 'User',
    chat_temp_characters: 'Temporary Characters',
    chat_deleted_temp_characters: 'Deleted Temporary Characters',
    chat_remove_user_confirm: 'Are you sure you wish to remove {handle} from this chat?',
    chat_no_chars_to_invite: 'No characters available to invite',
    chat_select_char_to_add: 'Select a character to add',
    chat_no_chars_available_to_add: 'No characters available to add',
    chat_no_user_id_provided: 'No user ID provided',
    chat_invite_user: 'Invite User',
    chat_invite_user_helper: 'Enter a user ID to invite to this chat',
    chat_send_invite: 'Send Invite',
    chat_owner: 'Owner',
    chat_temp_character: 'Temp Character',
    reset: 'Reset',
    back: 'Back',
    character: 'Character',

    // Settings UI
    settings_ui_viewMode_background: 'Background',
    settings_ui_typewriter_test: 'There are ten types of people in the world. Those who understand binary and those who don\'t.',

    // Navigation
    nav_main_page_aria: 'HuanYouAI main page',
    nav_add_new_preset: 'Add a new preset',
    nav_add_new_character: 'Add a new character',
    nav_create_new_chat: 'Create a new chat',
    nav_edit_user_profile: 'Edit user profile',
    nav_open_impersonation: 'Open impersonation menu',
    nav_email_support: 'Email Support',

    // Toasts
    toasts_site_updates: 'Site Updates and Notifications',
    toasts_no_notifications: 'You have no notifications.',
    toasts_clear_notifications: 'Clear Notifications',
    toasts_message_from_admin: 'Message from Administrator',
    toasts_latest_updates: 'Latest Updates',
    toasts_admin_notification: 'Admin Notification',
    image_prompt: 'Prompt',
    image_clean: 'Clean',
    image_generate: 'Generate',
    image_stop: 'Stop',
    image_to_unsent: 'To Unsent',
    image_to_current: 'To Current',
    image_add_attachment: 'Add Message Attachment',
    image_caption: 'Image Caption',
    image_caption_hint_placeholder: 'Caption Hint: What to focus on when generating the caption?',
    image_count: 'Image: {current}/{total}',
    image_fix: 'Fix',
    image_attach_to_message: 'Attach to Message',
    invite_title: 'Invites',
    invite_no_pending: 'You have no pending Chat Invitations',
    invite_from: 'From',
    invite_character: 'Character',
    invite_sent: 'Sent',
    invite_unknown_user: 'Unknown User',
    invite_unknown_character: 'Unknown Character',
    login_reset_password: 'Reset Password',
    login_username_placeholder: 'Username...',
    login_password_placeholder: 'Password',
    login_confirm_password_placeholder: 'Confirm Password',
    login_error_not_logged_in: 'Error - You are not currently logged in.',
    login_missing_callback: 'Missing callback from query parameters.',
    login_failed: 'Failed: {error}',
    login_oauth_request: 'An application is requesting to access your HuanYouAI account on your behalf',
    login_oauth_access_list: 'The application will be able to access your:',
    login_oauth_access_items: 'Profile name, Avatar, Characters, and Presets.',
    login_authorize: 'Authorize',
    login_authorizing: 'Authorizing...',
    privacy_policy_text: `
We at HuanYouAI (together with our affiliates, "we", "our" or "us") respect your privacy and are strongly committed to keeping secure any information we obtain from you or about you. This Privacy Policy describes our practices with respect to Personal Information we collect from or about you when you use our website and services (collectively, "Services"). Our use of that data is governed by our customer agreements covering access to and use of those offerings.

## 1. Personal information we collect

We collect information that alone or in combination with other information in our possession could be used to identify you ("Personal Information") as follows:

**Personal Information You Provide:** We may collect Personal Information if you create an account to use our Services or communicate with us as follows:

- **Account Information:** When you create an account with us, we will collect information associated with your account, including your display name, account credentials, profile picture, and other information provided during registration (collectively, "Account Information").
- **User Content:** When you use our Services, we may collect Personal Information that is included in the input, file uploads, or feedback that you provide to our Services ("Content").{' '}
- **Communication Information:** If you communicate with us, we may collect your name, contact information, and the contents of any messages you send ("Communication Information").
- **Social Media Information:** We may have pages on social media sites like Instagram, Facebook, Medium, Twitter, YouTube and LinkedIn, as well as Reddit, 4chan, and a [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat). When you interact with our social media pages, we will collect Personal Information that you elect to provide to us, such as your contact details or social media usernames and profile information (collectively, "Social Information"). In addition, the companies that host our social media accounts may provide us with aggregate information and analytics about our social media activity.

**Personal Information We Receive Automatically From Your Use of the Services:** When you visit, use, and interact with the Services, we may receive the following information about your visit, use, or interactions ("Technical Information"):

- **Log Data:** Information that your browser automatically sends whenever you use our website ("log data"). Log data includes your Internet Protocol address, browser type and settings, the date and time of your request, and how you interacted with our website.
- **Usage Data:** We may automatically collect information about your use of the Services, such as the types of content that you view or engage with, the features you use and the actions you take, as well as your time zone, country, the dates and times of access, user agent and version, type of computer or mobile device, computer connection, IP address, and the like.
- **Device Information:** Includes name of the device, operating system, and browser you are using. Information collected may depend on the type of device you use and its settings.
- **Browser Storage:** We use cookies and localstorage ("Browser Storage") to operate and administer our Services, and improve your experience on it. A "cookie" is a piece of information sent to your browser by a website you visit. "Localstorage" is a feature of your web browser that lets us store information on your computer related to your use of our Services. You can set your browser to accept all cookies, to reject all cookies, or to notify you whenever a cookie is offered so that you can decide each time whether to accept it. However, refusing a cookie may in some cases preclude you from using, or negatively affect the display or function of, a website or certain areas or features of a website. For more details on cookies please visit [All About Cookies](https://www.google.com/url?q=https://allaboutcookies.org/&amp;sa=D&amp;source=editors&amp;ust=1681348702239252&amp;usg=AOvVaw1sGG2db6TzG2Fy_dtBclPZ).
- **Analytics:** We may use a variety of online analytics products that use cookies to help us analyze how users use our Services and enhance your experience when you use the Services.

## 2. How we use personal information**

We may use Personal Information for the following purposes:

- To provide, administer, maintain, improve and/or analyze the Services;
- To conduct research;
- To communicate with you;
- To develop new programs and services;
- To prevent fraud, criminal activity, or misuses of our Services, and to ensure the security of our IT systems, architecture, and networks; and 
- To comply with legal obligations and legal process and to protect our rights, privacy, safety, or property, and/or that of our affiliates, you, or other third parties. 

Aggregated or De-Identified Information. We may aggregate or de-identify Personal
Information and use the aggregated information to analyze the effectiveness of our
Services, to improve and add features to our Services, to conduct research and for other
similar purposes. In addition, from time to time, we may analyze the general behavior and
characteristics of users of our Services and share aggregated information like general
user statistics with third parties, publish such aggregated information or make such
aggregated information generally available. We may collect aggregated information through
the Services, through cookies, and through other means described in this Privacy Policy.
We will maintain and use de-identified information in anonymous or de-identified form and
we will not attempt to reidentify the information.

## 3. Disclosure of personal information

In certain circumstances we may provide your Personal Information to third parties without further notice to you, unless required by the law:
- Vendors and Service Providers: To assist us in meeting business operations needs and to perform certain services and functions, we may provide Personal Information to vendors and service providers, including providers of hosting services, cloud services, and other information technology services providers, event management services, email communication software and email newsletter services, and web analytics services. Pursuant to our instructions, these parties will access, process, or store Personal Information only in the course of performing their duties to us. 
- Business Transfers: If we are involved in strategic transactions, reorganization, bankruptcy, receivership, or transition of service to another provider (collectively a "Transaction"), your Personal Information and other information may be disclosed in the diligence process with counterparties and others assisting with the Transaction and transferred to a successor or affiliate as part of that Transaction along with other assets. 
- Legal Requirements: If required to do so by law or in the good faith belief that such action is necessary to (i) comply with a legal obligation, including to meet national security or law enforcement requirements, (ii) protect and defend our rights or property, (iii) prevent fraud, (iv) act in urgent circumstances to protect the personal safety of users of the Services, or the public, or (v) protect against legal liability. 
- Affiliates: We may disclose Personal Information to our affiliates, meaning an entity that controls, is controlled by, or is under common control with HuanYouAI. Our affiliates may use the Personal Information we share in a manner consistent with this Privacy Policy. 

## 4. Your rights

Depending on location, individuals in the EEA, the UK, and across the globe may have certain statutory rights in relation to their Personal Information. For example, you may have the right to:

- Access your Personal Information.
- Delete your Personal Information.
- Correct or update your Personal Information.
- Transfer your Personal Information elsewhere.
- Withdraw your consent to the processing of your Personal Information where we rely on consent as the legal basis for processing. 
- Object to or restrict the processing of your Personal Information where we rely on legitimate interests as the legal basis for processing

You can exercise some of these rights through your Agnaistic account. If you are unable to exercise your rights through your account, please send your request in our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat).

## 5. California privacy rights

The following table provides additional information about how we disclose Personal Information. You can read more about the Personal Information we collect in "Personal information we collect" above, how we use Personal information in "How we use personal information" above, and how we retain personal information in "Security and Retention" below.

| Category of Personal Information                                                     | Disclosure of Personal Information                                                                                                    |
|:-------------------------------------------------------------------------------------|:--------------------------------------------------------------------------------------------------------------------------------------|
| Identifiers, such as your contact details                                            | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |
| Commercial Information, such as your transaction history                             | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |
| Network Activity Information, such as Content and how you interact with our Services | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |
| Geolocation Data                                                                     | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |
| Your account login credentials (Sensitive Personal Information)                      | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |

To the extent provided for by law and subject to applicable exceptions, California residents have the following privacy rights in relation to their Personal Information:

- The right to know information about our processing of your Personal Information, including the specific pieces of Personal Information that we have collected from you;
- The right to request deletion of your Personal Information;
- The right to correct your Personal Information; and
- The right to be free from discrimination relating to the exercise of any of your privacy rights. 

We don't sell or share Personal Information as defined by the California Consumer Privacy Act, as amended by the California Privacy Rights Act. We also don't process sensitive personal information for the purposes of inferring characteristics about a consumer.

**Exercising Your Rights**. California residents can exercise their CCPA privacy rights by sending their request to us on our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat).
**Verification**. In order to protect your Personal Information from unauthorized access, change, or deletion, we may require you to verify your credentials before you can submit a request to know, correct, or delete Personal Information. If you do not have an account with us, or if we suspect fraudulent or malicious activity, we may ask you to provide additional Personal Information and proof of residency for verification. If we cannot verify your identity, we will not provide, correct, or delete your Personal Information.
**Authorized Agents**. you may submit a rights request through an authorized agent. If you do so, the agent must present signed written permission to act on your behalf and you may also be required to independently verify your identity and submit proof of your residency with us. Authorized agent requests can be submitted to us on our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat).

## 6. Children

Our Service is not directed to children who are under the age of 18. Agnaistic does not knowingly collect Personal Information from children under the age of 18. If you have reason to believe that a child under the age of 18 has provided Personal Information to Agnaistic through the Service please contact us on our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat). We will investigate any notification and if appropriate, delete the Personal Information from our systems.

## 7. Links to other websites

The Service may contain links to other websites not operated or controlled by Agnaistic, including social media services ("Third Party Sites"). The information that you share with Third Party Sites will be governed by the specific privacy policies and terms of service of the Third Party Sites and not by this Privacy Policy. By providing these links we do not imply that we endorse or have reviewed these sites. Please contact the Third Party Sites directly for information on their privacy practices and policies. 

## 8. Security and Retention

We implement commercially reasonable technical, administrative, and organizational measures to protect Personal Information both online and offline from loss, misuse, and unauthorized access, disclosure, alteration, or destruction. However, no Internet or email transmission is ever fully secure or error free. In particular, email sent to or from us may not be secure. Therefore, you should take special care in deciding what information you send to us via the Service or email. In addition, we are not responsible for circumvention of any privacy settings or security measures contained on the Service, or third party websites.

We'll retain your Personal Information for only as long as we need in order to provide our Service to you, or for other legitimate business purposes such as resolving disputes, safety and security reasons, or complying with our legal obligations. How long we retain Personal Information will depend on a number of factors, such as the amount, nature, and sensitivity of the information, the potential risk of harm from unauthorized use or disclosure, our purpose for processing the information, and any legal requirements.

We may also anonymize or de-identify your Personal Information (so that it can no longer be associated with you) for research or statistical purposes, as described above, in which case we may use this information indefinitely without further notice to you.

## 9. International users

By using our Service, you understand and acknowledge that your Personal Information will be transferred from your location to our facilities and servers in the United States.

For EEA, UK or Swiss users:

- Legal Basis for Processing. Our legal bases for processing your Personal Information include: Performance of a contract with you when we provide and maintain our Services. This may include the processing of Account Information, Content, and Technical Information.
- Our legitimate interests in protecting our Services from abuse, fraud, or security risks, or when we develop, improve, or promote our Services. This may include the processing of Account Information, Content, Social Information, and Technical Information.
- Your consent when we ask for your consent to process your Personal Information for a specific purpose that we communicate to you. You have the right to withdraw your consent at any time.
- Compliance with our legal obligations when we use your Personal Information to comply with applicable law or when we protect our or our affiliates' or users' rights, safety and property.

If feel we have not adequately addressed an issue, you have the right to lodge a complaint with your local supervisory authority.

Data Transfers. Where required, we will use appropriate safeguards for transferring Personal Information outside of the EEA, Switzerland, and the UK. We will only transfer Personal Information pursuant to a legally valid transfer mechanism.

## 10. Your choices

If you choose not to provide Personal Information that is needed to use some features of our Service, you may be unable to use those features.

## 11. Changes to the privacy policy

We may change this Privacy Policy at any time. When we do, we will post an updated version on this page, unless another type of notice is required by applicable law. By continuing to use our Service or providing us with Personal Information after we have posted an updated Privacy Policy, or notified you by other means, you consent to the revised Privacy Policy.

## 12. How to contact us
Please contact us on our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat) if you have any questions or concerns not already addressed in this Privacy Policy.
`,
    memory_create_book: 'Create memory book',
    memory_edit_book: 'Edit Memory Book',
    memory_update_book: 'Update Book',
    memory_definitions: 'Definitions',
    memory_priority: 'Priority',
    memory_priority_helper: 'When deciding which entries to INCLUDE in the prompt, the higher the priority entries win.',
    memory_weight: 'Weight',
    memory_weight_helper: 'When deciding how to ORDER entries, the higher the weight the closer to the bottom.',
    memory_keywords: 'Keywords',
    memory_keywords_helper: 'You can use {{char}} and {{user}} placeholders',
    memory_entry: 'Entry',
    memory_entry_helper: '{{char}} and {{user}} placeholders here.',
    memory_embeddings: 'Memory - Embeddings',
    memory_loaded: 'Loaded',
    memory_not_loaded: 'Not loaded',
    memory_books: 'Memory - Books',
    memory_no_books: 'You have no memory books yet. Click Create to get started.',
    memory_book_accepted: 'Memory book accepted',
    memory_import_book: 'Import Memory Book',
    memory_json_file: 'JSON File',
    memory_import_helper: 'Only HuanYouAI exported memory books are currently supported.',
    memory_sort_creation: 'By creation date',
    memory_sort_alpha: 'Alphabetically',
    memory_book_name: 'Book Name',
    memory_book_name_placeholder: 'Name for your memory book',
    memory_description_placeholder: '(Optional) A description for your memory book',
    memory_entries: 'Entries',
    memory_filter_placeholder: 'Filter by entry name...',
    memory_entry_name_placeholder: 'Name of entry',
    memory_keywords_placeholder: 'Comma separated words. E.g.: circle, shape, round, cylinder, oval',
    memory_entry_placeholder: 'Memory entry. E.g. {{user}} likes fruit and vegetables',
    memory_embedding_created: 'Successfully created embedding',
    memory_article: 'Article',
    memory_pdf: 'PDF',
    memory_text_file: 'Text file',
    memory_plain_text: 'Plain Text',
    memory_enter_name: 'Enter a name for the embedding',
    memory_no_pdf: 'No PDF loaded',
    memory_content_empty: 'Embedding content is empty',
    memory_enable_embeddings_helper: 'You need to enable Embeddings/Long-Term Memory in your Settings',
    memory_embed_wiki: 'Embed Wikipedia Article',
    memory_embed_wiki_helper: 'Create an embedding using the content from a Wikipedia article',
    memory_wiki_placeholder: 'URL. E.g. https://en.wikipedia.org/wiki/Taylor_Swift',
    memory_embed_article_button: 'Embed Article',
    memory_embed_name_helper: 'An identifier for your embedding.',
    memory_embed_pdf: 'Embed PDF',
    memory_embed_pdf_helper: 'This may take a long time depending on the size of the PDF.',
    memory_embed_file: 'Embed File',
    memory_embed_file_helper: 'This may take a long time depending on the size of the file.',
    memory_embed_text_helper: 'The content to be embedded. Use line breaks to seperate lines.',
    memory_embed_text_button: 'Embed Text',
    memory_embed_name_optional_helper: '(Optional) An identifier for your embedding. This will become a "slug". E.g. "Hello World" will become "hello-world"',
    memory_embed_name_slug_helper: 'An identifier for your embedding. This will become a "slug". E.g. "Hello World" will become "hello-world"',

    // WorkerModal
    worker_modal_title: 'Select Horde Workers',
    worker_modal_select_workers: 'Select Workers',
    worker_modal_helper: 'To use any worker de-select all workers',
    worker_modal_selected_count: 'Workers selected: {count}',
    worker_modal_deselect_all: 'De-select All',

    // OpenRouterOauth
    openrouter_oauth_instruction: 'Click <b class="highlight">Login with OpenRouter</b> or visit <a class="link" target="_blank" href="https://openrouter.ai/keys">OpenRouter.ai/keys</a> to create an API key and enter it above.',
    openrouter_oauth_logging_in: 'Logging in...',
    openrouter_oauth_login: 'Login with OpenRouter',
    openrouter_oauth_logout: 'Logout',

    // PatreonOauth
    patreon_oauth_verifying: 'Verifying Patreon account...',
    patreon_oauth_error: 'Unable to verify Patreon account',
    patreon_oauth_return_to_settings: 'Return to Settings',
    patreon_oauth_success: 'Patreon account verified',
    patreon_oauth_redirecting: 'Redirecting to Settings page...',
    patreon_oauth_link_benefit: 'Link your Patreon account to receive subscriber benefits',
    patreon_oauth_link: 'Link Patreon Account',
    patreon_oauth_unlink: 'Unlink Patreon Account',
    patreon_oauth_revalidate: 'Re-validate',

    // ImageSettings
    image_settings_shared: 'Shared Settings',
    image_settings_global_default: 'Global/Default',
    image_settings_character_settings: 'Character Settings',
    image_settings_character: 'Character:',
    image_settings_current_chat: 'Current Chat Settings',
    image_settings_chatting_with: 'Chatting with:',
    image_settings_source_label: 'Current Chat Image Settings Source',
    image_settings_source_helper: 'Control which image settings are used when generating "Chat Images"',
    image_settings_use_settings: 'Use {tab} Settings',
    image_settings_use_settings_active: 'Use {tab} Settings (Active)',
    image_settings_summary_preset: 'Summary Preset',
    image_settings_summary_preset_helper: 'Choose which service and model is used for creating summaries for chat images',
    image_settings_summary_settings: 'Summary Settings',
    image_settings_summarise_chat: 'Summarise Chat',
    image_settings_summarise_chat_helper: 'Use your AI service to summarise the chat into an image prompt.',
    image_settings_summary_prompt: 'Summary Prompt',
    image_settings_summary_prompt_helper: 'When summarising the chat to an image caption, this is the "prompt" is used summarise your conversation into an image prompt.',
    image_settings_default: 'Default:',
    image_settings_style_booru: 'Booru/Tag Style',
    image_settings_style_plain: 'Flux/Plain Style',
    image_settings_use_recommended: 'Use Recommended Settings',
    image_settings_use_recommended_helper: "Use the image model's recommended settings when available.",
    image_settings_toggle_all: 'Toggle All',
    image_settings_affixes: 'Affixes',
    image_settings_size: 'Size',
    image_settings_guidance: 'Guidance',
    image_settings_steps: 'Steps',
    image_settings_negative_prompt: 'Negative Prompt',
    image_settings_sampler: 'Sampler',
    image_settings_recommended_hint: 'Refer to the recommended settings when using HuanYouAI image models',
    image_settings_sampling_steps: 'Sampling Steps',
    image_settings_clip_skip: 'Clip Skip',
    image_settings_width: 'Image Width',
    image_settings_height: 'Image Height',
    image_settings_guidance_scale: 'Guidance Scale',
    image_settings_seed: 'Seed',
    image_settings_seed_helper: 'Seed number (0 = random). Note: The seed will not be consistent across different servers.',
    image_settings_prefix: 'Prompt Prefix',
    image_settings_prefix_helper: '(Optional) Text to prepend to your image prompt',
    image_settings_prefix_placeholder: 'E.g.: best quality, masterpiece',
    image_settings_suffix: 'Prompt Suffix',
    image_settings_suffix_helper: '(Optional) Text to append to your image prompt',
    image_settings_suffix_placeholder: 'E.g.: full body, visible legs, dramatic lighting',
    image_settings_negative_helper: '(Optional) Negative Prompt',
    image_settings_negative_placeholder: 'E.g.: painting, drawing, illustration, glitch, deformed, mutated, cross-eyed, disfigured',
    image_settings_edit_summary_preset: 'Edit Summary Preset',
    image_settings_unavailable_hint: 'Note: <b>Chat</b> and <b>Character</b> image settings are only available when a chat is open.',
    image_settings_image_settings: 'Image Settings',

    // ServiceSettings
    service_settings_model: 'Model:',
    service_settings_sampler: 'Sampler:',
    service_settings_novel_key_error: 'You do not have a valid NovelAI key set. You will not be able to generate images using Novel.',
    service_settings_novel_quality_tags: 'Add Quality Tags',
    service_settings_novel_undesired_content: 'Undesired Content',
    service_settings_novel_undesired_content_helper: 'Add `nsfw` to your negative prompt to omit NSFW content',
    service_settings_novel_heavy: 'Heavy',
    service_settings_novel_light: 'Light',
    service_settings_novel_none: 'None',
    service_settings_swarm_url: 'SwarmUI URL',
    service_settings_swarm_url_helper: 'Base URL for SwarmUI. E.g. https://local-tunnel-url-10-20-30-40.loca.lt. If you are self-hosting, you can use http://localhost:7801',
    service_settings_automatic: 'Automatic',
    service_settings_add_lora: '+ Lora',
    service_settings_use_local: 'Use Local Requests',
    service_settings_none_selected: 'None Selected',
    service_settings_sd_url: 'SD WebUI URL',
    service_settings_sd_url_helper: 'Base URL for Stable Diffusion. E.g. https://local-tunnel-url-10-20-30-40.loca.lt. If you are self-hosting, you can use http://localhost:7860',
    service_settings_sd_provider_helper: 'Use API Key from a Provider',
    service_settings_no_options: 'No additional options available',
    service_settings_draft_mode: 'Draft Mode',
    service_settings_draft_mode_helper: 'If available: Quickly generate a lower quality image',
    service_settings_recommended: 'Recommended',
    service_settings_limits: 'Limits',
    service_settings_tags_keyword: 'Tags / Keyword',
    service_settings_tags: 'Tags',
    service_settings_on: 'On',
    service_settings_off: 'Off',
    service_settings_model_strength: 'Model Strength',
    service_settings_clip_strength: 'Clip Strength',
    service_settings_image_model: 'Image Model',
    service_settings_sampler_label: 'Sampler',
    service_settings_steps: 'Steps',
    service_settings_cfg: 'CFG',
    service_settings_width: 'Width',
    service_settings_height: 'Height',
    service_settings_clip_skip: 'Clip Skip',
    service_settings_sampler_title: 'Sampler',
    service_settings_prefix: 'Prefix',
    service_settings_suffix: 'Suffix',
    service_settings_negative: 'Negative',

    // Provider/index
    provider_index_select_provider: 'Select Provider',
    provider_index_service: 'Service',
    provider_index_providers: 'Providers',
    provider_index_providers_helper: 'Providers are used to connect to your preferred AI models.',
    provider_index_new_provider_helper: 'Click **`+ New`** to create a new provider and fill in the information.',
    provider_index_format_helper: '**Format**\nIf you prompted to select a **Format** and you are not sure one to use, select `Chat`.',
    provider_index_important_helper: '**Important**: Make sure the correct provider is chosen in the dropdown below in your props.state.',
    provider_index_edit_selected: 'Edit Selected',
    provider_index_new: 'New',
    provider_index_edit: 'Edit',
    provider_index_edit_connection: 'Edit Connection Details',
    provider_index_accept: 'Accept',
    provider_index_ai_service: 'AI Service',
    provider_index_no_service_warning: 'Warning! Your preset does not currently have a service set.',
    provider_index_third_party_format: 'Third-Party Format',
    provider_index_request_format_helper: 'Controls how requests are sent',
    provider_index_none: 'None',
    provider_index_url: 'URL',
    provider_index_url_helper: 'API URL for **third-party** or **self-hosted** services',
    provider_index_url_placeholder: 'E.g. https://some-tunnel-url.loca.lt',
    provider_index_api_key: 'API Key',
    provider_index_remove_key: 'Remove Key',
    provider_index_key_warning: 'Never enter your official OpenAI, Claude, Mistral keys here.',
    provider_index_key_is_set: 'Key is set',
    provider_index_key_placeholder: 'E.g. sk-...',

    // Provider/Manage
    provider_manage_supported: 'Supported Providers',
    provider_manage_local_selfhost: 'Local / Self-Host',
    provider_manage_custom: 'Custom',
    provider_manage_choose_provider: 'Provider: Choose a Provider',
    provider_manage_provider_prefix: 'Provider: ',
    provider_manage_invalid_url: 'URL is not valid. Check it and try again',
    provider_manage_update_title: 'Update Provider',
    provider_manage_create_title: 'Create Provider',
    provider_manage_delete: 'Delete',
    provider_manage_update: 'Update',
    provider_manage_create: 'Create',
    provider_manage_instruction: 'Provide connection details to use an external service',
    provider_manage_label: 'Label',
    provider_manage_label_placeholder: 'Custom label for this provider',
    provider_manage_url_placeholder: 'https://...',
    provider_manage_disable_auto_url: 'Disable Auto-URL',
    provider_manage_request_format: 'Request Format',
    provider_manage_test_connection: 'Test Connection',
  },
  zh: {
    chub_title: '角色枢纽',
    chub_search_placeholder: '按名称搜索...',
    chub_tags_placeholder: '标签...',
    chub_import: '导入',
    chub_preview: '预览',
    chub_disclaimer: '免责声明：角色归属和管理由',
    chub_import_book_hint_1: '可以随意修改除图像以外的世界书的所有方面。',
    chub_import_book_hint_2: '此处提供的信息将在导入时与世界书一起保存。',
    chub_import_char_hint_1: '可以随意修改除头像以外的角色的所有方面。',
    chub_import_char_hint_2: '此处提供的信息将在导入时与角色一起保存。',
    chub_import_char_name_label: '角色名称',
    chub_import_char_name_helper: '在此处重写角色名称',
    chub_import_char_optional: '（可选）',
    chub_import_char_greeting: '问候语',
    chub_import_char_scenario: '场景',
    chub_import_char_sample_chat: '示例聊天',
    chub_import_char_persona: '人设',
    chub_filter_nsfw_label: '成人内容 (NSFW)',
    chub_filter_nsfw_helper: '允许 NSFW 角色/世界书出现在结果中。',
    chub_filter_query_tags_label: '查询标签',
    chub_filter_query_tags_helper: '以逗号分隔的包含标签列表。',
    chub_filter_exclude_tags_label: '排除标签',
    chub_filter_exclude_tags_helper: '以逗号分隔的排除标签列表。',
    chub_filter_sort_label: '排序方式',
    chub_invalid_tavern_image: '无效的 Tavern 图像',
    chub_sort_default: '默认',
    chub_sort_trending: '热门',
    chub_sort_favorites: '收藏数',
    chub_sort_random: '随机',
    chub_sort_rating: '评分',
    chub_sort_updated: '更新时间',
    chub_sort_popularity: '流行度',
    chub_sort_created: '创建时间',
    chub_sort_name: '名称',
    chub_sort_tokens: 'Token 数量',
    chub_sort_ratings: '评分数量',
    chub_error_importing: '导入 {name} 时出错！{error}',
    chub_filter_tags_placeholder: '例如：blue_archive,female,anime',
    product_name: PRODUCT_NAME,
    product_slogan: SLOGAN,

    welcome: '欢迎',
    login: '登录',
    register: '注册',
    language: '语言',
    close: '关闭',
    cancel: '取消',
    confirm: '确认',
    ok: '确定',
    yes: '是',
    no: '否',
    edit: '编辑',
    editing: '正在编辑',
    update: '更新',
    save: '保存',
    copy: '复制',
    search: '搜索',
    voice: '语音',

    // Time
    time_seconds: '{count} 秒',
    time_second: '{count} 秒',
    time_minutes: '{count} 分钟',
    time_minute: '{count} 分钟',
    time_hours: '{count} 小时',
    time_hour: '{count} 小时',
    time_days: '{count} 天',
    time_day: '{count} 天',
    time_aMoment: '刚才',
    time_unknown: '未知',
    time_ago: '{duration}前',

    welcomeTitle: `欢迎来到 ${PRODUCT_NAME}`,
    welcomeMessage: SLOGAN,
    welcomeDisclaimer: '本平台不对中国大陆用户提供服务，请确认您已年满18岁且不在中国大陆地区使用本平台。',
    welcomeContentWarning: '所有互动内容皆由AI生成，请勿轻信或受误导，也请勿引导AI生成不符规范的内容。',
    termsAgreement: '本人已年满18岁并同意',
    termsLink: '用户条款',
    ageConfirmation: '本人已年满18岁并同意用户条款',
    createCharacter: '创建角色',
    importCharacter: '导入角色',
    characters: '角色',
    lorebooks: '设定书',
    creativeWorkshop: '创意工坊',
    personalCenter: '个人中心',
    chatHistory: '聊天记录',
    trending: '热搜流行',
    memoryFragments: '记忆片段',
    menu: '菜单',
    library: '图书馆',
    lib_memories: '记忆',
    lib_scenarios: '场景',
    lib_templates: '模板',
    lib_embeddings: '嵌入',
    login_remote_error_not_logged_in: '错误 - 您当前未登录。',
    login_remote_missing_callback: '查询参数中缺少回调地址。',
    login_remote_failed: '失败：{error}',
    login_remote_request_access: `一个应用程序正在请求代表您访问您的 ${PRODUCT_NAME} 账户`,
    login_remote_application_access: '该应用程序将能够访问您的个人资料名称、头像、角色和预设。',
    login_remote_authorize: '授权',
    login_remote_authorizing: '授权中...',
    presets: '预设',
    settings: '设置',
    profile: '个人资料',
    chats: '聊天',
    sounds: '声音',
    manage: '管理',
    gen_presets_copy_preset: '复制预设 {name}',
    gen_presets_edit_preset: '编辑预设 {name}',
    configuration: '配置',
    users: '用户',
    subscriptions: '订阅',
    announcements: '公告',
    persona: '角色扮演',
    faq: '常见问题',
    termsOfService: '服务条款',
    nav_home: '角色',
    nav_trends: '热搜流行',
    nav_workshop: '创意工坊',
    nav_me: '个人中心',
    home_tab_recommended: '推荐',
    home_tab_trending: '排行',
    home_tab_latest: '最新',
    home_tab_race: '杯赛',
    home_filter_gender: '性别',
    home_filter_tags: '选择标签',
    char_card_original: '原创',
    workshop_title: '工坊',
    workshop_my_characters: '我的角色',
    workshop_create_character: '创建角色',
    workshop_import_character: '导入角色',
    trends_title: '动态',
    trends_latest: '最新',
    trends_follow: '关注',
    share_fragment_title: '分享对话',
    share_fragment_select: '选择要分享的消息',
    share_fragment_post: '发布到动态',
    share_fragment_success: '分享成功！',
    char_visibility: '可见性',
    char_visibility_public: '公开',
    char_visibility_unlisted: '仅链接',
    char_visibility_private: '私有',
    profile_my_creations: '我的创作',
    profile_my_favorites: '我的收藏',
    profile_chat_history: '聊天记录',
    search_placeholder: '搜索角色、创作者或标签...',
    trending_hot_keywords: '热搜标签',
    trending_hot_tags: '热搜标签',
    trending_ranking: '排行榜',
    trending_top10: 'TOP10',
    trending_top30: 'TOP30',
    trending_top50: 'TOP50',
    trending_daily: '日榜',
    trending_weekly: '周榜',
    trending_monthly: '月榜',
    trending_views: '浏览',
    trending_likes: '点赞',
    trending_favorites: '收藏',
    trending_chats: '聊天',
    trending_author: '作者',
    trending_author_ranking_title: '神豪排行榜',
    trending_author_total: '总榜',
    trending_author_tips: '打赏',
    trending_author_income: '收入',
    privacyPolicy: '隐私政策',

    // Profile / Subscription
    profile_checkout_success: '结账成功',
    profile_checkout_thank_you: '感谢您的订阅！',
    profile_checkout_start_using: '通过创建和使用 {name} 预设开始使用您的订阅。',
    profile_checkout_close_window: '关闭窗口',
    profile_checkout_cancelled: '结账已取消',
    profile_checkout_cancelled_msg: '您的订阅尝试已取消。您未被收费。',
    profile_sub_valid_until: '有效期至',
    profile_sub_patreon_subscriber: 'Patreon 订阅者',
    profile_sub_cancels_at: '取消于',
    profile_sub_renews_at: '续订于',
    profile_sub_why_title: '为什么要订阅？',
    profile_sub_why_msg_1: '订阅可让您访问更高质量的模型、更快的响应和更大的上下文。',
    profile_sub_why_msg_2: '未来您还将获得额外功能！例如：语音生成、图像存储，以及与 Discord、Slack 和 WhatsApp 等第三方应用的集成等！',
    profile_sub_why_msg_3: `订阅允许我投入更多时间开发和增强 ${PRODUCT_NAME}。`,
    profile_sub_support_contact: '如果您需要账单或订阅支持，请联系',
    profile_sub_view_models: '查看可用模型',
    profile_sub_current_title: '当前订阅',
    profile_sub_update_payment: '更新付款方式',
    profile_sub_via: '订阅方式',
    profile_sub_via_gift: '赠送',
    profile_sub_via_patreon: 'Patreon',
    profile_sub_via_stripe: 'Stripe',
    profile_sub_via_none: '无',
    profile_sub_set_to_downgrade: '您的订阅已设置为降级',
    profile_sub_cancel_downgrade: '取消降级',
    profile_sub_scheduled_to_cancel: '您的订阅目前计划取消',
    profile_sub_resume: '恢复订阅',
    profile_sub_enjoy: '享受吧！',
    profile_sub_subscribed: '已订阅！',
    profile_sub_options: '订阅选项',
    profile_sub_patreon_msg: '成为赞助人并关联您的账户，或使用以下选项',
    profile_sub_gifted_to_you: '此层级目前已赠送给您',
    profile_sub_login_to_subscribe: '登录以订阅',
    profile_sub_upgrade: '升级',
    profile_sub_downgrading: '降级中...',
    profile_sub_downgrade: '降级',
    profile_sub_resubscribe: '重新订阅',
    profile_sub_subscribe: '订阅',
    profile_sub_prices_usd: '所有价格均以美元计',
    profile_sub_unsubscribe: '取消订阅',
    profile_sub_confirm_unsubscribe: '您确定要取消订阅吗？',
    profile_sub_upgrade_charge_msg: '确认后将立即向您收费。',
    profile_sub_confirm_upgrade: '您确定现在升级吗？',
    profile_sub_downgrade_affect_msg: '您的降级将在下一个计费周期开始时生效。在降级生效之前，您将保留对当前订阅层级的访问权限。',
    profile_sub_confirm_downgrade: '您确定要降级吗？',
    profile_sub_per_mo: '/月',
    profile_sub_or: '或',

    // Prompt Templates
    prompt_templates_title: '提示词模板',
    prompt_templates_new_template: '模板',
    prompt_templates_no_templates: '您没有保存的提示词模板',
    prompt_templates_builtin: '内置模板',
    prompt_templates_updated: '模板已更新',
    prompt_templates_created: '模板已创建',
    prompt_templates_name: '名称',

    // Saga
    saga_help_link: 'Saga 模板帮助',
    saga_preview_title: '预览：Sagas',
    saga_preview_msg: '这是“Sagas”的预览。这些是由用户制作的开放式文本冒险。',
    saga_new_template: '新建模板',
    saga_untitled_template: '未命名模板',
    saga_menu_prompts: '提示词',
    saga_menu_preset: '预设',
    saga_menu_help: '帮助',
    saga_session_saved: '会话已保存',
    saga_btn_restart: '重新开始',
    saga_btn_start: '开始',
    saga_btn_new: '新建',
    saga_btn_load: '加载',
    saga_btn_save: '保存',
    saga_btn_reimage: '重新生成图像',
    saga_tab_template: '模板',
    saga_tab_session: '会话',
    saga_current_template: '当前模板',
    saga_load_template: '加载模板',
    saga_field_name: '名称',
    saga_field_format: '格式',
    saga_field_init_template: '初始模板',
    saga_field_init_template_helper: '用于生成介绍的初始值。',
    saga_field_intro_format: '介绍格式',
    saga_field_intro_format_helper: '如何格式化您的介绍。 .\n\n您可以使用从**初始模板**派生的任何字段。',
    saga_field_display_format: '响应显示格式（可选）',
    saga_field_display_format_helper: '如何显示**显示**的响应（如果为空则使用**响应提示词格式**）\n您可以使用从模板派生的任何字段。',
    saga_field_image_prompt: '图像生成的提示词模板',
    saga_field_image_prompt_helper: '留空以禁用图像生成',
    saga_field_history_template: '历史记录模板',
    saga_field_history_template_helper: '在游戏循环模板中使用 **{{history}}**',
    saga_field_loop_template: '游戏循环模板',
    saga_field_loop_template_helper: '使用 **{{input}}** 使用用户输入',
    saga_manual_fields: '手动字段',
    saga_manual_fields_helper: '这些字段需要由您填写',
    saga_fields: '字段',
    saga_fields_helper: '**切换**: 控制字段是否出现在聊天窗口中。\n**标签**: 启用后，字段在聊天窗口中的名称。\n**值**: 覆盖值而不是生成它。',
    saga_lists: '列表',
    saga_add_items: '添加项目...',
    saga_required_value: '（必填）值',
    saga_optional_value: '（可选）值',
    saga_guidance_title: '引导 (Guidance)',
    saga_import_success: '成功导入模板',
    saga_import_title: '导入模板',
    saga_import_json_label: '模板 JSON',

    // Scenario
    scenario_title: '场景',
    scenario_import: '导入场景',
    scenario_create: '创建场景',
    scenario_no_scenarios: '您还没有场景。',
    scenario_unnamed: '未命名场景',
    scenario_edit_title: '编辑场景',
    scenario_btn_duplicate: '复制',
    scenario_btn_download: '下载',
    scenario_btn_delete: '删除',
    scenario_no_events: '此场景未附加事件',
    scenario_events_count: '个事件',
    scenario_details_title: '场景详情',
    scenario_field_name_helper: '场景的名称。',
    scenario_field_desc: '描述',
    scenario_field_desc_helper: '有关场景的更多信息。',
    scenario_field_prompt: '提示文本',
    scenario_field_prompt_helper: '可选。要添加到场景提示词的附加文本。',
    scenario_field_overwrite: '覆盖角色场景',
    scenario_field_overwrite_helper: '如果角色已经有场景，则用此场景覆盖。否则，追加到其后。',
    scenario_field_instructions: '用户说明',
    scenario_field_instructions_helper: '可选。显示给用户的文本，帮助他们了解如何使用此场景。',
    scenario_confirm_delete: '您确定要删除此场景吗？',
    scenario_download_title: '下载场景',
    scenario_event_type_hidden: '隐藏（不向用户显示）',
    scenario_event_type_world: '世界（显示，角色外部）',
    scenario_event_type_character: '角色（显示，角色的想法或行为）',
    scenario_event_type_ooc: '离题 (OOC)（仅用户可见）',
    scenario_trigger_greeting: '问候语',
    scenario_trigger_manual: '手动触发',
    scenario_trigger_opened: '聊天已打开',
    scenario_trigger_received: '消息已接收',
    scenario_states_used: '已使用的状态',
    scenario_states_used_helper: '到目前为止您在事件中使用的状态',
    scenario_events_title: '事件',
    scenario_btn_create_event: '创建事件',
    scenario_no_events_msg: '您还没有事件。',
    scenario_event_name_placeholder: '事件名称，例如“问候语”',
    scenario_field_trigger: '触发器',
    scenario_field_req_states: '所需状态',
    scenario_field_req_states_helper: '触发此事件之前需要的状态。',
    scenario_field_req_states_placeholder: '触发所需的状态',
    scenario_field_assign_states: '分配状态',
    scenario_field_assign_states_helper: '触发时，哪些状态将被分配给聊天',
    scenario_field_assign_states_placeholder: '触发时添加的状态',
    scenario_field_event_type: '类型',
    scenario_field_event_type_helper: '此事件将如何向用户显示。',
    scenario_field_event_prompt_helper: '每当发生此事件时发送的提示文本。(OOC: something) 文本将对用户隐藏。',
    scenario_event_greeting_msg: '开始新聊天时自动发送。',
    scenario_field_probability: '概率',
    scenario_field_probability_helper: '手动触发器将被随机选择，值越高概率越高。',
    scenario_field_after_hours: '在（小时）之后',
    scenario_field_after_hours_helper: '多少小时后应激活此触发器？将选择最长的触发器。',
    scenario_field_after_messages: '在（自上次事件以来的消息数）之后',
    scenario_field_after_messages_helper: '多少条消息后应激活此触发器？将选择最短的触发器。',
    scenario_btn_update: '更新',
    scenario_help_title: '场景事件帮助',
    scenario_help_triggers_msg: 'Events are triggers when:',
    scenario_help_greeting_msg: 'The very first time the user starts a chat',
    scenario_help_manual_msg: 'When the user uses the Trigger Event menu in the chat',
    scenario_help_opened_msg: 'When the user opens a chat with a character after some time',
    scenario_help_received_msg: 'When the character writes something',
    scenario_help_prompt_msg: 'Whenever an event is triggered, a prompt will be sent to the character.',
    scenario_help_world_msg: 'The event will be shown as if something happened independently of the character.',
    scenario_help_character_msg:
      'The event will be shown as if the character wrote it, for example if the character does something.',
    scenario_help_hidden_msg:
      'The event will be hidden from the user. This is useful to make the character do something, and make it look like it was on their own initiative.',
    scenario_help_ooc_msg:
      'The event will be hidden from the character. This is useful to give information or clues to the user.',
    scenario_help_processing_msg: 'The prompt text will have processing.',
    scenario_help_placeholders_msg: 'The {{char}} and {{user}} placeholders will be replaced',
    scenario_help_ooc_processing_msg:
      'Any text with (OOC: TEXT) will be hidden from the user, so you can add additional instructions for the character.',
    scenario_help_asterisks_msg:
      'It is recommended to wrap your text in *asterisks* unless you want the character to say the prompt text.',
    scenario_help_states_msg:
      'Finally, you can use the states to control which events are triggered under which conditions. The chat will keep track of a list of states, which can be assigned by events.',
    scenario_help_req_states_msg:
      'Required states are states that must exist in the chat to allow the trigger to run. You can also prefix a required state by ! to require the state not to exist in the chat for the event to run. You can specify multiple states by separating them with a comma.',
    scenario_help_assign_states_msg:
      'Assigned states are states that will be added to the chat whenever the event is triggered. You can also prefix an assigned state by ! to remove the state from the chat. You can specify multiple states by separating them with a comma.',
    scenario_help_random_msg: 'When multiple events can run, they will be randomly selected.',
    scenario_import_error_json: '文件不是有效的 JSON',
    scenario_import_error_schema: '文件不是受支持的场景（架构不正确）',
    scenario_import_error_invalid: '无效的场景',
    scenario_import_json_label: '场景 JSON 文件',
    scenario_import_supported_formats: '支持的格式：HuanYouAI',

    // Generation Presets
    gen_presets_title: '生成预设',
    gen_presets_new_preset: '新建预设',
    gen_presets_load_preset: '加载预设',
    gen_presets_save_preset: '保存预设',
    gen_presets_import_preset: '导入预设',
    gen_presets_delete_preset_confirm: '您确定要删除此预设吗？',
    gen_presets_name_label: '名称',
    gen_presets_name_helper: '预设的名称或简短描述',
    gen_presets_name_placeholder: '预设名称',
    gen_presets_id_label: 'ID',
    gen_presets_new_preset_id: '新预设',
    gen_presets_builtin_warning: '这是一个内置预设，无法保存。',
    gen_presets_copy_click_here: '点击这里',
    gen_presets_copy_helper_text: '如果您想创建此预设的副本。',
    gen_presets_select_preset_helper: '选择要开始编辑的预设。如果您当前正在编辑某个预设，它将不会出现在列表中。',
    gen_presets_filter_placeholder: '筛选...',
    gen_presets_providers_tab: '提供商',
    gen_presets_presets_tab: '预设',
    gen_presets_new_button: '新建',
    gen_presets_import_button: '导入',
    gen_presets_preset_json_label: '预设 JSON',
    gen_presets_imported: '已导入',
    gen_presets_imported_preset: '导入的预设',
    gen_presets_invalid_preset: '预设无效',
    gen_presets_could_not_parse: '无法解析预设',

    // Additional UI
    nav_charHub: '角色枢纽',
    nav_sagasPreview: '故事预览',
    nav_imageGeneration: '图像生成',
    nav_toggleTheme: '切换亮色/暗色模式',
    nav_newNotifications: '状态：您有 {count} 条新通知',
    nav_noNotifications: '状态：没有新通知',
    nav_subscribeCTA: '订阅以获得更高质量的聊天且无广告',
    home_modelsTitle: '模型',
    home_modelsMessage: 'HuanYouAI 现在托管自己的模型！在您的预设中选用 Agnaistic 服务即可免费开始',
    home_browserNoStorage: '您的浏览器不支持本地存储。您需要登录/注册才能使用 Agnaistic。',
    home_officialGuides: '官方指南',
    chat_forkConversation: '分支对话',
    chat_forkConfirm: '从此处分支将删除此消息之后的所有消息。您要继续吗？',
    chat_user_handle_you: '您',
    chat_user_anon_name: '用户 {id}',
    chat_bot_label: '机器人: {name}',
    chat_profile_label: '个人资料: {handle}',
    chat_ago: '{duration}前',
    chat_confirm_discard: '丢弃',
    chat_thinking: '思考中...',
    chat_reasoning_thought: '想法',
    chat_option_prompt: '提示词',
    chat_option_edit: '编辑',
    chat_option_fork: '分支',
    chat_option_regen: '重新生成',
    chat_option_attach: '附件',
    chat_option_visibility: '可见性',
    chat_option_delete: '删除',
    chat_option_gen_image: '生成图片',
    chat_option_gen_json: '生成JSON',
    chat_option_export: '导出',
    chat_removed_from_convo: '您已被移出对话',
    chat_unnamed_preset: '未命名预设',
    admin_notYetImplemented: '尚未实现',
    admin_noSubscriptionId: '没有订阅 ID',
    admin_session: '会话：',

    recentConversations: '最近对话',
    startConversation: '开始对话',
    guides: '指南',
    links: '链接',
    gettingStarted: '开始使用',
    createACharacter: '创建角色',
    configureYourAIServices: '配置您的AI服务',
    officialGuides: '官方指南',
    memoryBook: '记忆书',
    agnaisticDiscord: 'HuanYouAI Discord',
    github: 'GitHub',
    notableFeatures: '主要功能',
    lookingForHelp: '需要帮助开始使用吗？',
    checkOutThe: '查看',
    officialGuide: '官方指南',
    orHeadToThe: '或前往',

    // Guides
    guide_memory_title: '记忆书',
    guide_memory_text: `## 什么是记忆书？

记忆书是一种在与角色交谈时动态提供上下文的方法。你可以使用记忆书，而不是在“场景”、“角色设定”和“示例对话”中填满你的整个上下文预算。

## 它是如何工作的？

当你创建一个**记忆条目**时，你需要提供：\`关键字\`和\`条目\`文本。
你也可以提供\`优先级\`和\`权重\`值，我们稍后会讲到。

- 关键字：
  - 这些是“触发”记忆并将其插入提示词的词。
  - 例如：\`饮料, 口渴, 补水, 喝水\`
- 条目：
  - 这是当找到你的一个关键字时插入到你的提示词中的文本。
  - 例如：\`{{user}}最喜欢的饮料是加冰的红色果汁\`

你的生成设置将有一个**记忆深度**。这是 Agnai 将扫描关键字的最大聊天消息数量。
重要的是要记住，这一切都发生在你的浏览器中。

### 为什么记住这一切发生在浏览器中很重要？

*注意：这不适用于匿名/访客用户。访客用户始终可以使用整个聊天历史记录进行提示词构建。*

如果你将记忆深度配置为超过 \`100\`，关键字可能不会按你预期的方式触发。
当你最初加载聊天时，你将从服务器接收最多 100 条消息。你可以继续向上滚动以检索更多消息。

## 什么是优先级和权重？

简而言之，这两个值用于确定哪些记忆应包含在你的记忆预算（\`memory context limit\`）中，以及它们在提示词中出现的顺序。

### 优先级 (Priority)

该值越高，它就越“重要”。为了评估我们将哪些记忆包含在提示词中：

- 我们按优先级对记忆进行排序
- 我们将记忆逐个添加到提示词中，直到预算填满

### 权重 (Weight)

该值越高，记忆在记忆提示词中的位置就越靠后（越接近底部）。
理论上是：提示词中越靠下的内容，在生成响应时越重要。

在记忆被“修剪”以适应预算后，记忆将按权重进行排序。

## 你推荐什么样的记忆生成设置？

目前我还不确定。我很想听听你在尝试这些设置时的经验。

可供尝试的生成设置有：\`depth\`（深度）和 \`contextLimit\`（上下文限制）。

- **深度 (Depth)**：扫描关键字的最大聊天消息数。
- **上下文限制 (Context Limit)**：记忆提示词将从你的“最大上下文长度”中消耗的最大标记（token）数。`,
    guide_novel_title: 'NovelAI 指南',
    guide_novel_text: `# Novel 说明

设置 NovelAI 有两种方法：

**从 NovelAI 网站获取持久 API 令牌。**

1. 登录 [NovelAI](https://novelai.net/stories)
2. 打开“用户设置”并转到“帐户”选项tab
3. 按“获取持久 API 令牌”按钮
4. 复制（使用剪贴板按钮）/粘贴生成的令牌到 [NovelAI 设置页面](https://agnai.chat/settings?tab=ai&service=novelai)中的 \`Novel API Key\` 字段

API 密钥看起来像这样：

\`\`\`
pst-ykHYhtDti6ZYYmgCtUnhYraECciZQCEVMGhhh4HUgRf7XLQGzeDinQtCRECZJXWE
\`\`\`

或者

**使用开发人员工具从 NovelAI 网站手动检索您的令牌。**

1. 登录 [Novel AI](https://novelai.net/stories)
2. 使用以下方法之一打开开发人员工具：

   - \`Ctrl + Shift + I\`
   - 右键单击页面 --> 单击“检查”

3. 打开 \`Console\`（控制台）选项卡并输入：

- \`console.log(JSON.parse(localStorage.getItem('session')).auth_token)\`

4. 复制/粘贴生成的输出到您的 [NovelAI 设置页面](/settings?tab=ai&service=novelai)中的 \`Novel API Key\` 字段

API 密钥看起来像这样：

\`\`\`
eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6Ii4uLiIsImlhdCI6MTUxNjIzOTAyMn0.pCVUFONBLI_Lw3vKQG6ykCkuWNeG4cDhdEqRO_QJbh4
\`\`\`

请注意，此令牌将定期过期，需要每月更换一次。最好使用持久 API 令牌。`,
    guide_pipeline_title: 'Pipeline 指南',
    guide_pipeline_subtitle: '如何安装和使用 Agnai Pipeline API',
    guide_pipeline_text: `### 什么是 Pipeline API？
Pipeline API 允许您运行其他功能来增强您的对话。
支持 Agnai.chat 和本地托管的对话。
目前，仅提供使用 ChromaDB 的嵌入（Embedding）支持。

### 什么是嵌入？
嵌入类似于记忆书，但更复杂。它们不使用简单的“关键字”匹配，而是使用一种称为“语义相似性”的技术。
这意味着结果基于“它们含义的相似性或接近程度”。您的消息用于查询整个正文，结果是“含义最接近”的内容。
这意味着我们可以执行以下操作：
- 使用最后一条消息来“唤起 AI 的记忆”，并召回提示词中不再容纳的对话部分。
- 将 PDF 或文章的相关部分传递给 AI，以便根据该信息提供有意义的回复。

### 我该如何安装并运行 Pipeline？
- 您需要安装 [Node.JS v16+](https://nodejs.org/en/download) 和 [Python 3.10+](https://www.python.org/downloads/)。
- 使用 NPM 包安装 Agnaistic。在您的终端中运行：\`npm install agnai -g\`
- 在您的终端中运行 \`agnai --pipeline\`

### 我现在如何使用 Pipeline？
- 前往您的\`设置 -> AI 设置\`，启用“使用本地 Pipeline”并点击保存。
- 如果您的 Pipeline 成功连接，您将在主菜单中的\`记忆\`旁边看到一个通知和一个绿色信号条。
- 如果 Pipeline 断开连接，您可以点击菜单中\`记忆\`旁边的电源图标。

### 我该如何创建和使用嵌入？
- 在您的\`聊天选项 -> 记忆\`模式窗口中，您可以从维基百科文章或 PDF 创建嵌入。也可以在\`记忆 -> 嵌入\`页面完成。
- 创建后，从记忆模式窗口的下拉列表中选择嵌入，然后点击“使用嵌入”。


如果您提供嵌入信息，\`{{user_embed}}\` 占位符将自动注入到您的提示词中。
您也可以手动将此 \`{{user_embed}}\` 占位符添加到您的模板中。`,

    home_faq_title: '常见问题',
    home_faq_subtitle: '经常问的问题',
    home_faq_content: `### 我的回复被过滤了吗？
不，HuanYouAI 不会尝试过滤您的回复。

### 角色的回复经常在句中被切断。我该怎么办？
您可以尝试以下几点：
- 在您的**预设设置**中增加\`最大令牌\`。
- 如果您使用的是 **Horde**，请确保您的\`最大令牌\`不会“太高”。在您的**设置 -> Horde 设置**中，您可以点击\`选择工作者\`来查看每个工作者的“上下文和令牌”限制。确保您的\`最大令牌\`不超过其令牌限制。

### 如何在聊天中拥有多个个人资料或更改我的名字？
这可以通过**扮演角色**来实现。要扮演角色，请在主菜单中点击您的头像/名字。

### 我可以在聊天中拥有多个用户和角色吗？
是的。在您的**聊天选项**中，您可以从**参与者**中添加角色并邀请用户。

### 我可以编辑或删除我的聊天消息吗？
是的。在**聊天选项**中启用“聊天编辑”，您的聊天消息中就会出现额外的按钮。

### 我的回复在句中被切断了，我可以继续吗？
是的。在**输入选项**中，您可以选择“生成更多”。

### 我可以根据我的对话生成图像吗？
是的，您可以在**设置 -> 图像设置**中配置图像生成。
当您指定 Web URL 时，请确保它是使用 Local Tunnel 或 NGrok 等服务*公开访问*的。

### 你们支持文本转语音吗？
是的，在您的**设置 -> 语音设置**中，我们支持多种文本转语音服务。

### 我可以自定义 UI 吗？
是的，您可以在**设置 -> UI 设置**中更改 Agnaistic 的一些元素。

### 我是从“某个其他网站”过来的，如何让我的机器人表现得像在那个网站上一样？
所有前端的表现都略有不同。您可以通过修改**预设**中的**提示模板**来调整角色的行为。

### 我忘记了密码！
恢复您的帐户并不保证成功。您可以尝试在 [Discord](https://discord.agnai.chat) 上联系 Sceik 尝试恢复您的帐户。

### 我的问题在这里没有得到解答，我该去哪里问？
获得快速解答的最佳场所是在 [Discord](https://discord.agnai.chat) 上。

### 词汇表/术语：
- **输入选项**：从聊天文本输入的右侧（三点菜单）访问。
- **聊天选项**：从聊天窗口的右上方访问。
- **设置**：从主菜单中的“设置”链接访问。
- **AI 设置**：在您的设置页面中可用。
- **提示词**：发送到您的 AI 服务以生成回复的文本正文。
- **最大上下文长度**：发送到您的 AI 服务的提示词的最大长度。
- **最大令牌**：从您的 AI 服务收到的回复中的最大令牌数量。
- **预设**：也称为**生成设置**。这控制：
    - 您使用哪种 AI 服务
    - 您的*提示词*的格式/形状
    - *最大上下文长度*和*最大令牌*
    - “生成设置”，如“温度”、“重复惩罚”等。`,
    maxNewTokens: '最大新建令牌',
    username: '用户名',
    password: '密码',
    confirmPassword: '确认密码',
    displayName: '显示名称',
    passwordsDoNotMatch: '密码不匹配',
    invalidCallbackUrl: '无效的回调 URL',
    loggingIn: '登录中...',
    registering: '注册中...',
    welcomeToAccount: '欢迎',
    authorizing: '授权中',
    youAreAlreadyLoggedIn: '您已经登录。',
    toYourAccount: '登录您的帐户',
    orContinueAsGuest: '或继续以访客身份使用。',
    failedToLogIn: '登录失败。',
    somethingWentWrong: '出了问题。',
    couldNotReachServers: '无法连接到服务器。',
    byLoggingIn: '通过登录或注册，您同意您已年满18岁并同意',
    youAgree: '您同意',
    and: '和',
    whyRegister: '为什么要注册？',
    youDontNeedToRegister: '您不需要注册即可使用HuanYouAI。您可以匿名使用，不会在服务器上存储任何数据。',
    ifYouChooseToRegister: '如果您选择注册',
    yourDataWillBeStored: '您的数据将被存储，并可在您登录的任何设备上访问。',

    // Admin
    admin_serverConfiguration: '服务器配置',
    admin_general: '常规',
    admin_images: '图像',
    admin_voice: '语音',
    admin_supportEmail: '支持电子邮件',
    admin_supportEmailHelper: '如果提供，将在主导航中添加此电子邮件的链接',
    admin_maintenanceModeEnabled: '启用维护模式',
    admin_maintenanceModeHelper: '注意：如果数据库不可用，此标志将不起作用。请改用环境变量。',
    admin_maintenanceMessage: '维护消息',
    admin_maintenanceMessageHelper: '支持 Markdown',
    admin_stripeCustomerPortal: 'Stripe 客户门户',
    admin_lockDuration: '锁定持续时间（秒）',
    admin_lockDurationHelper: '用户级锁定的最大 TTL - 设置为零 (0) 以禁用',
    admin_googleClientId: 'Google 客户端 ID',
    admin_googleClientIdHelper: '用于登录',
    admin_slotsConfiguration: '插槽配置',
    admin_slotsConfigurationHelper: '必须是 JSON。与远程插槽配置合并 -- 此配置会覆盖 slots.txt',
    admin_format: '格式化',
    admin_enablePolicies: '启用政策',
    admin_enablePoliciesHelper: '显示服务条款和隐私声明',
    admin_privacyStatement: '隐私声明',
    admin_apiAccessLevel: 'API 访问级别',
    admin_off: '关闭',
    admin_allUsers: '所有用户',
    admin_subscribers: '订阅者',
    admin_administrators: '管理员',
    admin_maxGuidanceTokens: '最大引导令牌',
    admin_maxGuidanceTokensHelper: '传奇/引导模板可以请求的最大令牌数。设置为 0 以禁用。',
    admin_maxGuidanceVariables: '最大引导变量',
    admin_maxGuidanceVariablesHelper: '传奇/引导模板可以请求的最大变量数。设置为 0 以禁用。',
    admin_imagesHost: '图像主机 (兼容 A1111)',
    admin_imagesLoraUrl: '图像 LoRA URL',
    admin_defaultImageModel: '默认图像模型',
    admin_imageModels: '图像模型',
    admin_add: '添加',
    admin_addModel: '添加模型',
    admin_description: '描述',
    admin_modelDescriptionPlaceholder: '模型描述...',
    admin_url: 'URL',
    admin_loraSupport: 'LoRA 支持',
    admin_host: '主机',
    admin_modelNamePlaceholder: '模型名称...',
    admin_override: '覆盖',
    admin_level: '级别',
    admin_prefix: '前缀',
    admin_suffix: '后缀',
    admin_negative: '负面提示词',
    admin_steps: '步数',
    admin_init: '初始',
    admin_max: '最大',
    admin_cfgScale: 'CFG 比例',
    admin_width: '宽度',
    admin_height: '高度',
    admin_clipSkip: 'Clip 跳过',
    admin_voiceAccessLevel: '语音访问级别',
    admin_voiceHost: '语音主机',
    admin_voiceHostHelper: '包含路径的完整 URL - 包含任何查询参数',
    admin_voiceApiKey: '语音 API 密钥',
    admin_metrics: '指标',
    admin_refresh: '刷新',
    admin_onlineUsers: '在线用户',
    admin_versions: '版本',
    admin_maxOnlineUsers: '最大在线用户',
    admin_registeredUsers: '注册用户',
    admin_services: '服务',
    admin_messageAllUsers: '向所有用户发送消息',
    admin_send: '发送',
    admin_confirmMessageAll: '您确定要向所有用户发送消息吗？',
    admin_userManagement: '用户管理',
    admin_backToManage: '返回管理',
    admin_customerId: '客户 ID',
    admin_subscribed: '已订阅',
    admin_search: '搜索',
    admin_reset: '重置',
    admin_info: '信息',
    admin_impersonate: '模拟身份',
    admin_changePassword: '更改密码',
    admin_banUser: '封禁用户',
    admin_unbanUser: '解封用户',
    admin_userId: '用户 ID',
    admin_banned: '已封禁',
    admin_handle: '用户名/昵称',
    admin_subscriptionDetails: '订阅详情',
    admin_gift: '礼物',
    admin_expiry: '到期时间',
    admin_apply: '应用',
    admin_assignSub: '分配订阅',
    admin_stripeSubscriptionId: 'Stripe 订阅 ID',
    admin_assign: '分配',
    admin_sessionIds: '会话 ID',
    admin_subscriptionLevel: '订阅级别',
    admin_native: '原生',
    admin_manual: '手动',
    admin_periodStart: '周期开始',
    admin_renewsAt: '续订于',
    admin_downgradingAt: '降级于',
    admin_cancelledAt: '取消于',
    admin_cancelsAt: '取消于',
    admin_state: '状态',
    admin_history: '历史记录',
    admin_noReasonGiven: '未提供原因',
    admin_banReason: '封禁原因',
    admin_resetLink: '重置链接',
    admin_generateLink: '生成链接',
    admin_manageAnnouncements: '管理公告',
    admin_created: '已创建',
    admin_hide: '隐藏',
    admin_unhide: '取消隐藏',
    admin_delete: '删除',
    admin_instructions: '使用说明',
    admin_deleted: '已删除',
    admin_hidden: '隐藏',
    admin_pending: '待处理',
    admin_active: '活动',
    admin_announcement: '公告',
    admin_title: '标题',
    admin_displayAtRequired: '“显示于” 为必填',
    admin_errorProductNotFound: '未找到产品：{id}',
    admin_errorProductNoPrice: '产品没有默认价格：{id}',
    admin_errorPriceNotFound: '未找到价格：{id}',
    admin_location: '位置',
    admin_home: '主页',
    admin_notification: '通知',
    admin_locationHelper: '显示在主页或通知列表中',
    admin_userLevelThreshold: '用户等级（阈值）',
    admin_userLevelThresholdHelper: '向等级大于或等于该等级的用户发布公告 `所有用户 = -1` `已订阅 = 0`',
    admin_content: '内容',
    admin_hideAnnouncement: '隐藏公告',
    admin_displayAt: '显示于',
    admin_now: '现在',
    admin_id: 'ID',
    admin_name: '名称',
    admin_apiAccessCapable: '支持 API 访问',
    admin_guidanceAccessCapable: '支持 Guidance (V2) 访问',
    admin_imagesAccessCapable: '支持图像生成访问',
    admin_patreonTier: 'Patreon 层级',
    admin_preview: '预览',
    admin_stripeProduct: 'Stripe 产品',
    admin_enabled: '已启用',
    admin_disableSlots: '禁用插槽',
    admin_subscriptionTier: '订阅层级',
    admin_backToSubscriptions: '返回订阅',
    admin_noPaymentRequired: '无需付款',
    admin_descriptionHelper: '这将使用 markdown 渲染器渲染。这里也支持 HTML。',
    admin_apiAccessHelper: '如果启用，如果服务器允许，该层级可以使用 API 访问',
    admin_guidanceAccessHelper: '如果启用，如果服务器/预设允许，该层級可以使用 GuidanceV2',
    admin_imagesAccessHelper: '如果启用，该层级可以使用 HuanYouAI 图像生成',
    admin_patreonTierHelper: '如果链接了 Patreon，则需要最低层级',
    admin_enabledHelper: '如果禁用，该层级将不供用户选择。',
    admin_disableSlotsHelper: '该层级将阻止插槽渲染',
    admin_subscriptions: '订阅',
    admin_model: '模型',
    admin_tier: '层级',
    admin_noTiers: '无层级',
    admin_tiers: '层级',
    admin_models: '模型',
    admin_disabled: '已禁用',
    admin_default: '默认',
    admin_stripe: 'Stripe',
    admin_patreon: 'Patreon',
    admin_unset: '未设置',
    admin_confirmDeleteSubscription: '您确定要删除此订阅吗？',
    admin_subscriptionModel: '订阅模型',
    admin_loadPreset: '加载预设',
    admin_newSubscription: '新订阅',
    admin_replaceSupercede: '替换/取代',
    admin_modelHelper: '仅限 HuanYouAI 服务',
    admin_modelServiceUrl: '模型服务 URL',
    admin_modelServiceUrlHelper: '仅限 HuanYouAI 服务',
    admin_guidanceCapable: '支持引导',
    admin_guidanceCapableHelper: '仅限 HuanYouAI 服务',
    admin_subscriptionDisabled: '订阅已禁用',
    admin_subscriptionDisabledHelper: '禁用此订阅的使用',
    admin_isDefaultSubscription: '是默认订阅',
    admin_isDefaultSubscriptionHelper: '当请求中未提供订阅时，将其作为回退选项',
    admin_jsonSchemaCapable: '支持 JSON Schema（结构化响应）',
    admin_visionModel: '视觉模型',
    admin_visionModelHelper: '仅限 HuanYouAI 服务',
    admin_allowGuestUsage: '允许访客使用',
    admin_allowGuestUsageHelper: '通常用于默认订阅。要求用户登录以使用此订阅。',
    admin_tokenizerOverride: '分词器覆盖',
    admin_tokenizerOverrideHelper: '可选。用于自定义模型。',
    admin_confirmDeletePreset: '您确定要删除此预设吗？',
    admin_replaceSubscription: '替换订阅',
    admin_replacementSubscription: '替换订阅',
    admin_replacementSubscriptionHelper: '将取代当前订阅的订阅',
    admin_replace: '替换',
    admin_levels: '等级',
    admin_subLevel: '订阅等级',
    admin_tokens: '令牌',
    admin_context: '上下文',
    admin_copySubscription: '复制订阅',
    admin_createSubscription: '创建订阅',
    admin_editSubscription: '编辑订阅',
    admin_selectAIServiceBeforeSaving: '保存前必须选择 AI 服务',
    admin_preset: '预设',
    admin_presetHelper: '选择一个预设开始编辑。如果您当前正在编辑一个预设，它将不会出现在列表中。',
    admin_apiKey: 'API 密钥',
    admin_apiKeyHelper: '（可选）如果适用，请提供您的 AI 服务的 API 密钥。',
    admin_apiKeyIsSet: 'API 密钥已设置',
    admin_apiKeyIsNotSet: 'API 密钥未设置',
    admin_subscriptionLevelHelper: '任何高于 -1 的级别都需要“订阅”。默认情况下所有用户都是 -1。',
    admin_replacementIdNotSet: '未设置替换 ID',

    // Profile
    profile_myProfile: '我的个人资料',
    profile_updateProfile: '更新个人资料',
    profile_impersonateNote: '您可以通过点击主菜单顶部的“角色扮演”按钮来模拟角色。',
    profile_linkGoogle: '链接 Google 帐户以启用 Google 登录',
    profile_accountLinkedGoogle: '您的帐户已链接到 Google',
    profile_unlinkGoogle: '取消链接 Google 帐户',
    profile_userIdHelper: '您的用户 ID。其他人可以使用它向您发送聊天邀请。',
    profile_usernameHelper: '您的用户名。这无法更改。您永远不需要分享您的用户名。',
    profile_displayNameHelper: '您在聊天中和他人的显示名称（未模拟身份时）',
    profile_profileImage: '个人头像',
    profile_removeAvatar: '删除头像',
    profile_fileSizeLimit2MB: '文件大小限制为 2MB',
    profile_guestData: '访客数据',
    profile_prepareBackup: '准备备份',
    profile_backupNotReady: '备份未就绪',
    profile_downloadGuestData: '下载访客数据',
    profile_unimpersonate: '取消模拟身份',
    profile_logout: '登出',
    profile_deleteAccount: '删除帐户',
    profile_importGuestDataWarning: '这将替换您所有现有的访客数据。您确定吗？',
    profile_importFailed: '导入失败：{message}',
    profile_changePassword: '更改密码',
    profile_changePasswordDescription: '此窗口允许您更改帐户密码',
    profile_updatePassword: '更新您的密码',
    profile_newPassword: '新密码',
    profile_confirmPassword: '确认密码',
    profile_deleteAccountWarning: '这是不可逆的！帐户一旦删除将无法恢复。',
    profile_deleteAccountConfirmNote: '输入您的用户名，然后点击“确认”以确认删除您的帐户',
    profile_confirmDeletion: '确认删除',

    // Settings
    settings_title: '设置',
    settings_updateSettings: '更新设置',
    settings_thisCannotBeUndone: '这将无法撤销！',
    settings_deleteGuestState: '删除访客状态',
    settings_ui_theme: '主题',
    settings_ui_chat: '聊天',
    settings_ui_messages: '消息',
    settings_ui_color: '颜色',
    settings_ui_mode: '模式',
    settings_ui_dark: '深色',
    settings_ui_light: '浅色',
    settings_ui_siteFontSize: '网站字体大小',
    settings_ui_backgrounds: '背景',
    settings_ui_resetToDefault: '重置为默认',
    settings_ui_backgroundColor: '背景颜色',
    settings_ui_backgroundImage: '背景图片',
    settings_ui_remove: '移除',
    settings_ui_font: '字体',
    settings_ui_custom: '自定义',
    settings_ui_responseHints: '响应提示',
    settings_ui_responseHintsHelper: '在消息中添加提示以引导响应',
    settings_ui_avatarWrapAround: '头像环绕',
    settings_ui_avatarWrapAroundHelper: '允许消息中的文本“环绕”头像',
    settings_ui_trimIncompleteSentences: '修剪不完整的句子',
    settings_ui_expandReasoning: '默认展开推理',
    settings_ui_expandReasoningHelper: '推理想法默认是折叠的。启用此项以默认展开它们。',
    settings_ui_midReasoningBehavior: '中途推理行为',
    settings_ui_midReasoningBehaviorHelper: '当推理处于响应中间时，应保留哪个话语（即非想法）',
    settings_ui_anonymizeChat: '匿名化聊天',
    settings_ui_anonymizeChatHelper: '在对话中隐藏个人资料名称。通常用于截图。',
    settings_ui_sendOnEnterOnMobile: '移动端回车发送',
    settings_ui_sendOnEnterOnMobileHelper: '“Enter”将发送消息而不是添加换行符（仅限移动端）',
    settings_ui_textSpeed: '文本速度',
    settings_ui_textSpeedHelper: '控制文本流出的速度。设置为 `0` 以禁用。',
    settings_ui_viewMode: '视图模式',
    settings_ui_viewModeHelper: '标准：消息占据整个聊天屏幕。分割：角色头像显示在屏幕顶部。背景：角色头像将成为聊天背景。',
    settings_ui_splitHeight: '分割高度 (%)',
    settings_ui_splitHeightHelper: '分割模式下角色头像的最大高度',
    settings_ui_standard: '标准',
    settings_ui_split: '分割',
    settings_ui_backgroundAuto: '背景：自动',
    settings_ui_backgroundCover: '背景：覆盖',
    settings_ui_backgroundContain: '背景：包含',
    settings_ui_defaultAll: '默认 (全部)',
    settings_ui_all: '全部',
    settings_ui_afterThought: '思考后',
    settings_ui_beforeThought: '思考前',
    settings_ui_avatars: '头像',
    settings_ui_size: '大小',
    settings_ui_cornerRadius: '圆角半径',
    settings_ui_width: '宽度',
    settings_ui_height: '高度',
    settings_ui_messageBackgroundColor: '消息背景颜色',
    settings_ui_botMessageBackgroundColor: '机器人消息背景颜色',
    settings_ui_chatTextColor: '聊天文本颜色',
    settings_ui_chatEmphasisColor: '聊天强调颜色',
    settings_ui_chatQuoteColor: '聊天引用颜色',
    settings_ui_chatQuoteEmphasisColor: '聊天引用强调颜色',
    settings_ui_chatQuoteEmphasisWeight: '聊天引用强调粗细',
    settings_ui_contentWidth: '内容宽度',
    settings_ui_messageOpacity: '消息透明度',
    settings_ui_messageOpacityHelper: '聊天窗口中消息块的透明度。',
    settings_ui_inlineMessageOptions: '内联消息选项',
    settings_ui_inlineMessageOptionsHelper: '启用哪些消息选项在消息中“内联”显示。其余选项将位于“更多选项”下拉菜单中',
    settings_ui_preview: '预览',
    settings_ui_none: '无',
    settings_ui_bold: '加粗',
    settings_ui_narrow: '窄',
    settings_ui_large: '大',
    settings_ui_xlarge: '特大',
    settings_ui_2xlarge: '超大',
    settings_ui_3xlarge: '极大',
    settings_ui_100: '100%',
    settings_ui_msg_edit: '编辑',
    settings_ui_msg_regenerate: '重新生成',
    settings_ui_msg_promptView: '提示词视图',
    settings_ui_msg_fork: '分支',
    settings_ui_msg_delete: '删除',
    settings_ui_msg_attach: '附加',
    settings_ui_msg_visibility: '可见性',
    settings_ui_msg_genImage: '生成图像',
    settings_ui_msg_genJson: '生成 JSON',
    settings_ai_embeddings: '嵌入/长期记忆',
    settings_ai_embeddingsHelper: '禁用时可提高网站性能。如果您的聊天出现延迟且无响应，请禁用长期记忆。',
    settings_ai_presets: '预设',
    settings_ai_chargen: '角色字段生成',
    settings_ai_useServerDefault: '使用服务器默认设置',
    settings_ai_chatSummary: '聊天摘要',
    settings_ai_useActiveChatPreset: '使用当前聊天预设',
    settings_ai_jsonSchemas: 'JSON 模式/输出',
    settings_ai_defaultPreset: '默认预设',
    settings_ai_defaultPresetHelper: '创建新聊天时最初选择的预设。',
    settings_ai_apiAccessTitle: 'HuanYouAI API 访问',
    settings_ai_howToUseApi: '如何使用 API 访问',
    settings_ai_apiAccessPreset: '默认/API 访问预设',
    settings_ai_apiAccessPresetHelper: '使用 API 访问时使用的预设。也是创建新聊天时最初选择的预设。',
    settings_ai_apiKey: 'API 密钥',
    settings_ai_revealKey: '显示密钥',
    settings_ai_generateKey: '生成密钥',
    settings_ai_regenerateKey: '重新生成密钥',
    settings_ai_apiKeyHidden: 'API 密钥已隐藏',
    settings_ai_lookingForProviders: '在寻找服务商部分吗？',
    settings_ai_headToPresets: '前往预设页面',
    settings_ai_editSummaryPreset: '编辑摘要预设',
    settings_ai_apiAccessHelp: '订阅者 API 端点使用 OpenAI 文本补全或 OpenAI 聊天补全格式。\n\n这些端点的完整 URL 为：\n- https://api.agnai.chat/v1/completions\n- https://api.agnai.chat/v1/chat/completions\n\n说明：\n1. 选择您的 API 访问预设：此预设将用于您的 API 调用。在设置页面更改此项。\n2. 生成您的 API 密钥。\n3. 使用 API URL https://api.agnai.chat 或 https://api.agnai.chat/v1 以及您生成的 API 密钥。',
    settings_voice_sttTitle: '语音转文本（使用麦克风说话）',
    settings_voice_sttNotAvailable: '您的浏览器不支持语音转文本',
    settings_voice_sttHelper: '您可以通过使用输入文本框中的麦克风图标来使用语音识别。',
    settings_voice_sttEnabled: '已启用',
    settings_voice_sttEnabledHelper: '是否显示麦克风按钮。',
    settings_voice_sttAutoSubmit: '自动提交',
    settings_voice_sttAutoSubmitHelper: '是否在句子完成后自动发送消息。',
    settings_voice_sttAutoRecord: '自动恢复录音',
    settings_voice_sttAutoRecordHelper: '是否在收到消息后重新开始录音。',
    settings_voice_ttsTitle: '文本转语音（角色语音）',
    settings_voice_ttsHelper: '您需要在角色编辑页面配置语音。',
    settings_voice_ttsEnabled: '已启用',
    settings_voice_ttsEnabledHelper: '配置了语音的角色将自动说话。',
    settings_voice_ttsFilterActions: '过滤动作文本',
    settings_voice_ttsFilterActionsHelper: '跳过星号和括号中的文本。',
    settings_voice_voiceServices: '语音服务',
    settings_voice_agnaistic: 'HuanYouAI',
    settings_voice_webspeechsynthesis: '网页语音合成',
    settings_voice_elevenlabs: 'ElevenLabs',
    settings_voice_novel: 'NovelAI 文本转语音',

    // Character
    char_advancedOptions: '高级选项',
    char_systemPrompt: '角色系统提示词（可选）',
    char_systemPromptHelper: '应用于角色的全局指令集。',
    char_systemPromptPlaceholder: '进入角色扮演模式。您将在 {{char}} 和 {{user}} 之间的对话中编写 {{char}} 的下一个回复。不要决定 {{user}} 说什么或做什么。使用互联网角色扮演风格，例如不使用引号，并以第三人称斜体编写用户动作，如：*示例*。允许使用 markdown。保持主动、创意，推动情节和对话前进。至少写一个段落，最多四个。始终保持角色形象。始终保持对话进行。（强烈不建议重复）',
    char_jailbreak: '角色越狱（可选）',
    char_jailbreakHelper: '应用于对话历史末尾的指令。有助于确保角色的性格特征。',
    char_jailbreakPlaceholder: '至少写四个段落。',
    char_insertDepthPrompt: '插入 / 深度提示词',
    char_insertDepthPromptHelper: '在对话历史中的 {depth} 处插入的一组指令。',
    char_insertDepth: '插入深度',
    char_insertDepthHelper: '应该存在于插入提示词下方的消息数量。介于 1 和',
    char_creator: '创建者（可选）',
    char_creatorPlaceholder: '例如 John1990',
    char_version: '角色版本（可选）',
    char_versionPlaceholder: '任何文本，例如 1, 2, v1, v1fempov...',
    char_chats: '聊天',
    char_noConversations: '没有对话',
    char_chatActivity: '聊天活动',
    char_botActivity: '机器人活动',
    char_chatCreated: '聊天创建时间',
    char_botName: '机器人名称',
    char_botCreated: '机器人创建时间',
    char_chatCounts: '聊天计数',
    char_allCharacters: '所有角色',
    char_confirmDeleteChat: '您确定要删除此对话吗？',
    char_noConversationsYet: '您还没有对话。',
    char_noConversationsWith: '您与以下角色没有对话：',
    char_lastModified: '最后修改',
    char_lastConversed: '最后对话',
    char_created: '创建时间',
    char_select: '选择',
    char_archiveSelected: '归档 {count} 个角色？',
    char_unarchiveSelected: '取消归档 {count} 个角色？',
    char_deleteSelected: '您确定要删除 {count} 个角色吗？',
    char_searchByName: '按名称搜索...',
    char_selectedNone: '已选择：无',
    char_selectedCount: '已选择：{count}',
    char_favorites: '收藏',
    char_editingTitle: '正在编辑：{name}',
    char_noCharactersFound: '未找到角色',
    char_toGetStarted: '开始吧！',
    char_jsonStructuredResponsesHelper: '使用 JSON 请求和结构化响应。仅在 JSON 模式可用时使用',
    char_updateSchema: '更新模式',
    char_editingSchema: '编辑模式',
    char_testSchema: '测试模式',
    char_templateReferencesUndefined: '模板引用了未定义的占位符：',
    char_responseTemplateWarning: '警告：历史或响应模板中未包含 {{response}}。{{response}} 字段始终生成，强烈建议使用。',
    char_invalidJsonSchema: '无效的 JSON 模式：',
    char_deleteChatsWarning: '这将删除与此角色关联的所有聊天！',
    char_newChat: '新聊天',
    char_new: '新建',
    char_unfavorite: '取消收藏',
    char_duplicate: '复制',
    char_downloadRetreiveFailed: '检索下载角色失败：',
    char_imageCard: '图像卡',
    char_textgen: '文本生成',
    char_downloadJson: '下载 (JSON)',
    char_downloadPng: '下载 (PNG)',
    char_createACharacterTitle: '创建角色',
    char_editACharacterTitle: '编辑角色',
    char_copyACharacterTitle: '复制角色',
    char_tokensPermanent: '{totalTokens} 令牌, {totalPermanentTokens} 永久',
    char_aiCharacterGenerationGuide: 'AI 角色生成指南',
    char_characterOverridesWarning: '警告！您的聊天当前覆盖了角色定义。在您于“编辑聊天”菜单中禁用它们之前，这些更改不会影响当前聊天。',
    char_temporaryCharacterWarning: '您正在 {action} 一个临时角色。临时角色仅存在于当前聊天中。',
    char_clearEditorConfirm: '您确定要清除编辑器吗？',
    char_descriptionCreatorsNotesHelper: '角色的描述、标签或注记。这不会以任何方式影响您的角色。',
    char_tagsHelper: '用于帮助您组织和过滤角色。',
    char_scenario: '场景',
    char_scenarioHelper: '对话和角色的当前环境和上下文。',
    char_personality: '个性',
    char_personalityWarning: '警告：“纯文本”和“非纯文本”模式不兼容。在它们之间切换将导致数据丢失。',
    char_greeting: '问候语',
    char_greetingHelper: '角色的第一条消息。建议提供较长的第一条消息，以鼓励角色提供较长的回复。',
    char_greetingPlaceholder: '例如：*当你走进房间时我微笑着* 你好，{{user}}！真不敢相信已经到午餐时间了！我们要去哪里？',
    char_sampleConversation: '示例对话',
    char_sampleConversationHelper: '您与角色之间的示例聊天。本部分对于教授角色如何说话非常重要。',
    char_voiceHelper: '开启此项以禁用此角色自动发言',
    char_languageHelper: '此角色说和理解的语言。',
    char_languageNote: ' 注意：要使用非英语语言，您还需要翻译预设 gaslight。',
    char_imageSettingsMoved: '图像设置已移动：点击主菜单中的',
    char_inMainMenu: '',
    char_avatarOrJsonFile: '头像或 JSON 文件',
    char_charactersToImport: '要导入的角色：',
    char_andOneOther: '... 以及另一个',
    char_andOthers: '... 以及其他 {count} 个',
    char_failedCharacterImports: '角色导入失败：',
    char_persona: '人格',
    char_images: '图像',
    char_advanced: '高级',
    char_attributesFormat: '属性 (键: 值)',
    char_plainTextFormat: '纯文本',
    char_downloadSuccess: '成功从 Character Hub 下载',
    char_downloadFailed: 'Character Hub 下载失败: {message}',
    char_sampleConversationPlaceholder: '{{char}}: *微笑并挥手* 你好！我很高兴你能来！',
    char_unnamed: '未命名',
    char_importChatLog: '导入聊天记录',
    char_chatLogAccepted: '聊天记录已接受',
    char_invalidChatLogFormat: '无效的聊天记录文件格式。支持格式：HuanYouAI, TavernAI',
    char_chatLogImportFor: '您的聊天记录将导入为 {name}。',
    char_jsonLinesFile: 'JSON Lines 文件 (.jsonl)',
    char_messagesToImport: '将导入 {count} 条消息。',
    chat_chatWith: '聊天',
    chat_notesFromCreator: '来自 {name} 创建者的注记',
    chat_generateMessage: '生成消息',
    chat_forkConversationConfirm: '这将从问候消息处分支您的对话。',
    chat_sendAMessage: '发送消息...',
    chat_sendAMessageTo: '发送消息给 {name}...',
    chat_confirmCancelSwipe: '发送前请确认或取消滑动',
    chat_respondAsMe: '以我的身份响应',
    chat_autoReply: '自动回复',
    chat_none: '无',
    chat_stopBotReply: '停止机器人回复',
    chat_generateImage: '生成图像',
    chat_respondAgain: '再次响应',
    chat_generateMore: '生成更多',
    chat_playVoice: '播放语音',
    chat_triggerEvent: '触发事件',
    chat_attachImage: '附加图像',
    chat_responseHint: '响应提示...',
    chat_invalidFileTypeImage: '无效的文件类型：必须是图像',
    chat_attachmentExceedsLimit: '附件超过大小限制 (1MB)',
    chat_loading: 'HuanYouAI 加载中...',
    chat_participants: '参与者',
    chat_editChat: '编辑聊天',
    chat_memory: '记忆',
    chat_ui: '界面',
    chat_graph: '聊天图表',
    chat_screenshot: '屏幕截图',
    chat_anonymize: '匿名化',
    chat_hideOocMessages: '隐藏 OOC 消息',
    chat_mainCharacter: '主要角色',
    chat_beginning_group: '这是群组对话的开始。',
    chat_beginning_with: '这是您与 {name} 对话的开始。',
    chat_restart: '重新开始',
    chat_loadingWait: '加载中，请稍候...',
    chat_screenshotFailedElement: '截图失败：找不到消息元素',
    chat_screenshotFailedConsole: '截图失败：错误已记录在控制台',
    chat_ooc_suffix: '(OOC)',
    chat_msg_id: 'ID',
    chat_msg_chat: '聊天',
    chat_msg_descendants: '后代',
    chat_pending_retrying: '正在重试',
    chat_pending_waiting: '正在等待',
    chat_pending_chatId: '会话 ID',
    chat_graph_root: '根节点',
    chat_avatar_modal_title: '头像预览',
    chat_graph_circular_error: '无效的会话树：包含循环引用',
    char_listView: '列表视图',
    char_cardsView: '卡片视图',
    char_folderView: '文件夹视图',
    char_failedToLoad: '加载角色失败。刷新重试。',
    char_jsonStructuredResponses: 'JSON 结构化响应',
    char_jsonStructuredWarning: '警告：并非所有模型都支持 JSON 输出/响应。',
    char_responseTemplate: '响应模板',
    char_responseTemplateHelper: '消息在聊天中的显示方式',
    char_historyTemplate: '历史模板',
    char_historyTemplateHelper: '消息在提示词中的显示方式',
    char_imageCaptionTemplate: '图像描述模板',
    char_imageCaptionTemplateHelper: '用于自动填充图像生成的“图像提示词”。',
    char_jsonSchemaFile: 'JSON Schema 文件 (.json)',
    char_confirmDeletion: '确认删除',
    char_confirmDeletionMessage: '您确定要删除此角色吗？',
    char_toggleFavorite: '切换收藏',
    char_openRecentChat: '打开最近聊天',
    char_openCharacterChats: '打开角色聊天',
    char_favorite: '收藏',
    char_downloadCharacter: '下载角色',
    char_outputFormat: '输出格式',
    char_fileType: '文件类型',
    char_characterName: '角色名称',
    char_descriptionCreatorsNotes: '描述 / 创建者注记',
    char_tags: '标签',
    char_scenarioPlaceholder: '例如 {{char}} 正在办公室工作。{{user}} 推门而入。',
    char_formatAsIsHelper: '如果您不知道这是什么意思，可以保持原样。',
    char_formatToUseHelper: '角色格式使用的格式',
    char_firstMessagePlaceholder: '{{char}}: *微笑并挥手* 你好！我很高兴你能来！',
    char_voice: '语音',
    char_disableVoice: '禁用角色语音',
    char_updatePreset: '更新预设',
    char_presetUsedForGeneration: '此预设用于角色生成',
    char_foldersGuide: '文件夹指南',
    char_foldersInstructions: '- 将角色拖到新文件夹以创建新文件夹\n- 将角色拖到文件夹上以移动角色',
    char_currentFolder: '当前文件夹',
    char_newFolder: '新文件夹',
    char_generateAvatar: '生成头像',
    char_impersonate: '模拟身份',
    char_changeChatPersona: '更改您当前的聊天身份。',
    char_changeDefaultPersona: '更改您的默认身份。',
    char_impersonationHelper: '使用角色模拟功能以另一个身份发言',
    char_failedImports: '导入失败的角色：',
    char_multiUserNote: "注意：目前不支持多用户聊天。所有消息将",
    char_alternateGreeting: '角色的备用问候语',
    char_appearancePrompt: '外观提示词（用于头像生成）',
    char_characterBook: '角色书',
    char_noCharacterBook: '此角色没有角色书。',
    char_hasCharacterBook: '此角色有角色书。',
    char_characterMemory: '角色记忆',
    char_characterDesigner: '角色设计器',
    char_root: '根目录',
    char_changeFolderTitle: '更改文件夹: {name}',
    char_folderNamesNormalized: '文件夹名称已“标准化”。',
    char_normalizedName: '标准化名称: {name}',
    char_openchats_with: '打开与 {name} 的聊天',
    char_remove_from_favorites: '从收藏角色中移除 {name}',
    char_add_to_favorites: '将 {name} 添加到收藏角色',
    char_create_new_chat_with: '创建与 {name} 的新聊天',
    char_download_character_name: '下载角色 {name}',
    char_edit_character_name: '编辑角色 {name}',
    char_duplicate_character_name: '克隆角色 {name}',
    char_delete_character_name: '删除角色 {name}',
    char_save: '保存',
    char_drag_to_move: '拖动图标以移动角色',
    char_drag_to_new_folder: '将角色拖到“新文件夹”以创建新文件夹',
    char_drag_onto_folder: '将角色拖到文件夹上以移动角色',
    char_regenerate_tooltip: '必须填写名称和描述',
    char_regenerate_warn: '填写名称和描述以进行生成',
    char_reel_send_to_editor: '发送到编辑器',
    char_insert_depth_placeholder: '例如：### 指令：像詹姆斯·乔伊斯一样写作。',
    char_importMemoryBook: '导入记忆书',
    char_editBook: '编辑记忆书',
    char_deleteBook: '删除记忆书',
    char_createNewBook: '创建新记忆书',
    char_hasNoCharacterBook: '该角色暂无记忆书。',
    char_addAlternateGreeting: '添加备用问候语',
    char_alternateGreetingPlaceholder: '写一条备用问候语……',
    char_voiceService: '语音服务',
    char_voiceLoading: '正在加载语音列表……',
    char_openCharacterBuilder: '打开角色构建器',
    char_selectAvatarImage: '选择头像图片',
    char_appearancePromptPlaceholder: '描述一下角色的外貌……',
    char_visualTypeAvatar: '头像',
    char_visualTypeSprite: '立绘',
    char_personaTab: '人设',
    char_voiceTab: '语音',
    char_imagesTab: '图片',
    char_advancedTab: '高级',
    char_currentChatPersona: '当前会话人设',
    char_defaultPersona: '默认人设',
    char_impersonateDescription: '请选择本次对话要使用的人设。',
    char_useMyProfile: '使用我的个人资料',
    char_currentLabel: '当前',
    char_defaultLabel: '默认',
    char_defaultForNewConvos: '新会话默认人设',
    char_jsonSchemaGenerationStatus: 'JSON Schema 已生成。',
    char_tempJsonSchemaUpdated: '临时 JSON Schema 已更新。',
    char_characterHubDownloadSuccess: '角色库下载成功。',
    char_characterHubDownloadFailed: '角色库下载失败：{message}',
    char_recommended: '推荐',
    char_unrecognizedFormat: '无法识别的格式',
    char_open_recent_chat: '打开最近的会话',
    char_open_character_chats: '打开角色会话列表',

    // Voice
    voice_elevenLabsModel: 'ElevenLabs 模型',
    voice_stability: '稳定性',
    voice_claritySimilarityEnhancement: '清晰度 + 相似度增强',
    voice_playbackRate: '播放速率',
    voice_seed: '种子',
    voice_service: '语音服务',
    voice_pitch: '音调',
    voice_rate: '速率',
    voice_preview: '预览',
    voice_modelsLoading: '正在加载模型……',
    voice_agnaisticSeedHelper: '使用固定种子可以让生成结果更可复现。',
    voice_novelSeedHelper: '设置 NovelAI 的种子（留空则随机）。',
    voice_stabilityHelper: '稳定性越高，声音越一致，但表现力会下降。',
    voice_similarityBoostHelper: '调高使声音更接近参考样本，调低则变化更大。',
    voice_pitchHelper: '控制合成语音的音调高低。',
    voice_rateHelper: '控制语音播放的语速。',

    // App
    app_login_issues: '登录有问题？尝试',
    app_logging_out: '退出登录',
    app_log_back_in: '然后重新登录。',
    app_page_loading_issues: '页面加载有问题？尝试',
    app_clicking_here: '点击这里',
    app_failed_to_load: 'HuanYouAI 加载失败',
    app_try_again: '重试',
    app_banned_message: '此账户因以下原因被封禁：',
    app_banned_contact: '如果您认为这是一个错误，请联系支持。',
    app_account_banned: '账户已封禁',
    app_information: '信息',

    // Home
    home_free_to_use: 'HuanYouAI 完全免费使用。注册也是免费的。您的数据将保持私密，您可以随时永久删除数据名。我们非常重视您的隐私。',
    home_chat_multi_user: '同时与多个用户和多个角色聊天',
    home_create_memory_book: '创建 {memoryBook} 以向您的角色提供有关他们世界的信息。',
    home_use_images: '{images} - 使用 Horde、NovelAI 或您自己的 Stable Diffusion 服务器。',
    home_give_voice: '{voice} - 为您的角色提供声音并向他们回话。',
    home_customise_presets: '{presets} - 完全自定义用于生成回复的生成设置。',
    home_horde_guide: 'Horde 指南',
    home_horde_important: '重要！为了获得可靠的响应，请确保您已在 {link} 注册。获得密钥后，请将其添加到您的 {settings}。',
    home_horde_volunteers: 'AI Horde 由少数提供 GPU 的志愿者运行和支持。这是一项很棒的服务，但可能会慢一些。考虑为 Horde 做贡献！',
    home_horde_tokens: '除非您知道自己在做什么，否则请将 {maxNewTokens} 保持在 100 以下！使用较高的“最大新令牌”值是超时和回复慢的主要原因。',
    home_horde_anonymous: '默认情况下，我们使用匿名访问。您可以在设置页面提供您的 API 密钥或更改模型。',
    home_openai_guide: 'OpenAI 指南',
    home_openai_paid: 'OpenAI 是一项 {paidService}。要使用 OpenAI，您需要在设置中提供您的 OpenAI API 密钥：',
    home_openai_register: '首先，您需要 {registerLink}。',
    home_openai_generate_key: '注册后，您需要 {generateLink}。',
    home_openai_set_key: '获得 API 密钥后，前往 {settingsLink} 页面并在 OpenAI 区域设置您的密钥。',
    home_openai_preset: '要使用 OpenAI 生成回复，请确保您的聊天正在使用 {chatPresetSettings} 中的 OpenAI 预设。您可以通过聊天右上角的菜单访问这些设置。',

    // Chat Create
    chat_create_title: '创建聊天',
    chat_create_description: '可选地修改一些对话上下文。您可以在对话创建后从对话中覆盖角色的其他方面。',
    chat_create_applied_to_new: '此处提供的信息仅适用于新创建的对话。',
    chat_create_main_character_helper: '对话的主要角色',
    chat_mode: '聊天模式',
    chat_mode_companion_description: '伴侣模式：一切都是永久性的。您将无法：编辑聊天、重试消息、删除消息等。',
    chat_mode_standard: '普通对话',
    chat_mode_companion: '伴侣',
    chat_conversation_name: '对话名称',
    chat_conversation_name_helper: '对话的名称。这纯粹是为了标记。（可选）',
    chat_override_character_definitions: '覆盖角色定义',
    chat_override_helper: '覆盖仅适用于新创建的对话。',
    chat_scenario_helper: '此对话要使用的场景',
    chat_create_button: '创建',

    // Chat Settings
    chat_settings_reset_character: '重置角色',
    chat_settings_image_source: '图像源',
    chat_settings_image_source_helper: '此聊天生成图像时使用的设置',
    chat_settings_main_character: '主要角色',
    chat_settings_last_character: '最后说话的角色',
    chat_settings_chat_settings: '聊天设置',
    chat_settings_app_settings: '应用设置',
    chat_settings_background_image: '背景图片',
    chat_settings_background_image_helper: '图片将存储在您当前设备上，无法在其他设备上访问',
    chat_settings_chat_mode_irreversible: '警告！切换到“伴侣”模式是不可逆的！您将无法：重试消息、删除聊天、编辑聊天设置。',
    chat_settings_chat_name: '聊天名称',
    chat_settings_override_helper: '覆盖仅适用于此聊天。如果您想编辑原始角色，请在“聊天菜单”中打开“角色”链接。',
    chat_settings_scenario_state: '场景的当前状态',
    chat_settings_scenario_state_helper: '目前场景在聊天中设置了哪些标志',
    chat_settings_field_description_helper: '您的角色的描述、标签或备注：用于 AI 字段生成。不会改变您的角色行为。',
    chat_settings_post_history_instructions: '角色历史后指令',
    chat_settings_default_visibility: '默认消息可见性',
    chat_settings_visibility_helper: '当消息尚未编辑可见性时。最具体的优先：消息 > 角色默认 > 所有默认',
    chat_settings_visible: '可见',
    chat_settings_invisible: '不可见',
    chat_settings_not_set: '未设置',
    chat_settings_defaults_all: '所有消息的默认值',
    chat_settings_defaults_per_char: '每个角色的默认设置',
    chat_settings_defaults_per_char_helper: '为每个角色视角设置默认可见性',
    remove_all: '移除全部',
    char_editCharacter: '编辑角色',
    chat_temp_char_updated: '临时角色已更新',
    chat_memory_guide: '记忆指南',
    chat_ui_settings: '聊天界面设置',
    chat_confirmDeleteChat: '您确定要删除此对话吗？',
    chat_graph_rejoin_node: '重新加入节点',
    chat_graph_assign_parent: '分配父节点',
    chat_graph_select_parent: '选择父节点',
    chat_graph_collapse: '折叠',
    chat_graph_expand: '展开',
    chat_graph_rotate: '旋转',
    chat_graph_help: '点击节点加载路径。点击并拖动移动图表。捏合/滚动缩放。',
    chat_token_probabilities: '令牌概率',
    chat_save_memory_book: '保存记忆书',
    chat_memory_book: '记忆书',
    chat_memory_book_helper: '选择用于此聊天的记忆书',
    chat_create_new_memory_book: '创建新记忆书',
    chat_embedding: '嵌入',
    chat_embedding_helper: '选择用于此聊天的嵌入',
    chat_use_embedding: '使用嵌入',
    chat_msg_info_title: '消息信息',
    admin_adapter: '适配器',
    chat_json_output: 'JSON 输出',
    chat_img_prompt_updated: '图像提示词已更新',
    chat_caption_hint_helper: '生成图像描述的提示',
    chat_caption_hint_placeholder: '输入描述提示...',
    chat_image_prompt: '图像提示词',
    interrupt: '中断',
    admin_clean: '清理',
    admin_edit: '编辑',
    chat_msg_prompt_title: '提示词视图',
    chat_prompt_approx_helper: '近似令牌计数。实际使用可能有所不同。',
    chat_prompt_budget_helper: '令牌预算信息',
    chat_est_tokens: '估计令牌数：{count}',
    chat_speech_recognition_error: '语音识别错误：{error}',
    chat_visibility_current: '当前可见性',
    chat_visibility_toggles: '切换可见性',
    chat: '聊天',
    download: '下载',
    chat_export_title: '导出聊天',
    chat_system_preset_horde: 'Horde',
    chat_system_preset: '系统预设',
    chat_your_default_preset: '您的默认预设',
    chat_delete_msg_title: '确认删除',
    chat_delete_swipe: '删除滑动',
    chat_delete_one: '删除一个',
    chat_delete_msg_confirm: '您确定要删除一个或最后 {count} 条消息吗？',
    chat_delete_msg_one_note: '删除"一个"将仅删除选定的消息。',
    chat_delete_msg_image_confirm: '您确定要删除 1 条图像消息吗？',
    chat_system_built_in_preset_horde: 'Horde',
    chat_please_select_preset: '请选择预设',
    chat_load_more: '加载更多',
    chat_add_temp_character: '添加临时角色',
    chat_user: '用户',
    chat_temp_characters: '临时角色',
    chat_deleted_temp_characters: '已删除的临时角色',
    chat_remove_user_confirm: '您确定要从此聊天中移除 {handle} 吗？',
    chat_no_chars_to_invite: '没有可邀请的角色',
    chat_select_char_to_add: '选择要添加的角色',
    chat_no_chars_available_to_add: '没有可添加的角色',
    chat_no_user_id_provided: '未提供用户 ID',
    chat_invite_user: '邀请用户',
    chat_invite_user_helper: '输入要邀请到此聊天的用户 ID',
    chat_send_invite: '发送邀请',
    chat_owner: '所有者',
    chat_temp_character: '临时角色',
    reset: '重置',
    back: '返回',
    character: '角色',

    // Settings UI
    settings_ui_viewMode_background: '背景',
    settings_ui_typewriter_test: '世界上有十种人：懂二进制的和不懂二进制的。',

    // Navigation
    nav_main_page_aria: 'HuanYouAI 主页',
    nav_add_new_preset: '添加新预设',
    nav_add_new_character: '添加新角色',
    nav_create_new_chat: '创建新聊天',
    nav_edit_user_profile: '编辑用户资料',
    nav_open_impersonation: '打开角色扮演菜单',
    nav_email_support: '电子邮件支持',

    // Toasts
    toasts_site_updates: '网站更新与通知',
    toasts_no_notifications: '您没有通知。',
    toasts_clear_notifications: '清除通知',
    toasts_message_from_admin: '来自管理员的消息',
    toasts_latest_updates: '最新更新',
    toasts_admin_notification: '管理员通知',
    image_prompt: '提示词',
    image_clean: '清除',
    image_generate: '生成',
    image_stop: '停止',
    image_to_unsent: '到未发送',
    image_to_current: '到当前',
    image_add_attachment: '添加消息附件',
    image_caption: '图像描述',
    image_caption_hint_placeholder: '描述提示：生成描述时要关注什么？',
    image_count: '图像：{current}/{total}',
    image_fix: '修复',
    image_attach_to_message: '附加到消息',
    invite_title: '邀请',
    invite_no_pending: '您没有待处理的聊天邀请',
    invite_from: '来自',
    invite_character: '角色',
    invite_sent: '发送于',
    invite_unknown_user: '未知用户',
    invite_unknown_character: '未知角色',
    login_reset_password: '重置密码',
    login_username_placeholder: '用户名...',
    login_password_placeholder: '密码',
    login_confirm_password_placeholder: '确认密码',
    login_error_not_logged_in: '错误 - 您当前未登录。',
    login_missing_callback: '查询参数中缺少回调地址。',
    login_failed: '失败：{error}',
    login_oauth_request: '一个应用程序正在请求代表您访问您的 HuanYouAI 账户',
    login_oauth_access_list: '该应用程序将能够访问您的：',
    login_oauth_access_items: '个人资料名称、头像、角色和预设。',
    login_authorize: '授权',
    login_authorizing: '正在授权...',
    privacy_policy_text: `
We at HuanYouAI (together with our affiliates, "we", "our" or "us") respect your privacy and are strongly committed to keeping secure any information we obtain from you or about you. This Privacy Policy describes our practices with respect to Personal Information we collect from or about you when you use our website and services (collectively, "Services"). Our use of that data is governed by our customer agreements covering access to and use of those offerings.

## 1. Personal information we collect

We collect information that alone or in combination with other information in our possession could be used to identify you ("Personal Information") as follows:

**Personal Information You Provide:** We may collect Personal Information if you create an account to use our Services or communicate with us as follows:

- **Account Information:** When you create an account with us, we will collect information associated with your account, including your display name, account credentials, profile picture, and other information provided during registration (collectively, "Account Information").
- **User Content:** When you use our Services, we may collect Personal Information that is included in the input, file uploads, or feedback that you provide to our Services ("Content").{' '}
- **Communication Information:** If you communicate with us, we may collect your name, contact information, and the contents of any messages you send ("Communication Information").
- **Social Media Information:** We may have pages on social media sites like Instagram, Facebook, Medium, Twitter, YouTube and LinkedIn, as well as Reddit, 4chan, and a [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat). When you interact with our social media pages, we will collect Personal Information that you elect to provide to us, such as your contact details or social media usernames and profile information (collectively, "Social Information"). In addition, the companies that host our social media accounts may provide us with aggregate information and analytics about our social media activity.

**Personal Information We Receive Automatically From Your Use of the Services:** When you visit, use, and interact with the Services, we may receive the following information about your visit, use, or interactions ("Technical Information"):

- **Log Data:** Information that your browser automatically sends whenever you use our website ("log data"). Log data includes your Internet Protocol address, browser type and settings, the date and time of your request, and how you interacted with our website.
- **Usage Data:** We may automatically collect information about your use of the Services, such as the types of content that you view or engage with, the features you use and the actions you take, as well as your time zone, country, the dates and times of access, user agent and version, type of computer or mobile device, computer connection, IP address, and the like.
- **Device Information:** Includes name of the device, operating system, and browser you are using. Information collected may depend on the type of device you use and its settings.
- **Browser Storage:** We use cookies and localstorage ("Browser Storage") to operate and administer our Services, and improve your experience on it. A "cookie" is a piece of information sent to your browser by a website you visit. "Localstorage" is a feature of your web browser that lets us store information on your computer related to your use of our Services. You can set your browser to accept all cookies, to reject all cookies, or to notify you whenever a cookie is offered so that you can decide each time whether to accept it. However, refusing a cookie may in some cases preclude you from using, or negatively affect the display or function of, a website or certain areas or features of a website. For more details on cookies please visit [All About Cookies](https://www.google.com/url?q=https://allaboutcookies.org/&amp;sa=D&amp;source=editors&amp;ust=1681348702239252&amp;usg=AOvVaw1sGG2db6TzG2Fy_dtBclPZ).
- **Analytics:** We may use a variety of online analytics products that use cookies to help us analyze how users use our Services and enhance your experience when you use the Services.

## 2. How we use personal information**

We may use Personal Information for the following purposes:

- To provide, administer, maintain, improve and/or analyze the Services;
- To conduct research;
- To communicate with you;
- To develop new programs and services;
- To prevent fraud, criminal activity, or misuses of our Services, and to ensure the security of our IT systems, architecture, and networks; and 
- To comply with legal obligations and legal process and to protect our rights, privacy, safety, or property, and/or that of our affiliates, you, or other third parties. 

Aggregated or De-Identified Information. We may aggregate or de-identify Personal
Information and use the aggregated information to analyze the effectiveness of our
Services, to improve and add features to our Services, to conduct research and for other
similar purposes. In addition, from time to time, we may analyze the general behavior and
characteristics of users of our Services and share aggregated information like general
user statistics with third parties, publish such aggregated information or make such
aggregated information generally available. We may collect aggregated information through
the Services, through cookies, and through other means described in this Privacy Policy.
We will maintain and use de-identified information in anonymous or de-identified form and
we will not attempt to reidentify the information.

## 3. Disclosure of personal information

In certain circumstances we may provide your Personal Information to third parties without further notice to you, unless required by the law:
- Vendors and Service Providers: To assist us in meeting business operations needs and to perform certain services and functions, we may provide Personal Information to vendors and service providers, including providers of hosting services, cloud services, and other information technology services providers, event management services, email communication software and email newsletter services, and web analytics services. Pursuant to our instructions, these parties will access, process, or store Personal Information only in the course of performing their duties to us. 
- Business Transfers: If we are involved in strategic transactions, reorganization, bankruptcy, receivership, or transition of service to another provider (collectively a "Transaction"), your Personal Information and other information may be disclosed in the diligence process with counterparties and others assisting with the Transaction and transferred to a successor or affiliate as part of that Transaction along with other assets. 
- Legal Requirements: If required to do so by law or in the good faith belief that such action is necessary to (i) comply with a legal obligation, including to meet national security or law enforcement requirements, (ii) protect and defend our rights or property, (iii) prevent fraud, (iv) act in urgent circumstances to protect the personal safety of users of the Services, or the public, or (v) protect against legal liability. 
- Affiliates: We may disclose Personal Information to our affiliates, meaning an entity that controls, is controlled by, or is under common control with HuanYouAI. Our affiliates may use the Personal Information we share in a manner consistent with this Privacy Policy. 

## 4. Your rights

Depending on location, individuals in the EEA, the UK, and across the globe may have certain statutory rights in relation to their Personal Information. For example, you may have the right to:

- Access your Personal Information.
- Delete your Personal Information.
- Correct or update your Personal Information.
- Transfer your Personal Information elsewhere.
- Withdraw your consent to the processing of your Personal Information where we rely on consent as the legal basis for processing. 
- Object to or restrict the processing of your Personal Information where we rely on legitimate interests as the legal basis for processing

You can exercise some of these rights through your Agnaistic account. If you are unable to exercise your rights through your account, please send your request in our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat).

## 5. California privacy rights

The following table provides additional information about how we disclose Personal Information. You can read more about the Personal Information we collect in "Personal information we collect" above, how we use Personal information in "How we use personal information" above, and how we retain personal information in "Security and Retention" below.

| Category of Personal Information                                                     | Disclosure of Personal Information                                                                                                    |
|:-------------------------------------------------------------------------------------|:--------------------------------------------------------------------------------------------------------------------------------------|
| Identifiers, such as your contact details                                            | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |
| Commercial Information, such as your transaction history                             | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |
| Network Activity Information, such as Content and how you interact with our Services | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |
| Geolocation Data                                                                     | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |
| Your account login credentials (Sensitive Personal Information)                      | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |

To the extent provided for by law and subject to applicable exceptions, California residents have the following privacy rights in relation to their Personal Information:

- The right to know information about our processing of your Personal Information, including the specific pieces of Personal Information that we have collected from you;
- The right to request deletion of your Personal Information;
- The right to correct your Personal Information; and
- The right to be free from discrimination relating to the exercise of any of your privacy rights. 

We don't sell or share Personal Information as defined by the California Consumer Privacy Act, as amended by the California Privacy Rights Act. We also don't process sensitive personal information for the purposes of inferring characteristics about a consumer.

**Exercising Your Rights**. California residents can exercise their CCPA privacy rights by sending their request to us on our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat).
**Verification**. In order to protect your Personal Information from unauthorized access, change, or deletion, we may require you to verify your credentials before you can submit a request to know, correct, or delete Personal Information. If you do not have an account with us, or if we suspect fraudulent or malicious activity, we may ask you to provide additional Personal Information and proof of residency for verification. If we cannot verify your identity, we will not provide, correct, or delete your Personal Information.
**Authorized Agents**. you may submit a rights request through an authorized agent. If you do so, the agent must present signed written permission to act on your behalf and you may also be required to independently verify your identity and submit proof of your residency with us. Authorized agent requests can be submitted to us on our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat).

## 6. Children

Our Service is not directed to children who are under the age of 18. Agnaistic does not knowingly collect Personal Information from children under the age of 18. If you have reason to believe that a child under the age of 18 has provided Personal Information to Agnaistic through the Service please contact us on our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat). We will investigate any notification and if appropriate, delete the Personal Information from our systems.

## 7. Links to other websites

The Service may contain links to other websites not operated or controlled by Agnaistic, including social media services ("Third Party Sites"). The information that you share with Third Party Sites will be governed by the specific privacy policies and terms of service of the Third Party Sites and not by this Privacy Policy. By providing these links we do not imply that we endorse or have reviewed these sites. Please contact the Third Party Sites directly for information on their privacy practices and policies. 

## 8. Security and Retention

We implement commercially reasonable technical, administrative, and organizational measures to protect Personal Information both online and offline from loss, misuse, and unauthorized access, disclosure, alteration, or destruction. However, no Internet or email transmission is ever fully secure or error free. In particular, email sent to or from us may not be secure. Therefore, you should take special care in deciding what information you send to us via the Service or email. In addition, we are not responsible for circumvention of any privacy settings or security measures contained on the Service, or third party websites.

We'll retain your Personal Information for only as long as we need in order to provide our Service to you, or for other legitimate business purposes such as resolving disputes, safety and security reasons, or complying with our legal obligations. How long we retain Personal Information will depend on a number of factors, such as the amount, nature, and sensitivity of the information, the potential risk of harm from unauthorized use or disclosure, our purpose for processing the information, and any legal requirements.

We may also anonymize or de-identify your Personal Information (so that it can no longer be associated with you) for research or statistical purposes, as described above, in which case we may use this information indefinitely without further notice to you.

## 9. International users

By using our Service, you understand and acknowledge that your Personal Information will be transferred from your location to our facilities and servers in the United States.

For EEA, UK or Swiss users:

- Legal Basis for Processing. Our legal bases for processing your Personal Information include: Performance of a contract with you when we provide and maintain our Services. This may include the processing of Account Information, Content, and Technical Information.
- Our legitimate interests in protecting our Services from abuse, fraud, or security risks, or when we develop, improve, or promote our Services. This may include the processing of Account Information, Content, Social Information, and Technical Information.
- Your consent when we ask for your consent to process your Personal Information for a specific purpose that we communicate to you. You have the right to withdraw your consent at any time.
- Compliance with our legal obligations when we use your Personal Information to comply with applicable law or when we protect our or our affiliates' or users' rights, safety and property.

If feel we have not adequately addressed an issue, you have the right to lodge a complaint with your local supervisory authority.

Data Transfers. Where required, we will use appropriate safeguards for transferring Personal Information outside of the EEA, Switzerland, and the UK. We will only transfer Personal Information pursuant to a legally valid transfer mechanism.

## 10. Your choices

If you choose not to provide Personal Information that is needed to use some features of our Service, you may be unable to use those features.

## 11. Changes to the privacy policy

We may change this Privacy Policy at any time. When we do, we will post an updated version on this page, unless another type of notice is required by applicable law. By continuing to use our Service or providing us with Personal Information after we have posted an updated Privacy Policy, or notified you by other means, you consent to the revised Privacy Policy.

## 12. How to contact us
Please contact us on our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat) if you have any questions or concerns not already addressed in this Privacy Policy.
`,
    memory_create_book: '创建记忆书',
    memory_edit_book: '编辑记忆书',
    memory_update_book: '更新记忆书',
    memory_definitions: '定义',
    memory_priority: '优先级',
    memory_priority_helper: '在决定哪些条目包含在提示词中时，优先级较高的条目将胜出。',
    memory_weight: '权重',
    memory_weight_helper: '在决定条目排序方式时，权重越高，条目越靠近底部。',
    memory_keywords: '关键词',
    memory_keywords_helper: '您可以使用 {{char}} 和 {{user}} 占位符',
    memory_entry: '条目',
    memory_entry_helper: '此处可使用 {{char}} 和 {{user}} 占位符。',
    memory_embeddings: '记忆 - 嵌入',
    memory_loaded: '已加载',
    memory_not_loaded: '未加载',
    memory_books: '记忆 - 书籍',
    memory_no_books: '您还没有记忆书。点击“创建”开始。',
    memory_book_accepted: '记忆书已接受',
    memory_import_book: '导入记忆书',
    memory_json_file: 'JSON 文件',
    memory_import_helper: '目前仅支持 HuanYouAI 导出的记忆书。',
    memory_sort_creation: '按创建日期',
    memory_sort_alpha: '按字母顺序',
    memory_book_name: '记忆书名称',
    memory_book_name_placeholder: '记忆书的名称',
    memory_description_placeholder: '（可选）记忆书的描述',
    memory_entries: '条目',
    memory_filter_placeholder: '按条目名称过滤...',
    memory_entry_name_placeholder: '条目名称',
    memory_keywords_placeholder: '以逗号分隔的单词。例如：circle, shape, round, cylinder, oval',
    memory_entry_placeholder: '记忆条目。例如：{{user}} 喜欢水果和蔬菜',
    memory_embedding_created: '成功创建嵌入',
    memory_article: '文章',
    memory_pdf: 'PDF',
    memory_text_file: '文本文件',
    memory_plain_text: '纯文本',
    memory_enter_name: '输入嵌入名称',
    memory_no_pdf: '未加载 PDF',
    memory_content_empty: '嵌入内容为空',
    memory_enable_embeddings_helper: '您需要在设置中启用“嵌入/长期记忆”',
    memory_embed_wiki: '嵌入维基百科文章',
    memory_embed_wiki_helper: '使用维基百科文章的内容创建嵌入',
    memory_wiki_placeholder: 'URL。例如：https://en.wikipedia.org/wiki/Taylor_Swift',
    memory_embed_article_button: '嵌入文章',
    memory_embed_name_helper: '嵌入的标识符。',
    memory_embed_pdf: '嵌入 PDF',
    memory_embed_pdf_helper: '这可能需要很长时间，具体取决于 PDF 的大小。',
    memory_embed_file: '嵌入文件',
    memory_embed_file_helper: '这可能需要很长时间，具体取决于文件的大小。',
    memory_embed_text_helper: '要嵌入的内容。使用换行符分隔行。',
    memory_embed_text_button: '嵌入文本',
    memory_embed_name_optional_helper: '（可选）嵌入的标识符。这将成为一个“slug”。例如：“Hello World”将变为“hello-world”',
    memory_embed_name_slug_helper: '嵌入的标识符。这将成为一个“slug”。例如：“Hello World”将变为“hello-world”',

    // WorkerModal
    worker_modal_title: '选择 Horde 节点',
    worker_modal_select_workers: '选择节点',
    worker_modal_helper: '要使用任何节点，请取消选择所有节点',
    worker_modal_selected_count: '已选节点：{count}',
    worker_modal_deselect_all: '取消全部选择',

    // OpenRouterOauth
    openrouter_oauth_instruction: '点击 <b class="highlight">使用 OpenRouter 登录</b> 或访问 <a class="link" target="_blank" href="https://openrouter.ai/keys">OpenRouter.ai/keys</a> 来创建 API 密钥并在上方输入。',
    openrouter_oauth_logging_in: '正在登录...',
    openrouter_oauth_login: '使用 OpenRouter 登录',
    openrouter_oauth_logout: '注销',

    // PatreonOauth
    patreon_oauth_verifying: '正在验证 Patreon 账号...',
    patreon_oauth_error: '无法验证 Patreon 账号',
    patreon_oauth_return_to_settings: '返回设置',
    patreon_oauth_success: 'Patreon 账号已验证',
    patreon_oauth_redirecting: '正在重定向到设置页面...',
    patreon_oauth_link_benefit: '关联您的 Patreon 账号以获取订阅者福利',
    patreon_oauth_link: '关联 Patreon 账号',
    patreon_oauth_unlink: '取消关联 Patreon 账号',
    patreon_oauth_revalidate: '重新验证',

    // ImageSettings
    image_settings_shared: '共享设置',
    image_settings_global_default: '全局/默认',
    image_settings_character_settings: '角色设置',
    image_settings_character: '角色：',
    image_settings_current_chat: '当前聊天设置',
    image_settings_chatting_with: '正在与以下角色聊天：',
    image_settings_source_label: '当前聊天图像设置来源',
    image_settings_source_helper: '控制在生成“聊天图像”时使用哪些图像设置',
    image_settings_use_settings: '使用 {tab} 设置',
    image_settings_use_settings_active: '使用 {tab} 设置 (活跃)',
    image_settings_summary_preset: '摘要预设',
    image_settings_summary_preset_helper: '选择用于创建聊天图像摘要的服务和模型',
    image_settings_summary_settings: '摘要设置',
    image_settings_summarise_chat: '摘要聊天',
    image_settings_summarise_chat_helper: '使用您的 AI 服务将聊天摘要为图像提示词。',
    image_settings_summary_prompt: '摘要提示词',
    image_settings_summary_prompt_helper: '在将聊天摘要为图像标题时，此“提示词”用于将您的对话摘要为图像提示词。',
    image_settings_default: '默认：',
    image_settings_style_booru: 'Booru/标签风格',
    image_settings_style_plain: 'Flux/普通风格',
    image_settings_use_recommended: '使用推荐设置',
    image_settings_use_recommended_helper: '在可用时使用图像模型的推荐设置。',
    image_settings_toggle_all: '全选/取消全选',
    image_settings_affixes: '词缀',
    image_settings_size: '尺寸',
    image_settings_guidance: '引导',
    image_settings_steps: '步数',
    image_settings_negative_prompt: '负向提示词',
    image_settings_sampler: '采样器',
    image_settings_recommended_hint: '使用 HuanYouAI 图像模型时，请参考推荐设置',
    image_settings_sampling_steps: '采样步数',
    image_settings_clip_skip: 'Clip Skip',
    image_settings_width: '图像宽度',
    image_settings_height: '图像高度',
    image_settings_guidance_scale: '引导比例',
    image_settings_seed: '种子',
    image_settings_seed_helper: '种子号码 (0 = 随机)。注意：不同服务器之间的种子可能不一致。',
    image_settings_prefix: '提示词前缀',
    image_settings_prefix_helper: '（可选）要添加到图像提示词前面的文本',
    image_settings_prefix_placeholder: '例如：best quality, masterpiece',
    image_settings_suffix: '提示词后缀',
    image_settings_suffix_helper: '（可选）要添加到图像提示词后面的文本',
    image_settings_suffix_placeholder: '例如：full body, visible legs, dramatic lighting',
    image_settings_negative_helper: '（可选）负向提示词',
    image_settings_negative_placeholder: '例如：painting, drawing, illustration, glitch, deformed, mutated, cross-eyed, disfigured',
    image_settings_edit_summary_preset: '编辑摘要预设',
    image_settings_unavailable_hint: '注意：<b>聊天</b> 和 <b>角色</b> 图像设置仅在聊天开启时可用。',
    image_settings_image_settings: '图像设置',

    // ServiceSettings
    service_settings_model: '模型：',
    service_settings_sampler: '采样器：',
    service_settings_novel_key_error: '您没有设置有效的 NovelAI 密钥。您将无法使用 Novel 生成图像。',
    service_settings_novel_quality_tags: '添加质量标签',
    service_settings_novel_undesired_content: '不希望出现的内容',
    service_settings_novel_undesired_content_helper: '在负向提示词中添加 `nsfw` 以忽略 NSFW 内容',
    service_settings_novel_heavy: '重度',
    service_settings_novel_light: '轻度',
    service_settings_novel_none: '无',
    service_settings_swarm_url: 'SwarmUI URL',
    service_settings_swarm_url_helper: 'SwarmUI 的基础 URL。例如 https://local-tunnel-url-10-20-30-40.loca.lt。如果是自行托管，可以使用 http://localhost:7801',
    service_settings_automatic: '自动',
    service_settings_add_lora: '+ Lora',
    service_settings_use_local: '使用本地请求',
    service_settings_none_selected: '未选择',
    service_settings_sd_url: 'SD WebUI URL',
    service_settings_sd_url_helper: 'Stable Diffusion 的基础 URL。例如 https://local-tunnel-url-10-20-30-40.loca.lt。如果是自行托管，可以使用 http://localhost:7860',
    service_settings_sd_provider_helper: '使用来自供应商的 API 密钥',
    service_settings_no_options: '没有更多可用选项',
    service_settings_draft_mode: '草稿模式',
    service_settings_draft_mode_helper: '如果可用：快速生成低质量图像',
    service_settings_recommended: '推荐',
    service_settings_limits: '限制',
    service_settings_tags_keyword: '标签 / 关键词',
    service_settings_tags: '标签',
    service_settings_on: '开',
    service_settings_off: '关',
    service_settings_model_strength: '模型强度',
    service_settings_clip_strength: 'Clip 强度',
    service_settings_image_model: '图像模型',
    service_settings_sampler_label: '采样器',
    service_settings_steps: '步数',
    service_settings_cfg: 'CFG',
    service_settings_width: '宽度',
    service_settings_height: '高度',
    service_settings_clip_skip: 'Clip Skip',
    service_settings_sampler_title: '采样器',
    service_settings_prefix: '前缀',
    service_settings_suffix: '后缀',
    service_settings_negative: '负向提示词',

    // Provider/index
    provider_index_select_provider: '选择供应商',
    provider_index_service: '服务',
    provider_index_providers: '供应商',
    provider_index_providers_helper: '供应商用于连接您首选的 AI 模型。',
    provider_index_new_provider_helper: '点击 **`+ 新建`** 创建一个新的供应商并填写信息。',
    provider_index_format_helper: '**格式**\n如果您被提示选择 **格式** 且不确定使用哪个，请选择 `Chat`。',
    provider_index_important_helper: '**重要**：确保在下方的下拉菜单中选择了正确的供应商。',
    provider_index_edit_selected: '编辑已选',
    provider_index_new: '新建',
    provider_index_edit: '编辑',
    provider_index_edit_connection: '编辑连接详情',
    provider_index_accept: '接受',
    provider_index_ai_service: 'AI 服务',
    provider_index_no_service_warning: '警告！您的预设目前尚未设置服务。',
    provider_index_third_party_format: '第三方格式',
    provider_index_request_format_helper: '控制请求的发送方式',
    provider_index_none: '无',
    provider_index_url: 'URL',
    provider_index_url_helper: '**第三方** 或 **自行托管** 服务的 API URL',
    provider_index_url_placeholder: '例如 https://some-tunnel-url.loca.lt',
    provider_index_api_key: 'API 密钥',
    provider_index_remove_key: '移除密钥',
    provider_index_key_warning: '切勿在此处输入您的官方 OpenAI、Claude、Mistral 密钥。',
    provider_index_key_is_set: '密钥已设置',
    provider_index_key_placeholder: '例如 sk-...',

    // Provider/Manage
    provider_manage_supported: '支持的供应商',
    provider_manage_local_selfhost: '本地 / 自行托管',
    provider_manage_custom: '自定义',
    provider_manage_choose_provider: '供应商：选择一个供应商',
    provider_manage_provider_prefix: '供应商：',
    provider_manage_invalid_url: 'URL 无效。请检查后重试',
    provider_manage_update_title: '更新供应商',
    provider_manage_create_title: '创建供应商',
    provider_manage_delete: '删除',
    provider_manage_update: '更新',
    provider_manage_create: '创建',
    provider_manage_instruction: '提供连接详情以使用外部服务',
    provider_manage_label: '标签',
    provider_manage_label_placeholder: '此供应商的自定义标签',
    provider_manage_url_placeholder: 'https://...',
    provider_manage_disable_auto_url: '禁用自动 URL',
    provider_manage_request_format: '请求格式',
    provider_manage_test_connection: '测试连接',
  },
  tw: {
    chub_title: '角色樞紐',
    chub_search_placeholder: '按名稱搜索...',
    chub_tags_placeholder: '標籤...',
    chub_import: '導入',
    chub_preview: '預覽',
    chub_disclaimer: '免責聲明：角色歸屬和管理由',
    chub_import_book_hint_1: '可以隨意修改除圖像以外的世界書的所有方面。',
    chub_import_book_hint_2: '此處提供的信息將在導入時與世界書一起保存。',
    chub_import_char_hint_1: '可以隨意修改除頭像以外的角色的所有方面。',
    chub_import_char_hint_2: '此處提供的信息將在導入時與角色一起保存。',
    chub_import_char_name_label: '角色名稱',
    chub_import_char_name_helper: '在此處重寫角色名稱',
    chub_import_char_optional: '（可選）',
    chub_import_char_greeting: '問候語',
    chub_import_char_scenario: '場景',
    chub_import_char_sample_chat: '示例聊天',
    chub_import_char_persona: '人設',
    chub_filter_nsfw_label: '成人內容 (NSFW)',
    chub_filter_nsfw_helper: '允許 NSFW 角色/世界書出現在結果中。',
    chub_filter_query_tags_label: '查詢標籤',
    chub_filter_query_tags_helper: '以逗號分隔的包含標籤列表。',
    chub_filter_exclude_tags_label: '排除標籤',
    chub_filter_exclude_tags_helper: '以逗號分隔的排除標籤列表。',
    chub_filter_sort_label: '排序方式',
    chub_invalid_tavern_image: '無效的 Tavern 圖像',
    chub_sort_default: '預設',
    chub_sort_trending: '熱門',
    chub_sort_favorites: '收藏數',
    chub_sort_random: '隨機',
    chub_sort_rating: '評分',
    chub_sort_updated: '更新時間',
    chub_sort_popularity: '流行度',
    chub_sort_created: '創建時間',
    chub_sort_name: '名稱',
    chub_sort_tokens: 'Token 數量',
    chub_sort_ratings: '評分數量',
    chub_error_importing: '導入 {name} 時出錯！{error}',
    chub_filter_tags_placeholder: '例如：blue_archive,female,anime',
    product_name: '幻友AI',
    product_slogan: '跨越次元，只為見你',

    welcome: '歡迎',
    login: '登入',
    register: '註冊',
    language: '語言',
    close: '關閉',
    cancel: '取消',
    confirm: '確認',
    ok: '確定',
    yes: '是',
    no: '否',
    edit: '編輯',
    editing: '正在編輯',
    update: '更新',
    save: '保存',
    copy: '複製',
    search: '搜尋',
    voice: '語音',

    // Time
    time_seconds: '{count} 秒',
    time_second: '{count} 秒',
    time_minutes: '{count} 分鐘',
    time_minute: '{count} 分鐘',
    time_hours: '{count} 小時',
    time_hour: '{count} 小時',
    time_days: '{count} 天',
    time_day: '{count} 天',
    time_aMoment: '剛才',
    time_unknown: '未知',
    time_ago: '{duration}前',

    welcomeTitle: '歡迎來到微靈',
    welcomeMessage: '我們是一個智慧體互動與創意創作的AI平台,您可以在此創作及體驗各種有趣的AI 智慧體角色。我們的願景是以最實惠的成本,提供最具性價比的互動體驗。Affordable AI for Everyone!',
    welcomeDisclaimer: '本平台不對中國大陸用戶提供服務,請確認您已年滿18歲且不在中國大陸地區使用本平台。',
    welcomeContentWarning: '所有互動內容皆由AI生成,請勿輕信或受誤導,也請勿引導AI生成不符規範的內容。',
    termsAgreement: '本人已年滿18歲並同意',
    termsLink: '使用者條款',
    ageConfirmation: '本人已年滿18歲並同意使用者條款',
    createCharacter: '創建角色',
    importCharacter: '導入角色',
    characters: '角色',
    lorebooks: '設定書',
    creativeWorkshop: '創意工坊',
    personalCenter: '個人中心',
    chatHistory: '聊天記錄',
    trending: '熱搜流行',
    memoryFragments: '記憶片段',
    menu: '菜單',
    library: '圖書館',
    lib_memories: '記憶',
    lib_scenarios: '場景',
    lib_templates: '模板',
    lib_embeddings: '嵌入',
    login_remote_error_not_logged_in: '錯誤 - 您當前未登錄。',
    login_remote_missing_callback: '查詢參數中缺少回調地址。',
    login_remote_failed: '失敗：{error}',
    login_remote_request_access: '一個應用程序正在請求代表您訪問您的 HuanYouAI 賬戶',
    login_remote_application_access: '該應用程序將能夠訪問您的個人資料名稱、頭像、角色和預設。',
    login_remote_authorize: '授權',
    login_remote_authorizing: '授權中...',
    presets: '預設',
    settings: '設置',
    profile: '個人資料',
    chats: '聊天',
    sounds: '聲音',
    manage: '管理',
    gen_presets_copy_preset: '複製預設 {name}',
    gen_presets_edit_preset: '編輯預設 {name}',
    configuration: '配置',
    users: '用戶',
    subscriptions: '訂閱',
    announcements: '公告',
    persona: '角色扮演',
    faq: '常見問題',
    termsOfService: '服務條款',
    privacyPolicy: '隱私政策',
    nav_home: '首頁',
    nav_trends: '趨勢',
    nav_workshop: '工坊',
    nav_me: '我的',
    home_tab_recommended: '推薦',
    home_tab_trending: '排行',
    home_tab_latest: '最新',

    // Profile / Subscription
    profile_checkout_success: '結帳成功',
    profile_checkout_thank_you: '感謝您的訂閱！',
    profile_checkout_start_using: '通過創建和使用 {name} 預設開始使用您的訂閱。',
    profile_checkout_close_window: '關閉窗口',
    profile_checkout_cancelled: '結帳已取消',
    profile_checkout_cancelled_msg: '您的訂閱嘗試已取消。您未被收費。',
    profile_sub_valid_until: '有效期至',
    profile_sub_patreon_subscriber: 'Patreon 訂閱者',
    profile_sub_cancels_at: '取消於',
    profile_sub_renews_at: '續訂於',
    profile_sub_why_title: '為什麼要訂閱？',
    profile_sub_why_msg_1: '訂閱可讓您訪問更高質量的模型、更快的響應和更大的上下文。',
    profile_sub_why_msg_2: '未來您還將獲得額外功能！例如：語音生成、圖像存儲，以及與 Discord、Slack 和 WhatsApp 等第三方應用的集成等！',
    profile_sub_why_msg_3: '訂閱允許我投入更多時間開發和增強 HuanYouAI。',
    profile_sub_support_contact: '如果您需要賬單或訂閱支持，請聯繫',
    profile_sub_view_models: '查看可用模型',
    profile_sub_current_title: '當前訂閱',
    profile_sub_update_payment: '更新付款方式',
    profile_sub_via: '訂閱方式',
    profile_sub_via_gift: '贈送',
    profile_sub_via_patreon: 'Patreon',
    profile_sub_via_stripe: 'Stripe',
    profile_sub_via_none: '無',
    profile_sub_set_to_downgrade: '您的訂閱已設置為降級',
    profile_sub_cancel_downgrade: '取消降級',
    profile_sub_scheduled_to_cancel: '您的訂閱目前計劃取消',
    profile_sub_resume: '恢復訂閱',
    profile_sub_enjoy: '享受吧！',
    profile_sub_subscribed: '已訂閱！',
    profile_sub_options: '訂閱選項',
    profile_sub_patreon_msg: '成為贊助人並關聯您的賬戶，或使用以下選項',
    profile_sub_gifted_to_you: '此層級目前已贈送給您',
    profile_sub_login_to_subscribe: '登錄以訂閱',
    profile_sub_upgrade: '升級',
    profile_sub_downgrading: '降級中...',
    profile_sub_downgrade: '降級',
    profile_sub_resubscribe: '重新訂閱',
    profile_sub_subscribe: '訂閱',
    profile_sub_prices_usd: '所有價格均以美元計',
    profile_sub_unsubscribe: '取消訂閱',
    profile_sub_confirm_unsubscribe: '您確定要取消訂閱嗎？',
    profile_sub_upgrade_charge_msg: '確認後將立即向您收費。',
    profile_sub_confirm_upgrade: '您確定現在升級嗎？',
    profile_sub_downgrade_affect_msg: '您的降級將在下一個計費週期開始時生效。在降級生效之前，您將保留對當前訂閱層級的訪問權限。',
    profile_sub_confirm_downgrade: '您確定要降級嗎？',
    profile_sub_per_mo: '/月',
    profile_sub_or: '或',

    // Prompt Templates
    prompt_templates_title: '提示詞模板',
    prompt_templates_new_template: '模板',
    prompt_templates_no_templates: '您沒有保存的提示詞模板',
    prompt_templates_builtin: '內置模板',
    prompt_templates_updated: '模板已更新',
    prompt_templates_created: '模板已創建',
    prompt_templates_name: '名稱',

    // Saga
    saga_help_link: 'Saga 模板幫助',
    saga_preview_title: '預覽：Sagas',
    saga_preview_msg: '這是“Sagas”的預覽。這些是由用戶製作的開放式文本冒險。',
    saga_new_template: '新建模板',
    saga_untitled_template: '未命名模板',
    saga_menu_prompts: '提示詞',
    saga_menu_preset: '預設',
    saga_menu_help: '幫助',
    saga_session_saved: '會話已保存',
    saga_btn_restart: '重新開始',
    saga_btn_start: '開始',
    saga_btn_new: '新建',
    saga_btn_load: '加載',
    saga_btn_save: '保存',
    saga_btn_reimage: '重新生成圖像',
    saga_tab_template: '模板',
    saga_tab_session: '會話',
    saga_current_template: '當前模板',
    saga_load_template: '加載模板',
    saga_field_name: '名稱',
    saga_field_format: '格式',
    saga_field_init_template: '初始模板',
    saga_field_init_template_helper: '用於生成介紹的初始值。',
    saga_field_intro_format: '介紹格式',
    saga_field_intro_format_helper: '如何格式化您的介紹。 .\n\n您可以使用從**初始模板**派生的任何字段。',
    saga_field_display_format: '響應顯示格式（可选）',
    saga_field_display_format_helper: '如何顯示**顯示**的響應（如果為空則使用**響應提示詞格式**）\n您可以使用從模板派生的任何字段。',
    saga_field_image_prompt: '圖像生成的提示詞模板',
    saga_field_image_prompt_helper: '留空以禁用圖像生成',
    saga_field_history_template: '歷史記錄模板',
    saga_field_history_template_helper: '在遊戲循環模板中使用 **{{history}}**',
    saga_field_loop_template: '遊戲循環模板',
    saga_field_loop_template_helper: '使用 **{{input}}** 使用用戶輸入',
    saga_manual_fields: '手動字段',
    saga_manual_fields_helper: '這些字段需要由您填寫',
    saga_fields: '字段',
    saga_fields_helper: '**切換**: 控制字段是否出現在聊天窗口中。\n**標籤**: 啟用後，字段在聊天窗口中的名稱。\n**值**: 覆蓋值而不是生成它。',
    saga_lists: '列表',
    saga_add_items: '添加項目...',
    saga_required_value: '（必填）值',
    saga_optional_value: '（可选）值',
    saga_guidance_title: '引導 (Guidance)',
    saga_import_success: '成功導入模板',
    saga_import_title: '導入模板',
    saga_import_json_label: '模板 JSON',

    // Scenario
    scenario_title: '場景',
    scenario_import: '導入場景',
    scenario_create: '創建場景',
    scenario_no_scenarios: '您還沒有場景。',
    scenario_unnamed: '未命名場景',
    scenario_edit_title: '編輯場景',
    scenario_btn_duplicate: '複製',
    scenario_btn_download: '下載',
    scenario_btn_delete: '刪除',
    scenario_no_events: '此場景未附加事件',
    scenario_events_count: '個事件',
    scenario_details_title: '場景詳情',
    scenario_field_name_helper: '場景的名稱。',
    scenario_field_desc: '描述',
    scenario_field_desc_helper: '有關場景的更多信息。',
    scenario_field_prompt: '提示文本',
    scenario_field_prompt_helper: '可选。要添加到場景提示詞的附加文本。',
    scenario_field_overwrite: '覆蓋角色場景',
    scenario_field_overwrite_helper: '如果角色已經有場景，則用此場景覆蓋。否則，追加到其後。',
    scenario_field_instructions: '用戶說明',
    scenario_field_instructions_helper: '可选。顯示給用戶的文本，幫助他們了解如何使用此場景。',
    scenario_confirm_delete: '您確定要刪除此場景嗎？',
    scenario_download_title: '下載場景',
    scenario_event_type_hidden: '隱藏（不向用戶顯示）',
    scenario_event_type_world: '世界（顯示，角色外部）',
    scenario_event_type_character: '角色（顯示，角色的想法或行為）',
    scenario_event_type_ooc: '離題 (OOC)（僅用戶可見）',
    scenario_trigger_greeting: '問候語',
    scenario_trigger_manual: '手動觸發',
    scenario_trigger_opened: '聊天已打開',
    scenario_trigger_received: '消息已接收',
    scenario_states_used: '已使用的狀態',
    scenario_states_used_helper: '到目前為止您在事件中使用的狀態',
    scenario_events_title: '事件',
    scenario_btn_create_event: '創建事件',
    scenario_no_events_msg: '您還沒有事件。',
    scenario_event_name_placeholder: '事件名稱，例如“問候語”',
    scenario_field_trigger: '觸發器',
    scenario_field_req_states: '所需狀態',
    scenario_field_req_states_helper: '觸發此事件之前需要的狀態。',
    scenario_field_req_states_placeholder: '觸發所需的狀態',
    scenario_field_assign_states: '分配狀態',
    scenario_field_assign_states_helper: '觸發時，哪些狀態將被分配給聊天',
    scenario_field_assign_states_placeholder: '觸發時添加的狀態',
    scenario_field_event_type: '類型',
    scenario_field_event_type_helper: '此事件將如何向用戶顯示。',
    scenario_field_event_prompt_helper: '每當發生此事件時發送的提示文本。(OOC: something) 文本將對用戶隱藏。',
    scenario_event_greeting_msg: '開始新聊天時自動發送。',
    scenario_field_probability: '概率',
    scenario_field_probability_helper: '手動觸發器將被隨機選擇，值越高概率越高。',
    scenario_field_after_hours: '在（小時）之後',
    scenario_field_after_hours_helper: '多少小時後應激活此觸發器？將選擇最長的觸發器。',
    scenario_field_after_messages: '在（自上次事件以來的消息數）之後',
    scenario_field_after_messages_helper: '多少條消息後應激活此觸發器？將選擇最短的觸發器。',
    scenario_btn_update: '更新',
    scenario_help_title: '場景事件幫助',
    scenario_help_triggers_msg: 'Events are triggers when:',
    scenario_help_greeting_msg: 'The very first time the user starts a chat',
    scenario_help_manual_msg: 'When the user uses the Trigger Event menu in the chat',
    scenario_help_opened_msg: 'When the user opens a chat with a character after some time',
    scenario_help_received_msg: 'When the character writes something',
    scenario_help_prompt_msg: 'Whenever an event is triggered, a prompt will be sent to the character.',
    scenario_help_world_msg: 'The event will be shown as if something happened independently of the character.',
    scenario_help_character_msg:
      'The event will be shown as if the character wrote it, for example if the character does something.',
    scenario_help_hidden_msg:
      'The event will be hidden from the user. This is useful to make the character do something, and make it look like it was on their own initiative.',
    scenario_help_ooc_msg:
      'The event will be hidden from the character. This is useful to give information or clues to the user.',
    scenario_help_processing_msg: 'The prompt text will have processing.',
    scenario_help_placeholders_msg: 'The {{char}} and {{user}} placeholders will be replaced',
    scenario_help_ooc_processing_msg:
      'Any text with (OOC: TEXT) will be hidden from the user, so you can add additional instructions for the character.',
    scenario_help_asterisks_msg:
      'It is recommended to wrap your text in *asterisks* unless you want the character to say the prompt text.',
    scenario_help_states_msg:
      'Finally, you can use the states to control which events are triggered under which conditions. The chat will keep track of a list of states, which can be assigned by events.',
    scenario_help_req_states_msg:
      'Required states are states that must exist in the chat to allow the trigger to run. You can also prefix a required state by ! to require the state not to exist in the chat for the event to run. You can specify multiple states by separating them with a comma.',
    scenario_help_assign_states_msg:
      'Assigned states are states that will be added to the chat whenever the event is triggered. You can also prefix an assigned state by ! to remove the state from the chat. You can specify multiple states by separating them with a comma.',
    scenario_help_random_msg: 'When multiple events can run, they will be randomly selected.',
    scenario_import_error_json: '文件不是有效的 JSON',
    scenario_import_error_schema: '文件不是受支持的場景（架構不正確）',
    scenario_import_error_invalid: '無效的場景',
    scenario_import_json_label: '場景 JSON 文件',
    scenario_import_supported_formats: '支持的格式：HuanYouAI',

    // Generation Presets
    gen_presets_title: '生成預設',
    gen_presets_new_preset: '新建預設',
    gen_presets_load_preset: '加載預設',
    gen_presets_save_preset: '保存預設',
    gen_presets_import_preset: '導入預設',
    gen_presets_delete_preset_confirm: '您確定要刪除此預設嗎？',
    gen_presets_name_label: '名稱',
    gen_presets_name_helper: '預設的名稱或簡短描述',
    gen_presets_name_placeholder: '預設名稱',
    gen_presets_id_label: 'ID',
    gen_presets_new_preset_id: '新預設',
    gen_presets_builtin_warning: '這是一個內置預設，無法保存。',
    gen_presets_copy_click_here: '點擊這裡',
    gen_presets_copy_helper_text: '如果您想創建此預設的副本。',
    gen_presets_select_preset_helper: '選擇要開始編輯的預設。如果您當前正在編輯某個預設，它將不會出現在列表中。',
    gen_presets_filter_placeholder: '篩選...',
    gen_presets_providers_tab: '提供商',
    gen_presets_presets_tab: '預設',
    gen_presets_new_button: '新建',
    gen_presets_import_button: '導入',
    gen_presets_preset_json_label: '預設 JSON',
    gen_presets_imported: '已導入',
    gen_presets_imported_preset: '導入的預設',
    gen_presets_invalid_preset: '預設無效',
    gen_presets_could_not_parse: '無法解析預設',

    // Additional UI
    nav_charHub: '角色樞紐',
    nav_sagasPreview: '故事預覽',
    nav_imageGeneration: '圖像生成',
    nav_toggleTheme: '切換亮色/暗色模式',
    nav_newNotifications: '狀態：您有 {count} 條新通知',
    nav_noNotifications: '狀態：沒有新通知',
    nav_subscribeCTA: '訂閱以獲得更高質量的聊天且無廣告',
    home_modelsTitle: '模型',
    home_modelsMessage: 'HuanYouAI 現在託管自己的模型！在您的預設中選用 Agnaistic 服務即可免費開始',
    home_browserNoStorage: '您的瀏覽器不支持本地存儲。您需要登入/註冊才能使用 Agnaistic。',
    home_officialGuides: '官方指南',
    chat_forkConversation: '分支對話',
    chat_forkConfirm: '從此處分支將刪除此消息之後的所有消息。您要繼續嗎？',
    chat_user_handle_you: '您',
    chat_user_anon_name: '用戶 {id}',
    chat_bot_label: '機器人: {name}',
    chat_profile_label: '個人資料: {handle}',
    chat_ago: '{duration}前',
    chat_confirm_discard: '丟棄',
    chat_thinking: '思考中...',
    chat_reasoning_thought: '想法',
    chat_option_prompt: '提示詞',
    chat_option_edit: '編輯',
    chat_option_fork: '分支',
    chat_option_regen: '重新生成',
    chat_option_attach: '附件',
    chat_option_visibility: '可見性',
    chat_option_delete: '刪除',
    chat_option_gen_image: '生成圖片',
    chat_option_gen_json: '生成JSON',
    chat_option_export: '導出',
    chat_removed_from_convo: '您已被移出對話',
    chat_unnamed_preset: '未命名預設',
    admin_notYetImplemented: '尚未實現',
    admin_noSubscriptionId: '沒有訂閱 ID',
    admin_session: '會話：',

    recentConversations: '最近對話',
    startConversation: '開始對話',
    guides: '指南',
    links: '鏈接',
    gettingStarted: '開始使用',
    createACharacter: '創建角色',
    configureYourAIServices: '配置您的AI服務',
    officialGuides: '官方指南',
    memoryBook: '記憶書',
    agnaisticDiscord: 'HuanYouAI Discord',
    github: 'GitHub',
    notableFeatures: '主要功能',
    lookingForHelp: '需要幫助開始使用嗎？',
    checkOutThe: '查看',
    officialGuide: '官方指南',
    orHeadToThe: '或前往',

    // Guides
    guide_memory_title: '記憶書',
    guide_memory_text: `## 什麼是記憶書？

記憶書是一種在與角色交談時動態提供上下文的方法。你可以使用記憶書，而不是在「場景」、「角色設定」和「示例對話」中填滿你的整個上下文預算。

## 它是如何工作的？

當你創建一個**記憶條目**時，你需要提供：\`關鍵字\`和\`條目\`文本。
你也可以提供\`優先級\`和\`權重\`值，我們稍後會講到。

- 關鍵字：
  - 這些是「觸發」記憶並將其插入提示詞的詞。
  - 例如：\`飲料, 口渴, 補水, 喝水\`
- 條目：
  - 這是當找到你的一個關鍵字时插入到你的提示詞中的文本。
  - 例如：\`{{user}}最喜歡的飲料是加冰的紅色果汁\`

你的生成設置將有一個**記憶深度**。這是 Agnai 將掃描關鍵字的最大聊天消息數量。
重要的是要記住，這一切都發生在你的瀏覽器中。

### 為什麼記住這一切發生在瀏覽器中很重要？

*注意：這不適用於匿名/訪客用戶。訪客用戶始終可以使用整個聊天歷史記錄進行提示詞構建。*

如果你將記憶深度配置為超過 \`100\`，關鍵字可能不會按你預期的方式觸發。
當你最初加載聊天時，你將從服務器接收最多 100 條消息。你可以繼續向上滾動以檢索更多消息。

## 什么是優先級和權重？

簡而言之，這兩個值用於確定哪些記憶應包含在你的記憶預算（\`memory context limit\`）中，以及它們在提示詞中出現的順序。

### 優先級 (Priority)

該值越高，它就越「重要」。為了評估我們將哪些記憶包含在提示词中：

- 我們按優先級對記憶進行排序
- 我們將記憶逐個添加到提示詞中，直到預算填滿

### 權重 (Weight)

該值越高，記憶在記憶提示詞中的位置就越靠後（越接近底部）。
理論上是：提示詞中越靠下的內容，在生成響應時越重要。

在記憶被「修剪」以適應預算後，記憶將按權重進行排序。

## 你推薦什麼樣的記憶生成設置？

目前我還不確定。我很想聽聽你在嘗試這些設置時的經驗。

可供嘗試的生成設置有：\`depth\`（深度）和 \`contextLimit\`（上下文限制）。

- **深度 (Depth)**：掃描關鍵字的最大聊天消息數。
- **上下文限制 (Context Limit)**：記憶提示詞將從你的「最大上下文長度」中消耗的最大標記（token）數。`,
    guide_novel_title: 'NovelAI 指南',
    guide_novel_text: `# Novel 說明

設置 NovelAI 有兩種方法：

**從 NovelAI 網站獲取持久 API 令牌。**

1. 登入 [NovelAI](https://novelai.net/stories)
2. 打開「用戶設置」并轉到「帳戶」選項tab
3. 按「獲取持久 API 令牌」按鈕
4. 複製（使用剪貼板按鈕）/粘貼生成的令牌到 [NovelAI 設置頁面](https://agnai.chat/settings?tab=ai&service=novelai)中的 \`Novel API Key\` 字段

API 密鑰看起來像这样：

\`\`\`
pst-ykHYhtDti6ZYYmgCtUnhYraECciZQCEVMGhhh4HUgRf7XLQGzeDinQtCRECZJXWE
\`\`\`

或者

**使用開發人員工具從 NovelAI 網站手動檢索您的令牌。**

1. 登入 [Novel AI](https://novelai.net/stories)
2. 使用以下方法之一打開開發人員工具：

   - \`Ctrl + Shift + I\`
   - 右鍵單擊頁面 --> 單擊「檢查」

3. 打開 \`Console\`（控制台）選項卡并輸入：

- \`console.log(JSON.parse(localStorage.getItem('session')).auth_token)\`

4. 複製/粘貼生成的輸出到您的 [NovelAI 設置頁面](/settings?tab=ai&service=novelai)中的 \`Novel API Key\` 字段

API 密鑰看起來像这样：

\`\`\`
eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6Ii4uLiIsImlhdCI6MTUxNjIzOTAyMn0.pCVUFONBLI_Lw3vKQG6ykCkuWNeG4cDhdEqRO_QJbh4
\`\`\`

請注意，此令牌將定期過期，需要每月更換一次。最好使用持久 API 令牌。`,
    guide_pipeline_title: 'Pipeline 指南',
    guide_pipeline_subtitle: '如何安裝和使用 Agnai Pipeline API',
    guide_pipeline_text: `### 什么是 Pipeline API？
Pipeline API 允許您運行其他功能来增強您的對話。
支持 Agnai.chat 和本地託管的對話。
目前，僅提供使用 ChromaDB 的嵌入（Embedding）支持。

### 什么是嵌入？
嵌入類似於記憶書，但更複雜。它們不使用簡單的「關鍵字」匹配，而是使用一種稱為「語義相似性」的技术。
這意味著結果基於「它們含義的相似性或接近程度」。您的消息用於查詢整個正文，結果是「含義最接近」的内容。
這意味着我們可以執行以下操作：
- 使用最後一條消息来「喚起 AI 的記憶」，並召回提示詞中不再容納的對話部分。
- 將 PDF 或文章的相关部分傳遞給 AI，以便根據該信息提供有意義的回复。

### 我該如何安裝並運行 Pipeline？
- 您需要安裝 [Node.JS v16+](https://nodejs.org/en/download) 和 [Python 3.10+](https://www.python.org/downloads/)。
- 使用 NPM 包安裝 Agnaistic。在您的終端中運行：\`npm install agnai -g\`
- 在您的終端中運行 \`agnai --pipeline\`

### 我現在如何使用 Pipeline？
- 前往您的\`設置 -> AI 設置\`，啟用「使用本地 Pipeline」並點擊保存。
- 如果您的 Pipeline 成功連接，您將在主菜單中的\`記憶\`旁邊看到一個通知和一個綠色信號條。
- 如果 Pipeline 斷開連接，您可以點擊菜單中\`記憶\`旁邊的電源圖標。

### 我該如何創建和使用嵌入？
- 在您的\`聊天選項 -> 記憶\`模式窗口中，您可以從維基百科文章或 PDF 創建嵌入。也可以在\`記憶 -> 嵌入\`頁面完成。
- 創建後，從記憶模式窗口的下拉列表中選擇嵌入，然後點擊「使用嵌入」。


如果您提供嵌入信息，\`{{user_embed}}\` 占位符將自動注入到您的提示詞中。
您也可以手動將此 \`{{user_embed}}\` 占位符添加到您的模板中。`,

    home_faq_title: '常見問題',
    home_faq_subtitle: '經常問的問題',
    home_faq_content: `### 我的回覆被過濾了嗎？
不，HuanYouAI 不會嘗試過濾您的回覆。

### 角色的回覆經常在句中被切斷。我該怎麼辦？
您可以嘗試以下幾點：
- 在您的**預設設置**中增加\`最大令牌\`。
- 如果您使用的是 **Horde**，請確保您的\`最大令牌\`不會「太高」。在您的**設置 -> Horde 設置**中，您可以點擊\`選擇工作者\`來查看每個工作者的「上下文和令牌」限制。確保您的\`最大令牌\`不超過其令牌限制。

### 如何在聊天中擁有多個個人資料或更改我的名字？
這可以通過**扮演角色**來實現。要扮演角色，請在主菜單中點擊您的頭像/名字。

### 我可以在聊天中擁有多個用戶和角色嗎？
是的。在您的**聊天選項**中，您可以從**參與者**中添加角色並邀請用戶。

### 我可以編輯或刪除我的聊天消息嗎？
是的。在**聊天選項**中啟用「聊天編輯」，您的聊天消息中就會出現額外的按鈕。

### 我的回覆在句中被切斷了，我可以繼續嗎？
是的。在**輸入選項**中，您可以選擇「生成更多」。

### 我可以根據我的對話生成圖像嗎？
是的，您可以在**設置 -> 圖像設置**中配置圖像生成。
當您指定 Web URL 時，請確保它是使用 Local Tunnel 或 NGrok 等服務*公開訪問*的。

### 你們支持文本轉語音嗎？
是的，在您的**設置 -> 語音設置**中，我們支持多種文本轉語音服務。

### 我可以自定義 UI 嗎？
是的，您可以在**設置 -> UI 設置**中更改 Agnaistic 的一些元素。

### 我是從「某個其他網站」過來的，如何讓我的機器人表現得像在那個網站上一樣？
所有前端的表現都略有不同。您可以通過修改**預設**中的**提示模板**來調整角色的行為。

### 我忘記了密碼！
恢復您的帳戶並不保證成功。您可以嘗試在 [Discord](https://discord.agnai.chat) 上聯繫 Sceik 嘗試恢復您的帳戶。

### 我的問題在這裡沒有得到解答，我該去哪裡問？
獲得快速解答的最佳場所是在 [Discord](https://discord.agnai.chat) 上。

### 詞彙表/術語：
- **輸入選項**：從聊天文本輸入的右側（三點菜單）訪問。
- **聊天選項**：從聊天窗口的右上方訪問。
- **設置**：從主菜單中的「設置」鏈接訪問。
- **AI 設置**：在您的設置頁面中可用。
- **提示詞**：發送到您的 AI 服務以生成回覆的文本正文。
- **最大上下文長度**：發送到您的 AI 服務的提示詞的最大長度。
- **最大令牌**：從您的 AI 服務收到的回覆中的最大令牌數量。
- **預設**：也稱為**生成設置**。這控制：
    - 您使用哪種 AI 服務
    - 您的*提示詞*的格式/形狀
    - *最大上下文長度*和*最大令牌*
    - 「生成設置」，如「溫度」、「重複懲罰」等。`,
    maxNewTokens: '最大新建令牌',
    username: '用戶名',
    password: '密碼',
    confirmPassword: '確認密碼',
    displayName: '顯示名稱',
    passwordsDoNotMatch: '密碼不匹配',
    invalidCallbackUrl: '無效的對調 URL',
    loggingIn: '登入中...',
    registering: '註冊中...',
    welcomeToAccount: '歡迎',
    authorizing: '授權中',
    youAreAlreadyLoggedIn: '您已經登入。',
    toYourAccount: '登入您的帳戶',
    orContinueAsGuest: '或繼續以訪客身份使用。',
    failedToLogIn: '登入失敗。',
    somethingWentWrong: '出了問題。',
    couldNotReachServers: '無法連接到服務器。',
    byLoggingIn: '通過登入或註冊，您同意您已年滿18歲並同意',
    youAgree: '您同意',
    and: '和',
    whyRegister: '為什麼要註冊？',
    youDontNeedToRegister: '您不需要註冊即可使用HuanYouAI。您可以匿名使用，不會在服務器上存儲任何數據。',
    ifYouChooseToRegister: '如果您選擇註冊',
    yourDataWillBeStored: '您的數據將被存儲，並可在您登入的任何設備上訪問。',

    // Admin
    admin_serverConfiguration: '服務器配置',
    admin_general: '常規',
    admin_images: '圖像',
    admin_voice: '語音',
    admin_supportEmail: '支持電子郵件',
    admin_supportEmailHelper: '如果提供，將在主導航中添加此電子郵件的鏈接',
    admin_maintenanceModeEnabled: '啟用維護模式',
    admin_maintenanceModeHelper: '注意：如果數據庫不可用，此標誌將不起作用。請改用環境變量。',
    admin_maintenanceMessage: '維護消息',
    admin_maintenanceMessageHelper: '支持 Markdown',
    admin_stripeCustomerPortal: 'Stripe 客戶門戶',
    admin_lockDuration: '鎖定持續時間（秒）',
    admin_lockDurationHelper: '用戶級鎖定的最大 TTL - 設置為零 (0) 以禁用',
    admin_googleClientId: 'Google 客戶端 ID',
    admin_googleClientIdHelper: '用於登錄',
    admin_slotsConfiguration: '插槽配置',
    admin_slotsConfigurationHelper: '必須是 JSON。與遠程插槽配置合併 -- 此配置會覆蓋 slots.txt',
    admin_format: '格式化',
    admin_enablePolicies: '啟用政策',
    admin_enablePoliciesHelper: '顯示服務條款和隱私聲明',
    admin_privacyStatement: '隱私聲明',
    admin_apiAccessLevel: 'API 訪問級別',
    admin_off: '關閉',
    admin_allUsers: '所有用戶',
    admin_subscribers: '訂閱者',
    admin_administrators: '管理員',
    admin_maxGuidanceTokens: '最大引導令牌',
    admin_maxGuidanceTokensHelper: '傳奇/引導模板可以請求的最大令牌數。設置為 0 以禁用。',
    admin_maxGuidanceVariables: '最大引導變量',
    admin_maxGuidanceVariablesHelper: '傳奇/引導模板可以請求的最大變量數。設置為 0 以禁用。',
    admin_imagesHost: '圖像主機 (兼容 A1111)',
    admin_imagesLoraUrl: '圖像 LoRA URL',
    admin_defaultImageModel: '默認圖像模型',
    admin_imageModels: '圖像模型',
    admin_add: '添加',
    admin_addModel: '添加模型',
    admin_description: '描述',
    admin_modelDescriptionPlaceholder: '模型描述...',
    admin_url: 'URL',
    admin_loraSupport: 'LoRA 支持',
    admin_host: '主機',
    admin_modelNamePlaceholder: '模型名稱...',
    admin_override: '覆蓋',
    admin_level: '級別',
    admin_prefix: '前綴',
    admin_suffix: '後綴',
    admin_negative: '負面提示詞',
    admin_steps: '步數',
    admin_init: '初始',
    admin_max: '最大',
    admin_cfgScale: 'CFG 比例',
    admin_width: '寬度',
    admin_height: '高度',
    admin_clipSkip: 'Clip 跳過',
    admin_voiceAccessLevel: '語音訪問級別',
    admin_voiceHost: '語音主機',
    admin_voiceHostHelper: '包含路徑的完整 URL - 包含任何查詢參數',
    admin_voiceApiKey: '語音 API 密鑰',
    admin_metrics: '指標',
    admin_refresh: '刷新',
    admin_onlineUsers: '在線用戶',
    admin_versions: '版本',
    admin_maxOnlineUsers: '最大在線用戶',
    admin_registeredUsers: '註冊用戶',
    admin_services: '服務',
    admin_messageAllUsers: '向所有用戶發送消息',
    admin_send: '發送',
    admin_confirmMessageAll: '您確定要向所有用戶發送消息嗎？',
    admin_userManagement: '用戶管理',
    admin_backToManage: '返回管理',
    admin_customerId: '客戶 ID',
    admin_subscribed: '已訂閱',
    admin_search: '搜索',
    admin_reset: '重置',
    admin_info: '信息',
    admin_impersonate: '模擬身份',
    admin_changePassword: '更改密碼',
    admin_banUser: '封禁用戶',
    admin_unbanUser: '解封用戶',
    admin_userId: '用戶 ID',
    admin_banned: '已封禁',
    admin_handle: '用戶名/暱稱',
    admin_subscriptionDetails: '訂閱詳情',
    admin_gift: '禮物',
    admin_expiry: '到期時間',
    admin_apply: '應用',
    admin_assignSub: '分配訂閱',
    admin_stripeSubscriptionId: 'Stripe 訂閱 ID',
    admin_assign: '分配',
    admin_sessionIds: '會話 ID',
    admin_subscriptionLevel: '訂閱級別',
    admin_native: '原生',
    admin_manual: '手動',
    admin_periodStart: '週期開始',
    admin_renewsAt: '續訂於',
    admin_downgradingAt: '降級於',
    admin_cancelledAt: '取消於',
    admin_cancelsAt: '取消於',
    admin_state: '狀態',
    admin_history: '歷史記錄',
    admin_noReasonGiven: '未提供原因',
    admin_banReason: '封禁原因',
    admin_resetLink: '重置鏈接',
    admin_generateLink: '生成鏈接',
    admin_manageAnnouncements: '管理公告',
    admin_created: '已創建',
    admin_hide: '隱藏',
    admin_unhide: '取消隱藏',
    admin_delete: '刪除',
    admin_instructions: '使用說明',
    admin_deleted: '已刪除',
    admin_hidden: '隱藏',
    admin_pending: '待處理',
    admin_active: '活動',
    admin_announcement: '公告',
    admin_title: '標題',
    admin_displayAtRequired: '「顯示於」 為必填',
    admin_errorProductNotFound: '未找到產品：{id}',
    admin_errorProductNoPrice: '產品沒有默認價格：{id}',
    admin_errorPriceNotFound: '未找到價格：{id}',
    admin_location: '位置',
    admin_home: '主頁',
    admin_notification: '通知',
    admin_locationHelper: '顯示在主頁或通知列表中',
    admin_userLevelThreshold: '用戶等級（閾值）',
    admin_userLevelThresholdHelper: '向等級大於或等於該等級的用戶發布公告 `所有用戶 = -1` `已訂閱 = 0`',
    admin_content: '內容',
    admin_hideAnnouncement: '隱藏公告',
    admin_displayAt: '顯示於',
    admin_now: '現在',
    admin_id: 'ID',
    admin_name: '名稱',
    admin_apiAccessCapable: '支持 API 訪問',
    admin_guidanceAccessCapable: '支持 Guidance (V2) 訪問',
    admin_imagesAccessCapable: '支持圖像生成訪問',
    admin_patreonTier: 'Patreon 層級',
    admin_preview: '預覽',
    admin_stripeProduct: 'Stripe 產品',
    admin_enabled: '已啟用',
    admin_disableSlots: '禁用插槽',
    admin_subscriptionTier: '訂閱層級',
    admin_backToSubscriptions: '返回訂閱',
    admin_noPaymentRequired: '無需付款',
    admin_descriptionHelper: '這將使用 markdown 渲染器渲染。這裡也支持 HTML。',
    admin_apiAccessHelper: '如果啟用，如果服務器允許，該層級可以使用 API 訪問',
    admin_guidanceAccessHelper: '如果啟用，如果服務器/預設允許，該層級可以使用 GuidanceV2',
    admin_imagesAccessHelper: '如果啟用，該層級可以使用 HuanYouAI 圖像生成',
    admin_patreonTierHelper: '如果鏈接了 Patreon，則需要最低層級',
    admin_enabledHelper: '如果禁用，該層級將不供用戶選擇。',
    admin_disableSlotsHelper: '該層級將阻止插槽渲染',
    admin_subscriptions: '訂閱',
    admin_model: '模型',
    admin_tier: '層級',
    admin_noTiers: '無層級',
    admin_tiers: '層級',
    admin_models: '模型',
    admin_disabled: '已禁用',
    admin_default: '默認',
    admin_stripe: 'Stripe',
    admin_patreon: 'Patreon',
    admin_unset: '未設置',
    admin_confirmDeleteSubscription: '您確定要刪除此訂閱嗎？',
    admin_subscriptionModel: '訂閱模型',
    admin_loadPreset: '加載預設',
    admin_newSubscription: '新訂閱',
    admin_replaceSupercede: '替換/取代',
    admin_modelHelper: '僅限 HuanYouAI 服務',
    admin_modelServiceUrl: '模型服務 URL',
    admin_modelServiceUrlHelper: '僅限 HuanYouAI 服務',
    admin_guidanceCapable: '支持引導',
    admin_guidanceCapableHelper: '僅限 HuanYouAI 服務',
    admin_subscriptionDisabled: '訂閱已禁用',
    admin_subscriptionDisabledHelper: '禁用此訂閱的使用',
    admin_isDefaultSubscription: '是默認訂閱',
    admin_isDefaultSubscriptionHelper: '當請求中未提供訂閱時，將其作為回退選項',
    admin_jsonSchemaCapable: '支持 JSON Schema（結構化響應）',
    admin_visionModel: '視覺模型',
    admin_visionModelHelper: '僅限 HuanYouAI 服務',
    admin_allowGuestUsage: '允許訪客使用',
    admin_allowGuestUsageHelper: '通常用於默認訂閱。要求用戶登錄以使用此訂閱。',
    admin_tokenizerOverride: '分詞器覆蓋',
    admin_tokenizerOverrideHelper: '可選。用於自定義模型。',
    admin_confirmDeletePreset: '您確定要刪除此預設嗎？',
    admin_replaceSubscription: '替換訂閱',
    admin_replacementSubscription: '替換訂閱',
    admin_replacementSubscriptionHelper: '將取代當前訂閱的訂閱',
    admin_replace: '替換',
    admin_levels: '等級',
    admin_subLevel: '訂閱等級',
    admin_tokens: '令牌',
    admin_context: '上下文',
    admin_copySubscription: '複製訂閱',
    admin_createSubscription: '創建訂閱',
    admin_editSubscription: '編輯訂閱',
    admin_selectAIServiceBeforeSaving: '保存前必須選擇 AI 服務',
    admin_preset: '預設',
    admin_presetHelper: '選擇一個預設開始編輯。如果您當前正在編輯一個預設，它將不會出現在列表中。',
    admin_apiKey: 'API 密鑰',
    admin_apiKeyHelper: '（可選）如果適用，請提供您的 AI 服務的 API 密鑰。',
    admin_apiKeyIsSet: 'API 密鑰已設置',
    admin_apiKeyIsNotSet: 'API 密鑰未設置',
    admin_subscriptionLevelHelper: '任何高於 -1 的級別都需要“訂閱”。默認情況下所有用戶都是 -1。',
    admin_replacementIdNotSet: '未設置替換 ID',
    
    // Profile
    profile_myProfile: '我的個人資料',
    profile_updateProfile: '更新個人資料',
    profile_impersonateNote: '您可以通過點擊主菜單頂部的“角色扮演”按鈕來模擬角色。',
    profile_linkGoogle: '鏈接 Google 帳戶以啟用 Google 登錄',
    profile_accountLinkedGoogle: '您的帳戶已鏈接到 Google',
    profile_unlinkGoogle: '取消鏈接 Google 帳戶',
    profile_userIdHelper: '您的用戶 ID。其他人可以使用它向您發送聊天邀請。',
    profile_usernameHelper: '您的用戶名。這無法更改。您永遠不需要分享您的用戶名。',
    profile_displayNameHelper: '您在聊天中和他人的顯示名稱（未模擬身份時）',
    profile_profileImage: '個人頭像',
    profile_removeAvatar: '刪除頭像',
    profile_fileSizeLimit2MB: '文件大小限制為 2MB',
    profile_guestData: '訪客數據',
    profile_prepareBackup: '準備備份',
    profile_backupNotReady: '備份未就緒',
    profile_downloadGuestData: '下載訪客數據',
    profile_unimpersonate: '取消模擬身份',
    profile_logout: '登出',
    profile_deleteAccount: '刪除帳戶',
    profile_importGuestDataWarning: '這將替換您所有現有的訪客數據。您確定嗎？',
    profile_importFailed: '導入失敗：{message}',
    profile_changePassword: '更改密碼',
    profile_changePasswordDescription: '此窗口允許您更改帳戶密碼',
    profile_updatePassword: '更新您的密碼',
    profile_newPassword: '新密碼',
    profile_confirmPassword: '確認密碼',
    profile_deleteAccountWarning: '這是不可逆的！帳戶一旦刪除將無法恢復。',
    profile_deleteAccountConfirmNote: '輸入您的用戶名，然後點擊“確認”以確認刪除您的帳戶',
    profile_confirmDeletion: '確認刪除',

    // Settings
    settings_title: '設置',
    settings_updateSettings: '更新設置',
    settings_thisCannotBeUndone: '這將無法撤銷！',
    settings_deleteGuestState: '刪除訪客狀態',
    settings_ui_theme: '主題',
    settings_ui_chat: '聊天',
    settings_ui_messages: '消息',
    settings_ui_color: '顏色',
    settings_ui_mode: '模式',
    settings_ui_dark: '深色',
    settings_ui_light: '淺色',
    settings_ui_siteFontSize: '網站字體大小',
    settings_ui_backgrounds: '背景',
    settings_ui_resetToDefault: '重置為默認',
    settings_ui_backgroundColor: '背景顏色',
    settings_ui_backgroundImage: '背景圖片',
    settings_ui_remove: '移除',
    settings_ui_font: '字體',
    settings_ui_custom: '自定義',
    settings_ui_responseHints: '響應提示',
    settings_ui_responseHintsHelper: '在消息中添加提示以引導響應',
    settings_ui_avatarWrapAround: '頭像環繞',
    settings_ui_avatarWrapAroundHelper: '允許消息中的文本“環繞”頭像',
    settings_ui_trimIncompleteSentences: '修剪不完整的句子',
    settings_ui_expandReasoning: '默認展開推理',
    settings_ui_expandReasoningHelper: '推理想法默認是摺疊的。啟用此項以默認展開它們。',
    settings_ui_midReasoningBehavior: '中途推理行為',
    settings_ui_midReasoningBehaviorHelper: '當推理處於響應中間時，應保留哪個話語（即非想法）',
    settings_ui_anonymizeChat: '匿名化聊天',
    settings_ui_anonymizeChatHelper: '在對話中隱藏個人資料名稱。通常用於截圖。',
    settings_ui_sendOnEnterOnMobile: '移動端回車發送',
    settings_ui_sendOnEnterOnMobileHelper: '“Enter”將發送消息而不是添加換行符（僅限移動端）',
    settings_ui_textSpeed: '文本速度',
    settings_ui_textSpeedHelper: '控制文本流出的速度。設置為 `0` 以禁用。',
    settings_ui_viewMode: '視圖模式',
    settings_ui_viewModeHelper: '標準：消息佔據整個聊天屏幕。分割：角色頭像顯示在屏幕頂部。背景：角色頭像將成為聊天背景。',
    settings_ui_splitHeight: '分割高度 (%)',
    settings_ui_splitHeightHelper: '分割模式下角色頭像的最大高度',
    settings_ui_standard: '標準',
    settings_ui_split: '分割',
    settings_ui_backgroundAuto: '背景：自動',
    settings_ui_backgroundCover: '背景：覆蓋',
    settings_ui_backgroundContain: '背景：包含',
    settings_ui_defaultAll: '默認 (全部)',
    settings_ui_all: '全部',
    settings_ui_afterThought: '思考後',
    settings_ui_beforeThought: '思考前',
    settings_ui_avatars: '頭像',
    settings_ui_size: '大小',
    settings_ui_cornerRadius: '圓角半徑',
    settings_ui_width: '寬度',
    settings_ui_height: '高度',
    settings_ui_messageBackgroundColor: '消息背景顏色',
    settings_ui_botMessageBackgroundColor: '機器人消息背景顏色',
    settings_ui_chatTextColor: '聊天文本顏色',
    settings_ui_chatEmphasisColor: '聊天強調顏色',
    settings_ui_chatQuoteColor: '聊天引用顏色',
    settings_ui_chatQuoteEmphasisColor: '聊天引用強調顏色',
    settings_ui_chatQuoteEmphasisWeight: '聊天引用強調粗細',
    settings_ui_contentWidth: '內容寬度',
    settings_ui_messageOpacity: '消息透明度',
    settings_ui_messageOpacityHelper: '聊天窗口中消息塊的透明度。',
    settings_ui_inlineMessageOptions: '內聯消息選項',
    settings_ui_inlineMessageOptionsHelper: '啟用哪些消息選項在消息中“內聯”顯示。其餘選項將位於“更多選項”下拉菜單中',
    settings_ui_preview: '預覽',
    settings_ui_none: '無',
    settings_ui_bold: '加粗',
    settings_ui_narrow: '窄',
    settings_ui_large: '大',
    settings_ui_xlarge: '特大',
    settings_ui_2xlarge: '超大',
    settings_ui_3xlarge: '極大',
    settings_ui_100: '100%',
    settings_ui_msg_edit: '編輯',
    settings_ui_msg_regenerate: '重新生成',
    settings_ui_msg_promptView: '提示詞視圖',
    settings_ui_msg_fork: '分支',
    settings_ui_msg_delete: '刪除',
    settings_ui_msg_attach: '附加',
    settings_ui_msg_visibility: '可見性',
    settings_ui_msg_genImage: '生成圖像',
    settings_ui_msg_genJson: '生成 JSON',
    settings_ai_embeddings: '嵌入/長期記憶',
    settings_ai_embeddingsHelper: '禁用時可提高網站性能。如果您的聊天出現延遲且無響應，請禁用長期記憶。',
    settings_ai_presets: '預設',
    settings_ai_chargen: '角色字段生成',
    settings_ai_useServerDefault: '使用服務器默認設置',
    settings_ai_chatSummary: '聊天摘要',
    settings_ai_useActiveChatPreset: '使用當前聊天預設',
    settings_ai_jsonSchemas: 'JSON 模式/輸出',
    settings_ai_defaultPreset: '默認預設',
    settings_ai_defaultPresetHelper: '創建新聊天時最初選擇的預設。',
    settings_ai_apiAccessTitle: 'HuanYouAI API 訪問',
    settings_ai_howToUseApi: '如何使用 API 訪問',
    settings_ai_apiAccessPreset: '默認/API 訪問預設',
    settings_ai_apiAccessPresetHelper: '使用 API 訪問時使用的預設。也是創建新聊天時最初選擇的預設。',
    settings_ai_apiKey: 'API 密鑰',
    settings_ai_revealKey: '顯示密鑰',
    settings_ai_generateKey: '生成密鑰',
    settings_ai_regenerateKey: '重新生成密鑰',
    settings_ai_apiKeyHidden: 'API 密鑰已隱藏',
    settings_ai_lookingForProviders: '在尋找服務商部分嗎？',
    settings_ai_headToPresets: '前往預設頁面',
    settings_ai_editSummaryPreset: '編輯摘要預設',
    settings_ai_apiAccessHelp: '訂閱者 API 端點使用 OpenAI 文本補全或 OpenAI 聊天補全格式。\n\n這些端點的完整 URL 為：\n- https://api.agnai.chat/v1/completions\n- https://api.agnai.chat/v1/chat/completions\n\n說明：\n1. 選擇您的 API 訪問預設：此預設將用於您的 API 調用。在設置頁面更改此項。\n2. 生成您的 API 密鑰。\n3. 使用 API URL https://api.agnai.chat 或 https://api.agnai.chat/v1 以及您生成的 API 密鑰。',
    settings_voice_sttTitle: '語音轉文本（使用麥克風說話）',
    settings_voice_sttNotAvailable: '您的瀏覽器不支持語音轉文本',
    settings_voice_sttHelper: '您可以通過使用輸入文本框中的麥克風圖標來使用語音識別。',
    settings_voice_sttEnabled: '已啟用',
    settings_voice_sttEnabledHelper: '是否顯示麥克風按鈕。',
    settings_voice_sttAutoSubmit: '自動提交',
    settings_voice_sttAutoSubmitHelper: '是否在句子完成後自動發送消息。',
    settings_voice_sttAutoRecord: '自動恢復錄音',
    settings_voice_sttAutoRecordHelper: '是否在收到消息後重新開始錄音。',
    settings_voice_ttsTitle: '文本轉語音（角色語音）',
    settings_voice_ttsHelper: '您需要在角色編輯頁面配置語音。',
    settings_voice_ttsEnabled: '已啟用',
    settings_voice_ttsEnabledHelper: '配置了語音的角色將自動說話。',
    settings_voice_ttsFilterActions: '過濾動作文本',
    settings_voice_ttsFilterActionsHelper: '跳過星號和括號中的文本。',
    settings_voice_voiceServices: '語音服務',
    settings_voice_agnaistic: 'HuanYouAI',
    settings_voice_webspeechsynthesis: '網頁語音合成',
    settings_voice_elevenlabs: 'ElevenLabs',
    settings_voice_novel: 'NovelAI 文本轉語音',

    // Character
    char_advancedOptions: '高級選項',
    char_systemPrompt: '角色系統提示詞（可選）',
    char_systemPromptHelper: '應用於角色的全局指令集。',
    char_systemPromptPlaceholder: '進入角色扮演模式。您將在 {{char}} 和 {{user}} 之間的對話中編寫 {{char}} 的下一個回復。不要決定 {{user}} 說什麼或做什麼。使用互聯網角色扮演風格，例如不使用引號，並以第三人稱斜體編寫用戶動作，如：*示例*。允許使用 markdown。保持主動、創意，推動情節和對話前進。至少寫一個段落，最多四個。始終保持角色形象。始終保持對話進行。（強烈不建議重複）',
    char_jailbreak: '角色越獄（可選）',
    char_jailbreakHelper: '應用於對話歷史末尾的指令。有助於確保角色的性格特徵。',
    char_jailbreakPlaceholder: '至少寫四個段落。',
    char_insertDepthPrompt: '插入 / 深度提示詞',
    char_insertDepthPromptHelper: '在對話歷史中的 {depth} 處插入的一組指令。',
    char_insertDepth: '插入深度',
    char_insertDepthHelper: '應該存在於插入提示詞下方的消息數量。介於 1 和',
    char_creator: '創建者（可選）',
    char_creatorPlaceholder: '例如 John1990',
    char_version: '角色版本（可選）',
    char_versionPlaceholder: '任何文本，例如 1, 2, v1, v1fempov...',
    char_chats: '聊天',
    char_noConversations: '沒有對話',
    char_chatActivity: '聊天活動',
    char_botActivity: '機器人活動',
    char_chatCreated: '聊天創建時間',
    char_botName: '機器人名稱',
    char_botCreated: '機器人創建時間',
    char_chatCounts: '聊天計數',
    char_allCharacters: '所有角色',
    char_confirmDeleteChat: '您確定要刪除此對話嗎？',
    char_noConversationsYet: '您還沒有對話。',
    char_noConversationsWith: '您與以下角色沒有對話：',
    char_lastModified: '最後修改',
    char_lastConversed: '最後對話',
    char_created: '創建時間',
    char_select: '選擇',
    char_archiveSelected: '歸檔 {count} 個角色？',
    char_unarchiveSelected: '取消歸檔 {count} 個角色？',
    char_deleteSelected: '您確定要刪除 {count} 個角色嗎？',
    char_searchByName: '按名稱搜索...',
    char_selectedNone: '已選擇：無',
    char_selectedCount: '已選擇：{count}',
    char_favorites: '收藏',
    char_editingTitle: '正在編輯：{name}',
    char_noCharactersFound: '未找到角色',
    char_toGetStarted: '開始吧！',
    char_jsonStructuredResponsesHelper: '使用 JSON 請求和結構化響應。僅在 JSON 模式可用時使用',
    char_updateSchema: '更新模式',
    char_editingSchema: '編輯模式',
    char_testSchema: '測試模式',
    char_templateReferencesUndefined: '模板引用了未定義的佔位符：',
    char_responseTemplateWarning: '警告：歷史或響應模板中未包含 {{response}}。{{response}} 字段始終生成，強烈建議使用。',
    char_invalidJsonSchema: '無效的 JSON 模式：',
    char_deleteChatsWarning: '這將刪除與此角色關聯的所有聊天！',
    char_newChat: '新聊天',
    char_new: '新建',
    char_unfavorite: '取消收藏',
    char_duplicate: '複製',
    char_downloadRetreiveFailed: '檢索下載角色失敗：',
    char_imageCard: '圖像卡',
    char_textgen: '文本生成',
    char_downloadJson: '下載 (JSON)',
    char_downloadPng: '下載 (PNG)',
    char_createACharacterTitle: '創建角色',
    char_editACharacterTitle: '編輯角色',
    char_copyACharacterTitle: '複製角色',
    char_tokensPermanent: '{totalTokens} 令牌, {totalPermanentTokens} 永久',
    char_aiCharacterGenerationGuide: 'AI 角色生成指南',
    char_characterOverridesWarning: '警告！您的聊天當前覆蓋了角色定義。在您於“編輯聊天”菜單中禁用它們之前，這些更改不會影響當前聊天。',
    char_temporaryCharacterWarning: '您正在 {action} 一個臨時角色。臨時角色僅存在於當前聊天中。',
    char_clearEditorConfirm: '您確定要清除編輯器嗎？',
    char_descriptionCreatorsNotesHelper: '角色的描述、標籤或註記。這不會以任何方式影響您的角色。',
    char_tagsHelper: '用於幫助您組織和過濾角色。',
    char_scenario: '場景',
    char_scenarioHelper: '對話和角色的當前環境和上下文。',
    char_personality: '個性',
    char_personalityWarning: '警告：“純文本”和“非純文本”模式不兼容。在它們之間切換將導致數據丟失。',
    char_greeting: '問候語',
    char_greetingHelper: '角色的第一條消息。建議提供較長的第一條消息，以鼓勵角色提供較長的回復。',
    char_greetingPlaceholder: '例如：*當你走進房間時我微笑著* 你好，{{user}}！真不敢相信已經到午餐時間了！我們要去哪裡？',
    char_sampleConversation: '示例對話',
    char_sampleConversationHelper: '您與角色之間的示例聊天。本部分對於教授角色如何說話非常重要。',
    char_voiceHelper: '開啟此項以禁用此角色自動發言',
    char_languageHelper: '此角色說和理解的語言。',
    char_languageNote: ' 注意：要使用非英語語言，您還需要翻譯預設 gaslight。',
    char_imageSettingsMoved: '圖像設置已移動：點擊主菜單中的',
    char_inMainMenu: '',
    char_avatarOrJsonFile: '頭像或 JSON 文件',
    char_charactersToImport: '要導入的角色：',
    char_andOneOther: '... 以及另一個',
    char_andOthers: '... 以及其他 {count} 個',
    char_failedCharacterImports: '角色導入失敗：',
    char_persona: '人格',
    char_images: '圖像',
    char_advanced: '高級',
    char_attributesFormat: '屬性 (鍵: 值)',
    char_plainTextFormat: '純文本',
    char_downloadSuccess: '成功從 Character Hub 下載',
    char_downloadFailed: 'Character Hub 下載失敗: {message}',
    char_sampleConversationPlaceholder: '{{char}}: *微笑並揮手* 你好！我很高興你能來！',
    char_unnamed: '未命名',
    char_importChatLog: '導入聊天記錄',
    char_chatLogAccepted: '聊天記錄已接受',
    char_invalidChatLogFormat: '無效的聊天記錄文件格式。支持格式：HuanYouAI, TavernAI',
    char_chatLogImportFor: '您的聊天記錄將導入為 {name}。',
    char_jsonLinesFile: 'JSON Lines 文件 (.jsonl)',
    char_messagesToImport: '將導入 {count} 條消息。',
    chat_chatWith: '與 {name} 聊天',
    chat_notesFromCreator: '來自 {name} 創建者的註記',
    chat_generateMessage: '生成消息',
    chat_forkConversationConfirm: '這將從問候消息處分支您的對話。',
    chat_sendAMessage: '發送消息...',
    chat_sendAMessageTo: '發送消息給 {name}...',
    chat_confirmCancelSwipe: '發送前請確認或取消滑動',
    chat_respondAsMe: '以我的身份響應',
    chat_autoReply: '自動回復',
    chat_none: '無',
    chat_stopBotReply: '停止機器人回復',
    chat_generateImage: '生成圖像',
    chat_respondAgain: '再次響應',
    chat_generateMore: '生成更多',
    chat_playVoice: '播放語音',
    chat_triggerEvent: '觸發事件',
    chat_attachImage: '附加圖像',
    chat_responseHint: '響應提示...',
    chat_invalidFileTypeImage: '無效的文件類型：必須是圖像',
    chat_attachmentExceedsLimit: '附件超過大小限制 (1MB)',
    chat_loading: 'HuanYouAI 加載中...',
    chat_participants: '參與者',
    chat_editChat: '編輯聊天',
    chat_memory: '記憶',
    chat_ui: '界面',
    chat_graph: '聊天圖表',
    chat_screenshot: '屏幕截圖',
    chat_anonymize: '匿名化',
    chat_hideOocMessages: '隱藏 OOC 消息',
    chat_mainCharacter: '主要角色',
    chat_beginning_group: '這是群組對話的開始。',
    chat_beginning_with: '這是您與 {name} 對話的開始。',
    chat_restart: '重新開始',
    chat_loadingWait: '加載中，請稍候...',
    chat_screenshotFailedElement: '截圖失敗：找不到消息元素',
    chat_screenshotFailedConsole: '截圖失敗：錯誤已記錄在控制台',
    chat_ooc_suffix: '(OOC)',
    chat_msg_id: 'ID',
    chat_msg_chat: '聊天',
    chat_msg_descendants: '後代',
    chat_pending_retrying: '正在重試',
    chat_pending_waiting: '正在等待',
    chat_pending_chatId: '對話 ID',
    chat_graph_root: '根節點',
    chat_avatar_modal_title: '頭像預覽',
    chat_graph_circular_error: '無效的對話樹：包含循環引用',
    char_listView: '列表視圖',
    char_cardsView: '卡片視圖',
    char_folderView: '文件夾視圖',
    char_failedToLoad: '加載角色失敗。刷新重試。',
    char_jsonStructuredResponses: 'JSON 結構化響應',
    char_jsonStructuredWarning: '警告：並非所有模型都支持 JSON 輸出/響應。',
    char_responseTemplate: '響應模板',
    char_responseTemplateHelper: '消息在聊天中的顯示方式',
    char_historyTemplate: '歷史模板',
    char_historyTemplateHelper: '消息在提示詞中的顯示方式',
    char_imageCaptionTemplate: '圖像描述模板',
    char_imageCaptionTemplateHelper: '用於自動填充圖像生成的“圖像提示詞”。',
    char_jsonSchemaFile: 'JSON Schema 文件 (.json)',
    char_confirmDeletion: '確認刪除',
    char_confirmDeletionMessage: '您確定要刪除此角色嗎？',
    char_toggleFavorite: '切換收藏',
    char_openRecentChat: '打開最近聊天',
    char_openCharacterChats: '打開角色聊天',
    char_favorite: '收藏',
    char_downloadCharacter: '下載角色',
    char_outputFormat: '輸出格式',
    char_fileType: '文件類型',
    char_characterName: '角色名稱',
    char_descriptionCreatorsNotes: '描述 / 創建者註記',
    char_tags: '標籤',
    char_scenarioPlaceholder: '例如 {{char}} 正在辦公室工作。{{user}} 推門而入。',
    char_formatAsIsHelper: '如果您不知道這是什麼意思，可以保持原樣。',
    char_formatToUseHelper: '角色格式使用的格式',
    char_firstMessagePlaceholder: '{{char}}: *微笑並揮手* 你好！我很高興你能來！',
    char_voice: '語音',
    char_disableVoice: '禁用角色語音',
    char_updatePreset: '更新預設',
    char_presetUsedForGeneration: '此預設用於角色生成',
    char_foldersGuide: '文件夾指南',
    char_foldersInstructions: '- 將角色拖到新文件夾以創建新文件夾\n- 將角色拖到文件夾上以移動角色',
    char_currentFolder: '當前文件夾',
    char_newFolder: '新文件夾',
    char_generateAvatar: '生成頭像',
    char_impersonate: '模擬身份',
    char_changeChatPersona: '更改您當前的聊天身份。',
    char_changeDefaultPersona: '更改您的默認身份。',
    char_impersonationHelper: '使用角色模擬功能以另一個身份發言',
    char_failedImports: '導入失敗的角色：',
    char_multiUserNote: "注意：目前不支持多用戶聊天。所有消息將",
    char_alternateGreeting: '角色的備用問候語',
    char_appearancePrompt: '外觀提示詞（用於頭像生成）',
    char_characterBook: '角色書',
    char_noCharacterBook: '此角色沒有角色書。',
    char_hasCharacterBook: '此角色有角色書。',
    char_characterMemory: '角色記憶',
    char_characterDesigner: '角色設計器',
    char_root: '根目錄',
    char_changeFolderTitle: '更改文件夾: {name}',
    char_folderNamesNormalized: '文件夾名稱已“標準化”。',
    char_normalizedName: '標準化名稱: {name}',
    char_openchats_with: '打開與 {name} 的聊天',
    char_remove_from_favorites: '從收藏角色中移除 {name}',
    char_add_to_favorites: '將 {name} 添加到收藏角色',
    char_create_new_chat_with: '創建與 {name} 的新聊天',
    char_download_character_name: '下載角色 {name}',
    char_edit_character_name: '編輯角色 {name}',
    char_duplicate_character_name: '克隆角色 {name}',
    char_delete_character_name: '刪除角色 {name}',
    char_save: '保存',
    char_drag_to_move: '拖動圖標以移動角色',
    char_drag_to_new_folder: '將角色拖到“新文件夾”以創建新文件夾',
    char_drag_onto_folder: '將角色拖到文件夾上以移動角色',
    char_regenerate_tooltip: '必須填寫名稱和描述',
    char_regenerate_warn: '填寫名稱和描述以進行生成',
    char_reel_send_to_editor: '發送到編輯器',
    char_insert_depth_placeholder: '例如：### 指令：像詹姆斯·喬伊斯一樣寫作。',
    char_importMemoryBook: '導入記憶書',
    char_editBook: '編輯記憶書',
    char_deleteBook: '刪除記憶書',
    char_createNewBook: '創建新記憶書',
    char_hasNoCharacterBook: '該角色暫無記憶書。',
    char_addAlternateGreeting: '添加備用問候語',
    char_alternateGreetingPlaceholder: '寫一條備用問候語……',
    char_voiceService: '語音服務',
    char_voiceLoading: '正在加載語音列表……',
    char_openCharacterBuilder: '打開角色構建器',
    char_selectAvatarImage: '選擇頭像圖片',
    char_appearancePromptPlaceholder: '描述一下角色的外貌……',
    char_visualTypeAvatar: '頭像',
    char_visualTypeSprite: '立繪',
    char_personaTab: '人設',
    char_voiceTab: '語音',
    char_imagesTab: '圖片',
    char_advancedTab: '高級',
    char_currentChatPersona: '當前會話人設',
    char_defaultPersona: '默人人設',
    char_impersonateDescription: '請選擇本次對話要使用的人設。',
    char_useMyProfile: '使用我的個人資料',
    char_currentLabel: '當前',
    char_defaultLabel: '默認',
    char_defaultForNewConvos: '新會話默人人設',
    char_jsonSchemaGenerationStatus: 'JSON Schema 已生成。',
    char_tempJsonSchemaUpdated: '臨時 JSON Schema 已更新。',
    char_characterHubDownloadSuccess: '角色庫下載成功。',
    char_characterHubDownloadFailed: '角色庫下載失敗：{message}',
    char_recommended: '推薦',
    char_unrecognizedFormat: '無法識別的格式',
    char_open_recent_chat: '打開最近的會話',
    char_open_character_chats: '打開角色會話列表',

    // Voice
    voice_elevenLabsModel: 'ElevenLabs 模型',
    voice_stability: '穩定性',
    voice_claritySimilarityEnhancement: '清晰度 + 相似度增強',
    voice_playbackRate: '播放速率',
    voice_seed: '種子',
    voice_service: '語音服務',
    voice_pitch: '音調',
    voice_rate: '速率',
    voice_preview: '預覽',
    voice_modelsLoading: '正在加載模型……',
    voice_agnaisticSeedHelper: '使用固定種子可以讓生成結果更可復現。',
    voice_novelSeedHelper: '設置 NovelAI 的種子（留空則隨機）。',
    voice_stabilityHelper: '穩定性越高，聲音越一致，但表現力會下降。',
    voice_similarityBoostHelper: '調高使聲音更接近參考樣本，調低則變化更大。',
    voice_pitchHelper: '控制合成語音的音調高低。',
    voice_rateHelper: '控制語音播放的語速。',

    // App
    app_login_issues: '登入有問題？嘗試',
    app_logging_out: '登出',
    app_log_back_in: '然後重新登入。',
    app_page_loading_issues: '頁面加載有問題？嘗試',
    app_clicking_here: '點擊這裡',
    app_failed_to_load: 'HuanYouAI 加載失敗',
    app_try_again: '重試',
    app_banned_message: '此帳戶因以下原因被封禁：',
    app_banned_contact: '如果您認為這是一個錯誤，請聯繫支持。',
    app_account_banned: '帳戶已封禁',
    app_information: '信息',

    // Home
    home_free_to_use: 'HuanYouAI 完全免費使用。註冊也是免費的。您的數據將保持私密，您可以隨時永久刪除數據。我們非常重視您的隱私。',
    home_chat_multi_user: '同時與多個用戶和多個角色聊天',
    home_create_memory_book: '創建 {memoryBook} 以向您的角色提供有關他們世界的信息。',
    home_use_images: '{images} - 使用 Horde、NovelAI 或您自己的 Stable Diffusion 服務器。',
    home_give_voice: '{voice} - 為您的角色提供聲音並向他們回話。',
    home_customise_presets: '{presets} - 完全自定義用於生成回覆的生成設置。',
    home_horde_guide: 'Horde 指南',
    home_horde_important: '重要！為了獲得可靠的響應，請確保您已在 {link} 註冊。獲得密鑰後，請將其添加到您的 {settings}。',
    home_horde_volunteers: 'AI Horde 由少數提供 GPU 的志願者運行和支持。這是一項很棒的服務，但可能會慢一些。考慮為 Horde 做貢獻！',
    home_horde_tokens: '除非您知道自己在做什麼，否則請將 {maxNewTokens} 保持在 100 以下！使用較高的“最大新令牌”值是超時和回覆慢的主要原因。',
    home_horde_anonymous: '默認情況下，我們使用匿名訪問。您可以在設置頁面提供您的 API 密鑰或更改模型。',
    home_openai_guide: 'OpenAI 指南',
    home_openai_paid: 'OpenAI 是一項 {paidService}。要使用 OpenAI，您需要在設置中提供您的 OpenAI API 密鑰：',
    home_openai_register: '首先，您需要 {registerLink}。',
    home_openai_generate_key: '註冊後，您需要 {generateLink}。',
    home_openai_set_key: '獲得 API 密鑰後，前往 {settingsLink} 頁面並在 OpenAI 區域設置您的密鑰。',
    home_openai_preset: '要使用 OpenAI 生成回覆，請確保您的聊天正在使用 {chatPresetSettings} 中的 OpenAI 預設。您可以通過聊天右上角的菜單訪問這些設置。',

    // Chat Create
    chat_create_title: '創建聊天',
    chat_create_description: '可選地修改一些對話上下文。您可以在對話創建後從對話中覆蓋角色的其他方面。',
    chat_create_applied_to_new: '此處提供的信息僅適用於新創建的對話。',
    chat_create_main_character_helper: '對話的主要角色',
    chat_mode: '聊天模式',
    chat_mode_companion_description: '伴侶模式：一切都是永久性的。您將無法：編輯聊天、重試消息、刪除消息等。',
    chat_mode_standard: '普通對話',
    chat_mode_companion: '伴侶',
    chat_conversation_name: '對話名稱',
    chat_conversation_name_helper: '對話的名稱。這純粹是為了標記。（可選）',
    chat_override_character_definitions: '覆蓋角色定義',
    chat_override_helper: '覆蓋僅適用於新創建的對話。',
    chat_scenario_helper: '此對話要使用的場景',
    chat_create_button: '創建',

    // Chat Settings
    chat_settings_reset_character: '重置角色',
    chat_settings_image_source: '圖像源',
    chat_settings_image_source_helper: '此聊天生成圖像時使用的設置',
    chat_settings_main_character: '主要角色',
    chat_settings_last_character: '最後說話的角色',
    chat_settings_chat_settings: '聊天設置',
    chat_settings_app_settings: '應用設置',
    chat_settings_background_image: '背景圖片',
    chat_settings_background_image_helper: '圖片將存儲在您當前設備上，無法在其他設備上訪問',
    chat_settings_chat_mode_irreversible: '警告！切換到“伴侶”模式是不可逆的！您將無法：重試消息、刪除聊天、編輯聊天設置。',
    chat_settings_chat_name: '聊天名稱',
    chat_settings_override_helper: '覆蓋僅適用於此聊天。如果您想編輯原始角色，請在“聊天菜單”中打開“角色”鏈接。',
    chat_settings_scenario_state: '場景的當前狀態',
    chat_settings_scenario_state_helper: '目前場景在聊天中設置了哪些標誌',
    chat_settings_field_description_helper: '您的角色的描述、標籤或備註：用於 AI 字段生成。不會改變您的角色行為。',
    chat_settings_post_history_instructions: '角色歷史後指令',
    chat_settings_default_visibility: '默認消息可見性',
    chat_settings_visibility_helper: '當消息尚未編輯可見性時。最具體的優先：消息 > 角色默認 > 所有默認',
    chat_settings_visible: '可見',
    chat_settings_invisible: '不可見',
    chat_settings_not_set: '未設置',
    chat_settings_defaults_all: '所有消息的默認值',
    chat_settings_defaults_per_char: '每個角色的默認設置',
    chat_settings_defaults_per_char_helper: '為每個角色視角設置默認可見性',
    remove_all: '移除全部',
    char_editCharacter: '編輯角色',
    chat_temp_char_updated: '臨時角色已更新',
    chat_memory_guide: '記憶指南',
    chat_ui_settings: '聊天界面設置',
    chat_confirmDeleteChat: '您確定要刪除此對話嗎？',
    chat_graph_rejoin_node: '重新加入節點',
    chat_graph_assign_parent: '分配父節點',
    chat_graph_select_parent: '選擇父節點',
    chat_graph_collapse: '摺疊',
    chat_graph_expand: '展開',
    chat_graph_rotate: '旋轉',
    chat_graph_help: '點擊節點加載路徑。點擊並拖動移動圖表。捏合/滾動縮放。',
    chat_token_probabilities: '令牌概率',
    chat_save_memory_book: '保存記憶書',
    chat_memory_book: '記憶書',
    chat_memory_book_helper: '選擇用於此聊天的記憶書',
    chat_create_new_memory_book: '創建新記憶書',
    chat_embedding: '嵌入',
    chat_embedding_helper: '選擇用於此聊天的嵌入',
    chat_use_embedding: '使用嵌入',
    chat_msg_info_title: '消息信息',
    admin_adapter: '適配器',
    chat_json_output: 'JSON 輸出',
    chat_img_prompt_updated: '圖像提示詞已更新',
    chat_caption_hint_helper: '生成圖像描述的提示',
    chat_caption_hint_placeholder: '輸入描述提示...',
    chat_image_prompt: '圖像提示詞',
    interrupt: '中斷',
    admin_clean: '清理',
    admin_edit: '編輯',
    chat_msg_prompt_title: '提示詞視圖',
    chat_prompt_approx_helper: '近似令牌計數。實際使用可能有所不同。',
    chat_prompt_budget_helper: '令牌預算信息',
    chat_est_tokens: '估計令牌數：{count}',
    chat_speech_recognition_error: '語音識別錯誤：{error}',
    chat_visibility_current: '當前可見性',
    chat_visibility_toggles: '切換可見性',
    chat: '聊天',
    download: '下載',
    chat_export_title: '導出聊天',
    chat_system_preset_horde: 'Horde',
    chat_system_preset: '系統預設',
    chat_your_default_preset: '您的默認預設',
    chat_delete_msg_title: '確認刪除',
    chat_delete_swipe: '刪除滑動',
    chat_delete_one: '刪除一個',
    chat_delete_msg_confirm: '您確定要刪除一個或最後 {count} 條消息嗎？',
    chat_delete_msg_one_note: '刪除"一個"將僅刪除選定的消息。',
    chat_delete_msg_image_confirm: '您確定要刪除 1 條圖像消息嗎？',
    chat_system_built_in_preset_horde: 'Horde',
    chat_please_select_preset: '請選擇預設',
    chat_load_more: '加載更多',
    chat_add_temp_character: '添加臨時角色',
    chat_user: '用戶',
    chat_temp_characters: '臨時角色',
    chat_deleted_temp_characters: '已刪除的臨時角色',
    chat_remove_user_confirm: '您確定要從此聊天中移除 {handle} 嗎？',
    chat_no_chars_to_invite: '沒有可邀請的角色',
    chat_select_char_to_add: '選擇要添加的角色',
    chat_no_chars_available_to_add: '沒有可添加的角色',
    chat_no_user_id_provided: '未提供用戶 ID',
    chat_invite_user: '邀請用戶',
    chat_invite_user_helper: '輸入要邀請到此聊天的用戶 ID',
    chat_send_invite: '發送邀請',
    chat_owner: '所有者',
    chat_temp_character: '臨時角色',
    reset: '重置',
    back: '返回',
    character: '角色',

    // Settings UI
    settings_ui_viewMode_background: '背景',
    settings_ui_typewriter_test: '世界上有十種人：懂二進制的和不懂二進制的。',

    // Navigation
    nav_main_page_aria: 'HuanYouAI 主頁',
    nav_add_new_preset: '添加新預設',
    nav_add_new_character: '添加新角色',
    nav_create_new_chat: '創建新聊天',
    nav_edit_user_profile: '編輯用戶資料',
    nav_open_impersonation: '打開角色扮演菜單',
    nav_email_support: '電子郵件支持',

    // Toasts
    toasts_site_updates: '網站更新與通知',
    toasts_no_notifications: '您沒有通知。',
    toasts_clear_notifications: '清除通知',
    toasts_message_from_admin: '來自管理員的消息',
    toasts_latest_updates: '最新更新',
    toasts_admin_notification: '管理員通知',
    image_prompt: '提示詞',
    image_clean: '清除',
    image_generate: '生成',
    image_stop: '停止',
    image_to_unsent: '到未發送',
    image_to_current: '到當前',
    image_add_attachment: '添加消息附件',
    image_caption: '圖像描述',
    image_caption_hint_placeholder: '描述提示：生成描述時要關注什麼？',
    image_count: '圖像：{current}/{total}',
    image_fix: '修復',
    image_attach_to_message: '附加到消息',
    invite_title: '邀請',
    invite_no_pending: '您沒有待處理的聊天邀請',
    invite_from: '來自',
    invite_character: '角色',
    invite_sent: '發送於',
    invite_unknown_user: '未知用戶',
    invite_unknown_character: '未知角色',
    login_reset_password: '重置密碼',
    login_username_placeholder: '用戶名...',
    login_password_placeholder: '密碼',
    login_confirm_password_placeholder: '確認密碼',
    login_error_not_logged_in: '錯誤 - 您當前未登錄。',
    login_missing_callback: '查詢參數中缺少回調地址。',
    login_failed: '失敗：{error}',
    login_oauth_request: '一個應用程序正在請求代表您訪問您的 HuanYouAI 賬戶',
    login_oauth_access_list: '該應用程序將能夠訪問您的：',
    login_oauth_access_items: '個人資料名稱、頭像、角色和預設。',
    login_authorize: '授權',
    login_authorizing: '正在授權...',
    privacy_policy_text: `
We at HuanYouAI (together with our affiliates, "we", "our" or "us") respect your privacy and are strongly committed to keeping secure any information we obtain from you or about you. This Privacy Policy describes our practices with respect to Personal Information we collect from or about you when you use our website and services (collectively, "Services"). Our use of that data is governed by our customer agreements covering access to and use of those offerings.

## 1. Personal information we collect

We collect information that alone or in combination with other information in our possession could be used to identify you ("Personal Information") as follows:

**Personal Information You Provide:** We may collect Personal Information if you create an account to use our Services or communicate with us as follows:

- **Account Information:** When you create an account with us, we will collect information associated with your account, including your display name, account credentials, profile picture, and other information provided during registration (collectively, "Account Information").
- **User Content:** When you use our Services, we may collect Personal Information that is included in the input, file uploads, or feedback that you provide to our Services ("Content").{' '}
- **Communication Information:** If you communicate with us, we may collect your name, contact information, and the contents of any messages you send ("Communication Information").
- **Social Media Information:** We may have pages on social media sites like Instagram, Facebook, Medium, Twitter, YouTube and LinkedIn, as well as Reddit, 4chan, and a [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat). When you interact with our social media pages, we will collect Personal Information that you elect to provide to us, such as your contact details or social media usernames and profile information (collectively, "Social Information"). In addition, the companies that host our social media accounts may provide us with aggregate information and analytics about our social media activity.

**Personal Information We Receive Automatically From Your Use of the Services:** When you visit, use, and interact with the Services, we may receive the following information about your visit, use, or interactions ("Technical Information"):

- **Log Data:** Information that your browser automatically sends whenever you use our website ("log data"). Log data includes your Internet Protocol address, browser type and settings, the date and time of your request, and how you interacted with our website.
- **Usage Data:** We may automatically collect information about your use of the Services, such as the types of content that you view or engage with, the features you use and the actions you take, as well as your time zone, country, the dates and times of access, user agent and version, type of computer or mobile device, computer connection, IP address, and the like.
- **Device Information:** Includes name of the device, operating system, and browser you are using. Information collected may depend on the type of device you use and its settings.
- **Browser Storage:** We use cookies and localstorage ("Browser Storage") to operate and administer our Services, and improve your experience on it. A "cookie" is a piece of information sent to your browser by a website you visit. "Localstorage" is a feature of your web browser that lets us store information on your computer related to your use of our Services. You can set your browser to accept all cookies, to reject all cookies, or to notify you whenever a cookie is offered so that you can decide each time whether to accept it. However, refusing a cookie may in some cases preclude you from using, or negatively affect the display or function of, a website or certain areas or features of a website. For more details on cookies please visit [All About Cookies](https://www.google.com/url?q=https://allaboutcookies.org/&amp;sa=D&amp;source=editors&amp;ust=1681348702239252&amp;usg=AOvVaw1sGG2db6TzG2Fy_dtBclPZ).
- **Analytics:** We may use a variety of online analytics products that use cookies to help us analyze how users use our Services and enhance your experience when you use the Services.

## 2. How we use personal information**

We may use Personal Information for the following purposes:

- To provide, administer, maintain, improve and/or analyze the Services;
- To conduct research;
- To communicate with you;
- To develop new programs and services;
- To prevent fraud, criminal activity, or misuses of our Services, and to ensure the security of our IT systems, architecture, and networks; and 
- To comply with legal obligations and legal process and to protect our rights, privacy, safety, or property, and/or that of our affiliates, you, or other third parties. 

Aggregated or De-Identified Information. We may aggregate or de-identify Personal
Information and use the aggregated information to analyze the effectiveness of our
Services, to improve and add features to our Services, to conduct research and for other
similar purposes. In addition, from time to time, we may analyze the general behavior and
characteristics of users of our Services and share aggregated information like general
user statistics with third parties, publish such aggregated information or make such
aggregated information generally available. We may collect aggregated information through
the Services, through cookies, and through other means described in this Privacy Policy.
We will maintain and use de-identified information in anonymous or de-identified form and
we will not attempt to reidentify the information.

## 3. Disclosure of personal information

In certain circumstances we may provide your Personal Information to third parties without further notice to you, unless required by the law:
- Vendors and Service Providers: To assist us in meeting business operations needs and to perform certain services and functions, we may provide Personal Information to vendors and service providers, including providers of hosting services, cloud services, and other information technology services providers, event management services, email communication software and email newsletter services, and web analytics services. Pursuant to our instructions, these parties will access, process, or store Personal Information only in the course of performing their duties to us. 
- Business Transfers: If we are involved in strategic transactions, reorganization, bankruptcy, receivership, or transition of service to another provider (collectively a "Transaction"), your Personal Information and other information may be disclosed in the diligence process with counterparties and others assisting with the Transaction and transferred to a successor or affiliate as part of that Transaction along with other assets. 
- Legal Requirements: If required to do so by law or in the good faith belief that such action is necessary to (i) comply with a legal obligation, including to meet national security or law enforcement requirements, (ii) protect and defend our rights or property, (iii) prevent fraud, (iv) act in urgent circumstances to protect the personal safety of users of the Services, or the public, or (v) protect against legal liability. 
- Affiliates: We may disclose Personal Information to our affiliates, meaning an entity that controls, is controlled by, or is under common control with HuanYouAI. Our affiliates may use the Personal Information we share in a manner consistent with this Privacy Policy. 

## 4. Your rights

Depending on location, individuals in the EEA, the UK, and across the globe may have certain statutory rights in relation to their Personal Information. For example, you may have the right to:

- Access your Personal Information.
- Delete your Personal Information.
- Correct or update your Personal Information.
- Transfer your Personal Information elsewhere.
- Withdraw your consent to the processing of your Personal Information where we rely on consent as the legal basis for processing. 
- Object to or restrict the processing of your Personal Information where we rely on legitimate interests as the legal basis for processing

You can exercise some of these rights through your Agnaistic account. If you are unable to exercise your rights through your account, please send your request in our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat).

## 5. California privacy rights

The following table provides additional information about how we disclose Personal Information. You can read more about the Personal Information we collect in "Personal information we collect" above, how we use Personal information in "How we use personal information" above, and how we retain personal information in "Security and Retention" below.

| Category of Personal Information                                                     | Disclosure of Personal Information                                                                                                    |
|:-------------------------------------------------------------------------------------|:--------------------------------------------------------------------------------------------------------------------------------------|
| Identifiers, such as your contact details                                            | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |
| Commercial Information, such as your transaction history                             | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |
| Network Activity Information, such as Content and how you interact with our Services | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |
| Geolocation Data                                                                     | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |
| Your account login credentials (Sensitive Personal Information)                      | We disclose this information to our affiliates, vendors and service providers, law enforcement, and parties involved in Transactions. |

To the extent provided for by law and subject to applicable exceptions, California residents have the following privacy rights in relation to their Personal Information:

- The right to know information about our processing of your Personal Information, including the specific pieces of Personal Information that we have collected from you;
- The right to request deletion of your Personal Information;
- The right to correct your Personal Information; and
- The right to be free from discrimination relating to the exercise of any of your privacy rights. 

We don't sell or share Personal Information as defined by the California Consumer Privacy Act, as amended by the California Privacy Rights Act. We also don't process sensitive personal information for the purposes of inferring characteristics about a consumer.

**Exercising Your Rights**. California residents can exercise their CCPA privacy rights by sending their request to us on our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat).
**Verification**. In order to protect your Personal Information from unauthorized access, change, or deletion, we may require you to verify your credentials before you can submit a request to know, correct, or delete Personal Information. If you do not have an account with us, or if we suspect fraudulent or malicious activity, we may ask you to provide additional Personal Information and proof of residency for verification. If we cannot verify your identity, we will not provide, correct, or delete your Personal Information.
**Authorized Agents**. you may submit a rights request through an authorized agent. If you do so, the agent must present signed written permission to act on your behalf and you may also be required to independently verify your identity and submit proof of your residency with us. Authorized agent requests can be submitted to us on our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat).

## 6. Children

Our Service is not directed to children who are under the age of 18. Agnaistic does not knowingly collect Personal Information from children under the age of 18. If you have reason to believe that a child under the age of 18 has provided Personal Information to Agnaistic through the Service please contact us on our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat). We will investigate any notification and if appropriate, delete the Personal Information from our systems.

## 7. Links to other websites

The Service may contain links to other websites not operated or controlled by Agnaistic, including social media services ("Third Party Sites"). The information that you share with Third Party Sites will be governed by the specific privacy policies and terms of service of the Third Party Sites and not by this Privacy Policy. By providing these links we do not imply that we endorse or have reviewed these sites. Please contact the Third Party Sites directly for information on their privacy practices and policies. 

## 8. Security and Retention

We implement commercially reasonable technical, administrative, and organizational measures to protect Personal Information both online and offline from loss, misuse, and unauthorized access, disclosure, alteration, or destruction. However, no Internet or email transmission is ever fully secure or error free. In particular, email sent to or from us may not be secure. Therefore, you should take special care in deciding what information you send to us via the Service or email. In addition, we are not responsible for circumvention of any privacy settings or security measures contained on the Service, or third party websites.

We'll retain your Personal Information for only as long as we need in order to provide our Service to you, or for other legitimate business purposes such as resolving disputes, safety and security reasons, or complying with our legal obligations. How long we retain Personal Information will depend on a number of factors, such as the amount, nature, and sensitivity of the information, the potential risk of harm from unauthorized use or disclosure, our purpose for processing the information, and any legal requirements.

We may also anonymize or de-identify your Personal Information (so that it can no longer be associated with you) for research or statistical purposes, as described above, in which case we may use this information indefinitely without further notice to you.

## 9. International users

By using our Service, you understand and acknowledge that your Personal Information will be transferred from your location to our facilities and servers in the United States.

For EEA, UK or Swiss users:

- Legal Basis for Processing. Our legal bases for processing your Personal Information include: Performance of a contract with you when we provide and maintain our Services. This may include the processing of Account Information, Content, and Technical Information.
- Our legitimate interests in protecting our Services from abuse, fraud, or security risks, or when we develop, improve, or promote our Services. This may include the processing of Account Information, Content, Social Information, and Technical Information.
- Your consent when we ask for your consent to process your Personal Information for a specific purpose that we communicate to you. You have the right to withdraw your consent at any time.
- Compliance with our legal obligations when we use your Personal Information to comply with applicable law or when we protect our or our affiliates' or users' rights, safety and property.

If feel we have not adequately addressed an issue, you have the right to lodge a complaint with your local supervisory authority.

Data Transfers. Where required, we will use appropriate safeguards for transferring Personal Information outside of the EEA, Switzerland, and the UK. We will only transfer Personal Information pursuant to a legally valid transfer mechanism.

## 10. Your choices

If you choose not to provide Personal Information that is needed to use some features of our Service, you may be unable to use those features.

## 11. Changes to the privacy policy

We may change this Privacy Policy at any time. When we do, we will post an updated version on this page, unless another type of notice is required by applicable law. By continuing to use our Service or providing us with Personal Information after we have posted an updated Privacy Policy, or notified you by other means, you consent to the revised Privacy Policy.

## 12. How to contact us
Please contact us on our [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat) if you have any questions or concerns not already addressed in this Privacy Policy.
`,
    memory_create_book: '創建記憶書',
    memory_edit_book: '編輯記憶書',
    memory_update_book: '更新記憶書',
    memory_definitions: '定義',
    memory_priority: '優先級',
    memory_priority_helper: '在決定哪些條目包含在提示詞中时，優先級較高的條目將勝出。',
    memory_weight: '權重',
    memory_weight_helper: '在決定條目排序方式時，權重越高，條目越靠近底部。',
    memory_keywords: '關鍵詞',
    memory_keywords_helper: '您可以使用 {{char}} 和 {{user}} 佔位符',
    memory_entry: '條目',
    memory_entry_helper: '此處可使用 {{char}} 和 {{user}} 佔位符。',
    memory_embeddings: '記憶 - 嵌入',
    memory_loaded: '已加載',
    memory_not_loaded: '未加載',
    memory_books: '記憶 - 書籍',
    memory_no_books: '您還沒有記憶書。點擊“創建”開始。',
    memory_book_accepted: '記憶書已接受',
    memory_import_book: '導入記憶書',
    memory_json_file: 'JSON 文件',
    memory_import_helper: '目前僅支持 HuanYouAI 導出的記憶書。',
    memory_sort_creation: '按創建日期',
    memory_sort_alpha: '按字母順序',
    memory_book_name: '記憶書名稱',
    memory_book_name_placeholder: '記憶書的名稱',
    memory_description_placeholder: '（可選）記憶書的描述',
    memory_entries: '條目',
    memory_filter_placeholder: '按條目名稱過濾...',
    memory_entry_name_placeholder: '條目名稱',
    memory_keywords_placeholder: '以逗號分隔的單詞。例如：circle, shape, round, cylinder, oval',
    memory_entry_placeholder: '記憶條目。例如：{{user}} 喜歡水果和蔬菜',
    memory_embedding_created: '成功創建嵌入',
    memory_article: '文章',
    memory_pdf: 'PDF',
    memory_text_file: '文本文件',
    memory_plain_text: '純文本',
    memory_enter_name: '輸入嵌入名稱',
    memory_no_pdf: '未加載 PDF',
    memory_content_empty: '嵌入內容為空',
    memory_enable_embeddings_helper: '您需要在設置中啟用“嵌入/長期記憶”',
    memory_embed_wiki: '嵌入維基百科文章',
    memory_embed_wiki_helper: '使用維基百科文章的內容創建嵌入',
    memory_wiki_placeholder: 'URL。例如：https://en.wikipedia.org/wiki/Taylor_Swift',
    memory_embed_article_button: '嵌入文章',
    memory_embed_name_helper: '嵌入的標識符。',
    memory_embed_pdf: '嵌入 PDF',
    memory_embed_pdf_helper: '這可能需要很長時間，具體取決於 PDF 的大小。',
    memory_embed_file: '嵌入文件',
    memory_embed_file_helper: '這可能需要很長時間，具體取決於文件的大小。',
    memory_embed_text_helper: '要嵌入的內容。使用換行符分隔行。',
    memory_embed_text_button: '嵌入文本',
    memory_embed_name_optional_helper: '（可選）嵌入的標識符。這將成為一個“slug”。例如：“Hello World”將變為“hello-world”',
    memory_embed_name_slug_helper: '嵌入的標識符。這將成為一個“slug”。例如：“Hello World”將變為“hello-world”',

    // WorkerModal
    worker_modal_title: '選擇 Horde 節點',
    worker_modal_select_workers: '選擇節點',
    worker_modal_helper: '要使用任何節點，請取消選擇所有節點',
    worker_modal_selected_count: '已選節點：{count}',
    worker_modal_deselect_all: '取消全部選擇',

    // OpenRouterOauth
    openrouter_oauth_instruction: '點擊 <b class="highlight">使用 OpenRouter 登錄</b> 或訪問 <a class="link" target="_blank" href="https://openrouter.ai/keys">OpenRouter.ai/keys</a> 來創建 API 金鑰並在上方輸入。',
    openrouter_oauth_logging_in: '正在登錄...',
    openrouter_oauth_login: '使用 OpenRouter 登錄',
    openrouter_oauth_logout: '登出',

    // PatreonOauth
    patreon_oauth_verifying: '正在驗證 Patreon 帳號...',
    patreon_oauth_error: '無法驗證 Patreon 帳號',
    patreon_oauth_return_to_settings: '返回設置',
    patreon_oauth_success: 'Patreon 帳號已驗證',
    patreon_oauth_redirecting: '正在重定向到設置頁面...',
    patreon_oauth_link_benefit: '關聯您的 Patreon 帳號以獲取訂閱者福利',
    patreon_oauth_link: '關聯 Patreon 帳號',
    patreon_oauth_unlink: '取消關聯 Patreon 帳號',
    patreon_oauth_revalidate: '重新驗證',

    // ImageSettings
    image_settings_shared: '共享設置',
    image_settings_global_default: '全局/預設',
    image_settings_character_settings: '角色設置',
    image_settings_character: '角色：',
    image_settings_current_chat: '當前聊天設置',
    image_settings_chatting_with: '正在與以下角色聊天：',
    image_settings_source_label: '當前聊天圖像設置來源',
    image_settings_source_helper: '控制在生成“聊天圖像”時使用哪些圖像設置',
    image_settings_use_settings: '使用 {tab} 設置',
    image_settings_use_settings_active: '使用 {tab} 設置 (活躍)',
    image_settings_summary_preset: '摘要預設',
    image_settings_summary_preset_helper: '選擇用於創建聊天圖像摘要的服務和模型',
    image_settings_summary_settings: '摘要設置',
    image_settings_summarise_chat: '摘要聊天',
    image_settings_summarise_chat_helper: '使用您的 AI 服務將聊天摘要為圖像提示詞。',
    image_settings_summary_prompt: '摘要提示詞',
    image_settings_summary_prompt_helper: '在將聊天摘要為圖像標題時，此“提示詞”用於將您的對話摘要為圖像提示詞。',
    image_settings_default: '預設：',
    image_settings_style_booru: 'Booru/標籤風格',
    image_settings_style_plain: 'Flux/普通風格',
    image_settings_use_recommended: '使用推薦設置',
    image_settings_use_recommended_helper: '在可用時使用圖像模型的推薦設置。',
    image_settings_toggle_all: '全選/取消全選',
    image_settings_affixes: '詞綴',
    image_settings_size: '尺寸',
    image_settings_guidance: '引導',
    image_settings_steps: '步數',
    image_settings_negative_prompt: '負向提示詞',
    image_settings_sampler: '採樣器',
    image_settings_recommended_hint: '使用 HuanYouAI 圖像模型時，請參考推薦設置',
    image_settings_sampling_steps: '採樣步數',
    image_settings_clip_skip: 'Clip Skip',
    image_settings_width: '圖像寬度',
    image_settings_height: '圖像高度',
    image_settings_guidance_scale: '引導比例',
    image_settings_seed: '種子',
    image_settings_seed_helper: '種子號碼 (0 = 隨機)。注意：不同伺服器之間的種子可能不一致。',
    image_settings_prefix: '提示詞前綴',
    image_settings_prefix_helper: '（可選）要添加到圖像提示詞前面的文本',
    image_settings_prefix_placeholder: '例如：best quality, masterpiece',
    image_settings_suffix: '提示詞後綴',
    image_settings_suffix_helper: '（可選）要添加到圖像提示詞後面的文本',
    image_settings_suffix_placeholder: '例如：full body, visible legs, dramatic lighting',
    image_settings_negative_helper: '（可選）負向提示詞',
    image_settings_negative_placeholder: '例如：painting, drawing, illustration, glitch, deformed, mutated, cross-eyed, disfigured',
    image_settings_edit_summary_preset: '編輯摘要預設',
    image_settings_unavailable_hint: '注意：<b>聊天</b> 和 <b>角色</b> 圖像設置僅在聊天開啟時可用。',
    image_settings_image_settings: '圖像設置',

    // ServiceSettings
    service_settings_model: '模型：',
    service_settings_sampler: '採樣器：',
    service_settings_novel_key_error: '您沒有設置有效的 NovelAI 金鑰。您將無法使用 Novel 生成圖像。',
    service_settings_novel_quality_tags: '添加質量標籤',
    service_settings_novel_undesired_content: '不希望出現的內容',
    service_settings_novel_undesired_content_helper: '在負向提示詞中添加 `nsfw` 以忽略 NSFW 內容',
    service_settings_novel_heavy: '重度',
    service_settings_novel_light: '輕度',
    service_settings_novel_none: '無',
    service_settings_swarm_url: 'SwarmUI URL',
    service_settings_swarm_url_helper: 'SwarmUI 的基礎 URL。例如 https://local-tunnel-url-10-20-30-40.loca.lt。如果是自行託管，可以使用 http://localhost:7801',
    service_settings_automatic: '自動',
    service_settings_add_lora: '+ Lora',
    service_settings_use_local: '使用本地請求',
    service_settings_none_selected: '未選擇',
    service_settings_sd_url: 'SD WebUI URL',
    service_settings_sd_url_helper: 'Stable Diffusion 的基礎 URL。例如 https://local-tunnel-url-10-20-30-40.loca.lt。如果是自行託管，可以使用 http://localhost:7860',
    service_settings_sd_provider_helper: '使用來自供應商的 API 金鑰',
    service_settings_no_options: '沒有更多可用選項',
    service_settings_draft_mode: '草稿模式',
    service_settings_draft_mode_helper: '如果可用：快速生成低質量圖像',
    service_settings_recommended: '推薦',
    service_settings_limits: '限制',
    service_settings_tags_keyword: '標籤 / 關鍵詞',
    service_settings_tags: '標籤',
    service_settings_on: '開',
    service_settings_off: '關',
    service_settings_model_strength: '模型強度',
    service_settings_clip_strength: 'Clip 強度',
    service_settings_image_model: '圖像模型',
    service_settings_sampler_label: '採樣器',
    service_settings_steps: '步數',
    service_settings_cfg: 'CFG',
    service_settings_width: '寬度',
    service_settings_height: '高度',
    service_settings_clip_skip: 'Clip Skip',
    service_settings_sampler_title: '採樣器',
    service_settings_prefix: '前綴',
    service_settings_suffix: '後綴',
    service_settings_negative: '負向提示詞',

    // Provider/index
    provider_index_select_provider: '選擇供應商',
    provider_index_service: '服務',
    provider_index_providers: '供應商',
    provider_index_providers_helper: '供應商用於連接您首選的 AI 模型。',
    provider_index_new_provider_helper: '點擊 **`+ 新建`** 創建一個新的供應商並填寫信息。',
    provider_index_format_helper: '**格式**\n如果您被提示選擇 **格式** 且不確定使用哪個，請選擇 `Chat`。',
    provider_index_important_helper: '**重要**：確保在下方的下拉菜單中選擇了正確的供應商。',
    provider_index_edit_selected: '編輯已選',
    provider_index_new: '新建',
    provider_index_edit: '編輯',
    provider_index_edit_connection: '編輯連接詳情',
    provider_index_accept: '接受',
    provider_index_ai_service: 'AI 服務',
    provider_index_no_service_warning: '警告！您的預設目前尚未設置服務。',
    provider_index_third_party_format: '第三方格式',
    provider_index_request_format_helper: '控制請求的發送方式',
    provider_index_none: '無',
    provider_index_url: 'URL',
    provider_index_url_helper: '**第三方** 或 **自行託管** 服務的 API URL',
    provider_index_url_placeholder: '例如 https://some-tunnel-url.loca.lt',
    provider_index_api_key: 'API 金鑰',
    provider_index_remove_key: '移除金鑰',
    provider_index_key_warning: '切勿在此處輸入您的官方 OpenAI、Claude、Mistral 金鑰。',
    provider_index_key_is_set: '金鑰已設置',
    provider_index_key_placeholder: '例如 sk-...',

    // Provider/Manage
    provider_manage_supported: '支持的供應商',
    provider_manage_local_selfhost: '本地 / 自行託管',
    provider_manage_custom: '自定義',
    provider_manage_choose_provider: '供應商：選擇一個供應商',
    provider_manage_provider_prefix: '供應商：',
    provider_manage_invalid_url: 'URL 無效。請檢查後重試',
    provider_manage_update_title: '更新供應商',
    provider_manage_create_title: '創建供應商',
    provider_manage_delete: '刪除',
    provider_manage_update: '更新',
    provider_manage_create: '創建',
    provider_manage_instruction: '提供連接詳情以使用外部服務',
    provider_manage_label: '標籤',
    provider_manage_label_placeholder: '此供應商的自定義標籤',
    provider_manage_url_placeholder: 'https://...',
    provider_manage_disable_auto_url: '禁用自動 URL',
    provider_manage_request_format: '請求格式',
    provider_manage_test_connection: '測試連接',
  },
  ja: {
    chub_title: 'キャラクターハブ',
    chub_search_placeholder: '名前で検索...',
    chub_tags_placeholder: 'タグ...',
    chub_import: 'インポート',
    chub_preview: 'プレビュー',
    chub_disclaimer: '免責事項：キャラクターは以下によって所有・管理されています：',
    chub_import_book_hint_1: '画像以外のロアブックのすべての要素をオプションで変更できます。',
    chub_import_book_hint_2: 'ここで提供された情報は、インポート時にロアブックと一緒に保存されます。',
    chub_import_char_hint_1: 'アバター以外のキャラクターのすべての要素をオプションで変更できます。',
    chub_import_char_hint_2: 'ここで提供された情報は、インポート時にキャラクターと一緒に保存されます。',
    chub_import_char_name_label: 'キャラクター名',
    chub_import_char_name_helper: 'ここでキャラクター名を上書きします',
    chub_import_char_optional: '（オプション）',
    chub_import_char_greeting: '挨拶',
    chub_import_char_scenario: 'シナリオ',
    chub_import_char_sample_chat: 'サンプルチャット',
    chub_import_char_persona: '属性',
    chub_filter_nsfw_label: 'NSFW',
    chub_filter_nsfw_helper: 'NSFWのキャラクター/ロアブックを検索結果に表示します。',
    chub_filter_query_tags_label: 'クエリタグ',
    chub_filter_query_tags_helper: 'カンマ区切りの含めるタグのリスト。',
    chub_filter_exclude_tags_label: '除外タグ',
    chub_filter_exclude_tags_helper: 'カンマ区切りの除外するタグのリスト。',
    chub_filter_sort_label: 'ソート順',
    chub_invalid_tavern_image: '無効な Tavern 画像',
    chub_sort_default: 'デフォルト',
    chub_sort_trending: 'トレンド',
    chub_sort_favorites: 'お気に入り数',
    chub_sort_random: 'ランダム',
    chub_sort_rating: '評価',
    chub_sort_updated: '更新日',
    chub_sort_popularity: '人気度',
    chub_sort_created: '作成日',
    chub_sort_name: '名前',
    chub_sort_tokens: 'トークン数',
    chub_sort_ratings: '評価数',
    chub_error_importing: '{name} のインポート中にエラーが発生しました！{error}',
    chub_filter_tags_placeholder: '例：blue_archive,female,anime',
    product_name: '幻友AI',
    product_slogan: '次元を超えて、あなたに会うために',
    chat_beginning_group: 'これはグループ会話の開始です。',
    chat_beginning_with: '{name}との会話の開始です。',

    welcome: 'ようこそ',
    login: 'ログイン',
    register: '登録',
    language: '言語',
    close: '閉じる',
    cancel: 'キャンセル',
    confirm: '確認',
    ok: 'OK',
    yes: 'はい',
    no: 'いいえ',
    edit: '編集',
    editing: '編集',
    update: '更新',
    save: '保存',
    copy: 'コピー',
    search: '検索',
    voice: 'ボイス',

    // Time
    time_seconds: '{count} 秒',
    time_second: '{count} 秒',
    time_minutes: '{count} 分',
    time_minute: '{count} 分',
    time_hours: '{count} 時間',
    time_hour: '{count} 時間',
    time_days: '{count} 日',
    time_day: '{count} 日',
    time_aMoment: 'たった今',
    time_unknown: '不明',
    time_ago: '{duration}前',

    welcomeTitle: 'VSOULへようこそ',
    welcomeMessage: '私たちは、知的な対話とクリエイティブな創作のためのAIプラットフォームです。ここでは、さまざまな興味深いAI知能キャラクターを作成し、体験できます。私たちのビジョンは、最も手頃なコストで、最もコストパフォーマンスの高い対話体験を提供することです。Affordable AI for Everyone!',
    welcomeDisclaimer: 'このプラットフォームは中国本土のユーザーにサービスを提供していません。18歳以上であり、中国本土でこのプラットフォームを使用していないことを確認してください。',
    welcomeContentWarning: 'すべての対話コンテンツはAIによって生成されます。簡単に信じたり誤解されたりしないでください。また、AIに非準拠のコンテンツを生成させないでください。',
    termsAgreement: '私は18歳以上であり、',
    termsLink: '利用規約',
    ageConfirmation: '私は18歳以上であり、利用規約に同意します',
    createCharacter: 'キャラクター作成',
    importCharacter: 'キャラクターインポート',
    characters: 'キャラクター',
    lorebooks: '設定集',
    creativeWorkshop: 'クリエイティブワークショップ',
    personalCenter: '個人センター',
    chatHistory: 'チャット履歴',
    trending: 'トレンド',
    memoryFragments: '記憶の断片',
    menu: 'メニュー',
    library: 'ライブラリ',
    lib_memories: 'メモリ',
    lib_scenarios: 'シナリオ',
    lib_templates: 'テンプレート',
    lib_embeddings: '埋め込み',
    login_remote_error_not_logged_in: 'エラー - 現在ログインしていません。',
    login_remote_missing_callback: 'クエリパラメータにコールバックがありません。',
    login_remote_failed: '失敗: {error}',
    login_remote_request_access: 'アプリケーションがあなたに代わって HuanYouAI アカウントへのアクセスをリクエストしています',
    login_remote_application_access: 'アプリケーションは、あなたのプロフィール名、アバター、キャラクター、およびプリセットにアクセスできるようになります。',
    login_remote_authorize: '承認',
    login_remote_authorizing: '承認中...',
    presets: 'プリセット',
    settings: '設定',
    profile: 'プロフィール',
    chats: 'チャット',
    sounds: 'サウンド',
    manage: '管理',
    gen_presets_copy_preset: 'プリセット {name} をコピー',
    gen_presets_edit_preset: 'プリセット {name} を編集',
    configuration: '設定',
    users: 'ユーザー',
    subscriptions: 'サブスクリプション',
    announcements: 'お知らせ',
    persona: 'ペルソナ',
    faq: 'よくある質問',
    termsOfService: '利用規約',
    privacyPolicy: 'プライバシーポリシー',
    nav_home: 'ホーム',
    nav_trends: 'トレンド',
    nav_workshop: 'ワークショップ',
    nav_me: 'マイページ',
    home_tab_recommended: 'おすすめ',
    home_tab_trending: 'ランキング',
    home_tab_latest: '最新',

    // Profile / Subscription
    profile_checkout_success: 'チェックアウト成功',
    profile_checkout_thank_you: '購読ありがとうございます！',
    profile_checkout_start_using: '{name} プリセットを作成して使用することで、購読の利用を開始してください。',
    profile_checkout_close_window: 'ウィンドウを閉じる',
    profile_checkout_cancelled: 'チェックアウトがキャンセルされました',
    profile_checkout_cancelled_msg: '購読の試行がキャンセルされました。料金は発生していません。',
    profile_sub_valid_until: '有効期限',
    profile_sub_patreon_subscriber: 'Patreon 購読者',
    profile_sub_cancels_at: 'キャンセル日',
    profile_sub_renews_at: '更新日',
    profile_sub_why_title: 'なぜ購読するのですか？',
    profile_sub_why_msg_1: '購読すると、より高品質なモデル、より迅速な応答、より大きなコンテキストにアクセスできるようになります。',
    profile_sub_why_msg_2: '将来的には追加機能も利用可能になります！例えば、音声生成、画像ストレージ、Discord、Slack、WhatsAppなどのサードパーティアプリとの連携などです！',
    profile_sub_why_msg_3: '購読により、私は HuanYouAI の開発と強化により多くの時間を費やすことができます。',
    profile_sub_support_contact: '請求または購読のサポートが必要な場合は、こちらに連絡してください',
    profile_sub_view_models: '利用可能なモデルを表示',
    profile_sub_current_title: '現在の購読',
    profile_sub_update_payment: '支払い方法を更新',
    profile_sub_via: '購読経由',
    profile_sub_via_gift: 'ギフト',
    profile_sub_via_patreon: 'Patreon',
    profile_sub_via_stripe: 'Stripe',
    profile_sub_via_none: 'なし',
    profile_sub_set_to_downgrade: '購読はダウングレードに設定されています',
    profile_sub_cancel_downgrade: 'ダウングレードをキャンセル',
    profile_sub_scheduled_to_cancel: '購読は現在キャンセルされる予定です',
    profile_sub_resume: '購読を再開',
    profile_sub_enjoy: '楽しんでください！',
    profile_sub_subscribed: '購読済み！',
    profile_sub_options: '購読オプション',
    profile_sub_patreon_msg: 'パトロンになってアカウントをリンクするか、以下のオプションを使用してください',
    profile_sub_gifted_to_you: 'このティアは現在ギフトとして贈られています',
    profile_sub_login_to_subscribe: 'ログインして購読',
    profile_sub_upgrade: 'アップグレード',
    profile_sub_downgrading: 'ダウングレード中...',
    profile_sub_downgrade: 'ダウングレード',
    profile_sub_resubscribe: '再購読',
    profile_sub_subscribe: '購読',
    profile_sub_prices_usd: 'すべての価格は米ドル表記です',
    profile_sub_unsubscribe: '購読解除',
    profile_sub_confirm_unsubscribe: '本当に購読解除しますか？',
    profile_sub_upgrade_charge_msg: '確認後、すぐに請求が発生します。',
    profile_sub_confirm_upgrade: '今すぐアップグレードしますか？',
    profile_sub_downgrade_affect_msg: 'ダウングレードは、次の請求期間の開始時に有効になります。ダウングレードが有効になるまで、現在の購読ティアへのアクセス権は保持されます。',
    profile_sub_confirm_downgrade: '本当にダウングレードしますか？',
    profile_sub_per_mo: '/月',
    profile_sub_or: 'または',

    // Prompt Templates
    prompt_templates_title: 'プロンプトテンプレート',
    prompt_templates_new_template: 'テンプレート',
    prompt_templates_no_templates: '保存されたプロンプトテンプレートはありません',
    prompt_templates_builtin: '組み込みテンプレート',
    prompt_templates_updated: 'テンプレートが更新されました',
    prompt_templates_created: 'テンプレートが作成されました',
    prompt_templates_name: '名前',

    // Saga
    saga_help_link: 'Saga テンプレートヘルプ',
    saga_preview_title: 'プレビュー：Sagas',
    saga_preview_msg: 'これは「Sagas」のプレビューです。これらはユーザーによって作成された自由形式のテキストベースのアドベンチャーです。',
    saga_new_template: '新規テンプレート',
    saga_untitled_template: '無題のテンプレート',
    saga_menu_prompts: 'プロンプト',
    saga_menu_preset: 'プリセット',
    saga_menu_help: 'ヘルプ',
    saga_session_saved: 'セッションが保存されました',
    saga_btn_restart: '再起動',
    saga_btn_start: '開始',
    saga_btn_new: '新規',
    saga_btn_load: '読み込み',
    saga_btn_save: '保存',
    saga_btn_reimage: '画像を再生成',
    saga_tab_template: 'テンプレート',
    saga_tab_session: 'セッション',
    saga_current_template: '現在のテンプレート',
    saga_load_template: 'テンプレートを読み込む',
    saga_field_name: '名前',
    saga_field_format: '形式',
    saga_field_init_template: '初期テンプレート',
    saga_field_init_template_helper: '紹介文の初期値を生成するため。',
    saga_field_intro_format: '紹介文形式',
    saga_field_intro_format_helper: '紹介文の形式を設定する方法。.\n\n**初期テンプレート**から派生した任意のフィールドを使用できます。',
    saga_field_display_format: '応答表示形式（オプション）',
    saga_field_display_format_helper: '**表示**の応答をどのように表示するか（空の場合は**応答プロンプト形式**を使用します）\nテンプレートから派生した任意のフィールドを使用できます。',
    saga_field_image_prompt: '画像生成用のプロンプトテンプレート',
    saga_field_image_prompt_helper: '画像生成を無効にするには空のままにします',
    saga_field_history_template: '履歴テンプレート',
    saga_field_history_template_helper: 'ゲームループテンプレートで **{{history}}** を使用します',
    saga_field_loop_template: 'ゲームループテンプレート',
    saga_field_loop_template_helper: 'ユーザー入力を使用するには **{{input}}** を使用します',
    saga_manual_fields: '手動フィールド',
    saga_manual_fields_helper: 'これらのフィールドはあなた自身で入力する必要があります',
    saga_fields: 'フィールド',
    saga_fields_helper: '**切り替え**: フィールドをチャットウィンドウに表示するかどうかを制御します。\n**ラベル**: 有効な場合、チャットウィンドウでのフィールド名。\n**値**: 生成する代わりに値を上書きします。',
    saga_lists: 'リスト',
    saga_add_items: '項目を追加...',
    saga_required_value: '（必須）値',
    saga_optional_value: '（オプション）値',
    saga_guidance_title: 'ガイダンス',
    saga_import_success: 'テンプレートのインポートに成功しました',
    saga_import_title: 'テンプレートをインポート',
    saga_import_json_label: 'テンプレート JSON',

    // Scenario
    scenario_title: 'シナリオ',
    scenario_import: 'シナリオをインポート',
    scenario_create: 'シナリオを作成',
    scenario_no_scenarios: 'まだシナリオはありません。',
    scenario_unnamed: '無題のシナリオ',
    scenario_edit_title: 'シナリオを編集',
    scenario_btn_duplicate: '複製',
    scenario_btn_download: 'ダウンロード',
    scenario_btn_delete: '削除',
    scenario_no_events: 'このシナリオにアタッチされたイベントはありません',
    scenario_events_count: '個のイベント',
    scenario_details_title: 'シナリオの詳細',
    scenario_field_name_helper: 'シナリオの名前。',
    scenario_field_desc: '説明',
    scenario_field_desc_helper: 'シナリオに関する詳細情報。',
    scenario_field_prompt: 'プロンプトテキスト',
    scenario_field_prompt_helper: 'オプション。シナリオプロンプトに追加する追加テキスト。',
    scenario_field_overwrite: 'キャラクターのシナリオを上書きする',
    scenario_field_overwrite_helper: 'キャラクターにすでにシナリオがある場合、このシナリオで上書きします。そうでない場合は、最後に追加します。',
    scenario_field_instructions: 'ユーザーへの指示',
    scenario_field_instructions_helper: 'オプション。ユーザーがこのシナリオの使用方法を理解するのを助けるためのテキスト。',
    scenario_confirm_delete: '本当にこのシナリオを削除しますか？',
    scenario_download_title: 'シナリオをダウンロード',
    scenario_event_type_hidden: '非表示（ユーザーには表示されません）',
    scenario_event_type_world: 'ワールド（表示、キャラクター外部）',
    scenario_event_type_character: 'キャラクター（表示、キャラクターによる思考または行動）',
    scenario_event_type_ooc: 'メタ発言 (OOC)（ユーザーにのみ表示）',
    scenario_trigger_greeting: '挨拶',
    scenario_trigger_manual: '手動トリガー',
    scenario_trigger_opened: 'チャット開始',
    scenario_trigger_received: 'メッセージ受信',
    scenario_states_used: '使用されている状態',
    scenario_states_used_helper: 'これまでにイベントで使用した状態',
    scenario_events_title: 'イベント',
    scenario_btn_create_event: 'イベントを作成',
    scenario_no_events_msg: 'まだイベントはありません。',
    scenario_event_name_placeholder: 'イベント名（例：「挨拶」）',
    scenario_field_trigger: 'トリガー',
    scenario_field_req_states: '必須の状態',
    scenario_field_req_states_helper: 'このイベントがトリガーされる前に必要な状態。',
    scenario_field_req_states_placeholder: 'トリガーに必要な状態',
    scenario_field_assign_states: '割り当てる状態',
    scenario_field_assign_states_helper: 'トリガーされたときに、チャットに割り当てられる状態',
    scenario_field_assign_states_placeholder: 'トリガー時に追加される状態',
    scenario_field_event_type: 'タイプ',
    scenario_field_event_type_helper: 'このイベントがユーザーにどのように表示されるか。',
    scenario_field_event_prompt_helper: 'このイベントが発生するたびに送信されるプロンプトテキスト。(OOC: something) テキストはユーザーから隠されます。',
    scenario_event_greeting_msg: '新しいチャットを開始するときに自動的に送信されます。',
    scenario_field_probability: '確率',
    scenario_field_probability_helper: '手動トリガーはランダムに選択され、値が高いほど確率が高くなります。',
    scenario_field_after_hours: '経過時間（時間）',
    scenario_field_after_hours_helper: '何時間後にこのトリガーをアクティブにする必要がありますか？最も長いトリガーが選択されます。',
    scenario_field_after_messages: '経過メッセージ数（前回のイベント以降）',
    scenario_field_after_messages_helper: '何メッセージ後にこのトリガーをアクティブにする必要がありますか？最も短いトリガーが選択されます。',
    scenario_btn_update: '更新',
    scenario_help_title: 'シナリオイベントのヘルプ',
    scenario_help_triggers_msg: 'Events are triggers when:',
    scenario_help_greeting_msg: 'The very first time the user starts a chat',
    scenario_help_manual_msg: 'When the user uses the Trigger Event menu in the chat',
    scenario_help_opened_msg: 'When the user opens a chat with a character after some time',
    scenario_help_received_msg: 'When the character writes something',
    scenario_help_prompt_msg: 'Whenever an event is triggered, a prompt will be sent to the character.',
    scenario_help_world_msg: 'The event will be shown as if something happened independently of the character.',
    scenario_help_character_msg:
      'The event will be shown as if the character wrote it, for example if the character does something.',
    scenario_help_hidden_msg:
      'The event will be hidden from the user. This is useful to make the character do something, and make it look like it was on their own initiative.',
    scenario_help_ooc_msg:
      'The event will be hidden from the character. This is useful to give information or clues to the user.',
    scenario_help_processing_msg: 'The prompt text will have processing.',
    scenario_help_placeholders_msg: 'The {{char}} and {{user}} placeholders will be replaced',
    scenario_help_ooc_processing_msg:
      'Any text with (OOC: TEXT) will be hidden from the user, so you can add additional instructions for the character.',
    scenario_help_asterisks_msg:
      'It is recommended to wrap your text in *asterisks* unless you want the character to say the prompt text.',
    scenario_help_states_msg:
      'Finally, you can use the states to control which events are triggered under which conditions. The chat will keep track of a list of states, which can be assigned by events.',
    scenario_help_req_states_msg:
      'Required states are states that must exist in the chat to allow the trigger to run. You can also prefix a required state by ! to require the state not to exist in the chat for the event to run. You can specify multiple states by separating them with a comma.',
    scenario_help_assign_states_msg:
      'Assigned states are states that will be added to the chat whenever the event is triggered. You can also prefix an assigned state by ! to remove the state from the chat. You can specify multiple states by separating them with a comma.',
    scenario_help_random_msg: 'When multiple events can run, they will be randomly selected.',
    scenario_import_error_json: 'ファイルが有効な JSON ではありません',
    scenario_import_error_schema: 'ファイルがサポートされているシナリオではありません（スキーマが正しくありません）',
    scenario_import_error_invalid: '無効なシナリオ',
    scenario_import_json_label: 'シナリオ JSON ファイル',
    scenario_import_supported_formats: 'サポートされている形式：HuanYouAI',

    // Generation Presets
    gen_presets_title: '生成プリセット',
    gen_presets_new_preset: '新規プリセット',
    gen_presets_load_preset: 'プリセットを読み込む',
    gen_presets_save_preset: 'プリセットを保存',
    gen_presets_import_preset: 'プリセットをインポート',
    gen_presets_delete_preset_confirm: 'このプリセットを削除してもよろしいですか？',
    gen_presets_name_label: '名前',
    gen_presets_name_helper: 'プリセットの名前または短い説明',
    gen_presets_name_placeholder: 'プリセット名',
    gen_presets_id_label: 'ID',
    gen_presets_new_preset_id: '新規プリセット',
    gen_presets_builtin_warning: 'これは組み込みのプリセットであり、保存できません。',
    gen_presets_copy_click_here: 'ここをクリック',
    gen_presets_copy_helper_text: 'して、このプリセットのコピーを作成してください。',
    gen_presets_select_preset_helper: '編集を開始するプリセットを選択してください。現在編集中のプリセットはリストに表示されません。',
    gen_presets_filter_placeholder: 'フィルター...',
    gen_presets_providers_tab: 'プロバイダー',
    gen_presets_presets_tab: 'プリセット',
    gen_presets_new_button: '新規',
    gen_presets_import_button: 'インポート',
    gen_presets_preset_json_label: 'プリセット JSON',
    gen_presets_imported: 'インポート済み',
    gen_presets_imported_preset: 'インポートされたプリセット',
    gen_presets_invalid_preset: 'プリセットが無効です',
    gen_presets_could_not_parse: 'プリセットを解析できませんでした',

    // Additional UI
    nav_charHub: 'キャラハブ',
    nav_sagasPreview: 'サガプレビュー',
    nav_imageGeneration: '画像生成',
    nav_toggleTheme: 'ライト/ダークモードの切り替え',
    nav_newNotifications: 'ステータス：{count} 件の新しい通知があります',
    nav_noNotifications: 'ステータス：新しい通知はありません',
    nav_subscribeCTA: 'より高品質なチャットと広告なしのために購読する',
    home_modelsTitle: 'モデル',
    home_modelsMessage: 'HuanYouAI が独自のモデルをホストするようになりました！プリセットで Agnaistic サービスを使用して無料で始めましょう',
    home_browserNoStorage: 'ブラウザがローカルストレージをサポートしていません。Agnaistic を使用するにはログイン/登録が必要です。',
    home_officialGuides: '公式ガイド',
    chat_forkConversation: '会話を分岐',
    chat_forkConfirm: 'ここから分岐すると、このメッセージ以降のすべてのメッセージが削除されます。続行しますか？',
    chat_user_handle_you: 'あなた',
    chat_user_anon_name: 'ユーザー {id}',
    chat_bot_label: 'ボット: {name}',
    chat_profile_label: 'プロフィール: {handle}',
    chat_ago: '{duration}前',
    chat_confirm_discard: '破棄',
    chat_thinking: '考え中...',
    chat_reasoning_thought: '思考',
    chat_option_prompt: 'プロンプト',
    chat_option_edit: '編集',
    chat_option_fork: '分岐',
    chat_option_regen: '再生成',
    chat_option_attach: '添付',
    chat_option_visibility: '表示設定',
    chat_option_delete: '削除',
    chat_option_gen_image: '画像生成',
    chat_option_gen_json: 'JSON生成',
    chat_option_export: 'エクスポート',
    chat_removed_from_convo: '会話から削除されました',
    chat_unnamed_preset: '未命名プリセット',
    admin_notYetImplemented: 'まだ実装されていません',
    admin_noSubscriptionId: 'サブスクリプションIDがありません',
    admin_session: 'セッション:',

    recentConversations: '最近の会話',
    startConversation: '会話を開始',
    guides: 'ガイド',
    links: 'リンク',
    gettingStarted: 'はじめに',
    createACharacter: 'キャラクターを作成',
    configureYourAIServices: 'AIサービスを設定',
    officialGuides: '公式ガイド',
    memoryBook: 'メモリーブック',
    agnaisticDiscord: 'HuanYouAI Discord',
    github: 'GitHub',
    notableFeatures: '主な機能',
    lookingForHelp: '始めるためのヘルプをお探しですか？',
    checkOutThe: 'を確認してください',
    officialGuide: '公式ガイド',
    orHeadToThe: 'または',

    // Guides
    guide_memory_title: 'メモリーブック',
    guide_memory_text: `## メモリーブックとは何ですか？

メモリーブックは、キャラクターとの対話中に動的にコンテキストを提供する方法です。 「シナリオ」、「ペルソナ」、「サンプルチャット」でコンテキスト予算をすべて使い切る代わりに、メモリーブックを使用できます。

## どのように機能しますか？

**メモリエントリ**を作成するときに、\`キーワード\`と\`エントリ\`テキストを提供します。
\`優先度\`と\`重み\`も提供できますが、これについては後で説明します。

- キーワード：
  - これらは、メモリをプロンプトに挿入するための「トリガー」となる言葉です。
  - 例：\`飲み物, 喉の渇き, 水分補給, 水を飲む\`
- エントリ：
  - これは、キーワードの1つが見つかったときにプロンプトに挿入されるテキストです。
  - 例：\`{{user}}のお気に入りの飲み物は、ロックのレッドコーディアルです\`

生成設定には**メモリ深度**があります。 これは、Agnaiがキーワードをスキャンする最大チャットメッセージ数です。
これらはすべてブラウザ内で発生することを覚えておくことが重要です。

### なぜこれがブラウザ内で発生することを覚えておくことが重要なのですか？

*注意：これは匿名/ゲストユーザーには適用されません。 ゲストユーザーは、プロンプト構築のために常にチャット履歴全体を利用できます。*

メモリ深度を \`100\` 以上に設定すると、キーワードが期待通りにトリガーされない場合があります。
最初にチャットをロードすると、サーバーから最大100メッセージが送信されます。 さらにスクロールアップしてメッセージを取得し続けることができます。

## 優先度と重みとは何ですか？

簡単に言うと、これら2つの値は、メモリ予算（\`memory context limit\`）に含めるメモリと、それらがプロンプトに表示される順序を決定するために使用されます。

### 優先度 (Priority)

この値が高いほど、そのメモリは「重要」です。 プロンプトに含めるメモリを評価するには：

- メモリを優先度順にソートします
- 予算がいっぱいになるまで、メモリを1つずつプロンプトに追加します

### 重み (Weight)

この値が高いほど、メモリはメモリプロンプトの下の方に配置されます。
理論的には、プロンプトの下の方にあるものほど、応答を生成する際により重要になります。

メモリが予算内に収まるように「整理」された後、メモリは重み順にソートされます。

## どのようなメモリ生成設定をお勧めしますか？

現時点ではわかりません。 実験の結果、どのような経験をされたかぜひお聞かせください。

利用可能な生成設定は、\`depth\`（深度）と \`contextLimit\`（コンテキスト制限）です。

- **深度 (Depth)**：キーワードをスキャンする最大チャットメッセージ数。
- **コンテキスト制限 (Context Limit)**：メモリプロンプトが「最大コンテキスト長」から消費する最大トークン数。`,
    guide_novel_title: 'NovelAI ガイド',
    guide_novel_text: `# NovelAI の手順

NovelAIをセットアップする方法は2つあります：

**NovelAIサイトから永続的なAPIトークンを取得する。**

1. [NovelAI](https://novelai.net/stories) にログインします
2. ユーザー設定を開き、[Account]タブに移動します
3. [Get Persistent API Token]ボタンを押します
4. 生成されたトークンをコピーし、[NovelAI 設定ページ](https://agnai.chat/settings?tab=ai&service=novelai)の \`Novel API Key\` フィールドに貼り付けます

APIキーは次のようになります：

\`\`\`
pst-ykHYhtDti6ZYYmgCtUnhYraECciZQCEVMGhhh4HUgRf7XLQGzeDinQtCRECZJXWE
\`\`\`

または

**開発者ツールを使用して、NovelAIサイトから手動でトークンを取得する。**

1. [NovelAI](https://novelai.net/stories) にログインします
2. 次のいずれかの方法を使用して開発者ツールを開きます：

   - \`Ctrl + Shift + I\`
   - ページを右クリック --> [検証]をクリック

3. [Console]タブを開き、次のように入力します：

- \`console.log(JSON.parse(localStorage.getItem('session')).auth_token)\`

4. 出力された結果をコピーし、[NovelAI 設定ページ](/settings?tab=ai&service=novelai)の \`Novel API Key\` フィールドに貼り付けます

APIキーは次のようになります：

\`\`\`
eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6Ii4uLiIsImlhdCI6MTUxNjIzOTAyMn0.pCVUFONBLI_Lw3vKQG6ykCkuWNeG4cDhdEqRO_QJbh4
\`\`\`

このトークンは定期的に期限切れになり、月に一度交換が必要になることに注意してください。 永続的なAPIトークンを使用することをお勧めします。`,
    guide_pipeline_title: 'パイプラインガイド',
    guide_pipeline_subtitle: 'Agnai パイプライン API のインストールと使用方法',
    guide_pipeline_text: `### パイプライン API とは何ですか？
パイプライン API を使用すると、会話を強化するための追加機能を実行できます。
Agnai.chat とローカルホストの会話の両方がサポートされています。
現時点では、ChromaDB を使用したエンベディングのサポートのみが利用可能です。

### エンベディングとは何ですか？
エンベディングはメモリーブックに似ていますが、より洗練されています。 単純な「キーワード」マッチングの代わりに、「意味的類似性」と呼ばれる手法を使用します。
これは、結果が「意味の類似性または近さ」に基づいていることを意味します。 メッセージを使用してテキスト全体を照会し、結果は「意味が最も近い」ものになります。
これにより、次のようなことが可能になります：
- 最後のメッセージを使用して AI の「記憶を呼び起こし」、プロンプトに収まらなくなった会話の一部を思い出させる。
- PDF や記事の関連部分を AI に渡し、その情報に基づいて有意義な応答を提供する。

### パイプラインをインストールして実行するにはどうすればよいですか？
- [Node.JS v16+](https://nodejs.org/en/download) と [Python 3.10+](https://www.python.org/downloads/) がインストールされている必要があります。
- NPM パッケージを使用して Agnaistic をインストールします。 ターミナルから： \`npm install agnai -g\`
- ターミナルから \`agnai --pipeline\` を実行します

### パイプラインを使用するにはどうすればよいですか？
- \`設定 -> AI設定\` に移動し、「ローカルパイプラインを使用する」を有効にして [保存] を押します。
- パイプラインが正常に接続されると、メインメニューの \`メモリ\` の横に通知と緑色の信号バーが表示されます。
- パイプラインが切断された場合は、メニューの \`メモリ\` の横にある電源アイコンをクリックできます。

### エンベディングを作成して使用するにはどうすればよいですか？
- \`チャットオプション -> メモリ\` モーダルで、Wikipedia の記事や PDF からエンベディングを作成できます。 これは、\`メモリ -> エンベディング\` ページからも実行できます。
- 作成したら、メモリモーダルのドロップダウンからエンベディングを選択し、[エンベディングを使用] をクリックします。


エンベディング情報を提供すると、 \`{{user_embed}}\` プレースホルダーがプロンプトに自動的に挿入されます。
また、テンプレートに \`{{user_embed}}\` プレースホルダーを手動で追加することもできます。`,

    home_faq_title: 'よくある質問',
    home_faq_subtitle: 'よくある質問と回答',
    home_faq_content: `### 私の回答はフィルタリングされますか？
いいえ、HuanYouAI はあなたの回答をフィルタリングしようとはしません。

### キャラクターからの回答が文の途中で切れてしまいます。どうすればいいですか？
いくつか試せることがあります：
- **プリセット設定**で \`最大トークン\` を増やします。
- **Horde** を使用している場合は、\`最大トークン\` が「高すぎない」ことを確認してください。**設定 -> Horde 設定** で、\`ワーカーを選択\` をクリックして、各ワーカーの「コンテキストとトークン」の制限を確認できます。\`最大トークン\` がそれらのトークン制限を超えないようにしてください。

### チャットで複数のプロフィールを持ったり、名前を変更したりするにはどうすればいいですか？
これは **キャラクターになりきる** ことで実現できます。なりきるには、メインメニューの自分のアバター/名前をクリックします。

### チャットに複数のユーザーやキャラクターを入れることはできますか？
はい。**チャットオプション** の **参加者** からキャラクターを追加したりユーザーを招待したりできます。

### チャットメッセージを編集または削除できますか？
はい。**チャットオプション** で *チャット編集* を有効にすると、チャットメッセージに追加のボタンが表示されます。

### 回答が文の途中で切れましたが、続きを生成できますか？
はい。**入力オプション** で *さらに生成* を選択できます。

### 会話に基づいて画像を生成できますか？
はい、**設定 -> 画像設定** で画像生成を設定できます。
Web URL を指定する場合は、Local Tunnel や NGrok などのサービスを使用して、それが *パブリックにアクセス可能* であることを確認してください。

### テキスト読み上げ（TTS）はサポートされていますか？
はい、**設定 -> 音声設定** でさまざまなテキスト読み上げサービスをサポートしています。

### UI をカスタマイズできますか？
はい、**設定 -> UI 設定** で Agnaistic の一部の要素を変更できます。

### 「他のサイト」から来ましたが、そのサイトのようにボットを話させるにはどうすればいいですか？
フロントエンドによって動作が少し異なります。**プリセット** 内の **プロンプトテンプレート** を変更することで、キャラクターの動作を微調整できます。

### パスワードを忘れました！
アカウントの回復は保証されません。[Discord](https://discord.agnai.chat) で Sceik に連絡して、アカウントの回復を試みることができます。

### ここで解決しない質問がある場合は、どこで聞けばいいですか？
すぐに回答を得るのに最適な場所は [Discord](https://discord.agnai.chat) です。

### 用語集 / 用語：
- **入力オプション**：チャットテキスト入力の右側（三点メニュー）からアクセスします。
- **チャットオプション**：チャットウィンドウの右上方からアクセスします。
- **設定**：メインメニューの「設定」リンクからアクセスします。
- **AI 設定**：設定ページで利用可能です。
- **プロンプト**：回答を生成するために AI サービスに送信されるテキストの本体です。
- **最大コンテキスト長**：AI サービスに送信するプロンプトの最大サイズです。
- **最大トークン**：AI サービスからの回答で受け取るトークンの最大量です。
- **プリセット**：**生成設定** とも呼ばれます。これは以下を制御します：
    - 使用する AI サービス
    - *プロンプト* の形式/形状
    - *最大コンテキスト長* と *最大トークン*
    - 「温度」、「繰り返しペナルティ」などの「生成設定」`,
    maxNewTokens: '最大新規トークン',
    username: 'ユーザー名',
    password: 'パスワード',
    confirmPassword: 'パスワード確認',
    displayName: '表示名',
    passwordsDoNotMatch: 'パスワードが一致しません',
    invalidCallbackUrl: '無効なコールバックURL',
    loggingIn: 'ログイン中...',
    registering: '登録中...',
    welcomeToAccount: 'ようこそ',
    authorizing: '認証中',
    youAreAlreadyLoggedIn: 'すでにログインしています。',
    toYourAccount: 'アカウントにログイン',
    orContinueAsGuest: 'またはゲストとして続行。',
    failedToLogIn: 'ログインに失敗しました。',
    somethingWentWrong: '問題が発生しました。',
    couldNotReachServers: 'サーバーに接続できませんでした。',
    byLoggingIn: 'ログインまたは登録することで、18歳以上であり、',
    youAgree: 'に同意したことになります',
    and: 'と',
    whyRegister: 'なぜ登録するのですか？',
    youDontNeedToRegister: 'HuanYouAIを使用するために登録する必要はありません。匿名で使用でき、サーバーにデータは保存されません。',
    ifYouChooseToRegister: '登録を選択した場合',
    yourDataWillBeStored: 'データは保存され、ログインするすべてのデバイスでアクセスできます。',

    // Admin
    admin_serverConfiguration: 'サーバー設定',
    admin_general: '全般',
    admin_images: '画像',
    admin_voice: '音声',
    admin_supportEmail: 'サポートメール',
    admin_supportEmailHelper: '提供された場合、このメールへのリンクがメインナビゲーションに追加されます',
    admin_maintenanceModeEnabled: 'メンテナンスモード有効',
    admin_maintenanceModeHelper: '注意：データベースが利用できない場合、このフラグは機能しません。代わりに環境変数を使用してください。',
    admin_maintenanceMessage: 'メンテナンスメッセージ',
    admin_maintenanceMessageHelper: 'Markdownがサポートされています',
    admin_stripeCustomerPortal: 'Stripeカスタマーポータル',
    admin_lockDuration: 'ロック期間（秒）',
    admin_lockDurationHelper: 'ユーザーレベルのロックの最大TTL - 無効にするにはゼロ（0）に設定',
    admin_googleClientId: 'GoogleクライアントID',
    admin_googleClientIdHelper: 'サインインに使用',
    admin_slotsConfiguration: 'スロット設定',
    admin_slotsConfigurationHelper: 'JSONである必要があります。リモートスロット設定とマージされます -- この設定はslots.txtを上書きします',
    admin_format: 'フォーマット',
    admin_enablePolicies: 'ポリシーを有効にする',
    admin_enablePoliciesHelper: '利用規約とプライバシーに関する声明を表示する',
    admin_privacyStatement: 'プライバシーに関する声明',
    admin_apiAccessLevel: 'APIアクセスレベル',
    admin_off: 'オフ',
    admin_allUsers: 'すべてのユーザー',
    admin_subscribers: '購読者',
    admin_administrators: '管理者',
    admin_maxGuidanceTokens: '最大ガイダンストークン',
    admin_maxGuidanceTokensHelper: 'サガ/ガイダンステンプレートが要求できるトークンの最大数。無効にするには0に設定。',
    admin_maxGuidanceVariables: '最大ガイダンス変数',
    admin_maxGuidanceVariablesHelper: 'サガ/ガイダンステンプレートが要求できる変数の最大数。無効にするには0に設定。',
    admin_imagesHost: '画像ホスト（A1111互換）',
    admin_imagesLoraUrl: '画像LoRA URL',
    admin_defaultImageModel: 'デフォルト画像モデル',
    admin_imageModels: '画像モデル',
    admin_add: '追加',
    admin_addModel: 'モデルを追加',
    admin_description: '説明',
    admin_modelDescriptionPlaceholder: 'モデルの説明...',
    admin_url: 'URL',
    admin_loraSupport: 'LoRAサポート',
    admin_host: 'ホスト',
    admin_modelNamePlaceholder: 'モデル名...',
    admin_override: 'オーバーライド',
    admin_level: 'レベル',
    admin_prefix: 'プレフィックス',
    admin_suffix: 'サフィックス',
    admin_negative: 'ネガティブプロンプト',
    admin_steps: 'ステップ数',
    admin_init: '初期値',
    admin_max: '最大値',
    admin_cfgScale: 'CFGスケール',
    admin_width: '幅',
    admin_height: '高さ',
    admin_clipSkip: 'Clipスキップ',
    admin_voiceAccessLevel: '音声アクセスレベル',
    admin_voiceHost: '音声ホスト',
    admin_voiceHostHelper: 'パスを含む完全なURL - クエリパラメータを含める',
    admin_voiceApiKey: '音声APIキー',
    admin_metrics: 'メトリクス',
    admin_refresh: '更新',
    admin_onlineUsers: 'オンラインユーザー',
    admin_versions: 'バージョン',
    admin_maxOnlineUsers: '最大オンラインユーザー',
    admin_registeredUsers: '登録ユーザー',
    admin_services: 'サービス',
    admin_messageAllUsers: 'すべてのユーザーにメッセージを送信',
    admin_send: '送信',
    admin_confirmMessageAll: 'すべてのユーザーにメッセージを送信してもよろしいですか？',
    admin_userManagement: 'ユーザー管理',
    admin_backToManage: '管理に戻る',
    admin_customerId: 'カスタマーID',
    admin_subscribed: '購読済み',
    admin_search: '検索',
    admin_reset: 'リセット',
    admin_info: '情報',
    admin_impersonate: 'なりきり',
    admin_changePassword: 'パスワード変更',
    admin_banUser: 'ユーザーを禁止',
    admin_unbanUser: 'ユーザーの禁止を解除',
    admin_userId: 'ユーザーID',
    admin_banned: '禁止済み',
    admin_handle: 'ハンドル名',
    admin_subscriptionDetails: '購読の詳細',
    admin_gift: 'ギフト',
    admin_expiry: '有効期限',
    admin_apply: '適用',
    admin_assignSub: '購読を割り当てる',
    admin_stripeSubscriptionId: 'Stripe購読ID',
    admin_assign: '割り当て',
    admin_sessionIds: 'セッションID',
    admin_subscriptionLevel: '購読レベル',
    admin_native: 'ネイティブ',
    admin_manual: '手動',
    admin_periodStart: '期間開始',
    admin_renewsAt: '更新日',
    admin_downgradingAt: 'ダウングレード日',
    admin_cancelledAt: 'キャンセル日',
    admin_cancelsAt: 'キャンセル日',
    admin_state: '状態',
    admin_history: '履歴',
    admin_noReasonGiven: '理由は提供されていません',
    admin_banReason: '禁止理由',
    admin_resetLink: 'リセットリンク',
    admin_generateLink: 'リンクを生成',
    admin_manageAnnouncements: 'お知らせの管理',
    admin_created: '作成済み',
    admin_hide: '非表示',
    admin_unhide: '表示',
    admin_delete: '削除',
    admin_instructions: '使い方',
    admin_deleted: '削除済み',
    admin_hidden: '非表示',
    admin_pending: '保留中',
    admin_active: '有効',
    admin_announcement: 'お知らせ',
    admin_title: 'タイトル',
    admin_displayAtRequired: '「表示日時」は必須です',
    admin_errorProductNotFound: '商品が見つかりません: {id}',
    admin_errorProductNoPrice: '商品にデフォルト価格がありません: {id}',
    admin_errorPriceNotFound: '価格が見つかりません: {id}',
    admin_location: '場所',
    admin_home: 'ホーム',
    admin_notification: '通知',
    admin_locationHelper: 'ホームページまたは通知リストに表示されます',
    admin_userLevelThreshold: 'ユーザーレベル（閾値）',
    admin_userLevelThresholdHelper: 'このレベル以上のティアを持つユーザーにお知らせを表示します `すべてのユーザー = -1` `購読済み = 0`',
    admin_content: 'コンテンツ',
    admin_hideAnnouncement: 'お知らせを隠す',
    admin_displayAt: '表示日時',
    admin_now: '今すぐ',
    admin_id: 'ID',
    admin_name: '名前',
    admin_apiAccessCapable: 'APIアクセス可能',
    admin_guidanceAccessCapable: 'Guidance (V2) アクセス可能',
    admin_imagesAccessCapable: '画像生成アクセス可能',
    admin_patreonTier: 'Patreonティア',
    admin_preview: 'プレビュー',
    admin_stripeProduct: 'Stripe製品',
    admin_enabled: '有効',
    admin_disableSlots: 'スロットを無効にする',
    admin_subscriptionTier: '購読ティア',
    admin_backToSubscriptions: '購読に戻る',
    admin_noPaymentRequired: '支払いは不要です',
    admin_descriptionHelper: 'これはMarkdownレンダラーを使用して表示されます。HTMLもサポートされています。',
    admin_apiAccessHelper: '有効な場合、サーバーが許可していれば、このティアはAPIアクセスを使用できます',
    admin_guidanceAccessHelper: '有効な場合、サーバー/プリセットが許可していれば、このティアはGuidanceV2を使用できます',
    admin_imagesAccessHelper: '有効な場合、このティアはHuanYouAI画像生成を使用できます',
    admin_patreonTierHelper: 'Patreonが連携されている場合、最小ティアが必要です',
    admin_enabledHelper: '無効な場合、このティアはユーザーが選択できません。',
    admin_disableSlotsHelper: 'このティアはスロットのレンダリングを防止します',
    admin_subscriptions: '購読',
    admin_model: 'モデル',
    admin_tier: 'ティア',
    admin_noTiers: 'ティアなし',
    admin_tiers: 'ティア',
    admin_models: 'モデル',
    admin_disabled: '無効',
    admin_default: 'デフォルト',
    admin_stripe: 'Stripe',
    admin_patreon: 'Patreon',
    admin_unset: '未設定',
    admin_confirmDeleteSubscription: 'この購読を削除してもよろしいですか？',
    admin_subscriptionModel: '購読モデル',
    admin_loadPreset: 'プリセットを読み込む',
    admin_newSubscription: '新規購読',
    admin_replaceSupercede: '置換/後継',
    admin_modelHelper: 'HuanYouAIサービスのみ',
    admin_modelServiceUrl: 'モデルサービスURL',
    admin_modelServiceUrlHelper: 'HuanYouAIサービスのみ',
    admin_guidanceCapable: 'ガイダンス対応',
    admin_guidanceCapableHelper: 'HuanYouAIサービスのみ',
    admin_subscriptionDisabled: '購読無効',
    admin_subscriptionDisabledHelper: 'この購読の使用を無効にします',
    admin_isDefaultSubscription: 'デフォルトの購読',
    admin_isDefaultSubscriptionHelper: 'リクエストに購読が指定されていない場合のフォールバックとして選択されます',
    admin_jsonSchemaCapable: 'JSONスキーマ対応（構造化レスポンス）',
    admin_visionModel: 'ビジョンモデル',
    admin_visionModelHelper: 'HuanYouAIサービスのみ',
    admin_allowGuestUsage: 'ゲストの使用を許可',
    admin_allowGuestUsageHelper: '通常、デフォルトの購読用です。この購読を使用するにはユーザーにサインインを求めます。',
    admin_tokenizerOverride: 'トークナイザーのオーバーライド',
    admin_tokenizerOverrideHelper: 'オプション。カスタムモデル用。',
    admin_confirmDeletePreset: 'このプリセットを削除してもよろしいですか？',
    admin_replaceSubscription: '購読を置換',
    admin_replacementSubscription: '置換購読',
    admin_replacementSubscriptionHelper: '現在の購読を継承する購読',
    admin_replace: '置換',
    admin_levels: 'レベル',
    admin_subLevel: '購読レベル',
    admin_tokens: 'トークン',
    admin_context: 'コンテキスト',
    admin_copySubscription: '購読をコピー',
    admin_createSubscription: '購読を作成',
    admin_editSubscription: '購読を編集',
    admin_selectAIServiceBeforeSaving: '保存する前にAIサービスを選択する必要があります',
    admin_preset: 'プリセット',
    admin_presetHelper: '編集を開始するプリセットを選択してください。現在編集中のプリセットはリストに表示されません。',
    admin_apiKey: 'APIキー',
    admin_apiKeyHelper: '（オプション）該当する場合、AIサービスのAPIキー。',
    admin_apiKeyIsSet: 'APIキー設定済み',
    admin_apiKeyIsNotSet: 'APIキー未設定',
    admin_subscriptionLevelHelper: '-1より大きい値は「購読」が必要です。デフォルトではすべてのユーザーが-1です。',
    admin_replacementIdNotSet: '置換IDが設定されていません',
    
    // Profile
    profile_myProfile: 'マイプロフィール',
    profile_updateProfile: 'プロフィールを更新',
    profile_impersonateNote: 'メインメニュー上部の「ペルソナ」ボタンをクリックすることで、キャラクターになりきることができます。',
    profile_linkGoogle: 'Googleでサインインを有効にするためにGoogleと連携する',
    profile_accountLinkedGoogle: 'アカウントはGoogleと連携されています',
    profile_unlinkGoogle: 'Googleアカウントの連携を解除',
    profile_userIdHelper: 'ユーザーID。他の人があなたにチャットの招待を送信するために使用されます。',
    profile_usernameHelper: 'ユーザー名。これは変更できません。ユーザー名を共有する必要はありません。',
    profile_displayNameHelper: 'チャット内や他人に表示される名前（なりきり中ではない場合）',
    profile_profileImage: 'プロフィール画像',
    profile_removeAvatar: 'アバターを削除',
    profile_fileSizeLimit2MB: 'ファイルサイズ制限は2MBです',
    profile_guestData: 'ゲストデータ',
    profile_prepareBackup: 'バックアップを準備',
    profile_backupNotReady: 'バックアップの準備ができていません',
    profile_downloadGuestData: 'ゲストデータをダウンロード',
    profile_unimpersonate: 'なりきりを解除',
    profile_logout: 'ログアウト',
    profile_deleteAccount: 'アカウントを削除',
    profile_importGuestDataWarning: 'これにより、既存のすべてのゲストデータが置換されます。よろしいですか？',
    profile_importFailed: 'インポートに失敗しました: {message}',
    profile_changePassword: 'パスワード変更',
    profile_changePasswordDescription: 'このウィンドウでアカウントのパスワードを変更できます',
    profile_updatePassword: 'パスワードを更新',
    profile_newPassword: '新しいパスワード',
    profile_confirmPassword: 'パスワードの確認',
    profile_deleteAccountWarning: 'これは取り消せません！アカウントを削除すると復元できません。',
    profile_deleteAccountConfirmNote: 'ユーザー名を入力し、「確認」をクリックしてアカウントの削除を確定してください',
    profile_confirmDeletion: '削除の確認',

    // Settings
    settings_title: '設定',
    settings_updateSettings: '設定を更新',
    settings_thisCannotBeUndone: 'これは取り消せません！',
    settings_deleteGuestState: 'ゲストの状態を削除',
    settings_ui_theme: 'テーマ',
    settings_ui_chat: 'チャット',
    settings_ui_messages: 'メッセージ',
    settings_ui_color: '色',
    settings_ui_mode: 'モード',
    settings_ui_dark: 'ダーク',
    settings_ui_light: 'ライト',
    settings_ui_siteFontSize: 'サイトのフォントサイズ',
    settings_ui_backgrounds: '背景',
    settings_ui_resetToDefault: 'デフォルトに戻す',
    settings_ui_backgroundColor: '背景色',
    settings_ui_backgroundImage: '背景画像',
    settings_ui_remove: '削除',
    settings_ui_font: 'フォント',
    settings_ui_custom: 'カスタム',
    settings_ui_responseHints: 'レスポンスヒント',
    settings_ui_responseHintsHelper: 'レスポンスを誘導するためにメッセージにヒントを追加する',
    settings_ui_avatarWrapAround: 'アバターの回り込み',
    settings_ui_avatarWrapAroundHelper: 'メッセージ内のテキストがアバターを「回り込む」ことを許可する',
    settings_ui_trimIncompleteSentences: '不完全な文を切り取る',
    settings_ui_expandReasoning: 'デフォルトで推論を展開',
    settings_ui_expandReasoningHelper: '推論の思考はデフォルトで折りたたまれています。これを有効にするとデフォルトで展開されます。',
    settings_ui_midReasoningBehavior: '推論中の動作',
    settings_ui_midReasoningBehaviorHelper: '推論がレスポンスの途中にある場合、どの発話（つまり非思考）を保持するか',
    settings_ui_anonymizeChat: 'チャットの匿名化',
    settings_ui_anonymizeChatHelper: '会話内のプロフィール名を隠す。主にスクリーンショット用。',
    settings_ui_sendOnEnterOnMobile: 'モバイルでEnterで送信',
    settings_ui_sendOnEnterOnMobileHelper: '改行を追加する代わりに、「Enter」でメッセージを送信する（モバイルのみ）',
    settings_ui_textSpeed: 'テキスト速度',
    settings_ui_textSpeedHelper: 'テキストが流れる速度を制御する。`0` に設定すると無効になります。',
    settings_ui_viewMode: '表示モード',
    settings_ui_viewModeHelper: '標準：メッセージがチャット画面全体を占めます。分割：キャラクターのアバターが画面上部に表示されます。背景：キャラクターのアバターがチャットの背景になります。',
    settings_ui_splitHeight: '分割の高さ (%)',
    settings_ui_splitHeightHelper: '分割モード時のキャラクターアバターの最大高さ',
    settings_ui_standard: '標準',
    settings_ui_split: '分割',
    settings_ui_backgroundAuto: '背景：自動',
    settings_ui_backgroundCover: '背景：カバー',
    settings_ui_backgroundContain: '背景：包含',
    settings_ui_defaultAll: 'デフォルト (すべて)',
    settings_ui_all: 'すべて',
    settings_ui_afterThought: '思考後',
    settings_ui_beforeThought: '思考前',
    settings_ui_avatars: 'アバター',
    settings_ui_size: 'サイズ',
    settings_ui_cornerRadius: '角の半径',
    settings_ui_width: '幅',
    settings_ui_height: '高さ',
    settings_ui_messageBackgroundColor: 'メッセージの背景色',
    settings_ui_botMessageBackgroundColor: 'ボットメッセージの背景色',
    settings_ui_chatTextColor: 'チャットのテキスト色',
    settings_ui_chatEmphasisColor: 'チャットの強調色',
    settings_ui_chatQuoteColor: 'チャットの引用色',
    settings_ui_chatQuoteEmphasisColor: 'チャットの引用強調色',
    settings_ui_chatQuoteEmphasisWeight: 'チャットの引用強調の太さ',
    settings_ui_contentWidth: 'コンテンツの幅',
    settings_ui_messageOpacity: 'メッセージの不透明度',
    settings_ui_messageOpacityHelper: 'チャットウィンドウ内のメッセージブロックの不透明度。',
    settings_ui_inlineMessageOptions: 'インラインメッセージオプション',
    settings_ui_inlineMessageOptionsHelper: 'メッセージ内に「インライン」で表示するメッセージオプションを有効にします。残りは「その他のオプション」ドロップメニューに配置されます',
    settings_ui_preview: 'プレビュー',
    settings_ui_none: 'なし',
    settings_ui_bold: '太字',
    settings_ui_narrow: '狭い',
    settings_ui_large: '大きい',
    settings_ui_xlarge: '特大',
    settings_ui_2xlarge: '超大',
    settings_ui_3xlarge: '極大',
    settings_ui_100: '100%',
    settings_ui_msg_edit: '編集',
    settings_ui_msg_regenerate: '再生成',
    settings_ui_msg_promptView: 'プロンプト表示',
    settings_ui_msg_fork: 'フォーク',
    settings_ui_msg_delete: '削除',
    settings_ui_msg_attach: '添付',
    settings_ui_msg_visibility: '可視性',
    settings_ui_msg_genImage: '画像生成',
    settings_ui_msg_genJson: 'JSON生成',
    settings_ai_embeddings: 'エンベディング/長期記憶',
    settings_ai_embeddingsHelper: '無効にするとサイトのパフォーマンスが向上します。チャットが遅延したり反応が悪い場合は、長期記憶を無効にしてください。',
    settings_ai_presets: 'プリセット',
    settings_ai_chargen: 'キャラクターフィールド生成',
    settings_ai_useServerDefault: 'サーバーのデフォルトを使用',
    settings_ai_chatSummary: 'チャット要約',
    settings_ai_useActiveChatPreset: 'アクティブなチャットプリセットを使用',
    settings_ai_jsonSchemas: 'JSONスキーマ/出力',
    settings_ai_defaultPreset: 'デフォルトプリセット',
    settings_ai_defaultPresetHelper: '新しいチャットを作成するときに最初に選択されるプリセット。',
    settings_ai_apiAccessTitle: 'HuanYouAI APIアクセス',
    settings_ai_howToUseApi: 'APIアクセスの使用方法',
    settings_ai_apiAccessPreset: 'デフォルト/APIアクセスプリセット',
    settings_ai_apiAccessPresetHelper: 'APIアクセスを使用する際に使用されるプリセット。また、新しいチャットを作成するときに最初に選択されるプリセット。',
    settings_ai_apiKey: 'APIキー',
    settings_ai_revealKey: 'キーを表示',
    settings_ai_generateKey: 'キーを生成',
    settings_ai_regenerateKey: 'キーを再生成',
    settings_ai_apiKeyHidden: 'APIキーは非表示です',
    settings_ai_lookingForProviders: 'プロバイダーセクションをお探しですか？',
    settings_ai_headToPresets: 'プリセットページへ移動',
    settings_ai_editSummaryPreset: '要約プリセットを編集',
    settings_ai_apiAccessHelp: '購読者用APIエンドポイントは、OpenAI Text CompletionまたはOpenAI Chat Completion形式を使用します。\n\nこれらのエンドポイントの完全なURLは以下の通りです：\n- https://api.agnai.chat/v1/completions\n- https://api.agnai.chat/v1/chat/completions\n\n手順：\n1. APIアクセスプリセットを選択：このプリセットがAPI呼び出しに使用されます。設定ページで変更してください。\n2. APIキーを生成します。\n3. API URL https://api.agnai.chat または https://api.agnai.chat/v1 と生成したAPIキーを使用してください。',
    settings_voice_sttTitle: '音声からテキスト（マイクで話す）',
    settings_voice_sttNotAvailable: 'お使いのブラウザでは音声からテキストへの変換は利用できません',
    settings_voice_sttHelper: '入力テキストボックスのマイクアイコンを使用して音声認識を使用できます。',
    settings_voice_sttEnabled: '有効',
    settings_voice_sttEnabledHelper: 'マイクボタンを表示するかどうか。',
    settings_voice_sttAutoSubmit: '自動送信',
    settings_voice_sttAutoSubmitHelper: '文が完成したときにメッセージを送信するかどうか。',
    settings_voice_sttAutoRecord: '自動的に録音を再開',
    settings_voice_sttAutoRecordHelper: 'メッセージを受信した後に録音を再開するかどうか。',
    settings_voice_ttsTitle: 'テキストから音声（キャラクターボイス）',
    settings_voice_ttsHelper: 'キャラクターの編集ページで音声を設定する必要があります。',
    settings_voice_ttsEnabled: '有効',
    settings_voice_ttsEnabledHelper: '音声が設定されたキャラクターは自動的に話します。',
    settings_voice_ttsFilterActions: 'アクションテキストをフィルター',
    settings_voice_ttsFilterActionsHelper: 'アスタリスクや括弧内のテキストをスキップします。',
    settings_voice_voiceServices: '音声サービス',
    settings_voice_agnaistic: 'HuanYouAI',
    settings_voice_webspeechsynthesis: 'Web音声合成',
    settings_voice_elevenlabs: 'ElevenLabs',
    settings_voice_novel: 'NovelAIテキストから音声',

    // Character
    char_advancedOptions: '詳細オプション',
    char_systemPrompt: 'キャラクターシステムプロンプト（オプション）',
    char_systemPromptHelper: 'キャラクターに適用されるグローバルな指示セット。',
    char_systemPromptPlaceholder: 'ロールプレイモードに入ります。{{char}}と{{user}}の対話の中で、{{char}}の次の返信を書きます。{{user}}が何を言い、何をするかは決めないでください。インターネットのロールプレイスタイルを使用してください（例：引用符なし、ユーザーのアクションは三人称斜体で書く：*例*）。markdownの使用が許可されています。積極的でクリエイティブに、プロットと会話を前進させてください。少なくとも1段落、最大4段落書いてください。常にキャラクターを維持してください。常に会話を続けてください。（繰り返しは強く推奨されません）',
    char_jailbreak: 'キャラクタージェイルブレイク（オプション）',
    char_jailbreakHelper: '会話履歴の最後に適用される指示。キャラクターのペルソナを確保するのに役立ちます。',
    char_jailbreakPlaceholder: '少なくとも4段落書いてください。',
    char_insertDepthPrompt: '挿入 / 深度プロンプト',
    char_insertDepthPromptHelper: '会話履歴の {depth} に挿入される指示セット。',
    char_insertDepth: '挿入深度',
    char_insertDepthHelper: '挿入プロンプトの下に存在すべきメッセージの数。1から',
    char_creator: '作成者（オプション）',
    char_creatorPlaceholder: '例：John1990',
    char_version: 'キャラクターバージョン（オプション）',
    char_versionPlaceholder: '任意のテキスト、例：1, 2, v1, v1fempov...',
    char_chats: 'チャット',
    char_noConversations: '会話はありません',
    char_chatActivity: 'チャット活動',
    char_botActivity: 'ボット活動',
    char_chatCreated: 'チャット作成日',
    char_botName: 'ボット名',
    char_botCreated: 'ボット作成日',
    char_chatCounts: 'チャット数',
    char_allCharacters: 'すべてのキャラクター',
    char_confirmDeleteChat: 'この会話を削除してもよろしいですか？',
    char_noConversationsYet: '会話はまだありません。',
    char_noConversationsWith: 'との会話はありません：',
    char_lastModified: '最終更新日',
    char_lastConversed: '最終会話日',
    char_created: '作成日',
    char_select: '選択',
    char_archiveSelected: '{count} 人のキャラクターをアーカイブしますか？',
    char_unarchiveSelected: '{count} 人のキャラクターのアーカイブを解除しますか？',
    char_deleteSelected: '本当に {count} 人のキャラクターを削除しますか？',
    char_searchByName: '名前で検索...',
    char_selectedNone: '選択済み：なし',
    char_selectedCount: '選択済み：{count}',
    char_favorites: 'お気に入り',
    char_editingTitle: '編集：{name}',
    char_noCharactersFound: 'キャラクターが見つかりません',
    char_toGetStarted: 'して始めましょう！',
    char_jsonStructuredResponsesHelper: 'JSONを使用してレスポンスを要求および構造化します。JSONスキーマが利用可能な場合にのみ使用されます',
    char_updateSchema: 'スキーマを更新',
    char_editingSchema: 'スキーマを編集',
    char_testSchema: 'スキーマをテスト',
    char_templateReferencesUndefined: 'テンプレートが未定義のプレースホルダーを参照しています：',
    char_responseTemplateWarning: '警告：履歴またはレスポンス形式に {{response}} が含まれていません。{{response}} フィールドは常に生成されるため、使用を強く推奨します。',
    char_invalidJsonSchema: '無効なJSONスキーマ：',
    char_deleteChatsWarning: 'これにより、このキャラクターに関連付けられたすべてのチャットが削除されます！',
    char_newChat: '新規チャット',
    char_new: '新規',
    char_unfavorite: 'お気に入り解除',
    char_duplicate: '複製',
    char_downloadRetreiveFailed: 'ダウンロード用のキャラクターの取得に失敗しました：',
    char_imageCard: '画像カード',
    char_textgen: 'テキスト生成',
    char_downloadJson: 'ダウンロード (JSON)',
    char_downloadPng: 'ダウンロード (PNG)',
    char_createACharacterTitle: 'キャラクター作成',
    char_editACharacterTitle: 'キャラクター編集',
    char_copyACharacterTitle: 'キャラクター複製',
    char_tokensPermanent: '{totalTokens} トークン, {totalPermanentTokens} 恒久',
    char_aiCharacterGenerationGuide: 'AIキャラクター生成ガイド',
    char_characterOverridesWarning: '警告！現在のチャットがキャラクター定義を上書きしています。これらは「チャット編集」メニューで無効にするまで、現在のチャットには反映されません。',
    char_temporaryCharacterWarning: '一時的なキャラクターを {action} しています。一時的なキャラクターは現在のチャット内のみに存在します。',
    char_clearEditorConfirm: 'エディタをクリアしてもよろしいですか？',
    char_descriptionCreatorsNotesHelper: 'キャラクターの説明、ラベル、またはメモ。これはキャラクターの動作には影響しません。',
    char_tagsHelper: 'キャラクターの整理やフィルタリングに使用されます。',
    char_scenario: 'シナリオ',
    char_scenarioHelper: '会話とキャラクターの現在の状況と背景。',
    char_personality: '性格',
    char_personalityWarning: '警告：「プレーンテキスト」と「非プレーンテキスト」の形式は互換性がありません。切り替えるとデータが失われます。',
    char_greeting: '挨拶',
    char_greetingHelper: 'キャラクターからの最初のメッセージ。キャラクターが長い返信をするように、最初のメッセージは長くすることをお勧めします。',
    char_greetingPlaceholder: '例：*あなたが部屋に入ってくると微笑む* こんにちは、{{user}}！もうお昼休みなんて信じられないわ！どこに行く？',
    char_sampleConversation: '会話例',
    char_sampleConversationHelper: 'あなたとキャラクターの会話例。このセクションはキャラクターの話し方を教えるために非常に重要です。',
    char_voiceHelper: 'このキャラクターが自動的に話すのを無効にするにはオンにします',
    char_languageHelper: 'このキャラクターが話し、理解する言語。',
    char_languageNote: ' 注意：英語以外の言語を使用するには、プリセットのgaslightも翻訳する必要があります。',
    char_imageSettingsMoved: '画像設定は移動しました：メインメニューの',
    char_inMainMenu: 'をクリックしてください',
    char_avatarOrJsonFile: 'アバターまたはJSONファイル',
    char_charactersToImport: 'インポートするキャラクター：',
    char_andOneOther: '... 他1つ',
    char_andOthers: '... 他 {count} つ',
    char_failedCharacterImports: 'インポートに失敗したキャラクター：',
    char_persona: 'ペルソナ',
    char_images: '画像',
    char_advanced: '詳細設定',
    char_attributesFormat: '属性 (キー: 値)',
    char_plainTextFormat: 'プレーンテキスト',
    char_downloadSuccess: 'Character Hub から正常にダウンロードされました',
    char_downloadFailed: 'Character Hub のダウンロードに失敗しました: {message}',
    char_sampleConversationPlaceholder: '{{char}}: *微笑んで手を振り返す* こんにちは！あなたが来てくれてとても嬉しいわ！',
    char_unnamed: '無名',
    char_importChatLog: 'チャットログをインポート',
    char_chatLogAccepted: 'チャットログが承認されました',
    char_invalidChatLogFormat: '無効なチャットログファイル形式です。サポートされている形式：HuanYouAI, TavernAI',
    char_chatLogImportFor: 'チャットログは {name} としてインポートされます。',
    char_jsonLinesFile: 'JSON Lines ファイル (.jsonl)',
    char_messagesToImport: '{count} 件のメッセージがインポートされます。',
    chat_chatWith: '{name} とチャット',
    chat_notesFromCreator: '{name} の作成者からのメモ',
    chat_generateMessage: 'メッセージを生成',
    chat_forkConversationConfirm: 'これにより、挨拶メッセージから会話が分岐されます。',
    chat_sendAMessage: 'メッセージを送信...',
    chat_sendAMessageTo: '{name} にメッセージを送信...',
    chat_confirmCancelSwipe: '送信前にスワイプを確定またはキャンセルしてください',
    chat_respondAsMe: '自分として応答',
    chat_autoReply: '自動返信',
    chat_none: 'なし',
    chat_stopBotReply: 'ボットの返信を停止',
    chat_generateImage: '画像を生成',
    chat_respondAgain: 'もう一度応答',
    chat_generateMore: 'さらに生成',
    chat_playVoice: '音声を再生',
    chat_triggerEvent: 'イベントをトリガー',
    chat_attachImage: '画像を添付',
    chat_responseHint: '応答ヒント...',
    chat_invalidFileTypeImage: '無効なファイル形式：画像である必要があります',
    chat_attachmentExceedsLimit: '添付ファイルがサイズ制限（1MB）を超えています',
    chat_loading: 'HuanYouAI 読み込み中...',
    chat_participants: '参加者',
    chat_editChat: 'チャットを編集',
    chat_memory: 'メモリ',
    chat_ui: 'UI',
    chat_graph: 'チャットグラフ',
    chat_screenshot: 'スクリーンショット',
    chat_anonymize: '匿名化',
    chat_hideOocMessages: 'OOCメッセージを非表示',
    chat_mainCharacter: 'メインキャラクター',
    chat_restart: '再開',
    chat_loadingWait: '読み込み中、しばらくお待ちください...',
    chat_screenshotFailedElement: 'スクリーンショットに失敗しました：メッセージ要素が見つかりません',
    chat_screenshotFailedConsole: 'スクリーンショットに失敗しました：コンソールにエラーが記録されました',
    chat_ooc_suffix: '(OOC)',
    chat_msg_id: 'ID',
    chat_msg_chat: 'チャット',
    chat_msg_descendants: '子孫',
    chat_pending_retrying: 'リトライ中',
    chat_pending_waiting: '待機中',
    chat_pending_chatId: 'チャットID',
    chat_graph_root: 'ルート',
    chat_avatar_modal_title: 'アバタープレビュー',
    chat_graph_circular_error: '無効なチャットツリー：循環参照が含まれています',
    char_listView: 'リスト表示',
    char_cardsView: 'カード表示',
    char_folderView: 'フォルダ表示',
    char_failedToLoad: 'キャラクターの読み込みに失敗しました。再読み込みしてください。',
    char_jsonStructuredResponses: 'JSON構造化レスポンス',
    char_jsonStructuredWarning: '警告：すべてのモデルがJSON出力/レスポンスをサポートしているわけではありません。',
    char_responseTemplate: 'レスポンス形式',
    char_responseTemplateHelper: 'チャット内でのメッセージの表示方法',
    char_historyTemplate: '履歴形式',
    char_historyTemplateHelper: 'プロンプト内でのメッセージの表示方法',
    char_imageCaptionTemplate: '画像説明形式',
    char_imageCaptionTemplateHelper: '画像生成用の「画像プロンプト」を自動入力するために使用されます。',
    char_jsonSchemaFile: 'JSONスキーマファイル (.json)',
    char_confirmDeletion: '削除の確認',
    char_confirmDeletionMessage: 'このキャラクターを削除してもよろしいですか？',
    char_toggleFavorite: 'お気に入りの切り替え',
    char_openRecentChat: '最近のチャットを開く',
    char_openCharacterChats: 'キャラクターチャットを開く',
    char_favorite: 'お気に入り',
    char_downloadCharacter: 'キャラクターをダウンロード',
    char_outputFormat: '出力形式',
    char_fileType: 'ファイル形式',
    char_characterName: 'キャラクター名',
    char_descriptionCreatorsNotes: '説明 / 作成者のメモ',
    char_tags: 'タグ',
    char_scenarioPlaceholder: '例：{{char}}はオフィスで働いています。{{user}}がドアを開けて入ってきます。',
    char_formatAsIsHelper: 'これが何を意味するか分からない場合は、そのままにしておいてください。',
    char_formatToUseHelper: 'キャラクターの形式に使用する形式',
    char_firstMessagePlaceholder: '{{char}}: *微笑んで手を振り返す* こんにちは！あなたが来てくれてとても嬉しいです！',
    char_voice: '音声',
    char_disableVoice: 'キャラクターの音声を無効にする',
    char_updatePreset: 'プリセットを更新',
    char_presetUsedForGeneration: 'このプリセットはキャラクター生成に使用されます',
    char_foldersGuide: 'フォルダガイド',
    char_foldersInstructions: '- キャラクターを「新規フォルダ」にドラッグして新しいフォルダを作成します\n- キャラクターをフォルダにドラッグしてキャラクターを移動します',
    char_currentFolder: '現在のフォルダ',
    char_newFolder: '新規フォルダ',
    char_generateAvatar: 'アバターを生成',
    char_impersonate: 'なりきり',
    char_changeChatPersona: '現在のチャットペルソナを変更します。',
    char_changeDefaultPersona: 'デフォルトのペルソナを変更します。',
    char_impersonationHelper: 'キャラクターなりきり機能を使用して、別のペルソナとして発言します',
    char_failedImports: '失敗したキャラクターインポート：',
    char_multiUserNote: '注意：現在、マルチユーザーチャットはサポートされていません。すべてのメッセージは',
    char_alternateGreeting: 'キャラクターの別の挨拶',
    char_appearancePrompt: '外見プロンプト（アバター生成に使用）',
    char_characterBook: 'キャラクターブック',
    char_noCharacterBook: 'このキャラクターにはキャラクターブックがありません。',
    char_hasCharacterBook: 'このキャラクターにはキャラクターブックがあります。',
    char_characterMemory: 'キャラクターの記憶',
    char_characterDesigner: 'キャラクターデザイナー',
    char_root: 'ルート',
    char_changeFolderTitle: 'フォルダの変更: {name}',
    char_folderNamesNormalized: 'フォルダ名は「標準化」されます。',
    char_normalizedName: '標準化された名前: {name}',
    char_openchats_with: '{name} とのチャットを開く',
    char_remove_from_favorites: '{name} をお気に入りから削除',
    char_add_to_favorites: '{name} をお気に入りに追加',
    char_create_new_chat_with: '{name} との新規チャットを作成',
    char_download_character_name: 'キャラクター {name} をダウンロード',
    char_edit_character_name: 'キャラクター {name} を編集',
    char_duplicate_character_name: 'キャラクター {name} を複製',
    char_delete_character_name: 'キャラクター {name} を削除',
    char_save: '保存',
    char_drag_to_move: 'アイコンをドラッグしてキャラクターを移動します',
    char_drag_to_new_folder: 'キャラクターを「新しいフォルダ」にドラッグして新しいフォルダを作成します',
    char_drag_onto_folder: 'キャラクターをフォルダにドラッグしてキャラクターを移動します',
    char_regenerate_tooltip: '名前と説明を入力する必要があります',
    char_regenerate_warn: '生成するには名前と説明を入力してください',
    char_reel_send_to_editor: 'エディターに送信',
    char_insert_depth_placeholder: '例：### 指示：ジェイムズ・ジョイスのように書いてください。',
    char_importMemoryBook: 'メモリーブックをインポート',
    char_editBook: 'メモリーブックを編集',
    char_deleteBook: 'メモリーブックを削除',
    char_createNewBook: '新しいメモリーブックを作成',
    char_hasNoCharacterBook: 'このキャラクターにはメモリーブックがありません。',
    char_addAlternateGreeting: '別の挨拶を追加',
    char_alternateGreetingPlaceholder: '別の挨拶を書いてください…',
    char_voiceService: '音声サービス',
    char_voiceLoading: '音声リストを読み込み中…',
    char_openCharacterBuilder: 'キャラクタービルダーを開く',
    char_selectAvatarImage: 'アバター画像を選択',
    char_appearancePromptPlaceholder: 'キャラクターの見た目を説明してください…',
    char_visualTypeAvatar: 'アバター',
    char_visualTypeSprite: 'スプライト',
    char_personaTab: 'ペルソナ',
    char_voiceTab: 'ボイス',
    char_imagesTab: '画像',
    char_advancedTab: '詳細設定',
    char_currentChatPersona: '現在のチャットペルソナ',
    char_defaultPersona: 'デフォルトペルソナ',
    char_impersonateDescription: 'このチャットで使用するペルソナを選択してください。',
    char_useMyProfile: '自分のプロフィールを使う',
    char_currentLabel: '現在',
    char_defaultLabel: 'デフォルト',
    char_defaultForNewConvos: '新規会話のデフォルトペルソナ',
    char_jsonSchemaGenerationStatus: 'JSONスキーマが正常に生成されました。',
    char_tempJsonSchemaUpdated: '一時的なJSONスキーマを更新しました。',
    char_characterHubDownloadSuccess: 'キャラクターハブからのダウンロードに成功しました。',
    char_characterHubDownloadFailed: 'キャラクターハブからのダウンロードに失敗しました: {message}',
    char_recommended: '推奨',
    char_unrecognizedFormat: '認識できない形式です',
    char_open_recent_chat: '最近のチャットを開く',
    char_open_character_chats: 'キャラクターチャットを開く',

    // Voice
    voice_elevenLabsModel: 'ElevenLabsモデル',
    voice_stability: '安定性',
    voice_claritySimilarityEnhancement: '明瞭度 + 類似性向上',
    voice_playbackRate: '再生速度',
    voice_seed: 'シード',
    voice_service: '音声サービス',
    voice_pitch: 'ピッチ',
    voice_rate: 'レート',
    voice_preview: 'プレビュー',
    voice_modelsLoading: 'モデルを読み込み中…',
    voice_agnaisticSeedHelper: '固定シードを使用すると、生成結果の再現性が高まります。',
    voice_novelSeedHelper: 'NovelAIのシードを設定します（空欄でランダム）。',
    voice_stabilityHelper: '安定性を高くすると声は一貫しますが、表現力は下がります。',
    voice_similarityBoostHelper: '値を上げるとリファレンスに近づき、下げるとバリエーションが増えます。',
    voice_pitchHelper: '合成音声のピッチ（高さ）を調整します。',
    voice_rateHelper: '音声の話す速さを調整します。',

    // App
    app_login_issues: 'ログインに問題がありますか？',
    app_logging_out: 'ログアウト',
    app_log_back_in: 'して、もう一度ログインしてみてください。',
    app_page_loading_issues: 'ページの読み込みに問題がありますか？',
    app_clicking_here: 'ここをクリック',
    app_failed_to_load: 'HuanYouAIの読み込みに失敗しました',
    app_try_again: 'もう一度お試しください',
    app_banned_message: 'このアカウントは以下の理由により停止されています：',
    app_banned_contact: 'これが誤りであると思われる場合は、サポートにお問い合わせください。',
    app_account_banned: 'アカウント停止',
    app_information: '情報',

    // Home
    home_free_to_use: 'HuanYouAIは完全に無料で使用できます。登録も無料です。データはプライベートに保たれ、いつでも永久に削除できます。私たちはあなたのプライバシーを非常に重視しています。',
    home_chat_multi_user: '複数のユーザーや複数のキャラクターと同時にチャットできます',
    home_create_memory_book: '{memoryBook}を作成して、キャラクターにその世界に関する情報を与えます。',
    home_use_images: '{images} - Horde、NovelAI、または独自のStable Diffusionサーバーを使用します。',
    home_give_voice: '{voice} - キャラクターに声を与え、話しかけます。',
    home_customise_presets: '{presets} - 返信を生成するために使用される生成設定を完全にカスタマイズします。',
    home_horde_guide: 'Horde ガイド',
    home_horde_important: '重要！信頼性の高いレスポンスを得るために、{link}で登録していることを確認してください。キーを取得したら、{settings}に追加してください。',
    home_horde_volunteers: 'AI Hordeは、GPUを提供する少数のボランティアによって運営されています。これは素晴らしいサービスですが、少し遅い場合があります。Hordeへの貢献を検討してください！',
    home_horde_tokens: '何をしているか分かっている場合を除き、{maxNewTokens}を100未満に保ってください！「最大新規トークン」に高い値を使用することが、タイムアウトや返信の遅延の主な原因です。',
    home_horde_anonymous: 'デフォルトでは匿名アクセスを使用します。設定ページでAPIキーを提供したり、モデルを変更したりできます。',
    home_openai_guide: 'OpenAI ガイド',
    home_openai_paid: 'OpenAIは{paidService}です。OpenAIを使用するには、設定でOpenAI APIキーを提供する必要があります：',
    home_openai_register: 'まず、{registerLink}する必要があります。',
    home_openai_generate_key: '登録したら、{generateLink}する必要があります。',
    home_openai_set_key: 'APIキーを取得したら、{settingsLink}ページに移動し、OpenAIエリアでキーを設定してください。',
    home_openai_preset: 'OpenAIを使用してレスポンスを生成するには、チャットが{chatPresetSettings}でOpenAIプリセットを使用していることを確認してください。これらには、チャットの右上のメニューからアクセスできます。',

    // Chat Create
    chat_create_title: 'チャットを作成',
    chat_create_description: '必要に応じて会話のコンテキストを変更できます。作成後にチャット内でキャラクターのペルソナの他の側面を上書きすることもできます。',
    chat_create_applied_to_new: 'ここでの設定は新しく作成される会話にのみ適用されます。',
    chat_create_main_character_helper: '会話のメインキャラクター',
    chat_mode: 'チャットモード',
    chat_mode_companion_description: 'コンパニオンモード：すべてが永続的です。チャットの編集、メッセージの再試行、メッセージの削除などはできません。',
    chat_mode_standard: '通常の会話',
    chat_mode_companion: 'コンパニオン',
    chat_conversation_name: '会話名',
    chat_conversation_name_helper: '会話の名前です。ラベル付けのみを目的としています（任意）。',
    chat_override_character_definitions: 'キャラクター定義を上書き',
    chat_override_helper: '上書きは新しく作成された会話にのみ適用されます。',
    chat_scenario_helper: 'この会話で使用するシナリオ',
    chat_create_button: '作成',

    // Chat Settings
    chat_settings_reset_character: 'キャラクターをリセット',
    chat_settings_image_source: '画像ソース',
    chat_settings_image_source_helper: 'このチャットで画像を生成する際に使用する設定',
    chat_settings_main_character: 'メインキャラクター',
    chat_settings_last_character: '最後に話したキャラクター',
    chat_settings_chat_settings: 'チャット設定',
    chat_settings_app_settings: 'アプリ設定',
    chat_settings_background_image: '背景画像',
    chat_settings_background_image_helper: '画像は現在のデバイスに保存され、他のデバイスでは利用できません',
    chat_settings_chat_mode_irreversible: '警告！コンパニオンモードへの切り替えは元に戻せません！メッセージの再試行、チャットの削除、チャット設定の編集などはできなくなります。',
    chat_settings_chat_name: 'チャット名',
    chat_settings_override_helper: '上書きはこのチャットにのみ適用されます。元のキャラクターを編集したい場合は、チャットメニューの「キャラクター」リンクから開いてください。',
    chat_settings_scenario_state: 'シナリオの現在の状態',
    chat_settings_scenario_state_helper: 'シナリオによってチャット内でこれまでに設定されたフラグ',
    chat_settings_field_description_helper: 'キャラクターの説明、ラベル、またはメモ：AIフィールド生成に使用されます。キャラクターの動作は変わりません。',
    chat_settings_post_history_instructions: 'キャラクター履歴後の指示',
    chat_settings_default_visibility: 'デフォルトのメッセージの可視性',
    chat_settings_visibility_helper: 'メッセージの可視性が編集されていない場合。最も具体的なものが優先されます：メッセージ > キャラクターのデフォルト > すべてのデフォルト',
    chat_settings_visible: '表示',
    chat_settings_invisible: '非表示',
    chat_settings_not_set: '未設定',
    chat_settings_defaults_all: 'すべてのメッセージのデフォルト',
    chat_settings_defaults_per_char: 'キャラクターごとのデフォルト',
    chat_settings_defaults_per_char_helper: '各キャラクターの視点でデフォルトの可視性を設定',
    remove_all: 'すべて削除',
    char_editCharacter: 'キャラクターを編集',
    chat_temp_char_updated: '一時キャラクターが更新されました',
    chat_memory_guide: 'メモリガイド',
    chat_ui_settings: 'チャットUI設定',
    chat_confirmDeleteChat: 'この会話を削除してもよろしいですか？',
    chat_graph_rejoin_node: 'ノードを再接続',
    chat_graph_assign_parent: '親を割り当て',
    chat_graph_select_parent: '親を選択',
    chat_graph_collapse: '折りたたむ',
    chat_graph_expand: '展開',
    chat_graph_rotate: '回転',
    chat_graph_help: 'ノードをクリックしてパスを読み込みます。クリック＆ドラッグでグラフを移動します。ピンチ/スクロールでズームします。',
    chat_token_probabilities: 'トークン確率',
    chat_save_memory_book: 'メモリブックを保存',
    chat_memory_book: 'メモリブック',
    chat_memory_book_helper: 'このチャットで使用するメモリブックを選択',
    chat_create_new_memory_book: '新しいメモリブックを作成',
    chat_embedding: '埋め込み',
    chat_embedding_helper: 'このチャットで使用する埋め込みを選択',
    chat_use_embedding: '埋め込みを使用',
    chat_msg_info_title: 'メッセージ情報',
    admin_adapter: 'アダプター',
    chat_json_output: 'JSON出力',
    chat_img_prompt_updated: '画像プロンプトが更新されました',
    chat_caption_hint_helper: '画像キャプション生成のヒント',
    chat_caption_hint_placeholder: 'キャプションヒントを入力...',
    chat_image_prompt: '画像プロンプト',
    interrupt: '中断',
    admin_clean: 'クリーン',
    admin_edit: '編集',
    chat_msg_prompt_title: 'プロンプトビュー',
    chat_prompt_approx_helper: 'おおよそのトークン数。実際の使用量は異なる場合があります。',
    chat_prompt_budget_helper: 'トークン予算情報',
    chat_est_tokens: '推定トークン数：{count}',
    chat_speech_recognition_error: '音声認識エラー：{error}',
    chat_visibility_current: '現在の可視性',
    chat_visibility_toggles: '可視性を切り替え',
    chat: 'チャット',
    download: 'ダウンロード',
    chat_export_title: 'チャットをエクスポート',
    chat_system_preset_horde: 'Horde',
    chat_system_preset: 'システムプリセット',
    chat_your_default_preset: 'デフォルトプリセット',
    chat_delete_msg_title: '削除を確認',
    chat_delete_swipe: 'スワイプを削除',
    chat_delete_one: '1つ削除',
    chat_delete_msg_confirm: '1つまたは最後の {count} 件のメッセージを削除してもよろしいですか？',
    chat_delete_msg_one_note: '"1つ"を削除すると、選択したメッセージのみが削除されます。',
    chat_delete_msg_image_confirm: '1件の画像メッセージを削除してもよろしいですか？',
    chat_system_built_in_preset_horde: 'Horde',
    chat_please_select_preset: 'プリセットを選択してください',
    chat_load_more: 'さらに読み込む',
    chat_add_temp_character: '一時キャラクターを追加',
    chat_user: 'ユーザー',
    chat_temp_characters: '一時キャラクター',
    chat_deleted_temp_characters: '削除された一時キャラクター',
    chat_remove_user_confirm: 'このチャットから {handle} を削除してもよろしいですか？',
    chat_no_chars_to_invite: '招待できるキャラクターがありません',
    chat_select_char_to_add: '追加するキャラクターを選択',
    chat_no_chars_available_to_add: '追加できるキャラクターがありません',
    chat_no_user_id_provided: 'ユーザーIDが提供されていません',
    chat_invite_user: 'ユーザーを招待',
    chat_invite_user_helper: 'このチャットに招待するユーザーIDを入力',
    chat_send_invite: '招待を送信',
    chat_owner: '所有者',
    chat_temp_character: '一時キャラクター',
    reset: 'リセット',
    back: '戻る',
    character: 'キャラクター',

    // Settings UI
    settings_ui_viewMode_background: '背景',
    settings_ui_typewriter_test: '世界には10種類の人間がいる。2進数を理解する者と理解しない者だ。',

    // Navigation
    nav_main_page_aria: 'HuanYouAI メインページ',
    nav_add_new_preset: '新しいプリセットを追加',
    nav_add_new_character: '新しいキャラクターを追加',
    nav_create_new_chat: '新しいチャットを作成',
    nav_edit_user_profile: 'ユーザープロフィールを編集',
    nav_open_impersonation: 'なりきりメニューを開く',
    nav_email_support: 'メールサポート',

    // Toasts
    toasts_site_updates: 'サイトの更新とお知らせ',
    toasts_no_notifications: '通知はありません。',
    toasts_clear_notifications: '通知をクリア',
    toasts_message_from_admin: '管理者からのメッセージ',
    toasts_latest_updates: '最新の更新',
    toasts_admin_notification: '管理者通知',
    image_prompt: 'プロンプト',
    image_clean: 'クリーン',
    image_generate: '生成',
    image_stop: '停止',
    image_to_unsent: '未送信へ',
    image_to_current: '現在へ',
    image_add_attachment: 'メッセージ添付ファイルを追加',
    image_caption: '画像キャプション',
    image_caption_hint_placeholder: 'キャプションのヒント：キャプションを生成する際に何に注目しますか？',
    image_count: '画像：{current}/{total}',
    image_fix: '修正',
    image_attach_to_message: 'メッセージに添付',
    invite_title: '招待',
    invite_no_pending: '保留中のチャット招待はありません',
    invite_from: '送信元',
    invite_character: 'キャラクター',
    invite_sent: '送信日時',
    invite_unknown_user: '不明なユーザー',
    invite_unknown_character: '不明なキャラクター',
    login_reset_password: 'パスワードをリセット',
    login_username_placeholder: 'ユーザー名...',
    login_password_placeholder: 'パスワード',
    login_confirm_password_placeholder: 'パスワードを再入力',
    login_error_not_logged_in: 'エラー - 現在ログインしていません。',
    login_missing_callback: 'クエリパラメータにコールバックがありません。',
    login_failed: '失敗：{error}',
    login_oauth_request: 'アプリケーションがあなたに代わって HuanYouAI アカウントへのアクセスを要求しています',
    login_oauth_access_list: 'アプリケーションは以下にアクセスできるようになります：',
    login_oauth_access_items: 'プロファイル名、アバター、キャラクター、およびプリセット。',
    login_authorize: '承認',
    login_authorizing: '承認中...',
    memory_create_book: '記憶書を作成',
    memory_edit_book: '記憶書を編集',
    memory_update_book: '記憶書を更新',
    memory_definitions: '定義',
    memory_priority: '優先度',
    memory_priority_helper: 'プロンプトに含めるエントリを決定する際、優先度の高いエントリが優先されます。',
    memory_weight: '重み',
    memory_weight_helper: 'エントリの順序を決定する際、重みが大きいほど下の方に配置されます。',
    memory_keywords: 'キーワード',
    memory_keywords_helper: '{{char}} および {{user}} プレースホルダーを使用できます',
    memory_entry: 'エントリ',
    memory_entry_helper: 'ここに {{char}} および {{user}} プレースホルダーを使用できます。',
    memory_embeddings: 'メモリ - 埋め込み',
    memory_loaded: 'ロード済み',
    memory_not_loaded: '未ロード',
    memory_books: 'メモリ - 書籍',
    memory_no_books: '記憶書がまだありません。「作成」をクリックして開始してください。',
    memory_book_accepted: '記憶書が承認されました',
    memory_import_book: '記憶書をインポート',
    memory_json_file: 'JSON ファイル',
    memory_import_helper: '現在、HuanYouAI からエクスポートされた記憶書のみがサポートされています。',
    memory_sort_creation: '作成日順',
    memory_sort_alpha: 'アルファベット順',
    memory_book_name: '記憶書名',
    memory_book_name_placeholder: '記憶書の名前',
    memory_description_placeholder: '（任意）記憶書の説明',
    memory_entries: 'エントリ',
    memory_filter_placeholder: 'エントリ名でフィルタリング...',
    memory_entry_name_placeholder: 'エントリの名前',
    memory_keywords_placeholder: 'カンマ区切りの単語。例：circle, shape, round, cylinder, oval',
    memory_entry_placeholder: '記憶エントリ。例：{{user}} は果物と野菜が好きです',
    memory_embedding_created: '埋め込みが正常に作成されました',
    memory_article: '記事',
    memory_pdf: 'PDF',
    memory_text_file: 'テキストファイル',
    memory_plain_text: 'プレーンテキスト',
    memory_enter_name: '埋め込みの名前を入力してください',
    memory_no_pdf: 'PDF がロードされていません',
    memory_content_empty: '埋め込みコンテンツが空です',
    memory_enable_embeddings_helper: '設定で「埋め込み/長期記憶」を有効にする必要があります',
    memory_embed_wiki: 'Wikipedia 記事を埋め込む',
    memory_embed_wiki_helper: 'Wikipedia 記事のコンテンツを使用して埋め込みを作成します',
    memory_wiki_placeholder: 'URL。例：https://en.wikipedia.org/wiki/Taylor_Swift',
    memory_embed_article_button: '記事を埋め込む',
    memory_embed_name_helper: '埋め込みの識別子。',
    memory_embed_pdf: 'PDF を埋め込む',
    memory_embed_pdf_helper: 'PDF のサイズによっては、これに時間がかかる場合があります。',
    memory_embed_file: 'ファイルを埋め込む',
    memory_embed_file_helper: 'ファイルのサイズによっては、これに時間がかかる場合があります。',
    memory_embed_text_helper: '埋め込むコンテンツ。改行を使用して行を区切ります。',
    memory_embed_text_button: 'テキストを埋め込む',
    memory_embed_name_optional_helper: '（任意）埋め込みの識別子。これは「スラッグ」になります。例：「Hello World」は「hello-world」になります',
    memory_embed_name_slug_helper: '埋め込みの識別子。これは「スラッグ」になります。例：「Hello World」は「hello-world」になります',

    // WorkerModal
    worker_modal_title: 'Horde ワーカーの選択',
    worker_modal_select_workers: 'ワーカーを選択',
    worker_modal_helper: 'すべてのワーカーを使用するには、すべてのワーカーの選択を解除してください',
    worker_modal_selected_count: '選択されたワーカー: {count}',
    worker_modal_deselect_all: 'すべての選択を解除',

    // OpenRouterOauth
    openrouter_oauth_instruction: '<b class="highlight">OpenRouterでログイン</b>をクリックするか、<a class="link" target="_blank" href="https://openrouter.ai/keys">OpenRouter.ai/keys</a>にアクセスしてAPIキーを作成し、上記に入力してください。',
    openrouter_oauth_logging_in: 'ログイン中...',
    openrouter_oauth_login: 'OpenRouterでログイン',
    openrouter_oauth_logout: 'ログアウト',

    // PatreonOauth
    patreon_oauth_verifying: 'Patreonアカウントを確認中...',
    patreon_oauth_error: 'Patreonアカウントを確認できません',
    patreon_oauth_return_to_settings: '設定に戻る',
    patreon_oauth_success: 'Patreonアカウントが確認されました',
    patreon_oauth_redirecting: '設定ページにリダイレクト中...',
    patreon_oauth_link_benefit: 'Patreonアカウントをリンクして購読者特典を受け取る',
    patreon_oauth_link: 'Patreonアカウントをリンク',
    patreon_oauth_unlink: 'Patreonアカウントのリンクを解除',
    patreon_oauth_revalidate: '再検証',

    // ImageSettings
    image_settings_shared: '共有設定',
    image_settings_global_default: 'グローバル/デフォルト',
    image_settings_character_settings: 'キャラクター設定',
    image_settings_character: 'キャラクター:',
    image_settings_current_chat: '現在のチャット設定',
    image_settings_chatting_with: 'チャット相手:',
    image_settings_source_label: '現在のチャット画像設定ソース',
    image_settings_source_helper: '「チャット画像」生成時に使用する画像設定を制御します',
    image_settings_use_settings: '{tab}設定を使用',
    image_settings_use_settings_active: '{tab}設定を使用（有効）',
    image_settings_summary_preset: '要約プリセット',
    image_settings_summary_preset_helper: 'チャット画像の要約作成に使用するサービスとモデルを選択します',
    image_settings_summary_settings: '要約設定',
    image_settings_summarise_chat: 'チャットを要約',
    image_settings_summarise_chat_helper: 'AIサービスを使用してチャットを画像プロンプトに要約します。',
    image_settings_summary_prompt: '要約プロンプト',
    image_settings_summary_prompt_helper: 'チャットを画像キャプションに要約する際、この「プロンプト」を使用して会話を画像プロンプトに要約します。',
    image_settings_default: 'デフォルト:',
    image_settings_style_booru: 'Booru/タグスタイル',
    image_settings_style_plain: 'Flux/プレーンスタイル',
    image_settings_use_recommended: '推奨設定を使用',
    image_settings_use_recommended_helper: '利用可能な場合、画像モデルの推奨設定を使用します。',
    image_settings_toggle_all: 'すべて切り替え',
    image_settings_affixes: '接辞',
    image_settings_size: 'サイズ',
    image_settings_guidance: 'ガイダンス',
    image_settings_steps: 'ステップ数',
    image_settings_negative_prompt: 'ネガティブプロンプト',
    image_settings_sampler: 'サンプラー',
    image_settings_recommended_hint: 'HuanYouAI画像モデルを使用する際は、推奨設定を参照してください',
    image_settings_sampling_steps: 'サンプリングステップ数',
    image_settings_clip_skip: 'クリップスキップ',
    image_settings_width: '画像の幅',
    image_settings_height: '画像の高さ',
    image_settings_guidance_scale: 'ガイダンススケール',
    image_settings_seed: 'シード',
    image_settings_seed_helper: 'シード番号（0 = ランダム）。注意：サーバーによってシードの一貫性は保証されません。',
    image_settings_prefix: 'プロンプト接頭辞',
    image_settings_prefix_helper: '（任意）画像プロンプトの先頭に追加するテキスト',
    image_settings_prefix_placeholder: '例: best quality, masterpiece',
    image_settings_suffix: 'プロンプト接尾辞',
    image_settings_suffix_helper: '（任意）画像プロンプトの末尾に追加するテキスト',
    image_settings_suffix_placeholder: '例: full body, visible legs, dramatic lighting',
    image_settings_negative_helper: '（任意）ネガティブプロンプト',
    image_settings_negative_placeholder: '例: painting, drawing, illustration, glitch, deformed, mutated, cross-eyed, disfigured',
    image_settings_edit_summary_preset: '要約プリセットを編集',
    image_settings_unavailable_hint: '注意：<b>チャット</b>および<b>キャラクター</b>の画像設定は、チャットが開いている時のみ利用可能です。',
    image_settings_image_settings: '画像設定',

    // ServiceSettings
    service_settings_model: 'モデル:',
    service_settings_sampler: 'サンプラー:',
    service_settings_novel_key_error: '有効なNovelAIキーが設定されていません。Novelを使用して画像を生成することはできません。',
    service_settings_novel_quality_tags: '品質タグを追加',
    service_settings_novel_undesired_content: '除外したい内容',
    service_settings_novel_undesired_content_helper: 'ネガティブプロンプトに `nsfw` を追加して、NSFWコンテンツを除外します',
    service_settings_novel_heavy: '重い',
    service_settings_novel_light: '軽い',
    service_settings_novel_none: 'なし',
    service_settings_swarm_url: 'SwarmUI URL',
    service_settings_swarm_url_helper: 'SwarmUIのベースURL。例: https://local-tunnel-url-10-20-30-40.loca.lt。セルフホストの場合は http://localhost:7801 を使用できます',
    service_settings_automatic: '自動',
    service_settings_add_lora: '+ Lora',
    service_settings_use_local: 'ローカルリクエストを使用',
    service_settings_none_selected: '未選択',
    service_settings_sd_url: 'SD WebUI URL',
    service_settings_sd_url_helper: 'Stable DiffusionのベースURL。例: https://local-tunnel-url-10-20-30-40.loca.lt。セルフホストの場合は http://localhost:7860 を使用できます',
    service_settings_sd_provider_helper: 'プロバイダーのAPIキーを使用する',
    service_settings_no_options: '利用可能な追加オプションはありません',
    service_settings_draft_mode: 'ドラフトモード',
    service_settings_draft_mode_helper: '利用可能な場合：低品質の画像を素早く生成します',
    service_settings_recommended: '推奨',
    service_settings_limits: '制限',
    service_settings_tags_keyword: 'タグ / キーワード',
    service_settings_tags: 'タグ',
    service_settings_on: 'オン',
    service_settings_off: 'オフ',
    service_settings_model_strength: 'モデル強度',
    service_settings_clip_strength: 'クリップ強度',
    service_settings_image_model: '画像モデル',
    service_settings_sampler_label: 'サンプラー',
    service_settings_steps: 'ステップ数',
    service_settings_cfg: 'CFG',
    service_settings_width: '幅',
    service_settings_height: '高さ',
    service_settings_clip_skip: 'クリップスキップ',
    service_settings_sampler_title: 'サンプラー',
    service_settings_prefix: '接頭辞',
    service_settings_suffix: '接尾辞',
    service_settings_negative: 'ネガティブ',

    // Provider/index
    provider_index_select_provider: 'プロバイダーを選択',
    provider_index_service: 'サービス',
    provider_index_providers: 'プロバイダー',
    provider_index_providers_helper: 'プロバイダーは、お好みのAIモデルに接続するために使用されます。',
    provider_index_new_provider_helper: '**`+ 新規`**をクリックして新しいプロバイダーを作成し、情報を入力してください。',
    provider_index_format_helper: '**フォーマット**\n**フォーマット**の選択を求められ、どれを使用すべきか分からない場合は、`Chat`を選択してください。',
    provider_index_important_helper: '**重要**: 下のドロップダウンで正しいプロバイダーが選択されていることを確認してください。',
    provider_index_edit_selected: '選択したものを編集',
    provider_index_new: '新規',
    provider_index_edit: '編集',
    provider_index_edit_connection: '接続詳細を編集',
    provider_index_accept: '承認',
    provider_index_ai_service: 'AIサービス',
    provider_index_no_service_warning: '警告！現在、プリセットにサービスが設定されていません。',
    provider_index_third_party_format: 'サードパーティフォーマット',
    provider_index_request_format_helper: 'リクエストの送信方法を制御します',
    provider_index_none: 'なし',
    provider_index_url: 'URL',
    provider_index_url_helper: '**サードパーティ**または**セルフホスト**サービスのAPI URL',
    provider_index_url_placeholder: '例: https://some-tunnel-url.loca.lt',
    provider_index_api_key: 'APIキー',
    provider_index_remove_key: 'キーを削除',
    provider_index_key_warning: 'ここに公式のOpenAI、Claude、Mistralのキーを入力しないでください。',
    provider_index_key_is_set: 'キーが設定されています',
    provider_index_key_placeholder: '例: sk-...',

    // Provider/Manage
    provider_manage_supported: 'サポートされているプロバイダー',
    provider_manage_local_selfhost: 'ローカル / セルフホスト',
    provider_manage_custom: 'カスタム',
    provider_manage_choose_provider: 'プロバイダー: プロバイダーを選択',
    provider_manage_provider_prefix: 'プロバイダー: ',
    provider_manage_invalid_url: 'URLが無効です。確認して再試行してください',
    provider_manage_update_title: 'プロバイダーを更新',
    provider_manage_create_title: 'プロバイダーを作成',
    provider_manage_delete: '削除',
    provider_manage_update: '更新',
    provider_manage_create: '作成',
    provider_manage_instruction: '外部サービスを使用するための接続詳細を入力してください',
    provider_manage_label: 'ラベル',
    provider_manage_label_placeholder: 'このプロバイダーのカスタムラベル',
    provider_manage_url_placeholder: 'https://...',
    provider_manage_disable_auto_url: '自動URLを無効化',
    provider_manage_request_format: '要求形式',
    provider_manage_test_connection: '接続テスト',

    privacy_policy_text: `
We at HuanYouAI (together with our affiliates, "we", "our" or "us") respect your privacy and are strongly committed to keeping secure any information we obtain from you or about you. This Privacy Policy describes our practices with respect to Personal Information we collect from or about you when you use our website and services (collectively, "Services"). Our use of that data is governed by our customer agreements covering access to and use of those offerings.

## 1. Personal information we collect

We collect information that alone or in combination with other information in our possession could be used to identify you ("Personal Information") as follows:

**Personal Information You Provide:** We may collect Personal Information if you create an account to use our Services or communicate with us as follows:

- **Account Information:** When you create an account with us, we will collect information associated with your account, including your display name, account credentials, profile picture, and other information provided during registration (collectively, "Account Information").
- **User Content:** When you use our Services, we may collect Personal Information that is included in the input, file uploads, or feedback that you provide to our Services ("Content").{' '}
- **Communication Information:** If you communicate with us, we may collect your name, contact information, and the contents of any messages you send ("Communication Information").
- **Social Media Information:** We may have pages on social media sites like Instagram, Facebook, Medium, Twitter, YouTube and LinkedIn, as well as Reddit, 4chan, and a [discord server ("https://discord.agnai.chat")](https://discord.agnai.chat). When you interact with our social media pages, we will collect Personal Information that you elect to provide to us, such as your contact details or social media usernames and profile information (collectively, "Social Information"). In addition, the companies that host our social media accounts may provide us with aggregate information and analytics about our social media activity.

**Personal Information We Receive Automatically From Your Use of the Services:** When you visit, use, and interact with the Services, we may receive the following information about your visit, use, or interactions ("Technical Information"):

- **Log Data:** Information that your browser automatically sends whenever you use our website ("log data"). Log data includes your Internet Protocol address, browser type and settings, the date and time of your request, and how you interacted with our website.
- **Usage Data:** We may automatically collect information about your use of the Services, such as the types of content that you view or engage with, the features you use and the actions you take, as well as your time zone, country, the dates and times of access, user agent and version, type of computer or mobile device, computer connection, IP address, and the like.
- **Device Information:** Includes name of the device, operating system, and browser you are using. Information collected may depend on the type of device you use and its settings.
- **Browser Storage:** We use cookies and localstorage ("Browser Storage") to operate and administer our Services, and improve your experience on it. A "cookie" is a piece of information sent to your browser by a website you visit. "Localstorage" is a feature of your web browser that lets us store information on your computer related to your use of our Services. You can set your browser to accept all cookies, to reject all cookies, or to notify you whenever a cookie is offered so that you can decide each time whether to accept it. However, refusing a cookie may in some cases preclude you from using, or negatively affect the display or function of, a website or certain areas or features of a website. For more details on cookies please visit [All About Cookies](https://www.google.com/url?q=https://allaboutcookies.org/&amp;sa=D&amp;source=editors&amp;ust=1681348702239252&amp;usg=AOvVaw1sGG2db6TzG2Fy_dtBclPZ).
- **Analytics:** We may use a variety of online analytics products that use cookies to help us analyze how users use our Services and enhance your experience when you use the Services.

## 2. How we use personal information**

We may use Personal Information for the following purposes:

- To provide, administer, maintain, improve and/or analyze the Services;
- To conduct research;
- To communicate with you;
- To develop new programs and services;
- To prevent fraud, criminal activity, or misuses of our Services, and to ensure the security of our IT systems, architecture, and networks; and
- To comply with legal obligations and legal process and to protect our rights, privacy, safety, or property, and/or that of our affiliates, you, or other third parties.
`,
  },
}

interface I18nState {
  language: Language
  t: Translations
}

const STORAGE_KEY = 'i18n_language'

const getInitialLanguage = (): Language => {
  const stored = storage.localGetItem(STORAGE_KEY)
  if (stored && (stored === 'en' || stored === 'zh' || stored === 'ja' || stored === 'tw')) {
    return stored as Language
  }
  
  // Try to detect from browser
  const browserLang = navigator.language.toLowerCase()
  if (browserLang.startsWith('zh-tw') || browserLang.startsWith('zh-hk')) return 'tw'
  if (browserLang.startsWith('zh')) return 'zh'
  if (browserLang.startsWith('ja')) return 'ja'
  
  return 'zh'
}

export const i18nStore = createStore<I18nState>(
  'i18n',
  {
    language: getInitialLanguage(),
    t: translations[getInitialLanguage()],
  },
  { quiet: true }
)((getState, setState) => ({
  setLanguage: (state: I18nState, lang: Language) => {
    storage.localSetItem(STORAGE_KEY, lang)
    return { language: lang, t: translations[lang] }
  },
}))

